
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eo9PV", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("9wCS5")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("9wCS5")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9wCS5")).monitorForElements);

var $9wCS5 = parcelRequire("9wCS5");

});
parcelRegister("9wCS5", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $713a693c74f5088c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $713a693c74f5088c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $713a693c74f5088c$export$c746a5152d4ba26c);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $8pyWR = parcelRequire("8pyWR");

var $4PCWk = parcelRequire("4PCWk");

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");

var $eDT75 = parcelRequire("eDT75");

var $kb9dc = parcelRequire("kb9dc");



const $713a693c74f5088c$var$draggableRegistry = new WeakMap();
function $713a693c74f5088c$var$addToRegistry(args) {
    $713a693c74f5088c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $713a693c74f5088c$var$draggableRegistry.delete(args.element);
    };
}
const $713a693c74f5088c$var$honeyPotFix = (0, $8pyWR.makeHoneyPotFix)();
const $713a693c74f5088c$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $jFl9L.combine)($713a693c74f5088c$var$honeyPotFix.bindEvents(), (0, $74BVL.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $713a693c74f5088c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $kb9dc.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $eDT75.isAndroid)() && !event.dataTransfer.types.includes((0, $559dbbdafee2f66d$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $63b7ad043dd75799$export$4c44a460f123106))) event.dataTransfer.setData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad), (0, $eDT75.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $4df75fb0870d0fce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $713a693c74f5088c$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $713a693c74f5088c$var$honeyPotFix.getOnPostDispatch()
});
const $713a693c74f5088c$export$e7140b68045b5036 = $713a693c74f5088c$var$adapter.dropTarget;
const $713a693c74f5088c$export$59a074bac4c54f54 = $713a693c74f5088c$var$adapter.monitor;
function $713a693c74f5088c$export$c746a5152d4ba26c(args) {
    return (0, $jFl9L.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $713a693c74f5088c$var$adapter.registerUsage(), $713a693c74f5088c$var$addToRegistry(args), (0, $ggbKc.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("cHW1B", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $4de7b3023d657aff$export$81d0353f25f5dd);

var $7HOOK = parcelRequire("7HOOK");
function $4de7b3023d657aff$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $7HOOK.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("7HOOK", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $40cb98f5bdb41c1d$export$821bdcd739a2706b);

function $40cb98f5bdb41c1d$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $d783bf87f05fb737$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("8pyWR", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $be63984178d64c97$export$8ecad27c959e89e0);

var $74BVL = parcelRequire("74BVL");


const $be63984178d64c97$var$honeyPotSize = 2;
const $be63984178d64c97$var$halfHoneyPotSize = $be63984178d64c97$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $be63984178d64c97$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $be63984178d64c97$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $be63984178d64c97$var$halfHoneyPotSize,
        y: point.y - $be63984178d64c97$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $be63984178d64c97$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $be63984178d64c97$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $be63984178d64c97$var$getHoneyPotRectFor({ client: client }) {
    const point = $be63984178d64c97$var$preventGoingForwardsOffScreen($be63984178d64c97$var$preventGoingBackwardsOffScreen($be63984178d64c97$var$pullBackByHalfHoneyPotSize($be63984178d64c97$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $be63984178d64c97$var$honeyPotSize,
        height: $be63984178d64c97$var$honeyPotSize
    });
}
function $be63984178d64c97$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $be63984178d64c97$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $be63984178d64c97$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$be63984178d64c97$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $74BVL.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $be63984178d64c97$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($be63984178d64c97$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $be63984178d64c97$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $74BVL.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $be63984178d64c97$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;


parcelRegister("4PCWk", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $e5ed704461f1a07b$export$2aa3a33160990d96);

var $jlxyb = parcelRequire("jlxyb");

var $buJNg = parcelRequire("buJNg");

var $gItnR = parcelRequire("gItnR");

var $j14G1 = parcelRequire("j14G1");
function $e5ed704461f1a07b$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $j14G1.makeMonitor)();
    const dropTargetAPI = (0, $gItnR.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $jlxyb.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $jlxyb.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $buJNg.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("jlxyb", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $6868b9e56fe4f659$export$3efdceeb8ca25c51);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $7HOOK = parcelRequire("7HOOK");

var $coJJ5 = parcelRequire("coJJ5");

var $fURjR = parcelRequire("fURjR");

var $kb9dc = parcelRequire("kb9dc");

var $9A5IM = parcelRequire("9A5IM");
const $6868b9e56fe4f659$var$globalState = {
    isActive: false
};
function $6868b9e56fe4f659$var$canStart() {
    return !$6868b9e56fe4f659$var$globalState.isActive;
}
function $6868b9e56fe4f659$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $6868b9e56fe4f659$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $6868b9e56fe4f659$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$6868b9e56fe4f659$var$canStart()) return;
    const initial = $6868b9e56fe4f659$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $6868b9e56fe4f659$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $6868b9e56fe4f659$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $9A5IM.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $6868b9e56fe4f659$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $kb9dc.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $7HOOK.isHoneyPotElement)(event.target) ? (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $6868b9e56fe4f659$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $6868b9e56fe4f659$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $coJJ5.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $6868b9e56fe4f659$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $6868b9e56fe4f659$var$getNativeSetDragImage(event)
    });
}
function $6868b9e56fe4f659$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $6868b9e56fe4f659$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $kb9dc.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $6868b9e56fe4f659$export$3efdceeb8ca25c51 = {
    canStart: $6868b9e56fe4f659$var$canStart,
    start: $6868b9e56fe4f659$var$start
};

});
parcelRegister("coJJ5", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $f35fe00a678b780a$export$57d220c74e84a273);

var $enquP = parcelRequire("enquP");

var $Fx8Dp = parcelRequire("Fx8Dp");

var $jivNo = parcelRequire("jivNo");

var $ehWpG = parcelRequire("ehWpG");
function $f35fe00a678b780a$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $Fx8Dp.isSafari)()) return (0, $jivNo.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $enquP.isFirefox)()) return (0, $ehWpG.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("enquP", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $e614166849bdfbc2$export$b7d78993b74f766d);

var $KsGIL = parcelRequire("KsGIL");
const $e614166849bdfbc2$export$b7d78993b74f766d = (0, $KsGIL.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("KsGIL", function(module, exports) {

$parcel$export(module.exports, "once", () => $60659947ef15ccf3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $60659947ef15ccf3$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("Fx8Dp", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $4c39b3d87a6f2982$export$95df08bae54cb4df);

var $KsGIL = parcelRequire("KsGIL");
const $4c39b3d87a6f2982$export$95df08bae54cb4df = (0, $KsGIL.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jivNo", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $988fa06fa869765d$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $988fa06fa869765d$export$f21837c338005454);

var $74BVL = parcelRequire("74BVL");

var $Fx8Dp = parcelRequire("Fx8Dp");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $988fa06fa869765d$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $988fa06fa869765d$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragEnter.hasOwnProperty($988fa06fa869765d$var$symbols.isEnteringWindow);
}
function $988fa06fa869765d$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragLeave.hasOwnProperty($988fa06fa869765d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $Fx8Dp.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$988fa06fa869765d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$988fa06fa869765d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("ehWpG", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $395b6cf20e8aa0ab$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $395b6cf20e8aa0ab$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $395b6cf20e8aa0ab$export$e46810fef53b5b0e(eventTarget) {
    return $395b6cf20e8aa0ab$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("fURjR", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $e1eef5448bb32238$export$ac5e5b0daf997b2);
function $e1eef5448bb32238$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("kb9dc", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $661957bb1ab51692$export$7c112ceec8941e67);
function $661957bb1ab51692$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("9A5IM", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $6674e392a266d08a$export$9f13ecc44e83d682);

var $8yx6O = parcelRequire("8yx6O");
const $6674e392a266d08a$var$scheduleOnDrag = (0, $8yx6O.default)((fn)=>fn());
const $6674e392a266d08a$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $6674e392a266d08a$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $6674e392a266d08a$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $6674e392a266d08a$var$scheduleOnDrag(()=>{
                $6674e392a266d08a$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("8yx6O", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ab2e75f41b36d7$export$2e2bcd8739ae039);
var $63ab2e75f41b36d7$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $63ab2e75f41b36d7$export$2e2bcd8739ae039 = $63ab2e75f41b36d7$var$rafSchd;

});



parcelRegister("buJNg", function(module, exports) {

$parcel$export(module.exports, "register", () => $16255e18a8cdf5a6$export$6503ec6e8aabbaf);
const $16255e18a8cdf5a6$var$ledger = new Map();
function $16255e18a8cdf5a6$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $16255e18a8cdf5a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $16255e18a8cdf5a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $16255e18a8cdf5a6$export$6503ec6e8aabbaf(args) {
    const entry = $16255e18a8cdf5a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $16255e18a8cdf5a6$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("gItnR", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $4df313649e179712$export$47d10e7bd9c81890);

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");
function $4df313649e179712$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $4df313649e179712$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $jFl9L.combine)((0, $ggbKc.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $4df313649e179712$var$copyReverse(current);
        const actualCaptureOrdered = $4df313649e179712$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $4df313649e179712$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jFl9L", function(module, exports) {

$parcel$export(module.exports, "combine", () => $e825059ee70ef631$export$1be1fc439b849fdf);
function $e825059ee70ef631$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("ggbKc", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $df9d12eec6804e85$export$5dcb5c23b6ba980a);
function $df9d12eec6804e85$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("j14G1", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $aec9bd094a175c02$export$5dd4ed888d5b12ca);
function $aec9bd094a175c02$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eDT75", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $773300f3a724036a$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $773300f3a724036a$export$aceb3ed8b7f7bd2c);

var $KsGIL = parcelRequire("KsGIL");
const $773300f3a724036a$export$a11b0059900ceec8 = (0, $KsGIL.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $773300f3a724036a$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $559dbbdafee2f66d$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $63b7ad043dd75799$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $4df75fb0870d0fce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("3f2za", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("jFl9L")).combine);

var $jFl9L = parcelRequire("jFl9L");

});

parcelRegister("jFtVs", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $e5190f4e823bb222$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $e5190f4e823bb222$export$bb5ca5fba6fb4f1f);

var $eUqFw = parcelRequire("eUqFw");

var $417zz = parcelRequire("417zz");
var $e5190f4e823bb222$var$generateUID = function(context) {
    var quartz = context || (0, $417zz.counter);
    var prefix = (0, $417zz.getPrefix)(quartz);
    var id = (0, $417zz.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $e5190f4e823bb222$var$useUIDState = function() {
    // @ts-ignore
    return $eUqFw.useState($e5190f4e823bb222$var$generateUID($eUqFw.useContext((0, $417zz.source))));
};
var $e5190f4e823bb222$export$87d05f07e65211f1 = function() {
    var uid = $e5190f4e823bb222$var$useUIDState()[0].uid;
    return uid;
};
var $e5190f4e823bb222$export$bb5ca5fba6fb4f1f = function() {
    var gen = $e5190f4e823bb222$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("417zz", function(module, exports) {

$parcel$export(module.exports, "counter", () => $2ecd2139c1e458e2$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $2ecd2139c1e458e2$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $2ecd2139c1e458e2$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $2ecd2139c1e458e2$export$36e24695f02d4503);

var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");
var $2ecd2139c1e458e2$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $tkrFt.generateUID)()
    };
};
var $2ecd2139c1e458e2$export$e575061ef2a070eb = $2ecd2139c1e458e2$export$1921362e86c73c88();
var $2ecd2139c1e458e2$export$b4d5da5f34fb77ad = $eUqFw.createContext($2ecd2139c1e458e2$export$1921362e86c73c88());
var $2ecd2139c1e458e2$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $2ecd2139c1e458e2$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("tkrFt", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $0582918cf26ae626$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $0582918cf26ae626$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $0582918cf26ae626$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $0582918cf26ae626$export$e2a22331486dcca0 = $0582918cf26ae626$export$bdbb4cbb3078e58d();

});



parcelRegister("7JEyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1c31c46c14c563$export$2e2bcd8739ae039);
const $5a1c31c46c14c563$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5a1c31c46c14c563$var$ATOMIC_GROUP_LENGTH = 5;
function $5a1c31c46c14c563$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $5a1c31c46c14c563$var$UNDERSCORE_UNICODE ? $5a1c31c46c14c563$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("asu8X", function(module, exports) {

$parcel$export(module.exports, "di", () => $79d3e6c28edd13b3$export$479d1ccc5f2ab701);

var $2P2t0 = parcelRequire("2P2t0");

var $dpjms = parcelRequire("dpjms");
function $79d3e6c28edd13b3$export$479d1ccc5f2ab701(deps, target) {
    // check if babel plugin has been added othrewise this is a noop
    if (Array.isArray(deps)) {
        // Read context and grab all the dependencies override Providers in the tree
        const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
        (0, $2P2t0.Context)._currentRenderer2 && (0, $2P2t0.Context)._currentValue2 || // grab value from default renderer
        (0, $2P2t0.Context)._currentValue || (0, $dpjms.globalDi);
        return getDependencies(deps, target);
    }
}

});
parcelRegister("2P2t0", function(module, exports) {

$parcel$export(module.exports, "Context", () => $20e242117d64e3db$export$841858b892ce1f4c);

var $eUqFw = parcelRequire("eUqFw");

var $dpjms = parcelRequire("dpjms");
const $20e242117d64e3db$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    getDependencies: (0, $dpjms.globalDi).getDependencies
});

});
parcelRegister("dpjms", function(module, exports) {

$parcel$export(module.exports, "globalDi", () => $9c2ca0eaed757b5d$export$a775919ebd7dd28a);

var $iF8Fq = parcelRequire("iF8Fq");

var $3d3oh = parcelRequire("3d3oh");
const $9c2ca0eaed757b5d$var$replacementMap = new Map();
const $9c2ca0eaed757b5d$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        return realDeps.map((dep)=>{
            const replacedInj = (0, $3d3oh.findInjectable)($9c2ca0eaed757b5d$var$replacementMap, dep, targetChild);
            return replacedInj ? replacedInj.value : dep;
        });
    },
    use (injs) {
        if ($9c2ca0eaed757b5d$var$replacementMap.size) throw new Error(`${(0, $iF8Fq.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $3d3oh.addInjectableToMap)($9c2ca0eaed757b5d$var$replacementMap, inj));
    },
    clear () {
        $9c2ca0eaed757b5d$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $iF8Fq.diRegistry).get(inj).global) (0, $3d3oh.addInjectableToMap)($9c2ca0eaed757b5d$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $3d3oh.removeInjectableFromMap)($9c2ca0eaed757b5d$var$replacementMap, inj));
    }
};
function $9c2ca0eaed757b5d$export$b887ce09d70113f9(thunk, deps) {
    $9c2ca0eaed757b5d$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($9c2ca0eaed757b5d$export$a775919ebd7dd28a.clear);
        else $9c2ca0eaed757b5d$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("iF8Fq", function(module, exports) {

$parcel$export(module.exports, "diRegistry", () => $d962c7745f008d23$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $d962c7745f008d23$export$b8b9d90f9e5bd72b);
const $d962c7745f008d23$export$4203fb010fad9bf0 = new WeakMap();
const $d962c7745f008d23$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("3d3oh", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $2565374a4f5459fd$export$5b28268982f175ba);
$parcel$export(module.exports, "addInjectableToMap", () => $2565374a4f5459fd$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $2565374a4f5459fd$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $2565374a4f5459fd$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $2565374a4f5459fd$export$7c436e151c3ee289);

var $iF8Fq = parcelRequire("iF8Fq");

var $1dtzH = parcelRequire("1dtzH");
let $2565374a4f5459fd$var$hasWarned = false;
function $2565374a4f5459fd$export$5b28268982f175ba(message) {
    if (!$2565374a4f5459fd$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $2565374a4f5459fd$var$hasWarned = true;
    }
}
function $2565374a4f5459fd$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $iF8Fq.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $1dtzH.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $2565374a4f5459fd$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $iF8Fq.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $2565374a4f5459fd$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $2565374a4f5459fd$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\[([^\]]+)/) || [];
    return args;
}
function $2565374a4f5459fd$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep) || new Set();
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.includes(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $1dtzH.stats).track(candidate);
    return candidate;
}

});
parcelRegister("1dtzH", function(module, exports) {

$parcel$export(module.exports, "stats", () => $0e2df24683a7a964$export$7804429c45dff272);
const $0e2df24683a7a964$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $0e2df24683a7a964$export$7804429c45dff272 = {
    state: $0e2df24683a7a964$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $0e2df24683a7a964$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("hUYqC", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $973b69ca88cb1fbb$export$12b6b072930fd68f);

var $9qfuq = parcelRequire("9qfuq");
class $973b69ca88cb1fbb$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $9qfuq.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("9qfuq", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $d3ac8439edce1196$export$c90b54e658fc4d7c);

var $1HAY5 = parcelRequire("1HAY5");
function $d3ac8439edce1196$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $d3ac8439edce1196$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $1HAY5.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $d3ac8439edce1196$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("1HAY5", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $45f9a111887618d9$export$d27a2b6293f7631c);
class $45f9a111887618d9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("1xrmr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $8deb5691e7b7ca56$export$a7b0697657ed8bd0);

var $eUqFw = parcelRequire("eUqFw");
const $8deb5691e7b7ca56$export$a7b0697657ed8bd0 = (0, $eUqFw.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("bW292", function(module, exports) {

$parcel$export(module.exports, "getATLContextDomain", () => $bbea85c236a72978$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $bbea85c236a72978$export$45d6512913ef41b4);


var $1LnKS = parcelRequire("1LnKS");

var $dHMKP = parcelRequire("dHMKP");
function $bbea85c236a72978$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $bbea85c236a72978$var$isValidDomainKey(domainKey) {
    if (!(0, $dHMKP.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $bbea85c236a72978$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$bbea85c236a72978$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $dHMKP.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $bbea85c236a72978$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $1LnKS.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? // Fallback to mandatory commercial production
    override[0, $80f8efc879637eec$export$f005e2e9f707cb5f][0, $80f8efc879637eec$export$42dd0cdd351a4a9]);
    // Third priority, join the subdomain
    const tld = (0, $1LnKS.domainMap)[perimeter]?.[env] ?? (0, $1LnKS.domainMap)[0, $80f8efc879637eec$export$f005e2e9f707cb5f][0, $80f8efc879637eec$export$42dd0cdd351a4a9];
    const subdomain = (0, $1LnKS.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $bbea85c236a72978$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$bbea85c236a72978$export$b5ce351acdc48c2a(domain)}`;
}
function $bbea85c236a72978$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $80f8efc879637eec$export$a739cd5aac835909),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $80f8efc879637eec$export$42dd0cdd351a4a9),
        (0, $80f8efc879637eec$export$f005e2e9f707cb5f)
    ];
}

});
const $80f8efc879637eec$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $80f8efc879637eec$export$f005e2e9f707cb5f = 'commercial';
const $80f8efc879637eec$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $80f8efc879637eec$export$a739cd5aac835909 = 'stg';
const $80f8efc879637eec$export$42dd0cdd351a4a9 = 'prod';
const $80f8efc879637eec$export$404582bc18fe4d9e = 'dev';

parcelRegister("1LnKS", function(module, exports) {

$parcel$export(module.exports, "domainMap", () => $1d7404ea220cca8f$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $1d7404ea220cca8f$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $1d7404ea220cca8f$export$4723232b625f823e);

const $1d7404ea220cca8f$export$6836b090dbaa813a = {
    [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $80f8efc879637eec$export$bd6b5a7802d76127)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
        [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $1d7404ea220cca8f$export$c6ab20d0ac4d06b2 = {};
const $1d7404ea220cca8f$export$4723232b625f823e = {
    analytics: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $80f8efc879637eec$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $80f8efc879637eec$export$ce553301d55c2fd8)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $80f8efc879637eec$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $80f8efc879637eec$export$f005e2e9f707cb5f)]: {
            [(0, $80f8efc879637eec$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("dHMKP", function(module, exports) {

$parcel$export(module.exports, "AllowedDomains", () => $cf431f961efd814d$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $cf431f961efd814d$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("eTIsH", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $7a4a71567638a22d$export$8bedcca5bbd73999);

var $bW292 = parcelRequire("bW292");

var $3JzD3 = parcelRequire("3JzD3");

var $eHfB9 = parcelRequire("eHfB9");
const $7a4a71567638a22d$var$redirect = ()=>{
    const identity = (0, $bW292.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $7a4a71567638a22d$var$DEFAULT_ENDPOINT = '/gateway/api/session/heartbeat';
const $7a4a71567638a22d$var$DEFAULT_IDLE_TIME = 60000;
const $7a4a71567638a22d$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $7a4a71567638a22d$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $eHfB9.postHeartbeat)($7a4a71567638a22d$var$DEFAULT_ENDPOINT, $7a4a71567638a22d$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($7a4a71567638a22d$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $7a4a71567638a22d$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, 10000);
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $3JzD3.default)({
            idleTimeoutMs: $7a4a71567638a22d$var$DEFAULT_IDLE_TIME,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $7a4a71567638a22d$var$instance = null;
const $7a4a71567638a22d$export$8bedcca5bbd73999 = ()=>{
    if (!$7a4a71567638a22d$var$instance) {
        $7a4a71567638a22d$var$instance = $7a4a71567638a22d$var$HeartbeatService();
        $7a4a71567638a22d$var$instance.init();
    }
    return $7a4a71567638a22d$var$instance;
};

});
parcelRegister("3JzD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $299863ab85a51a0a$export$2e2bcd8739ae039);

var $a576Y = parcelRequire("a576Y");
const $299863ab85a51a0a$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $299863ab85a51a0a$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $299863ab85a51a0a$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $299863ab85a51a0a$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $299863ab85a51a0a$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $299863ab85a51a0a$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $299863ab85a51a0a$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("a576Y", function(module, exports) {

var $dxIU5 = parcelRequire("dxIU5");

var $feGjZ = parcelRequire("feGjZ");
/** Error message constants. */ var $756fe338e6f9fa23$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $756fe338e6f9fa23$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($756fe338e6f9fa23$var$FUNC_ERROR_TEXT);
    if ($feGjZ(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $dxIU5(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $756fe338e6f9fa23$var$throttle;

});


parcelRegister("eHfB9", function(module, exports) {

$parcel$export(module.exports, "postHeartbeat", () => $516485869046e43f$export$931f43089f67754c);
const $516485869046e43f$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $516485869046e43f$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $516485869046e43f$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $516485869046e43f$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $516485869046e43f$var$timeout(backoff);
        return await $516485869046e43f$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $516485869046e43f$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $516485869046e43f$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        if ($516485869046e43f$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
    }
};

});


parcelRegister("cmqZo", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $1ad7d743431753a6$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $1ad7d743431753a6$export$55bce18df99af758);
const $1ad7d743431753a6$var$aggPathname = `/gateway/api/graphql${''}`;
const $1ad7d743431753a6$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $1ad7d743431753a6$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $1ad7d743431753a6$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("2n6bs", function(module, exports) {

$parcel$export(module.exports, "startCapturingExtensions", () => $0172e6b67b1321d7$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $0172e6b67b1321d7$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $0172e6b67b1321d7$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $0172e6b67b1321d7$export$7c6ea4184129ef74);
const $0172e6b67b1321d7$var$OperationExtensionsMap = {};
const $0172e6b67b1321d7$export$8656ba3981c6f6c1 = (operationName)=>{
    $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] = $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] || [];
};
const $0172e6b67b1321d7$export$f16fa6040161f056 = (operationName)=>{
    $0172e6b67b1321d7$var$OperationExtensionsMap[operationName] = undefined;
};
const $0172e6b67b1321d7$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $0172e6b67b1321d7$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $0172e6b67b1321d7$export$7c6ea4184129ef74 = (operationName)=>$0172e6b67b1321d7$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("5udmX", function(module, exports) {

$parcel$export(module.exports, "startCapturingTraceIds", () => $d0155ee58038d577$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $d0155ee58038d577$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $d0155ee58038d577$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $d0155ee58038d577$export$5113e470f5c95670);
const $d0155ee58038d577$var$OperationTraceIdMap = {};
const $d0155ee58038d577$export$a2bcb2fac360646c = (operationName)=>{
    $d0155ee58038d577$var$OperationTraceIdMap[operationName] = $d0155ee58038d577$var$OperationTraceIdMap[operationName] || [];
};
const $d0155ee58038d577$export$559128bdc4352001 = (operationName)=>{
    $d0155ee58038d577$var$OperationTraceIdMap[operationName] = undefined;
};
const $d0155ee58038d577$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $d0155ee58038d577$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $d0155ee58038d577$export$5113e470f5c95670 = (operationName)=>$d0155ee58038d577$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("MYW4e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $0933c058066b723b$var$batchActions;
module.exports.enableBatching = $0933c058066b723b$var$enableBatching;
module.exports.batchDispatchMiddleware = $0933c058066b723b$var$batchDispatchMiddleware;
var $0933c058066b723b$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $0933c058066b723b$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0933c058066b723b$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $0933c058066b723b$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $0933c058066b723b$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("iFajX", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("bwbFz", function(module, exports) {

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $862bbc2a33c81882$var$partition = $f2sQe(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $862bbc2a33c81882$var$partition;

});
parcelRegister("f2sQe", function(module, exports) {

var $7MBST = parcelRequire("7MBST");

var $4rMll = parcelRequire("4rMll");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $af2d6a413362b8c6$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1c8hB(collection) ? $7MBST : $4rMll, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $7qARj(iteratee, 2), accumulator);
    };
}
module.exports = $af2d6a413362b8c6$var$createAggregator;

});
parcelRegister("7MBST", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $5aaa672b52d26956$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $5aaa672b52d26956$var$arrayAggregator;

});

parcelRegister("4rMll", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $33cf2f00574fe6b3$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $awetI(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $33cf2f00574fe6b3$var$baseAggregator;

});
parcelRegister("awetI", function(module, exports) {

var $piimr = parcelRequire("piimr");

var $72U1W = parcelRequire("72U1W");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7a881f9e470b1c13$var$baseEach = $72U1W($piimr);
module.exports = $7a881f9e470b1c13$var$baseEach;

});
parcelRegister("piimr", function(module, exports) {

var $1Bv9p = parcelRequire("1Bv9p");

var $8nrDO = parcelRequire("8nrDO");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $04c086f2d85ef094$var$baseForOwn(object, iteratee) {
    return object && $1Bv9p(object, iteratee, $8nrDO);
}
module.exports = $04c086f2d85ef094$var$baseForOwn;

});

parcelRegister("72U1W", function(module, exports) {

var $jxg5X = parcelRequire("jxg5X");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $52142ec7e7327faf$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$jxg5X(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $52142ec7e7327faf$var$createBaseEach;

});





parcelRegister("9RGox", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $f875ca936a00e523$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $3BsIJ = parcelRequire("3BsIJ");

var $3rAsQ = parcelRequire("3rAsQ");
var $f875ca936a00e523$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f875ca936a00e523$var$__await ? (this.v = v, this) : new $f875ca936a00e523$var$__await(v);
};
var $f875ca936a00e523$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f875ca936a00e523$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f875ca936a00e523$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $f875ca936a00e523$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$f875ca936a00e523$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $3BsIJ.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $3BsIJ.stringifyMessage)({
                                    type: (0, $3BsIJ.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($f875ca936a00e523$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $3BsIJ.stringifyMessage)(payload ? {
                            type: (0, $3BsIJ.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $3BsIJ.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $3BsIJ.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $3BsIJ.CloseCode).InternalClientError, (0, $3rAsQ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $3BsIJ.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $3BsIJ.stringifyMessage)(message.payload ? {
                                    type: (0, $3BsIJ.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $3BsIJ.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $3BsIJ.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $3BsIJ.CloseCode).BadResponse, (0, $3rAsQ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($f875ca936a00e523$var$isLikeCloseEvent(errOrCloseEvent) && ($f875ca936a00e523$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $3BsIJ.CloseCode).InternalServerError,
            (0, $3BsIJ.CloseCode).InternalClientError,
            (0, $3BsIJ.CloseCode).BadRequest,
            (0, $3BsIJ.CloseCode).BadResponse,
            (0, $3BsIJ.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $3BsIJ.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $3BsIJ.CloseCode).SubscriberAlreadyExists,
            (0, $3BsIJ.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($f875ca936a00e523$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $3BsIJ.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $3BsIJ.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $3BsIJ.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $3BsIJ.stringifyMessage)({
                        id: id,
                        type: (0, $3BsIJ.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $3BsIJ.stringifyMessage)({
                            id: id,
                            type: (0, $3BsIJ.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $f875ca936a00e523$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $f875ca936a00e523$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $f875ca936a00e523$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $f875ca936a00e523$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $f875ca936a00e523$var$isLikeCloseEvent(val) {
    return (0, $3rAsQ.isObject)(val) && 'code' in val && 'reason' in val;
}
function $f875ca936a00e523$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $f875ca936a00e523$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("3BsIJ", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $fd0053e519e3c093$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $fd0053e519e3c093$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $fd0053e519e3c093$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $fd0053e519e3c093$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $fd0053e519e3c093$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $3rAsQ = parcelRequire("3rAsQ");
const $fd0053e519e3c093$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $fd0053e519e3c093$export$ec743af8bb66f3be = 'graphql-ws';
var $fd0053e519e3c093$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($fd0053e519e3c093$export$777128f41f6616ec || ($fd0053e519e3c093$export$777128f41f6616ec = {}));
var $fd0053e519e3c093$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($fd0053e519e3c093$export$80edbf15fa61a4db || ($fd0053e519e3c093$export$80edbf15fa61a4db = {}));
function $fd0053e519e3c093$export$c17861b159b1b673(val) {
    if (!(0, $3rAsQ.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $fd0053e519e3c093$export$80edbf15fa61a4db.ConnectionInit:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.ConnectionAck:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Ping:
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $3rAsQ.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $3rAsQ.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $3rAsQ.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $3rAsQ.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $3rAsQ.extendedTypeof)(val.payload)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $3rAsQ.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $fd0053e519e3c093$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $3rAsQ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $fd0053e519e3c093$export$9e0e49e75fa7d548(val) {
    try {
        $fd0053e519e3c093$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $fd0053e519e3c093$export$f2f615077a189f21(data, reviver) {
    return $fd0053e519e3c093$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $fd0053e519e3c093$export$77896e5b47bfd50b(msg, replacer) {
    $fd0053e519e3c093$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("3rAsQ", function(module, exports) {

$parcel$export(module.exports, "extendedTypeof", () => $32f1a4ab48fd0f7d$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $32f1a4ab48fd0f7d$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $32f1a4ab48fd0f7d$export$2937fa0c8dddae54);
/** @private */ function $32f1a4ab48fd0f7d$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a(val) {
    return $32f1a4ab48fd0f7d$export$573326049e1b1c6b(val) === 'object';
}
function $32f1a4ab48fd0f7d$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $32f1a4ab48fd0f7d$export$92bd080471bc30f1(val) {
    return $32f1a4ab48fd0f7d$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $32f1a4ab48fd0f7d$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $32f1a4ab48fd0f7d$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("isMPK", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $e3fae251ef2ef0f5$export$6c790f07f4ef6a59);

var $cNy9K = parcelRequire("cNy9K");

var $qdE6s = parcelRequire("qdE6s");

var $XHGTv = parcelRequire("XHGTv");

var $4Tdfn = parcelRequire("4Tdfn");

var $15269 = parcelRequire("15269");

var $hF3cH = parcelRequire("hF3cH");

var $iBFHQ = parcelRequire("iBFHQ");
const $e3fae251ef2ef0f5$var$createStore = (source, options)=>{
    if ((0, $XHGTv.fg)('platform.jira-frontend.enable-relay-resolvers')) {
        (0, $cNy9K.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
        return new (0, (/*@__PURE__*/$parcel$interopDefault($qdE6s)))(source, options);
    }
    return new (0, $cNy9K.Store)(source, options);
};
const $e3fae251ef2ef0f5$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $hF3cH.network),
        store: $e3fae251ef2ef0f5$var$createStore(new (0, $cNy9K.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $4Tdfn.default)
        }),
        log: log,
        requiredFieldLogger: requiredFieldLogger,
        // Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
        // @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $4Tdfn.default),
        scheduler: (0, $iBFHQ.default),
        missingFieldHandlers: (0, $15269.default)
    });

});
parcelRegister("qdE6s", function(module, exports) {
'use strict';

var $dtAl9 = parcelRequire("dtAl9");
var $04ed03996c6e9951$var$_interopRequireDefault = $dtAl9.default;

var $04ed03996c6e9951$var$_createForOfIteratorHelper2 = $04ed03996c6e9951$var$_interopRequireDefault((parcelRequire("lmsCe")));

var $04ed03996c6e9951$var$_defineProperty2 = $04ed03996c6e9951$var$_interopRequireDefault((parcelRequire("1D56o")));

var $7KoMD = parcelRequire("7KoMD");
var $04ed03996c6e9951$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $7KoMD.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $04ed03996c6e9951$var$assertInternalActorIdentifier = $7KoMD.assertInternalActorIdentifier;
parcelRequire("heLGS");

var $grRYo = parcelRequire("grRYo");

var $6nfyv = parcelRequire("6nfyv");

var $7lswl = parcelRequire("7lswl");

var $baBc2 = parcelRequire("baBc2");

var $jt7k0 = parcelRequire("jt7k0");

var $99UOj = parcelRequire("99UOj");

var $05dHU = parcelRequire("05dHU");

var $azgxh = parcelRequire("azgxh");

var $gGF6e = parcelRequire("gGF6e");

var $gGF6e = parcelRequire("gGF6e");
var $04ed03996c6e9951$var$ROOT_ID = $gGF6e.ROOT_ID, $04ed03996c6e9951$var$ROOT_TYPE = $gGF6e.ROOT_TYPE;

var $23BbL = parcelRequire("23BbL");
var $04ed03996c6e9951$var$LiveResolverCache = $23BbL.LiveResolverCache, $04ed03996c6e9951$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $23BbL.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $04ed03996c6e9951$var$getUpdatedDataIDs = $23BbL.getUpdatedDataIDs;

var $h8TzT = parcelRequire("h8TzT");
var $04ed03996c6e9951$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $04ed03996c6e9951$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $04ed03996c6e9951$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $04ed03996c6e9951$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $grRYo;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $7lswl;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $04ed03996c6e9951$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $azgxh(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $04ed03996c6e9951$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $04ed03996c6e9951$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $04ed03996c6e9951$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $6nfyv.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $04ed03996c6e9951$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $04ed03996c6e9951$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $99UOj.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $04ed03996c6e9951$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $baBc2.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $04ed03996c6e9951$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $h8TzT(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $jt7k0.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $h8TzT(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $jt7k0.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $04ed03996c6e9951$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $05dHU.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $baBc2.getValue(record, $04ed03996c6e9951$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $04ed03996c6e9951$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $04ed03996c6e9951$var$initializeRecordSource(target) {
    if (!target.has($04ed03996c6e9951$var$ROOT_ID)) {
        var rootRecord = $baBc2.create($04ed03996c6e9951$var$ROOT_ID, $04ed03996c6e9951$var$ROOT_TYPE);
        target.set($04ed03996c6e9951$var$ROOT_ID, rootRecord);
    }
}
function $04ed03996c6e9951$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $baBc2.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $baBc2.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $baBc2.setValue(nextRecord, $gGF6e.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $baBc2.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $04ed03996c6e9951$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $04ed03996c6e9951$var$LiveResolverStore;

});
parcelRegister("23BbL", function(module, exports) {
'use strict';

var $dtAl9 = parcelRequire("dtAl9");
var $17f8b57d4e505253$var$_interopRequireDefault = $dtAl9.default;

var $17f8b57d4e505253$var$_createForOfIteratorHelper2 = $17f8b57d4e505253$var$_interopRequireDefault((parcelRequire("lmsCe")));

var $a0EJx = parcelRequire("a0EJx");

var $cjmxo = parcelRequire("cjmxo");
var $17f8b57d4e505253$var$RELAY_LIVE_RESOLVER = $cjmxo.RELAY_LIVE_RESOLVER;

var $cJ2Np = parcelRequire("cJ2Np");

var $dWKX4 = parcelRequire("dWKX4");

var $iF3co = parcelRequire("iF3co");
var $17f8b57d4e505253$var$generateClientID = $iF3co.generateClientID, $17f8b57d4e505253$var$generateClientObjectClientID = $iF3co.generateClientObjectClientID;

var $baBc2 = parcelRequire("baBc2");

var $2UHy2 = parcelRequire("2UHy2");
var $17f8b57d4e505253$var$createNormalizationSelector = $2UHy2.createNormalizationSelector;

var $ct1na = parcelRequire("ct1na");

var $b3XEH = parcelRequire("b3XEH");
var $17f8b57d4e505253$var$normalize = $b3XEH.normalize;

var $gGF6e = parcelRequire("gGF6e");
var $17f8b57d4e505253$var$RELAY_RESOLVER_ERROR_KEY = $gGF6e.RELAY_RESOLVER_ERROR_KEY, $17f8b57d4e505253$var$RELAY_RESOLVER_INVALIDATION_KEY = $gGF6e.RELAY_RESOLVER_INVALIDATION_KEY, $17f8b57d4e505253$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $gGF6e.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $17f8b57d4e505253$var$RELAY_RESOLVER_SNAPSHOT_KEY = $gGF6e.RELAY_RESOLVER_SNAPSHOT_KEY, $17f8b57d4e505253$var$RELAY_RESOLVER_VALUE_KEY = $gGF6e.RELAY_RESOLVER_VALUE_KEY, $17f8b57d4e505253$var$getStorageKey = $gGF6e.getStorageKey;

var $3ciZK = parcelRequire("3ciZK");

var $4A5TX = parcelRequire("4A5TX");

var $b0VVE = parcelRequire("b0VVE");
var $17f8b57d4e505253$var$isSuspenseSentinel = $b0VVE.isSuspenseSentinel;

var $h8TzT = parcelRequire("h8TzT");
parcelRequire("33n4A");
var $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $17f8b57d4e505253$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $17f8b57d4e505253$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $17f8b57d4e505253$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $17f8b57d4e505253$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $17f8b57d4e505253$var$expectRecord(recordSource, recordID);
        var storageKey = $17f8b57d4e505253$var$getStorageKey(field, variables);
        var linkedID = $baBc2.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $17f8b57d4e505253$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $17f8b57d4e505253$var$generateClientID(recordID, storageKey);
            linkedRecord = $baBc2.create(linkedID, $17f8b57d4e505253$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $17f8b57d4e505253$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $h8TzT(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $17f8b57d4e505253$var$expectRecord(recordSource, recordID);
            var nextRecord = $baBc2.clone(currentRecord);
            $baBc2.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $17f8b57d4e505253$var$getStorageKey(field.fragment, variables);
                var resolverID = $17f8b57d4e505253$var$generateClientID(recordID, fragmentStorageKey);
                $17f8b57d4e505253$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $17f8b57d4e505253$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $17f8b57d4e505253$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $17f8b57d4e505253$var$RELAY_LIVE_RESOLVER && $baBc2.getValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $17f8b57d4e505253$var$generateClientID(recordID, storageKey);
            linkedRecord = $baBc2.clone(linkedRecord);
            var _liveState = $baBc2.getValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$4A5TX(_liveState)) $h8TzT(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $baBc2.getValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $baBc2.getValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($17f8b57d4e505253$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $17f8b57d4e505253$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $h8TzT(false);
        var liveState = $baBc2.getValue(liveStateRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $baBc2.setValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$baBc2.hasValue(currentRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $baBc2.clone(currentRecord);
            $baBc2.setValue(nextRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $ct1na.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $ct1na.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $h8TzT(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $baBc2.setValue(resolverRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$17f8b57d4e505253$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $3ciZK(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $h8TzT(false);
                resolverValue = [];
                var nextSource = $ct1na.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $h8TzT(false);
                    var typename = $17f8b57d4e505253$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $17f8b57d4e505253$var$generateClientObjectClientID(typename, $baBc2.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $17f8b57d4e505253$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $17f8b57d4e505253$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $h8TzT(false);
                var _typename = $17f8b57d4e505253$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $17f8b57d4e505253$var$generateClientObjectClientID(_typename, $baBc2.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $17f8b57d4e505253$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $baBc2.setValue(resolverRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $dWKX4(resolverValue);
            $baBc2.setValue(resolverRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $dWKX4(value);
            $baBc2.setValue(resolverRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $baBc2.getValue(resolverRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $17f8b57d4e505253$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$baBc2.getValue(record, $17f8b57d4e505253$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $baBc2.getValue(record, $17f8b57d4e505253$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $a0EJx(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($cJ2Np.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $baBc2.clone(record);
            $baBc2.setValue(nextRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($baBc2.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $ct1na.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $baBc2.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $17f8b57d4e505253$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $17f8b57d4e505253$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $baBc2.create(outputTypeDataID, typename);
                $baBc2.setValue(_record, $17f8b57d4e505253$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $h8TzT(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $17f8b57d4e505253$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $baBc2.create(key, typeName);
            $baBc2.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $17f8b57d4e505253$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $17f8b57d4e505253$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $17f8b57d4e505253$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $17f8b57d4e505253$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $17f8b57d4e505253$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $baBc2.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $17f8b57d4e505253$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $17f8b57d4e505253$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $baBc2.getFields(record).forEach(function(field) {
        if ($baBc2.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $baBc2.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($baBc2.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $baBc2.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $17f8b57d4e505253$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $baBc2.clone(record);
    $baBc2.setValue(nextRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $17f8b57d4e505253$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $17f8b57d4e505253$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $17f8b57d4e505253$var$isResolverRecord(_record2)) $17f8b57d4e505253$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $17f8b57d4e505253$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $17f8b57d4e505253$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $17f8b57d4e505253$var$isResolverRecord(record)) $17f8b57d4e505253$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $17f8b57d4e505253$var$isResolverRecord(record) {
    return $baBc2.getType(record) === $17f8b57d4e505253$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $17f8b57d4e505253$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $baBc2.getValue(linkedRecord, $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $17f8b57d4e505253$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $h8TzT(false);
    return record;
}
function $17f8b57d4e505253$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $17f8b57d4e505253$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $h8TzT(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $17f8b57d4e505253$var$LiveResolverCache,
    getUpdatedDataIDs: $17f8b57d4e505253$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $17f8b57d4e505253$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("4A5TX", function(module, exports) {
'use strict';
function $355f1a24bd4c141c$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $355f1a24bd4c141c$var$isLiveStateValue;

});



parcelRegister("4Tdfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b836f7d9d390f8cd$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $6MdYq = parcelRequire("6MdYq");
const $b836f7d9d390f8cd$var$idTypeMap = new Map();
function $b836f7d9d390f8cd$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $XHGTv.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($b836f7d9d390f8cd$var$idTypeMap.has(idString)) {
            const entry = $b836f7d9d390f8cd$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $6MdYq.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $b836f7d9d390f8cd$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("6MdYq", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $2a56635cdb9d83c0$export$b8c037155fd57aaf);
const $2a56635cdb9d83c0$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $2a56635cdb9d83c0$var$isProduction = ()=>true;
const $2a56635cdb9d83c0$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $2a56635cdb9d83c0$var$INTERVAL_MS = 1000;
let $2a56635cdb9d83c0$var$requestQueue = [];
let $2a56635cdb9d83c0$var$isProcessingQueue = false;
const $2a56635cdb9d83c0$var$processQueue = ()=>{
    if ($2a56635cdb9d83c0$var$isProcessingQueue) return;
    $2a56635cdb9d83c0$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($2a56635cdb9d83c0$var$requestQueue.length === 0) {
            $2a56635cdb9d83c0$var$isProcessingQueue = false;
            return;
        }
        const batch = $2a56635cdb9d83c0$var$requestQueue.splice(0, $2a56635cdb9d83c0$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$2a56635cdb9d83c0$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $2a56635cdb9d83c0$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $2a56635cdb9d83c0$var$sendToServerBatched = (body, endpoint)=>{
    $2a56635cdb9d83c0$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $2a56635cdb9d83c0$var$processQueue();
};
const $2a56635cdb9d83c0$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$2a56635cdb9d83c0$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $2a56635cdb9d83c0$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $2a56635cdb9d83c0$var$sendData = (level, location, message, event = {})=>{
    const data = $2a56635cdb9d83c0$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($2a56635cdb9d83c0$var$isProduction()) return $2a56635cdb9d83c0$var$sendToServerBatched(body, endpoint);
    return $2a56635cdb9d83c0$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $2a56635cdb9d83c0$export$b8c037155fd57aaf = (location, message, event)=>{
    $2a56635cdb9d83c0$var$sendData('warn', location, message, event);
};

});


parcelRegister("15269", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6e48922c56e0c4$export$2e2bcd8739ae039);

var $3zsgO = parcelRequire("3zsgO");

var $4Tdfn = parcelRequire("4Tdfn");
const $9e6e48922c56e0c4$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $9e6e48922c56e0c4$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $9e6e48922c56e0c4$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $3zsgO.JiraFilterAri).parse(id).filterId;
            if ($9e6e48922c56e0c4$var$isCustomFilter(filterId)) return (0, $4Tdfn.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($9e6e48922c56e0c4$var$isSystemFilter(filterId)) return (0, $4Tdfn.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $9e6e48922c56e0c4$var$MissingFieldHandlers = [
    $9e6e48922c56e0c4$export$77232ec02db7a24a
];
var $9e6e48922c56e0c4$export$2e2bcd8739ae039 = $9e6e48922c56e0c4$var$MissingFieldHandlers;

});
parcelRegister("3zsgO", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $0990a7c412d6e11d$export$3cfb6cc809e835bd);

var $lEGF7 = parcelRequire("lEGF7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/filter/manifest.ts
var $0990a7c412d6e11d$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $lEGF7.JiraFilterAriResourceOwner),
    resourceType: (0, $lEGF7.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $0990a7c412d6e11d$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $0990a7c412d6e11d$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $0990a7c412d6e11d$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("lEGF7", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $7663f750b905e6dc$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $7663f750b905e6dc$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $7663f750b905e6dc$export$e6199848f52f1119 = "jira", $7663f750b905e6dc$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("v8cEo", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $81a8d536c343a20d$export$579ee78b1dcf0a11);

var $dCoVL = parcelRequire("dCoVL");
// src/core/registered-ari.ts
var $81a8d536c343a20d$export$579ee78b1dcf0a11 = class extends (0, $dCoVL.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $dCoVL.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("dCoVL", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $baf269e1b4d6f11c$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $baf269e1b4d6f11c$export$44a7af7122933d6b);

var $hkoEN = parcelRequire("hkoEN");
// src/core/ari.ts
var $baf269e1b4d6f11c$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $hkoEN.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $baf269e1b4d6f11c$export$44a7af7122933d6b = class _AnyAri extends $baf269e1b4d6f11c$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $hkoEN.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $hkoEN.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("hkoEN", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $e3044e82ed7f104f$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $e3044e82ed7f104f$export$ab4b293d0121b8ee);

var $gZt4y = parcelRequire("gZt4y");

var $lpE9K = parcelRequire("lpE9K");
// src/core/rules/cloud-id.ts
function $e3044e82ed7f104f$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9\\-]*$")) {
    if (!cloudId.match(format)) throw new (0, $lpE9K.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $e3044e82ed7f104f$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $lpE9K.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $e3044e82ed7f104f$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $e3044e82ed7f104f$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $e3044e82ed7f104f$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $lpE9K.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $e3044e82ed7f104f$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $lpE9K.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $e3044e82ed7f104f$var$NUMBER_OF_ARI_SEGMENTS = 5, $e3044e82ed7f104f$export$4c3a8cde7a55740b = class extends (0, $gZt4y.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $e3044e82ed7f104f$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $gZt4y.validateAriQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $e3044e82ed7f104f$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $lpE9K.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $lpE9K.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $e3044e82ed7f104f$var$NUMBER_OF_ATI_SEGMENTS = 4, $e3044e82ed7f104f$var$AtiParser = class extends (0, $gZt4y.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $e3044e82ed7f104f$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $gZt4y.validateAtiQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $gZt4y.validateAtiQualifier)(qualifier), (0, $gZt4y.validatePlatformQualifier)(platformQualifier), $e3044e82ed7f104f$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $e3044e82ed7f104f$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $e3044e82ed7f104f$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $e3044e82ed7f104f$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("gZt4y", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $f849c92f95d9da05$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $f849c92f95d9da05$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $f849c92f95d9da05$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $f849c92f95d9da05$export$3d09a5c28ff3e040);

var $lpE9K = parcelRequire("lpE9K");
// src/core/rules/platform-qualifier.ts
function $f849c92f95d9da05$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $lpE9K.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $f849c92f95d9da05$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $lpE9K.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $f849c92f95d9da05$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $lpE9K.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $f849c92f95d9da05$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $lpE9K.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS = 5, $f849c92f95d9da05$var$SEGMENT_SEPARATOR = ":", $f849c92f95d9da05$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($f849c92f95d9da05$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $lpE9K.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($f849c92f95d9da05$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($f849c92f95d9da05$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("lpE9K", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $74d7e98cfa4df308$export$2191b9da168c6cf0);
// src/errors.ts
var $74d7e98cfa4df308$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("hF3cH", function(module, exports) {

$parcel$export(module.exports, "network", () => $2663841f55898ac1$export$21fcfd9d5c6ebbd4);

var $cNy9K = parcelRequire("cNy9K");

var $cmqZo = parcelRequire("cmqZo");
function $2663841f55898ac1$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $cmqZo.getAggEndpoint)(request, cacheConfig);
    const body = (0, $cmqZo.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json'
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $2663841f55898ac1$export$21fcfd9d5c6ebbd4 = (0, $cNy9K.Network).create($2663841f55898ac1$var$fetchQuery);

});

parcelRegister("iBFHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $035a85083c70fbef$export$2e2bcd8739ae039);

var $lEfVV = parcelRequire("lEfVV");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$035a85083c70fbef$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // Enable batch updates for state changes scheduled by Relay. In React 18 this will be
        // superseded by `React.startTransition` or removed entirely if Relay enable batch updates by
        // default.
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
            fn();
        });
        return '';
    }
};

});


parcelRegister("4fyxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $17815f2e3f82fdac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useUFOTransitionCompleter", () => $17815f2e3f82fdac$export$369f0ded13ce6c50);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $66aNr = parcelRequire("66aNr");

var $fTZm7 = parcelRequire("fTZm7");

var $baC3k = parcelRequire("baC3k");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $41dmJ = parcelRequire("41dmJ");

var $gCWJ3 = parcelRequire("gCWJ3");
function $17815f2e3f82fdac$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $fTZm7.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $fYqUr.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $fYqUr.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $41dmJ.default).current = ufoName;
        const rate = (0, $fTZm7.getInteractionRate)(ufoName, 'transition');
        if ((0, $66aNr.default)(rate)) {
            const newId = (0, $hompL.v4)();
            (0, $gCWJ3.setInteractionActiveTrace)(newId);
            (0, $51JrV.DefaultInteractionID).current = newId;
            (0, $fYqUr.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $baC3k.getActiveTrace)());
        }
    }
}
function $17815f2e3f82fdac$export$369f0ded13ce6c50() {
    const interactionId = (0, $eUqFw.useContext)((0, $51JrV.default));
    const capturedInteractionId = interactionId.current;
    (0, $eUqFw.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $fYqUr.tryComplete)(capturedInteractionId);
                });
            });
            (0, $fYqUr.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}

});
parcelRegister("41dmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $641b0c55a9a1d828$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $641b0c55a9a1d828$var$UFORouteName = {
    current: null
};
var $641b0c55a9a1d828$export$2e2bcd8739ae039 = $641b0c55a9a1d828$var$UFORouteName;

});

parcelRegister("gCWJ3", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $d6464306c83b9161$export$f2e521e495a88544);

var $baC3k = parcelRequire("baC3k");

var $b0r6N = parcelRequire("b0r6N");
const $d6464306c83b9161$export$f2e521e495a88544 = (newId)=>{
    (0, $baC3k.setActiveTrace)(newId.replace(/-/g, ''), (0, $b0r6N.generateSpanId)(), 'transition');
};

});
parcelRegister("b0r6N", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $d22d165a5a2e7ff5$export$295213bc4d0c54ad);
const $d22d165a5a2e7ff5$export$295213bc4d0c54ad = ()=>Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');

});



parcelRegister("4nnPJ", function(module, exports) {

$parcel$export(module.exports, "GlobalPageLoadExperience", () => $f2a0338addd29e74$export$bf7c1e56255f1467);

var $6coAu = parcelRequire("6coAu");

var $e8Y19 = parcelRequire("e8Y19");

var $12kyE = parcelRequire("12kyE");

var $2Khqb = parcelRequire("2Khqb");
class $f2a0338addd29e74$var$UFOGlobalPageLoadExperience extends (0, $e8Y19.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $e8Y19.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args);
        this.loadingPageLoadId = 'UNKNOWN';
        this.type = (0, $12kyE.ExperienceTypes).Load;
        this.performanceType = (0, $12kyE.ExperiencePerformanceTypes).PageLoad;
        this.initial = true;
    }
}
const $f2a0338addd29e74$export$bf7c1e56255f1467 = new $f2a0338addd29e74$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $6coAu.untilAll)([
        {
            category: (0, $2Khqb.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("6coAu", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $a05a5dd59924faf3$export$44695628831598be);

var $L0eva = parcelRequire("L0eva");

var $liN9S = parcelRequire("liN9S");
const $a05a5dd59924faf3$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $a05a5dd59924faf3$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $a05a5dd59924faf3$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($a05a5dd59924faf3$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($a05a5dd59924faf3$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $liN9S.UFOExperienceState).ABORTED || data.state === (0, $liN9S.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $L0eva.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $liN9S.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("liN9S", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $55ae6648ca41fb22$export$81b70111112841a0);
const $55ae6648ca41fb22$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("e8Y19", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $a4269200cbf0c97b$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $a4269200cbf0c97b$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $1vxVh = parcelRequire("1vxVh");

var $2OtXX = parcelRequire("2OtXX");

var $L0eva = parcelRequire("L0eva");

var $1zivP = parcelRequire("1zivP");

var $2mh9F = parcelRequire("2mh9F");

var $9rqMH = parcelRequire("9rqMH");

var $liN9S = parcelRequire("liN9S");

var $5l5pG = parcelRequire("5l5pG");

var $12kyE = parcelRequire("12kyE");
const $a4269200cbf0c97b$var$getPageVisibleState = ()=>{
    return !(0, $1vxVh.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $2mh9F.PageVisibleState).VISIBLE : (0, $2mh9F.PageVisibleState).HIDDEN;
};
const $a4269200cbf0c97b$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9rqMH.roundPerfNow)();
};
class $a4269200cbf0c97b$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $liN9S.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $2mh9F.PageVisibleState).MIXED;
            (0, $1zivP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $a4269200cbf0c97b$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $L0eva.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $5l5pG.canTransition)(this.state, newState)) {
            (0, $L0eva.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $liN9S.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.unsubscribeEvent)((0, $2mh9F.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $L0eva.ufolog)('this.parent', this.parent);
                (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $L0eva.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $L0eva.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $liN9S.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $a4269200cbf0c97b$var$getPageVisibleState();
            (0, $1zivP.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $L0eva.ufolog)('subscribed', this.id);
                (0, $2OtXX.getGlobalEventStream)().push((0, $2OtXX.subscribeEvent)((0, $2mh9F.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $2mh9F.FMP_MARK) && name !== (0, $2mh9F.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $L0eva.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $a4269200cbf0c97b$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $liN9S.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $2mh9F.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $2mh9F.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $L0eva.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1zivP.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $liN9S.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $L0eva.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $6ddab31b75c80c2b$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $6ddab31b75c80c2b$export$2295b861f318254a = '0.1.5';

parcelRegister("9rqMH", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $0de24159cdedfae7$export$5f490af6b2b115cf);
const $0de24159cdedfae7$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("5l5pG", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $63afb23507bea36e$export$178881f329fdb81f);

var $liN9S = parcelRequire("liN9S");
const $63afb23507bea36e$var$UFOStateAvailableTransitions = {
    [(0, $liN9S.UFOExperienceState).NOT_STARTED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).STARTED.id]: [
        (0, $liN9S.UFOExperienceState).IN_PROGRESS.id,
        (0, $liN9S.UFOExperienceState).BLOCKED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $liN9S.UFOExperienceState).BLOCKED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).BLOCKED.id]: [
        (0, $liN9S.UFOExperienceState).RECOVERED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).RECOVERED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).SUCCEEDED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $liN9S.UFOExperienceState).SUCCEEDED.id,
        (0, $liN9S.UFOExperienceState).FAILED.id,
        (0, $liN9S.UFOExperienceState).ABORTED.id
    ],
    [(0, $liN9S.UFOExperienceState).FAILED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ],
    [(0, $liN9S.UFOExperienceState).ABORTED.id]: [
        (0, $liN9S.UFOExperienceState).STARTED.id
    ]
};
const $63afb23507bea36e$export$178881f329fdb81f = (state1, state2)=>{
    return $63afb23507bea36e$var$UFOStateAvailableTransitions[state1.id] && $63afb23507bea36e$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("2Khqb", function(module, exports) {

$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $c52c445b33fd5379$export$17d97452062ccf73);
const $c52c445b33fd5379$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("lNfG4", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $6c316f0e4b2a63ea$export$b0c5c2fac8144e54);

var $9DfZf = parcelRequire("9DfZf");

var $guivW = parcelRequire("guivW");
const $6c316f0e4b2a63ea$export$b0c5c2fac8144e54 = {
    pageLoad: $guivW.pageLoad,
    pageSegmentLoad: $guivW.pageSegmentLoad,
    interaction: $guivW.interaction,
    custom: $guivW.custom,
    concurrent: $9DfZf.concurrent
};

});
parcelRegister("9DfZf", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $1f209dc7129e1820$export$370df09ecc3de059);

var $b5Sjr = parcelRequire("b5Sjr");

var $guivW = parcelRequire("guivW");
const $1f209dc7129e1820$var$concurrentMetrics = {};
const $1f209dc7129e1820$var$getKey = (config, type)=>`${type}--${config.key}`;
const $1f209dc7129e1820$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $1f209dc7129e1820$var$ensurePath = (config, type)=>{
    const key = $1f209dc7129e1820$var$getKey(config, type);
    if (!(key in $1f209dc7129e1820$var$concurrentMetrics)) $1f209dc7129e1820$var$concurrentMetrics[key] = {};
};
const $1f209dc7129e1820$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $1f209dc7129e1820$var$getKey(config, type);
    if (concurrentKey in $1f209dc7129e1820$var$concurrentMetrics && $1f209dc7129e1820$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $1f209dc7129e1820$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $1f209dc7129e1820$var$concurrentMetrics)) $1f209dc7129e1820$var$concurrentMetrics[concurrentKey] = {};
};
const $1f209dc7129e1820$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $1f209dc7129e1820$var$validateConfig(config);
    $1f209dc7129e1820$var$ensurePath(config, type);
    const metricFromCache = $1f209dc7129e1820$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $b5Sjr.BMEventsType).INLINE_RESULT ? (0, $guivW.interaction) : (0, $guivW.custom);
    const metric = metricFactory(config);
    $1f209dc7129e1820$var$concurrentMetrics[$1f209dc7129e1820$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $1f209dc7129e1820$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$1f209dc7129e1820$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$1f209dc7129e1820$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b5Sjr.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$1f209dc7129e1820$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b5Sjr.BMEventsType).CUSTOM)
};

});
parcelRegister("guivW", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $2dc761830f5936de$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $2dc761830f5936de$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $2dc761830f5936de$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $2dc761830f5936de$export$4c00f665f0d4b443);

var $5LLU8 = parcelRequire("5LLU8");

var $h66lL = parcelRequire("h66lL");

var $2Z4Sf = parcelRequire("2Z4Sf");

var $b5Sjr = parcelRequire("b5Sjr");
const $2dc761830f5936de$export$791d520f7e8058a5 = (config)=>{
    return new (0, $h66lL.PageLoadMetric)({
        ...config,
        type: (0, $b5Sjr.BMEventsType).PAGE_LOAD
    });
};
const $2dc761830f5936de$export$94114666844d5f66 = (config)=>{
    return new (0, $2Z4Sf.PageSegmentLoadMetric)({
        ...config,
        type: (0, $b5Sjr.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $2dc761830f5936de$export$92473e6020ad89b4 = (config)=>{
    return new (0, $5LLU8.Metric)({
        ...config,
        type: (0, $b5Sjr.BMEventsType).INLINE_RESULT
    });
};
const $2dc761830f5936de$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $5LLU8.Metric)({
        ...config,
        type: (0, $b5Sjr.BMEventsType).CUSTOM
    });
};

});
parcelRegister("5LLU8", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $8af4d3a78a1e2721$export$efdd3e096bc27746);

var $eBTRG = parcelRequire("eBTRG");

var $cQ9wm = parcelRequire("cQ9wm");

var $csrXc = parcelRequire("csrXc");
class $8af4d3a78a1e2721$export$efdd3e096bc27746 extends (0, $csrXc.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $eBTRG.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $cQ9wm.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("h66lL", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $ac09ff82049226d9$export$3c51073271a9eac3);

var $gwwta = parcelRequire("gwwta");

var $ayvjR = parcelRequire("ayvjR");

var $eBTRG = parcelRequire("eBTRG");

var $cQ9wm = parcelRequire("cQ9wm");

var $b5Sjr = parcelRequire("b5Sjr");

var $hW7BM = parcelRequire("hW7BM");

var $5Bdpp = parcelRequire("5Bdpp");

var $aDpmM = parcelRequire("aDpmM");
class $ac09ff82049226d9$export$3c51073271a9eac3 extends (0, $hW7BM.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $5Bdpp.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $5Bdpp.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $5Bdpp.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $hW7BM.BasePageLoadMetric).FMP]) {
                const mark = (0, $gwwta.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $5Bdpp.pageLoadMetaMetric).markFMP(mark);
            } else (0, $5Bdpp.pageLoadMetaMetric).markFMP(this.marks[(0, $hW7BM.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $eBTRG.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $cQ9wm.submitter).queue(data);
        (0, $ayvjR.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $5Bdpp.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $5Bdpp.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $5Bdpp.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $cQ9wm.submitter).config.configChunk;
        if (!configChunk?.[(0, $b5Sjr.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $aDpmM.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $cQ9wm.submitter).queue(webVitalMetric.getData());
        (0, $ayvjR.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("aDpmM", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $8ed172f12932257b$export$dc0d85d4d6503cd7);

var $b5Sjr = parcelRequire("b5Sjr");

var $csrXc = parcelRequire("csrXc");
class $8ed172f12932257b$export$dc0d85d4d6503cd7 extends (0, $csrXc.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $b5Sjr.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $csrXc.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("2Z4Sf", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $4a8b857ad4ca646d$export$24c8bfcd77494cc1);

var $gwwta = parcelRequire("gwwta");

var $b5Sjr = parcelRequire("b5Sjr");

var $csrXc = parcelRequire("csrXc");

var $5LLU8 = parcelRequire("5LLU8");

var $5Bdpp = parcelRequire("5Bdpp");
class $4a8b857ad4ca646d$export$24c8bfcd77494cc1 extends (0, $5LLU8.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $5Bdpp.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4a8b857ad4ca646d$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4a8b857ad4ca646d$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $5Bdpp.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4a8b857ad4ca646d$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $gwwta.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $b5Sjr.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $csrXc.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $csrXc.MetricState).STARTED) (0, $5Bdpp.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("df4Sl", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $9a40753b2274e68f$export$1e511d4a378977f5, (v) => $9a40753b2274e68f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "defaultMemoize", () => $9a40753b2274e68f$export$281bff7f05488aa2, (v) => $9a40753b2274e68f$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $9a40753b2274e68f$export$5943f4447f6ef248, (v) => $9a40753b2274e68f$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $9a40753b2274e68f$export$75979cfcd91bf38f, (v) => $9a40753b2274e68f$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $9a40753b2274e68f$export$595d22ed68ca2841, (v) => $9a40753b2274e68f$export$595d22ed68ca2841 = v);
var $9a40753b2274e68f$export$1e511d4a378977f5;
var $9a40753b2274e68f$export$281bff7f05488aa2;
var $9a40753b2274e68f$export$5943f4447f6ef248;
var $9a40753b2274e68f$export$75979cfcd91bf38f;
var $9a40753b2274e68f$export$595d22ed68ca2841;
'use strict';
$9a40753b2274e68f$export$1e511d4a378977f5 = true;
$9a40753b2274e68f$export$281bff7f05488aa2 = $9a40753b2274e68f$var$defaultMemoize;
$9a40753b2274e68f$export$5943f4447f6ef248 = $9a40753b2274e68f$var$createSelectorCreator;
$9a40753b2274e68f$export$75979cfcd91bf38f = $9a40753b2274e68f$var$createStructuredSelector;
function $9a40753b2274e68f$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9a40753b2274e68f$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9a40753b2274e68f$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9a40753b2274e68f$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9a40753b2274e68f$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9a40753b2274e68f$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9a40753b2274e68f$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9a40753b2274e68f$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $9a40753b2274e68f$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9a40753b2274e68f$var$createSelector = $9a40753b2274e68f$export$595d22ed68ca2841 = $9a40753b2274e68f$var$createSelectorCreator($9a40753b2274e68f$var$defaultMemoize);
function $9a40753b2274e68f$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9a40753b2274e68f$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("iPaeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

$fKE23.__exportStar((parcelRequire("B4QHA")), module.exports);

});
parcelRegister("B4QHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesMeetConditions = void 0;

var $4VRD8 = parcelRequire("4VRD8");
var $06f737bb8ca63e5e$var$AND_OPERATION = 'and';
var $06f737bb8ca63e5e$var$OR_OPERATION = 'or';
var $06f737bb8ca63e5e$var$NOT_OPERATION = 'not';
var $06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS = [
    $06f737bb8ca63e5e$var$AND_OPERATION,
    $06f737bb8ca63e5e$var$OR_OPERATION,
    $06f737bb8ca63e5e$var$NOT_OPERATION
];
var $06f737bb8ca63e5e$var$SKIP_INSTRUCTION = 'skip';
var $06f737bb8ca63e5e$var$isObject = function(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
};
var $06f737bb8ca63e5e$var$unhandledOperation = function(operation) {
    throw new Error($4VRD8.errors.unhandledOperation(operation));
};
var $06f737bb8ca63e5e$var$checkOperation = function(conditionsInput, staticContextInput, operation, nesting) {
    if (nesting === void 0) nesting = 0;
    if (nesting >= 10) throw Error($4VRD8.errors.nestingOvercomplicated());
    var conditions = $06f737bb8ca63e5e$var$isObject(conditionsInput) ? conditionsInput : {};
    var staticContext = $06f737bb8ca63e5e$var$isObject(staticContextInput) ? staticContextInput : {};
    var staticKeys = Object.keys(conditions).filter(function(key) {
        return !$06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS.includes(key);
    });
    var operationEntries = Object.entries(conditions).filter(function(_a) {
        var key = _a[0];
        return $06f737bb8ca63e5e$var$SUPPORTED_OPERATIONS.includes(key);
    });
    var staticKeysLength = staticKeys.length;
    var operationsLength = operationEntries.length;
    var staticEqualityComparator = function(key) {
        return (Array.isArray(conditions[key]) ? conditions[key] : [
            conditions[key]
        ]).includes(staticContext[key]);
    };
    if (staticKeysLength === 0 && operationsLength === 0) return $06f737bb8ca63e5e$var$SKIP_INSTRUCTION;
    if (staticKeysLength !== 0) switch(operation){
        case $06f737bb8ca63e5e$var$AND_OPERATION:
            if (!staticKeys.every(staticEqualityComparator)) return false;
            break;
        case $06f737bb8ca63e5e$var$OR_OPERATION:
            if (staticKeys.some(staticEqualityComparator)) return true;
            break;
        case $06f737bb8ca63e5e$var$NOT_OPERATION:
            if (staticKeys.some(function(key) {
                return !staticEqualityComparator(key);
            })) return true;
            break;
        default:
            return $06f737bb8ca63e5e$var$unhandledOperation(operation);
    }
    for(var index = 0; index < operationEntries.length; index += 1){
        var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
        var nextOperationResult = $06f737bb8ca63e5e$var$checkOperation(nextConditions, staticContext, nextOperation, nesting + 1);
        switch(operation){
            case $06f737bb8ca63e5e$var$AND_OPERATION:
                if (nextOperationResult === false) return false;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : true;
                break;
            case $06f737bb8ca63e5e$var$OR_OPERATION:
                if (nextOperationResult === true) return true;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : false;
                break;
            case $06f737bb8ca63e5e$var$NOT_OPERATION:
                if (nextOperationResult === false) return true;
                if (nextOperationResult === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION && operationsLength === 1) return staticKeysLength === 0 ? $06f737bb8ca63e5e$var$SKIP_INSTRUCTION : false;
                break;
            default:
                return $06f737bb8ca63e5e$var$unhandledOperation(operation);
        }
    }
    switch(operation){
        case $06f737bb8ca63e5e$var$AND_OPERATION:
            return true;
        case $06f737bb8ca63e5e$var$OR_OPERATION:
            return false;
        case $06f737bb8ca63e5e$var$NOT_OPERATION:
            return false;
        default:
            return $06f737bb8ca63e5e$var$unhandledOperation(operation);
    }
};
module.exports.doesMeetConditions = function(conditions, staticContext) {
    try {
        var result = $06f737bb8ca63e5e$var$checkOperation(conditions, staticContext, $06f737bb8ca63e5e$var$AND_OPERATION);
        return result === $06f737bb8ca63e5e$var$SKIP_INSTRUCTION ? true : result;
    } catch (_a) {
        return false;
    }
};

});
parcelRegister("4VRD8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errors = void 0;
module.exports.errors = {
    nestingOvercomplicated: function() {
        return 'Nesting of display conditions exceeds 10 levels';
    },
    unhandledOperation: function(operation) {
        return "Unhandled operation: " + operation;
    }
};

});



parcelRegister("2y3XF", function(module, exports) {
module.exports = $1db1d460693008df$var$defaultsPlugin;
function $1db1d460693008df$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("gleLd", function(module, exports) {
var $be5a0ea507855c2a$var$namespace = 'expire_mixin';
module.exports = $be5a0ea507855c2a$var$expirePlugin;
function $be5a0ea507855c2a$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $be5a0ea507855c2a$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($be5a0ea507855c2a$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("ZGlKn", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $0b968c6645c3089e$var$slice = $7jNqu.slice;
var $0b968c6645c3089e$var$pluck = $7jNqu.pluck;
var $0b968c6645c3089e$var$each = $7jNqu.each;
var $0b968c6645c3089e$var$bind = $7jNqu.bind;
var $0b968c6645c3089e$var$create = $7jNqu.create;
var $0b968c6645c3089e$var$isList = $7jNqu.isList;
var $0b968c6645c3089e$var$isFunction = $7jNqu.isFunction;
var $0b968c6645c3089e$var$isObject = $7jNqu.isObject;
module.exports = {
    createStore: $0b968c6645c3089e$var$createStore
};
var $0b968c6645c3089e$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $0b968c6645c3089e$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $0b968c6645c3089e$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $0b968c6645c3089e$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $0b968c6645c3089e$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$0b968c6645c3089e$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$0b968c6645c3089e$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $0b968c6645c3089e$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $0b968c6645c3089e$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($0b968c6645c3089e$var$isList(plugin)) {
                $0b968c6645c3089e$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $0b968c6645c3089e$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$0b968c6645c3089e$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$0b968c6645c3089e$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $0b968c6645c3089e$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$0b968c6645c3089e$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $0b968c6645c3089e$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $0b968c6645c3089e$var$create(_privateStoreProps, $0b968c6645c3089e$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $0b968c6645c3089e$var$each(store, function(prop, propName) {
        if ($0b968c6645c3089e$var$isFunction(prop)) store.raw[propName] = $0b968c6645c3089e$var$bind(store, prop);
    });
    $0b968c6645c3089e$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $0b968c6645c3089e$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("7jNqu", function(module, exports) {
var $5540a5c51161c92f$var$assign = $5540a5c51161c92f$var$make_assign();
var $5540a5c51161c92f$var$create = $5540a5c51161c92f$var$make_create();
var $5540a5c51161c92f$var$trim = $5540a5c51161c92f$var$make_trim();
var $5540a5c51161c92f$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $5540a5c51161c92f$var$assign,
    create: $5540a5c51161c92f$var$create,
    trim: $5540a5c51161c92f$var$trim,
    bind: $5540a5c51161c92f$var$bind,
    slice: $5540a5c51161c92f$var$slice,
    each: $5540a5c51161c92f$var$each,
    map: $5540a5c51161c92f$var$map,
    pluck: $5540a5c51161c92f$var$pluck,
    isList: $5540a5c51161c92f$var$isList,
    isFunction: $5540a5c51161c92f$var$isFunction,
    isObject: $5540a5c51161c92f$var$isObject,
    Global: $5540a5c51161c92f$var$Global
};
function $5540a5c51161c92f$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$5540a5c51161c92f$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $5540a5c51161c92f$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $5540a5c51161c92f$var$slice(arguments, 1);
        return $5540a5c51161c92f$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $5540a5c51161c92f$var$slice(arguments, 1);
            F.prototype = obj;
            return $5540a5c51161c92f$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $5540a5c51161c92f$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $5540a5c51161c92f$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $5540a5c51161c92f$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $5540a5c51161c92f$var$each(obj, fn) {
    $5540a5c51161c92f$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $5540a5c51161c92f$var$map(obj, fn) {
    var res = $5540a5c51161c92f$var$isList(obj) ? [] : {};
    $5540a5c51161c92f$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $5540a5c51161c92f$var$pluck(obj, fn) {
    if ($5540a5c51161c92f$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $5540a5c51161c92f$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $5540a5c51161c92f$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $5540a5c51161c92f$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("5rWiD", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $3f7cb275f8e060aa$var$Global = $7jNqu.Global;
module.exports = {
    name: 'localStorage',
    read: $3f7cb275f8e060aa$var$read,
    write: $3f7cb275f8e060aa$var$write,
    each: $3f7cb275f8e060aa$var$each,
    remove: $3f7cb275f8e060aa$var$remove,
    clearAll: $3f7cb275f8e060aa$var$clearAll
};
function $3f7cb275f8e060aa$var$localStorage() {
    return $3f7cb275f8e060aa$var$Global.localStorage;
}
function $3f7cb275f8e060aa$var$read(key) {
    return $3f7cb275f8e060aa$var$localStorage().getItem(key);
}
function $3f7cb275f8e060aa$var$write(key, data) {
    return $3f7cb275f8e060aa$var$localStorage().setItem(key, data);
}
function $3f7cb275f8e060aa$var$each(fn) {
    for(var i = $3f7cb275f8e060aa$var$localStorage().length - 1; i >= 0; i--){
        var key = $3f7cb275f8e060aa$var$localStorage().key(i);
        fn($3f7cb275f8e060aa$var$read(key), key);
    }
}
function $3f7cb275f8e060aa$var$remove(key) {
    return $3f7cb275f8e060aa$var$localStorage().removeItem(key);
}
function $3f7cb275f8e060aa$var$clearAll() {
    return $3f7cb275f8e060aa$var$localStorage().clear();
}

});

parcelRegister("gpWeB", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $bf3c274d25fc0e14$var$read,
    write: $bf3c274d25fc0e14$var$write,
    each: $bf3c274d25fc0e14$var$each,
    remove: $bf3c274d25fc0e14$var$remove,
    clearAll: $bf3c274d25fc0e14$var$clearAll
};
var $bf3c274d25fc0e14$var$memoryStorage = {};
function $bf3c274d25fc0e14$var$read(key) {
    return $bf3c274d25fc0e14$var$memoryStorage[key];
}
function $bf3c274d25fc0e14$var$write(key, data) {
    $bf3c274d25fc0e14$var$memoryStorage[key] = data;
}
function $bf3c274d25fc0e14$var$each(callback) {
    for(var key in $bf3c274d25fc0e14$var$memoryStorage)if ($bf3c274d25fc0e14$var$memoryStorage.hasOwnProperty(key)) callback($bf3c274d25fc0e14$var$memoryStorage[key], key);
}
function $bf3c274d25fc0e14$var$remove(key) {
    delete $bf3c274d25fc0e14$var$memoryStorage[key];
}
function $bf3c274d25fc0e14$var$clearAll(key) {
    $bf3c274d25fc0e14$var$memoryStorage = {};
}

});

parcelRegister("6G5mG", function(module, exports) {

var $8uRtH = parcelRequire("8uRtH");

var $85YVZ = parcelRequire("85YVZ");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $4dcad3b0f5b12e6f$var$has(object, path) {
    return object != null && $85YVZ(object, path, $8uRtH);
}
module.exports = $4dcad3b0f5b12e6f$var$has;

});
parcelRegister("8uRtH", function(module, exports) {
/** Used for built-in method references. */ var $62fa9bac23574fbd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62fa9bac23574fbd$var$hasOwnProperty = $62fa9bac23574fbd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $62fa9bac23574fbd$var$baseHas(object, key) {
    return object != null && $62fa9bac23574fbd$var$hasOwnProperty.call(object, key);
}
module.exports = $62fa9bac23574fbd$var$baseHas;

});


parcelRegister("224h2", function(module, exports) {

var $6ZDS2 = parcelRequire("6ZDS2");

var $6aRM9 = parcelRequire("6aRM9");

var $ly0Gc = parcelRequire("ly0Gc");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $17af155c4b8942b9$var$flatRest(func) {
    return $ly0Gc($6aRM9(func, undefined, $6ZDS2), func + '');
}
module.exports = $17af155c4b8942b9$var$flatRest;

});

parcelRegister("kDfSL", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $a22cc5f9db02daee$export$c00d22927c60484a);

var $e8Y19 = parcelRequire("e8Y19");
class $a22cc5f9db02daee$export$c00d22927c60484a extends (0, $e8Y19.UFOAbstractExperience) {
}

});

parcelRegister("7PHyj", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $5b3f14712986d9ef$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5b3f14712986d9ef$var$isBoolean(value) {
    return value === true || value === false || $hYEMs(value) && $2OY5s(value) == $5b3f14712986d9ef$var$boolTag;
}
module.exports = $5b3f14712986d9ef$var$isBoolean;

});

parcelRegister("hvbu2", function(module, exports) {

var $8ua71 = parcelRequire("8ua71");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $cbde3d4cc86967f1$var$values(object) {
    return object == null ? [] : $8ua71(object, $8nrDO(object));
}
module.exports = $cbde3d4cc86967f1$var$values;

});
parcelRegister("8ua71", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $62d8f82e40088c8a$var$baseValues(object, props) {
    return $kJvGp(props, function(key) {
        return object[key];
    });
}
module.exports = $62d8f82e40088c8a$var$baseValues;

});


parcelRegister("53ciZ", function(module, exports) {

$parcel$export(module.exports, "extract", () => $3ad6c71f9180779f$export$f9380c9a627682d3, (v) => $3ad6c71f9180779f$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $3ad6c71f9180779f$export$98e6a39c04603d36, (v) => $3ad6c71f9180779f$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $3ad6c71f9180779f$export$fac44ee5b035f737, (v) => $3ad6c71f9180779f$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $3ad6c71f9180779f$export$7a5253c0f62e0150, (v) => $3ad6c71f9180779f$export$7a5253c0f62e0150 = v);
var $3ad6c71f9180779f$export$f9380c9a627682d3;
var $3ad6c71f9180779f$export$98e6a39c04603d36;
var $3ad6c71f9180779f$export$fac44ee5b035f737;
var $3ad6c71f9180779f$export$7a5253c0f62e0150;
'use strict';

var $bEWE2 = parcelRequire("bEWE2");

var $8aUjw = parcelRequire("8aUjw");

var $bJEvY = parcelRequire("bJEvY");
function $3ad6c71f9180779f$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[',
                    $3ad6c71f9180779f$var$encode(index, opts),
                    ']=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $3ad6c71f9180779f$var$encode(key, opts) : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '[]=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $3ad6c71f9180779f$var$encode(key, opts) : [
                    $3ad6c71f9180779f$var$encode(key, opts),
                    '=',
                    $3ad6c71f9180779f$var$encode(value, opts)
                ].join('');
            };
    }
}
function $3ad6c71f9180779f$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ad6c71f9180779f$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $bEWE2(value) : encodeURIComponent(value);
    return value;
}
function $3ad6c71f9180779f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $3ad6c71f9180779f$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $3ad6c71f9180779f$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $3ad6c71f9180779f$var$parse(str, opts) {
    opts = $8aUjw({
        arrayFormat: 'none'
    }, opts);
    var formatter = $3ad6c71f9180779f$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $bJEvY(val);
        formatter($bJEvY(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $3ad6c71f9180779f$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$3ad6c71f9180779f$export$f9380c9a627682d3 = $3ad6c71f9180779f$var$extract;
$3ad6c71f9180779f$export$98e6a39c04603d36 = $3ad6c71f9180779f$var$parse;
$3ad6c71f9180779f$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $8aUjw(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $3ad6c71f9180779f$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $3ad6c71f9180779f$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $3ad6c71f9180779f$var$encode(key, opts) + '=' + $3ad6c71f9180779f$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$3ad6c71f9180779f$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $3ad6c71f9180779f$var$parse($3ad6c71f9180779f$var$extract(str), opts)
    };
};

});
parcelRegister("bEWE2", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("8aUjw", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f3af0aacb50ec3b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f3af0aacb50ec3b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f3af0aacb50ec3b$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f3af0aacb50ec3b$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f3af0aacb50ec3b$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f3af0aacb50ec3b$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f3af0aacb50ec3b$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f3af0aacb50ec3b$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f3af0aacb50ec3b$var$getOwnPropertySymbols) {
            symbols = $5f3af0aacb50ec3b$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f3af0aacb50ec3b$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("5xY1g", function(module, exports) {

$parcel$export(module.exports, "choreographerFactory", () => $05a4857e7e09206d$export$55d2aeb17c4cfbe);

var $eUqFw = parcelRequire("eUqFw");

var $67SDP = parcelRequire("67SDP");

var $fIYfV = parcelRequire("fIYfV");

var $64C7F = parcelRequire("64C7F");
var $jL1So = parcelRequire("jL1So");
var $620QA = parcelRequire("620QA");
var $cMnpd = parcelRequire("cMnpd");
var $8ZogX = parcelRequire("8ZogX");
var $aqlFf = parcelRequire("aqlFf");
var $dsycF = parcelRequire("dsycF");
var $bGdKZ = parcelRequire("bGdKZ");
var $1DdZr = parcelRequire("1DdZr");
function $05a4857e7e09206d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $fIYfV.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $67SDP.MessageEventType).START]: startCallback, [(0, $67SDP.MessageEventType).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $eUqFw.useRef)(false);
        const startRef = (0, $eUqFw.useRef)(startCallback);
        const stopRef = (0, $eUqFw.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $eUqFw.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $eUqFw.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId,
            startMessageCallback
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $eUqFw.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $eUqFw.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $67SDP.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $eUqFw.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $eUqFw.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $eUqFw.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $67SDP.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $67SDP.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $eUqFw.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        return (0, $bGdKZ.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        });
        (0, $eUqFw.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessage();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $eUqFw.useLayoutEffect)(()=>{
                if (toggleablePropValue && !shouldRender) {
                    const startMessageAsync = async ()=>{
                        const disposition = await startMessage();
                        onMessageDisposition?.(disposition);
                    };
                    startMessageAsync();
                } else if (!toggleablePropValue && shouldRender) stopMessage();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessage();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $64C7F.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $jL1So.Banner));
    const Flag = wrapWithFactoryFunctions((0, $620QA.Flag));
    const Modal = wrapWithFactoryFunctions((0, $8ZogX.Modal));
    const Popper = wrapWithFactoryFunctions((0, $aqlFf.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $1DdZr.Spotlight));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $cMnpd.InlineDialog));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dsycF.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $dsycF.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight
    };
}

});
parcelRegister("fIYfV", function(module, exports) {

$parcel$export(module.exports, "ProductChoreographerPlugin", () => $be7ed095207fb131$export$44bee9c9373d59fb);

var $lpE0E = parcelRequire("lpE0E");
class $be7ed095207fb131$export$44bee9c9373d59fb extends (0, $lpE0E.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("64C7F", function(module, exports) {

$parcel$export(module.exports, "AutoDismissFlag", () => $a80ba506feb6b6b5$export$9879a8e0db317538);

var $3Oaez = parcelRequire("3Oaez");

var $bGdKZ = parcelRequire("bGdKZ");
const $a80ba506feb6b6b5$export$9879a8e0db317538 = (0, $bGdKZ.wrapComponentForChoreographer)((0, $3Oaez.default));

});

parcelRegister("jL1So", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $41d73a284475fb35$export$3b4e64e77073e307);

var $2CgwC = parcelRequire("2CgwC");

var $bGdKZ = parcelRequire("bGdKZ");
const $41d73a284475fb35$export$3b4e64e77073e307 = (0, $bGdKZ.wrapComponentForChoreographer)((0, $2CgwC.default));

});

parcelRegister("620QA", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $c718ce33ebbaebea$export$48ea269755562084);

var $4GEic = parcelRequire("4GEic");

var $bGdKZ = parcelRequire("bGdKZ");
const $c718ce33ebbaebea$export$48ea269755562084 = (0, $bGdKZ.wrapComponentForChoreographer)((0, $4GEic.default));

});

parcelRegister("cMnpd", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $b28f041625cacea7$export$c7313f750e9cbc9d);

var $29yDk = parcelRequire("29yDk");

var $bGdKZ = parcelRequire("bGdKZ");
const $b28f041625cacea7$export$c7313f750e9cbc9d = (0, $bGdKZ.wrapToggleableComponentForChoreographer)((0, $29yDk.default), 'isOpen');

});

parcelRegister("8ZogX", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $6f6a36d3251c982d$export$2b77a92f1a5ad772);

var $aOw1G = parcelRequire("aOw1G");

var $bGdKZ = parcelRequire("bGdKZ");
const $6f6a36d3251c982d$export$2b77a92f1a5ad772 = (0, $bGdKZ.wrapComponentForChoreographer)((0, $aOw1G.default));

});

parcelRegister("aqlFf", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $d8d4962805558e3e$export$badac9ada3a0bdf9);

var $i6BC8 = parcelRequire("i6BC8");

var $bGdKZ = parcelRequire("bGdKZ");
const $d8d4962805558e3e$export$badac9ada3a0bdf9 = (0, $bGdKZ.wrapComponentForChoreographer)((0, $i6BC8.Popper));

});

parcelRegister("dsycF", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $d804133cf4fe1538$export$129a32eedafa97c5);

var $3MV1G = parcelRequire("3MV1G");

var $bGdKZ = parcelRequire("bGdKZ");
const $d804133cf4fe1538$export$129a32eedafa97c5 = (0, $bGdKZ.wrapToggleableComponentForChoreographer)((0, $3MV1G.Popup), 'isOpen');

});

parcelRegister("1DdZr", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $2a3e9765351fb902$export$1033c28b5e1c2deb);

var $hJJD2 = parcelRequire("hJJD2");

var $bGdKZ = parcelRequire("bGdKZ");
const $2a3e9765351fb902$export$1033c28b5e1c2deb = (0, $bGdKZ.wrapComponentForChoreographer)((0, $hJJD2.default));

});


parcelRegister("lbDTY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j4VTi = parcelRequire("j4VTi");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f6c993b5d14dfd2e$var$_interopRequireDefault($j4VTi).default;
    }
});
function $f6c993b5d14dfd2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("j4VTi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $de3b4bf63375b073$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $de3b4bf63375b073$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $de3b4bf63375b073$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $de3b4bf63375b073$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $de3b4bf63375b073$var$NodeResolver = function(_Component) {
    $de3b4bf63375b073$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $de3b4bf63375b073$var$_classCallCheck(this, NodeResolver);
        return $de3b4bf63375b073$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $de3b4bf63375b073$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $lEfVV.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($eUqFw.Component);
module.exports.default = $de3b4bf63375b073$var$NodeResolver;

});


parcelRegister("6Pq2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8bb4caacfcbc85$export$2e2bcd8739ae039);

var $id9el = parcelRequire("id9el");

var $4f8bb4caacfcbc85$export$2e2bcd8739ae039 = (0, $id9el.default);

});
parcelRegister("id9el", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42099d57401c4cc$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $c16hR = parcelRequire("c16hR");

var $lzXvi = parcelRequire("lzXvi");
var $d42099d57401c4cc$var$FocusLockCombination = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $eUqFw.createElement((0, $c16hR.default), (0, $kU09D.default)({
        sideCar: (0, $lzXvi.default),
        ref: ref
    }, props));
});
var $d42099d57401c4cc$var$_ref = (0, $c16hR.default).propTypes || {}, $d42099d57401c4cc$var$sideCar = $d42099d57401c4cc$var$_ref.sideCar, $d42099d57401c4cc$var$propTypes = (0, $6XgOP.default)($d42099d57401c4cc$var$_ref, [
    "sideCar"
]);
$d42099d57401c4cc$var$FocusLockCombination.propTypes = {};
var $d42099d57401c4cc$export$2e2bcd8739ae039 = $d42099d57401c4cc$var$FocusLockCombination;

});
parcelRegister("c16hR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bfa747e7d11be41$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $9liOh = parcelRequire("9liOh");

var $kkWA2 = parcelRequire("kkWA2");

var $d2TZh = parcelRequire("d2TZh");

var $829XA = parcelRequire("829XA");

var $9Marc = parcelRequire("9Marc");
var $8bfa747e7d11be41$var$emptyArray = [];
var $8bfa747e7d11be41$var$FocusLock = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $eUqFw.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $eUqFw.useRef();
    var isActive = $eUqFw.useRef(false);
    var originalFocusedElement = $eUqFw.useRef(null);
    var _React$useState2 = $eUqFw.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $8bfa747e7d11be41$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $eUqFw.useState({}), id = _React$useState3[0];
    var onActivation = $eUqFw.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $eUqFw.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $eUqFw.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $eUqFw.useCallback(function(event) {
        if (isActive.current) (0, $829XA.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $829XA.mediumBlur).useMedium;
    var setObserveNode = $eUqFw.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $kU09D.default)((_extends2 = {}, _extends2[$9liOh.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$9liOh.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $kkWA2.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $eUqFw.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $d2TZh.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $d2TZh.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $eUqFw.createElement(SideCar, {
        id: id,
        sideCar: (0, $829XA.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $eUqFw.createElement(Container, (0, $kU09D.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $eUqFw.createElement((0, $9Marc.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $eUqFw.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $d2TZh.hiddenGuard)
    }));
});
$8bfa747e7d11be41$var$FocusLock.propTypes = {};
var $8bfa747e7d11be41$export$2e2bcd8739ae039 = $8bfa747e7d11be41$var$FocusLock;

});
parcelRegister("9liOh", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $6cd4aa7cfb25592a$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $6cd4aa7cfb25592a$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $6cd4aa7cfb25592a$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $6cd4aa7cfb25592a$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $6cd4aa7cfb25592a$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $6cd4aa7cfb25592a$export$4f9a06cb7441a087 = 'data-focus-lock';
var $6cd4aa7cfb25592a$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $6cd4aa7cfb25592a$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $6cd4aa7cfb25592a$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $6cd4aa7cfb25592a$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("kkWA2", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $ece31db3286b5afe$export$74665b213cb5c4cf);

var $eUqFw = parcelRequire("eUqFw");

var $iYh9J = parcelRequire("iYh9J");

var $kKhG5 = parcelRequire("kKhG5");
const $ece31db3286b5afe$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;
const $ece31db3286b5afe$var$currentValues = new WeakMap();
function $ece31db3286b5afe$export$74665b213cb5c4cf(refs, defaultValue) {
    const callbackRef = (0, $kKhG5.useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
    // handle refs changes - added or removed
    $ece31db3286b5afe$var$useIsomorphicLayoutEffect(()=>{
        const oldValue = $ece31db3286b5afe$var$currentValues.get(callbackRef);
        if (oldValue) {
            const prevRefs = new Set(oldValue);
            const nextRefs = new Set(refs);
            const current = callbackRef.current;
            prevRefs.forEach((ref)=>{
                if (!nextRefs.has(ref)) (0, $iYh9J.assignRef)(ref, null);
            });
            nextRefs.forEach((ref)=>{
                if (!prevRefs.has(ref)) (0, $iYh9J.assignRef)(ref, current);
            });
        }
        $ece31db3286b5afe$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("iYh9J", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $dcfb2365fcfb0cfb$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $dcfb2365fcfb0cfb$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("kKhG5", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $f1a5d0fa6fcab9e0$export$25bec8c6f54ee79a);

var $eUqFw = parcelRequire("eUqFw");
function $f1a5d0fa6fcab9e0$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $eUqFw.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("d2TZh", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $97f6e436e4415bf7$export$b8c7b07253306600);

var $eUqFw = parcelRequire("eUqFw");

var $97f6e436e4415bf7$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $97f6e436e4415bf7$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $97f6e436e4415bf7$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $97f6e436e4415bf7$export$b8c7b07253306600
    }));
};
$97f6e436e4415bf7$var$InFocusGuard.propTypes = {};
var $97f6e436e4415bf7$export$2e2bcd8739ae039 = $97f6e436e4415bf7$var$InFocusGuard;

});

parcelRegister("829XA", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $5d963c84baeb8294$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $5d963c84baeb8294$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $5d963c84baeb8294$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $5d963c84baeb8294$export$892cbf28e5518020);

var $j5xtV = parcelRequire("j5xtV");
var $5d963c84baeb8294$export$5733e022b1d538cb = (0, $j5xtV.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $5d963c84baeb8294$export$b3e9a9312f73723c = (0, $j5xtV.createMedium)();
var $5d963c84baeb8294$export$3a1d52767cbc07b8 = (0, $j5xtV.createMedium)();
var $5d963c84baeb8294$export$892cbf28e5518020 = (0, $j5xtV.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("j5xtV", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $de5874b68bebaf87$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $de5874b68bebaf87$export$e13ec7dd7a14088d);
function $de5874b68bebaf87$var$ItoI(a) {
    return a;
}
function $de5874b68bebaf87$var$innerCreateMedium(defaults, middleware = $de5874b68bebaf87$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $de5874b68bebaf87$export$9ffbfcaf067b02c6(defaults, middleware = $de5874b68bebaf87$var$ItoI) {
    return $de5874b68bebaf87$var$innerCreateMedium(defaults, middleware);
}
function $de5874b68bebaf87$export$e13ec7dd7a14088d(options = {}) {
    const medium = $de5874b68bebaf87$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}

});


parcelRegister("9Marc", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $71e0b17131af802f$export$f5272e9b1168239c);

var $eUqFw = parcelRequire("eUqFw");
var $71e0b17131af802f$export$f5272e9b1168239c = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("lzXvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb5b06146dfae6bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $hN291 = parcelRequire("hN291");

var $1S1Me = parcelRequire("1S1Me");
var $7VkAc = parcelRequire("7VkAc");
var $evhrg = parcelRequire("evhrg");
var $4Z1pG = parcelRequire("4Z1pG");
var $iQnjT = parcelRequire("iQnjT");parcelRequire("58RUg");
var $9NCWw = parcelRequire("9NCWw");

var $dhc7V = parcelRequire("dhc7V");

var $829XA = parcelRequire("829XA");
var $fb5b06146dfae6bc$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $fb5b06146dfae6bc$var$isFreeFocus = function isFreeFocus() {
    return $fb5b06146dfae6bc$var$focusOnBody() || (0, $iQnjT.focusIsHidden)();
};
var $fb5b06146dfae6bc$var$lastActiveTrap = null;
var $fb5b06146dfae6bc$var$lastActiveFocus = null;
var $fb5b06146dfae6bc$var$lastPortaledElement = null;
var $fb5b06146dfae6bc$var$focusWasOutsideWindow = false;
var $fb5b06146dfae6bc$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $fb5b06146dfae6bc$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($fb5b06146dfae6bc$var$lastActiveTrap.whiteList || $fb5b06146dfae6bc$var$defaultWhitelist)(activeElement);
};
var $fb5b06146dfae6bc$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $fb5b06146dfae6bc$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $fb5b06146dfae6bc$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $fb5b06146dfae6bc$var$lastPortaledElement && $fb5b06146dfae6bc$var$lastPortaledElement.portaledElement === element;
};
function $fb5b06146dfae6bc$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $fb5b06146dfae6bc$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($fb5b06146dfae6bc$var$focusWasOutsideWindow);
    return $fb5b06146dfae6bc$var$focusWasOutsideWindow === 'meanwhile';
};
var $fb5b06146dfae6bc$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $fb5b06146dfae6bc$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $fb5b06146dfae6bc$var$checkInHost(activeElement, area, area);
    });
};
var $fb5b06146dfae6bc$var$activateTrap = function activateTrap() {
    var result = false;
    if ($fb5b06146dfae6bc$var$lastActiveTrap) {
        var _lastActiveTrap = $fb5b06146dfae6bc$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $fb5b06146dfae6bc$var$lastPortaledElement && $fb5b06146dfae6bc$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $dhc7V.extractRef)).filter(Boolean));
            if (!activeElement || $fb5b06146dfae6bc$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $fb5b06146dfae6bc$var$focusWasOutside(crossFrame) || !$fb5b06146dfae6bc$var$isFreeFocus() || !$fb5b06146dfae6bc$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $4Z1pG.focusInside)(workingArea) || activeElement && $fb5b06146dfae6bc$var$withinHost(activeElement, workingArea) || $fb5b06146dfae6bc$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$fb5b06146dfae6bc$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9NCWw.moveFocusInside)(workingArea, $fb5b06146dfae6bc$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $fb5b06146dfae6bc$var$lastPortaledElement = {};
                        }
                    }
                    $fb5b06146dfae6bc$var$focusWasOutsideWindow = false;
                    $fb5b06146dfae6bc$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $7VkAc.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $fb5b06146dfae6bc$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $fb5b06146dfae6bc$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $fb5b06146dfae6bc$var$onTrap = function onTrap(event) {
    if ($fb5b06146dfae6bc$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $fb5b06146dfae6bc$var$onBlur = function onBlur() {
    return (0, $dhc7V.deferAction)($fb5b06146dfae6bc$var$activateTrap);
};
var $fb5b06146dfae6bc$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $fb5b06146dfae6bc$var$recordPortal(currentNode, source);
};
var $fb5b06146dfae6bc$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $fb5b06146dfae6bc$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        onBlur: $fb5b06146dfae6bc$var$onBlur,
        onFocus: $fb5b06146dfae6bc$var$onFocus
    }, children);
};
$fb5b06146dfae6bc$var$FocusTrap.propTypes = {};
var $fb5b06146dfae6bc$var$onWindowBlur = function onWindowBlur() {
    $fb5b06146dfae6bc$var$focusWasOutsideWindow = 'just';
    (0, $dhc7V.deferAction)(function() {
        $fb5b06146dfae6bc$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $fb5b06146dfae6bc$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $fb5b06146dfae6bc$var$onTrap);
    document.addEventListener('focusout', $fb5b06146dfae6bc$var$onBlur);
    window.addEventListener('blur', $fb5b06146dfae6bc$var$onWindowBlur);
};
var $fb5b06146dfae6bc$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $fb5b06146dfae6bc$var$onTrap);
    document.removeEventListener('focusout', $fb5b06146dfae6bc$var$onBlur);
    window.removeEventListener('blur', $fb5b06146dfae6bc$var$onWindowBlur);
};
function $fb5b06146dfae6bc$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $fb5b06146dfae6bc$var$focusLockAPI = {
    moveFocusInside: (0, $9NCWw.moveFocusInside),
    focusInside: (0, $4Z1pG.focusInside),
    focusNextElement: (0, $evhrg.focusNextElement),
    focusPrevElement: (0, $evhrg.focusPrevElement),
    focusFirstElement: (0, $evhrg.focusFirstElement),
    focusLastElement: (0, $evhrg.focusLastElement),
    captureFocusRestore: (0, $1S1Me.captureFocusRestore)
};
function $fb5b06146dfae6bc$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$fb5b06146dfae6bc$var$lastActiveTrap) $fb5b06146dfae6bc$var$attachHandler();
    var lastTrap = $fb5b06146dfae6bc$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $fb5b06146dfae6bc$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $fb5b06146dfae6bc$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($fb5b06146dfae6bc$var$focusLockAPI);
        $fb5b06146dfae6bc$var$activateTrap(true);
        (0, $dhc7V.deferAction)($fb5b06146dfae6bc$var$activateTrap);
    } else {
        $fb5b06146dfae6bc$var$detachHandler();
        $fb5b06146dfae6bc$var$lastActiveFocus = null;
    }
}
(0, $829XA.mediumFocus).assignSyncMedium($fb5b06146dfae6bc$var$onFocus);
(0, $829XA.mediumBlur).assignMedium($fb5b06146dfae6bc$var$onBlur);
(0, $829XA.mediumEffect).assignMedium(function(cb) {
    return cb($fb5b06146dfae6bc$var$focusLockAPI);
});
var $fb5b06146dfae6bc$export$2e2bcd8739ae039 = (0, $hN291.default)($fb5b06146dfae6bc$var$reducePropsToState, $fb5b06146dfae6bc$var$handleStateChangeOnClient)($fb5b06146dfae6bc$var$FocusWatcher);

});
parcelRegister("hN291", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf38ad1d35f9c2ff$export$2e2bcd8739ae039);

var $6MEf7 = parcelRequire("6MEf7");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $cf38ad1d35f9c2ff$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $6MEf7.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $eUqFw.PureComponent));
        (0, $5zQU9.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $cf38ad1d35f9c2ff$export$2e2bcd8739ae039 = $cf38ad1d35f9c2ff$var$withSideEffect;

});
parcelRegister("5zQU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f942638ae71eea$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $40f942638ae71eea$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $aM0Ke.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("aM0Ke", function(module, exports) {

$parcel$export(module.exports, "default", () => $02062d4611583e12$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $5AqK3 = parcelRequire("5AqK3");
function $02062d4611583e12$export$2e2bcd8739ae039(t) {
    var i = (0, $5AqK3.default)(t, "string");
    return "symbol" == (0, $5sKOb.default)(i) ? i : i + "";
}

});
parcelRegister("5sKOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3e077cf4a5296$export$2e2bcd8739ae039);
function $3fa3e077cf4a5296$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3fa3e077cf4a5296$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fa3e077cf4a5296$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5AqK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $41150ee4bca88606$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");
function $41150ee4bca88606$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5sKOb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5sKOb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("1S1Me", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $15cc367201b8b9de$export$d357db6e554ff59a);

var $86n2c = parcelRequire("86n2c");
function $15cc367201b8b9de$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $15cc367201b8b9de$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $15cc367201b8b9de$var$weakRef(currentElement),
            parent: $15cc367201b8b9de$var$weakRef(currentElement.parentElement),
            left: $15cc367201b8b9de$var$weakRef(currentElement.previousElementSibling),
            right: $15cc367201b8b9de$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $15cc367201b8b9de$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $15cc367201b8b9de$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $86n2c.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $15cc367201b8b9de$export$d357db6e554ff59a = function(targetElement) {
    var location = $15cc367201b8b9de$export$5061a7725be48ff9(targetElement);
    return function() {
        return $15cc367201b8b9de$var$restoreFocusTo(location);
    };
};

});
parcelRegister("86n2c", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $5e60c06bcf81da64$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $5e60c06bcf81da64$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $5e60c06bcf81da64$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $5e60c06bcf81da64$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $5e60c06bcf81da64$export$2344b14b097df817);

var $6iFou = parcelRequire("6iFou");

var $6KELS = parcelRequire("6KELS");

var $ioW3j = parcelRequire("ioW3j");

var $6Wn3C = parcelRequire("6Wn3C");
var $5e60c06bcf81da64$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $6iFou.toArray)(nodes).filter(function(node) {
        return (0, $6KELS.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $6KELS.notHiddenInput)(node);
    });
};
var $5e60c06bcf81da64$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $6iFou.toArray)(nodes).filter(function(node) {
        return (0, $6KELS.isAutoFocusAllowedCached)(cache, node);
    });
};
var $5e60c06bcf81da64$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $ioW3j.orderByTabIndex)($5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $5e60c06bcf81da64$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $ioW3j.orderByTabIndex)($5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getFocusables)(topNodes), visibilityCache), false);
};
var $5e60c06bcf81da64$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $5e60c06bcf81da64$export$6266a5cd5915dc33((0, $6Wn3C.getParentAutofocusables)(topNode), visibilityCache);
};
var $5e60c06bcf81da64$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $5e60c06bcf81da64$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $6iFou.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $5e60c06bcf81da64$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $5e60c06bcf81da64$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("6iFou", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $4964888380044e00$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $4964888380044e00$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $4964888380044e00$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $4964888380044e00$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $4964888380044e00$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $4964888380044e00$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("6KELS", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $4ea6aa497637ba8a$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $4ea6aa497637ba8a$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $4ea6aa497637ba8a$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $4ea6aa497637ba8a$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $4ea6aa497637ba8a$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $4ea6aa497637ba8a$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $4ea6aa497637ba8a$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $4ea6aa497637ba8a$export$4e62c701997796c1);

var $9liOh = parcelRequire("9liOh");
var $4ea6aa497637ba8a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $4ea6aa497637ba8a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $4ea6aa497637ba8a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $4ea6aa497637ba8a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $4ea6aa497637ba8a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $4ea6aa497637ba8a$var$isTopNode(node) || !$4ea6aa497637ba8a$var$isElementHidden(node) && !$4ea6aa497637ba8a$var$isInert(node) && checkParent($4ea6aa497637ba8a$var$getParentNode(node));
};
var $4ea6aa497637ba8a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $4ea6aa497637ba8a$var$isVisibleUncached(node, $4ea6aa497637ba8a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $4ea6aa497637ba8a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$4ea6aa497637ba8a$var$isTopNode(node) ? $4ea6aa497637ba8a$export$b8550e27de209d85(node) ? checkParent($4ea6aa497637ba8a$var$getParentNode(node)) : false : true;
};
var $4ea6aa497637ba8a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $4ea6aa497637ba8a$var$isAutoFocusAllowedUncached(node, $4ea6aa497637ba8a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $4ea6aa497637ba8a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $4ea6aa497637ba8a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $4ea6aa497637ba8a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $4ea6aa497637ba8a$export$9d74f6fbc6f469d0 = function(node) {
    return $4ea6aa497637ba8a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $4ea6aa497637ba8a$export$8197b0ea56b3b055 = function(node) {
    return !(($4ea6aa497637ba8a$export$88a6ceeed5737ba3(node) || $4ea6aa497637ba8a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $4ea6aa497637ba8a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $9liOh.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $4ea6aa497637ba8a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $4ea6aa497637ba8a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $4ea6aa497637ba8a$export$602e5a0d338d7750 = function(node) {
    return !$4ea6aa497637ba8a$export$d94b8b58ec2f30eb(node);
};
var $4ea6aa497637ba8a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("ioW3j", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $d6577fdd3d3f79b9$export$cb40ee071f0d5226);

var $6iFou = parcelRequire("6iFou");
var $d6577fdd3d3f79b9$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $d6577fdd3d3f79b9$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $d6577fdd3d3f79b9$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $6iFou.toArray)(nodes).map(function(node, index) {
        var tabIndex = $d6577fdd3d3f79b9$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($d6577fdd3d3f79b9$export$350ee6c095d98996);
};

});

parcelRegister("6Wn3C", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $50da0b8c8573a7aa$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $50da0b8c8573a7aa$export$853fa94d922e78b9);

var $9liOh = parcelRequire("9liOh");

var $6iFou = parcelRequire("6iFou");

var $2EctD = parcelRequire("2EctD");
var $50da0b8c8573a7aa$var$queryTabbables = (0, $2EctD.tabbables).join(',');
var $50da0b8c8573a7aa$var$queryGuardTabbables = "".concat($50da0b8c8573a7aa$var$queryTabbables, ", [data-focus-guard]");
var $50da0b8c8573a7aa$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $6iFou.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $50da0b8c8573a7aa$var$queryGuardTabbables : $50da0b8c8573a7aa$var$queryTabbables) ? [
            child
        ] : [], $50da0b8c8573a7aa$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $50da0b8c8573a7aa$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $50da0b8c8573a7aa$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $50da0b8c8573a7aa$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $50da0b8c8573a7aa$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $50da0b8c8573a7aa$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $6iFou.toArray)(parent.parentNode.querySelectorAll($50da0b8c8573a7aa$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $50da0b8c8573a7aa$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $9liOh.FOCUS_AUTO), "]"));
    return (0, $6iFou.toArray)(parentFocus).map(function(node) {
        return $50da0b8c8573a7aa$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("2EctD", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $1ed8fed9706ed342$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $1ed8fed9706ed342$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("7VkAc", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $5c4dd299f915357d$export$f89ac71e91767111);

var $InSZn = parcelRequire("InSZn");

var $6KELS = parcelRequire("6KELS");

var $4YYah = parcelRequire("4YYah");

var $ioW3j = parcelRequire("ioW3j");

var $6Wn3C = parcelRequire("6Wn3C");
var $5c4dd299f915357d$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $InSZn.getAllAffectedNodes)(topNode).filter((0, $6KELS.isNotAGuard));
    var commonParent = (0, $4YYah.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $ioW3j.orderByTabIndex)((0, $6Wn3C.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $6Wn3C.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $6KELS.isGuard)(node)
        };
    });
};

});
parcelRegister("InSZn", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $0856a36bcd3b2082$export$7e87c4720b9b279b);

var $9liOh = parcelRequire("9liOh");

var $6iFou = parcelRequire("6iFou");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $0856a36bcd3b2082$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $0856a36bcd3b2082$var$getTopParent = function(node) {
    return node.parentNode ? $0856a36bcd3b2082$var$getTopParent(node.parentNode) : node;
};
var $0856a36bcd3b2082$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $6iFou.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $9liOh.FOCUS_GROUP));
        acc.push.apply(acc, group ? $0856a36bcd3b2082$var$filterNested((0, $6iFou.toArray)($0856a36bcd3b2082$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $9liOh.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $9liOh.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("4YYah", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $3a0b6f8558d1c7f8$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $3a0b6f8558d1c7f8$export$8f99714c70a37db1);

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");
var $3a0b6f8558d1c7f8$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $3a0b6f8558d1c7f8$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $3a0b6f8558d1c7f8$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $3a0b6f8558d1c7f8$var$getParents(nodeA);
    var parentsB = $3a0b6f8558d1c7f8$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $3a0b6f8558d1c7f8$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $6iFou.asArray)(baseActiveElement);
    var leftEntries = (0, $6iFou.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $86n2c.contains)(common, topCommon)) topCommon = common;
                else topCommon = $3a0b6f8558d1c7f8$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $3a0b6f8558d1c7f8$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $86n2c.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("evhrg", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $a8f17ce5843b9ccd$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $a8f17ce5843b9ccd$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $a8f17ce5843b9ccd$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $a8f17ce5843b9ccd$export$6a79073ddabfd6c3);

var $5wzXm = parcelRequire("5wzXm");

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");
var $a8f17ce5843b9ccd$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $6iFou.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $86n2c.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $86n2c.getTabbableNodes)(shards, new Map()) : (0, $86n2c.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $a8f17ce5843b9ccd$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $86n2c.getTabbableNodes)((0, $6iFou.asArray)(shards), new Map()) : (0, $86n2c.getFocusableNodes)((0, $6iFou.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $a8f17ce5843b9ccd$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $a8f17ce5843b9ccd$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $a8f17ce5843b9ccd$var$defaultOptions(options);
    var solution = $a8f17ce5843b9ccd$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $5wzXm.focusOn)(target.node, newOptions.focusOptions);
};
var $a8f17ce5843b9ccd$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $a8f17ce5843b9ccd$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $a8f17ce5843b9ccd$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $a8f17ce5843b9ccd$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $5wzXm.focusOn)(node.node, options.focusOptions);
};
var $a8f17ce5843b9ccd$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$pickBoundary(scope, options, 'first');
};
var $a8f17ce5843b9ccd$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $a8f17ce5843b9ccd$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("5wzXm", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $405bd51e6199886f$export$c12b3da842c43a8);
var $405bd51e6199886f$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("4Z1pG", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $3a0df49206e81afa$export$20115f8da7baa6fa);

var $86n2c = parcelRequire("86n2c");

var $InSZn = parcelRequire("InSZn");

var $6iFou = parcelRequire("6iFou");

var $29N1l = parcelRequire("29N1l");
var $3a0df49206e81afa$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $3a0df49206e81afa$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $6iFou.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $3a0df49206e81afa$var$focusInFrame(node, activeElement);
    }));
};
var $3a0df49206e81afa$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $29N1l.getActiveElement)((0, $6iFou.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $InSZn.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $86n2c.contains)(node, activeElement) || $3a0df49206e81afa$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("29N1l", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $192272877e661b38$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $8Ypvn = parcelRequire("8Ypvn");
var $192272877e661b38$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $192272877e661b38$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $8Ypvn.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $192272877e661b38$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("8Ypvn", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $6887b6167779247b$export$78d20aae35adef88);
var $6887b6167779247b$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("iQnjT", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $db7f2c22dedf6fb3$export$be6b21806d3fd485);

var $9liOh = parcelRequire("9liOh");

var $86n2c = parcelRequire("86n2c");

var $6iFou = parcelRequire("6iFou");

var $29N1l = parcelRequire("29N1l");
var $db7f2c22dedf6fb3$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $29N1l.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $6iFou.toArray)(inDocument.querySelectorAll("[".concat((0, $9liOh.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $86n2c.contains)(node, activeElement);
    });
};

});

parcelRegister("58RUg", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9NCWw")).moveFocusInside);

var $9liOh = parcelRequire("9liOh");

var $4Z1pG = parcelRequire("4Z1pG");

var $iQnjT = parcelRequire("iQnjT");


var $7VkAc = parcelRequire("7VkAc");

var $9NCWw = parcelRequire("9NCWw");

var $1S1Me = parcelRequire("1S1Me");

var $evhrg = parcelRequire("evhrg");

var $86n2c = parcelRequire("86n2c");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $3be783d54e0ec6a9$export$1a988e7317c65621 = $9liOh;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $3be783d54e0ec6a9$var$deprecated_default_moveFocusInside = (0, $9NCWw.moveFocusInside);
var $3be783d54e0ec6a9$export$2e2bcd8739ae039 //
 = $3be783d54e0ec6a9$var$deprecated_default_moveFocusInside;

});
parcelRegister("9NCWw", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $7226e5eb175f5d23$export$cd599851e879a025);

var $5wzXm = parcelRequire("5wzXm");

var $bIplp = parcelRequire("bIplp");
var $7226e5eb175f5d23$var$guardCount = 0;
var $7226e5eb175f5d23$var$lockDisabled = false;
var $7226e5eb175f5d23$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $bIplp.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($7226e5eb175f5d23$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($7226e5eb175f5d23$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7226e5eb175f5d23$var$lockDisabled = true;
            setTimeout(function() {
                $7226e5eb175f5d23$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7226e5eb175f5d23$var$guardCount++;
        (0, $5wzXm.focusOn)(focusable.node, options.focusOptions);
        $7226e5eb175f5d23$var$guardCount--;
    }
};

});
parcelRegister("bIplp", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $887776a219b68cf0$export$305758c744b57f6f);

var $2v7o2 = parcelRequire("2v7o2");

var $86n2c = parcelRequire("86n2c");

var $InSZn = parcelRequire("InSZn");

var $6iFou = parcelRequire("6iFou");

var $3OLvr = parcelRequire("3OLvr");

var $29N1l = parcelRequire("29N1l");

var $6KELS = parcelRequire("6KELS");

var $4YYah = parcelRequire("4YYah");
var $887776a219b68cf0$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $6KELS.isDefined));
};
var $887776a219b68cf0$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $29N1l.getActiveElement)((0, $6iFou.asArray)(topNode).length > 0 ? document : (0, $6iFou.getFirst)(topNode).ownerDocument);
    var entries = (0, $InSZn.getAllAffectedNodes)(topNode).filter((0, $6KELS.isNotAGuard));
    var commonParent = (0, $4YYah.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $86n2c.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $6KELS.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $86n2c.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $887776a219b68cf0$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $2v7o2.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $2v7o2.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $3OLvr.pickAutofocus)(anyFocusable, innerTabbable, (0, $4YYah.allParentAutofocusables)(entries, visibilityCache)) || (0, $3OLvr.pickAutofocus)(anyFocusable, innerFocusables, (0, $4YYah.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("2v7o2", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $1d2434e0b90a992a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $1d2434e0b90a992a$export$65842178e9bb4205);

var $hxIhW = parcelRequire("hxIhW");

var $cbr4O = parcelRequire("cbr4O");

var $6KELS = parcelRequire("6KELS");
var $1d2434e0b90a992a$export$85710b12cf912438 = 'NEW_FOCUS';
var $1d2434e0b90a992a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $6KELS.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $1d2434e0b90a992a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $1d2434e0b90a992a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $hxIhW.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $cbr4O.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $cbr4O.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("hxIhW", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $cc57df7a0531e2f3$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $cc57df7a0531e2f3$export$4a5a72a7124e45f9);

var $6KELS = parcelRequire("6KELS");
var $cc57df7a0531e2f3$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $6KELS.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $cc57df7a0531e2f3$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $6KELS.isRadioElement)(node) && node.name) return $cc57df7a0531e2f3$var$findSelectedRadio(node, nodes);
    return node;
};
var $cc57df7a0531e2f3$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($cc57df7a0531e2f3$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("cbr4O", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $8deb83fb03cfe8f2$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $8deb83fb03cfe8f2$export$e06728ee87c96122);

var $hxIhW = parcelRequire("hxIhW");
var $8deb83fb03cfe8f2$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $hxIhW.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $8deb83fb03cfe8f2$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $hxIhW.correctNode)(node, nodes));
};

});


parcelRegister("3OLvr", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $2c7ae450a5f11ee7$export$cfb742983e257555);

var $86n2c = parcelRequire("86n2c");

var $cbr4O = parcelRequire("cbr4O");

var $6KELS = parcelRequire("6KELS");
var $2c7ae450a5f11ee7$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $6KELS.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $2c7ae450a5f11ee7$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $86n2c.filterAutoFocusable)(nodes.filter($2c7ae450a5f11ee7$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $cbr4O.pickFirstFocus)(autoFocusable);
    return (0, $cbr4O.pickFirstFocus)((0, $86n2c.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("dhc7V", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $9aa6450933a076b0$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $9aa6450933a076b0$export$c613fed06e332533);
function $9aa6450933a076b0$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $9aa6450933a076b0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $9aa6450933a076b0$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("96Gx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a15aa6e88393318$export$2e2bcd8739ae039);

var $c16hR = parcelRequire("c16hR");






var $6a15aa6e88393318$export$2e2bcd8739ae039 = (0, $c16hR.default);

});

parcelRegister("1TUfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $16269070d5096408$export$2e2bcd8739ae039);

var $5l9CX = parcelRequire("5l9CX");

var $16269070d5096408$export$2e2bcd8739ae039 = (0, $5l9CX.default);

});
parcelRegister("5l9CX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3661b532887b99$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $ii8SN = parcelRequire("ii8SN");

var $bvqX7 = parcelRequire("bvqX7");
var $3e3661b532887b99$var$FocusLockCombination = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $eUqFw.createElement((0, $ii8SN.default), (0, $kU09D.default)({
        sideCar: (0, $bvqX7.default),
        ref: ref
    }, props));
});
var $3e3661b532887b99$var$_ref = (0, $ii8SN.default).propTypes || {}, $3e3661b532887b99$var$sideCar = $3e3661b532887b99$var$_ref.sideCar, $3e3661b532887b99$var$propTypes = (0, $6XgOP.default)($3e3661b532887b99$var$_ref, [
    "sideCar"
]);
$3e3661b532887b99$var$FocusLockCombination.propTypes = {};
var $3e3661b532887b99$export$2e2bcd8739ae039 = $3e3661b532887b99$var$FocusLockCombination;

});
parcelRegister("ii8SN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d510cc61604e92be$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");


var $9liOh = parcelRequire("9liOh");

var $kkWA2 = parcelRequire("kkWA2");

var $huoK1 = parcelRequire("huoK1");

var $2Tp1B = parcelRequire("2Tp1B");

var $2wDtI = parcelRequire("2wDtI");
var $d510cc61604e92be$var$emptyArray = [];
var $d510cc61604e92be$var$FocusLock = /*#__PURE__*/ $eUqFw.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $eUqFw.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $eUqFw.useRef();
    var isActive = $eUqFw.useRef(false);
    var originalFocusedElement = $eUqFw.useRef(null);
    var _React$useState2 = $eUqFw.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $d510cc61604e92be$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $eUqFw.useState({}), id = _React$useState3[0];
    var onActivation = $eUqFw.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $eUqFw.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $eUqFw.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $eUqFw.useCallback(function(event) {
        if (isActive.current) (0, $2Tp1B.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $2Tp1B.mediumBlur).useMedium;
    var setObserveNode = $eUqFw.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $kU09D.default)((_extends2 = {}, _extends2[$9liOh.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$9liOh.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $kkWA2.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $eUqFw.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $huoK1.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $eUqFw.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $huoK1.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $eUqFw.createElement(SideCar, {
        id: id,
        sideCar: (0, $2Tp1B.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ $eUqFw.createElement(Container, (0, $kU09D.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $eUqFw.createElement((0, $2wDtI.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $eUqFw.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $huoK1.hiddenGuard)
    }));
});
$d510cc61604e92be$var$FocusLock.propTypes = {};
var $d510cc61604e92be$export$2e2bcd8739ae039 = $d510cc61604e92be$var$FocusLock;

});
parcelRegister("huoK1", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $cbb86e1bed42cbf7$export$b8c7b07253306600);

var $eUqFw = parcelRequire("eUqFw");

var $cbb86e1bed42cbf7$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $cbb86e1bed42cbf7$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $eUqFw.createElement($eUqFw.Fragment, null, /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cbb86e1bed42cbf7$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $eUqFw.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cbb86e1bed42cbf7$export$b8c7b07253306600
    }));
};
$cbb86e1bed42cbf7$var$InFocusGuard.propTypes = {};
var $cbb86e1bed42cbf7$export$2e2bcd8739ae039 = $cbb86e1bed42cbf7$var$InFocusGuard;

});

parcelRegister("2Tp1B", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $21b4214345489dc8$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $21b4214345489dc8$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $21b4214345489dc8$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $21b4214345489dc8$export$892cbf28e5518020);

var $j5xtV = parcelRequire("j5xtV");
var $21b4214345489dc8$export$5733e022b1d538cb = (0, $j5xtV.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $21b4214345489dc8$export$b3e9a9312f73723c = (0, $j5xtV.createMedium)();
var $21b4214345489dc8$export$3a1d52767cbc07b8 = (0, $j5xtV.createMedium)();
var $21b4214345489dc8$export$892cbf28e5518020 = (0, $j5xtV.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("2wDtI", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $1d6d317f3a502c2c$export$f5272e9b1168239c);

var $eUqFw = parcelRequire("eUqFw");
var $1d6d317f3a502c2c$export$f5272e9b1168239c = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("bvqX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $86077f302eb7d22b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $hN291 = parcelRequire("hN291");

var $1S1Me = parcelRequire("1S1Me");
var $7VkAc = parcelRequire("7VkAc");
var $evhrg = parcelRequire("evhrg");
var $4Z1pG = parcelRequire("4Z1pG");
var $iQnjT = parcelRequire("iQnjT");
var $86n2c = parcelRequire("86n2c");parcelRequire("58RUg");
var $9NCWw = parcelRequire("9NCWw");

var $6bB1i = parcelRequire("6bB1i");

var $2Tp1B = parcelRequire("2Tp1B");
var $86077f302eb7d22b$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $86077f302eb7d22b$var$isFreeFocus = function isFreeFocus() {
    return $86077f302eb7d22b$var$focusOnBody() || (0, $iQnjT.focusIsHidden)();
};
var $86077f302eb7d22b$var$lastActiveTrap = null;
var $86077f302eb7d22b$var$lastActiveFocus = null;
var $86077f302eb7d22b$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $86077f302eb7d22b$var$lastPortaledElement = null;
var $86077f302eb7d22b$var$focusWasOutsideWindow = false;
var $86077f302eb7d22b$var$windowFocused = false;
var $86077f302eb7d22b$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $86077f302eb7d22b$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($86077f302eb7d22b$var$lastActiveTrap.whiteList || $86077f302eb7d22b$var$defaultWhitelist)(activeElement);
};
var $86077f302eb7d22b$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $86077f302eb7d22b$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $86077f302eb7d22b$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $86077f302eb7d22b$var$lastPortaledElement && $86077f302eb7d22b$var$lastPortaledElement.portaledElement === element;
};
function $86077f302eb7d22b$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $86077f302eb7d22b$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($86077f302eb7d22b$var$focusWasOutsideWindow);
    return $86077f302eb7d22b$var$focusWasOutsideWindow === 'meanwhile';
};
var $86077f302eb7d22b$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $86077f302eb7d22b$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $86077f302eb7d22b$var$checkInHost(activeElement, area, area);
    });
};
var $86077f302eb7d22b$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $86n2c.getFocusableNodes)(nodes, new Map());
};
var $86077f302eb7d22b$var$isNotFocusable = function isNotFocusable(node) {
    return !$86077f302eb7d22b$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $86077f302eb7d22b$var$activateTrap = function activateTrap() {
    var result = false;
    if ($86077f302eb7d22b$var$lastActiveTrap) {
        var _lastActiveTrap = $86077f302eb7d22b$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $86077f302eb7d22b$var$lastPortaledElement && $86077f302eb7d22b$var$lastPortaledElement.portaledElement;
        if ($86077f302eb7d22b$var$focusOnBody() && $86077f302eb7d22b$var$lastActiveFocus) {
            if (!document.body.contains($86077f302eb7d22b$var$lastActiveFocus) || $86077f302eb7d22b$var$isNotFocusable($86077f302eb7d22b$var$lastActiveFocus)) {
                $86077f302eb7d22b$var$lastActiveFocus = null;
                var newTarget = $86077f302eb7d22b$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $6bB1i.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$86077f302eb7d22b$var$focusWasOutside(crossFrame) || !noFocusGuards || !$86077f302eb7d22b$var$lastActiveFocus || $86077f302eb7d22b$var$windowFocused) return false;
                var nodes = $86077f302eb7d22b$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $86077f302eb7d22b$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $86077f302eb7d22b$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$86077f302eb7d22b$var$isFreeFocus() || !$86077f302eb7d22b$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $4Z1pG.focusInside)(workingArea) || activeElement && $86077f302eb7d22b$var$withinHost(activeElement, workingArea) || $86077f302eb7d22b$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$86077f302eb7d22b$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9NCWw.moveFocusInside)(workingArea, $86077f302eb7d22b$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $86077f302eb7d22b$var$lastPortaledElement = {};
                        }
                    }
                    $86077f302eb7d22b$var$focusWasOutsideWindow = false;
                    $86077f302eb7d22b$var$lastActiveFocus = document && document.activeElement;
                    $86077f302eb7d22b$var$tryRestoreFocus = (0, $1S1Me.captureFocusRestore)($86077f302eb7d22b$var$lastActiveFocus);
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $7VkAc.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $86077f302eb7d22b$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $86077f302eb7d22b$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $86077f302eb7d22b$var$onTrap = function onTrap(event) {
    if ($86077f302eb7d22b$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $86077f302eb7d22b$var$onBlur = function onBlur() {
    return (0, $6bB1i.deferAction)($86077f302eb7d22b$var$activateTrap);
};
var $86077f302eb7d22b$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $86077f302eb7d22b$var$recordPortal(currentNode, source);
};
var $86077f302eb7d22b$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $86077f302eb7d22b$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        onBlur: $86077f302eb7d22b$var$onBlur,
        onFocus: $86077f302eb7d22b$var$onFocus
    }, children);
};
$86077f302eb7d22b$var$FocusTrap.propTypes = {};
var $86077f302eb7d22b$var$onWindowFocus = function onWindowFocus() {
    $86077f302eb7d22b$var$windowFocused = true;
};
var $86077f302eb7d22b$var$onWindowBlur = function onWindowBlur() {
    $86077f302eb7d22b$var$windowFocused = false;
    $86077f302eb7d22b$var$focusWasOutsideWindow = 'just';
    (0, $6bB1i.deferAction)(function() {
        $86077f302eb7d22b$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $86077f302eb7d22b$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $86077f302eb7d22b$var$onTrap);
    document.addEventListener('focusout', $86077f302eb7d22b$var$onBlur);
    window.addEventListener('focus', $86077f302eb7d22b$var$onWindowFocus);
    window.addEventListener('blur', $86077f302eb7d22b$var$onWindowBlur);
};
var $86077f302eb7d22b$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $86077f302eb7d22b$var$onTrap);
    document.removeEventListener('focusout', $86077f302eb7d22b$var$onBlur);
    window.removeEventListener('focus', $86077f302eb7d22b$var$onWindowFocus);
    window.removeEventListener('blur', $86077f302eb7d22b$var$onWindowBlur);
};
function $86077f302eb7d22b$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $86077f302eb7d22b$var$focusLockAPI = {
    moveFocusInside: (0, $9NCWw.moveFocusInside),
    focusInside: (0, $4Z1pG.focusInside),
    focusNextElement: (0, $evhrg.focusNextElement),
    focusPrevElement: (0, $evhrg.focusPrevElement),
    focusFirstElement: (0, $evhrg.focusFirstElement),
    focusLastElement: (0, $evhrg.focusLastElement),
    captureFocusRestore: (0, $1S1Me.captureFocusRestore)
};
function $86077f302eb7d22b$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$86077f302eb7d22b$var$lastActiveTrap) $86077f302eb7d22b$var$attachHandler();
    var lastTrap = $86077f302eb7d22b$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $86077f302eb7d22b$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $86077f302eb7d22b$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($86077f302eb7d22b$var$focusLockAPI);
        $86077f302eb7d22b$var$activateTrap(true);
        (0, $6bB1i.deferAction)($86077f302eb7d22b$var$activateTrap);
    } else {
        $86077f302eb7d22b$var$detachHandler();
        $86077f302eb7d22b$var$lastActiveFocus = null;
    }
}
(0, $2Tp1B.mediumFocus).assignSyncMedium($86077f302eb7d22b$var$onFocus);
(0, $2Tp1B.mediumBlur).assignMedium($86077f302eb7d22b$var$onBlur);
(0, $2Tp1B.mediumEffect).assignMedium(function(cb) {
    return cb($86077f302eb7d22b$var$focusLockAPI);
});
var $86077f302eb7d22b$export$2e2bcd8739ae039 = (0, $hN291.default)($86077f302eb7d22b$var$reducePropsToState, $86077f302eb7d22b$var$handleStateChangeOnClient)($86077f302eb7d22b$var$FocusWatcher);

});
parcelRegister("6bB1i", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $01298e653e6ac26a$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $01298e653e6ac26a$export$c613fed06e332533);
function $01298e653e6ac26a$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $01298e653e6ac26a$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $01298e653e6ac26a$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("8MHxr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4WeBZ = parcelRequire("4WeBZ");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $6654943a7fe9051b$var$_interopRequireDefault($4WeBZ).default;
    }
});

var $bJ1LD = parcelRequire("bJ1LD");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $bJ1LD.TouchScrollable;
    }
});
function $6654943a7fe9051b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4WeBZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3987e9cf0414f409$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $3987e9cf0414f409$var$_react2 = $3987e9cf0414f409$var$_interopRequireDefault($eUqFw);

var $kQ44K = parcelRequire("kQ44K");

var $bJ1LD = parcelRequire("bJ1LD");

var $hLKOl = parcelRequire("hLKOl");
var $3987e9cf0414f409$var$_withLockSheet2 = $3987e9cf0414f409$var$_interopRequireDefault($hLKOl);

var $6sZKb = parcelRequire("6sZKb");
var $3987e9cf0414f409$var$_withTouchListeners2 = $3987e9cf0414f409$var$_interopRequireDefault($6sZKb);

var $bUSBK = parcelRequire("bUSBK");
function $3987e9cf0414f409$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3987e9cf0414f409$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3987e9cf0414f409$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3987e9cf0414f409$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3987e9cf0414f409$var$ScrollLock = function(_PureComponent) {
    $3987e9cf0414f409$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $3987e9cf0414f409$var$_classCallCheck(this, ScrollLock);
        return $3987e9cf0414f409$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $3987e9cf0414f409$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kQ44K.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $3987e9cf0414f409$var$_react2.default.createElement($bJ1LD.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($eUqFw.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $3987e9cf0414f409$var$compose = (0, $bUSBK.pipe)($3987e9cf0414f409$var$_withTouchListeners2.default, $3987e9cf0414f409$var$_withLockSheet2.default);
var $3987e9cf0414f409$var$SheetLock = $3987e9cf0414f409$var$compose($3987e9cf0414f409$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $3987e9cf0414f409$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $3987e9cf0414f409$var$_react2.default.createElement($3987e9cf0414f409$var$SheetLock, props) : props.children;
};
$3987e9cf0414f409$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $3987e9cf0414f409$var$LockToggle;

});
parcelRegister("kQ44K", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("bJ1LD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $889544a197fa4954$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $889544a197fa4954$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $bUSBK = parcelRequire("bUSBK");
function $889544a197fa4954$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $889544a197fa4954$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $889544a197fa4954$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $889544a197fa4954$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $889544a197fa4954$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $889544a197fa4954$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $889544a197fa4954$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $889544a197fa4954$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $889544a197fa4954$var$_possibleConstructorReturn(_this, _ret);
    }
    $889544a197fa4954$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kQ44K.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $bUSBK.preventInertiaScroll, $bUSBK.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $bUSBK.allowTouchMove, $bUSBK.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$kQ44K.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $bUSBK.preventInertiaScroll, $bUSBK.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $bUSBK.allowTouchMove, $bUSBK.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $889544a197fa4954$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $eUqFw.cloneElement)(children, $889544a197fa4954$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($eUqFw.PureComponent);

});
parcelRegister("bUSBK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $8acf48ac1a508f0a$var$preventTouchMove;
module.exports.allowTouchMove = $8acf48ac1a508f0a$var$allowTouchMove;
module.exports.preventInertiaScroll = $8acf48ac1a508f0a$var$preventInertiaScroll;
module.exports.isTouchDevice = $8acf48ac1a508f0a$var$isTouchDevice;
module.exports.camelToKebab = $8acf48ac1a508f0a$var$camelToKebab;
module.exports.parse = $8acf48ac1a508f0a$var$parse;
module.exports.getPadding = $8acf48ac1a508f0a$var$getPadding;
module.exports.getWindowHeight = $8acf48ac1a508f0a$var$getWindowHeight;
module.exports.getDocumentHeight = $8acf48ac1a508f0a$var$getDocumentHeight;
module.exports.makeStyleTag = $8acf48ac1a508f0a$var$makeStyleTag;
module.exports.injectStyles = $8acf48ac1a508f0a$var$injectStyles;
module.exports.insertStyleTag = $8acf48ac1a508f0a$var$insertStyleTag;

var $kQ44K = parcelRequire("kQ44K");
var $8acf48ac1a508f0a$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $8acf48ac1a508f0a$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $8acf48ac1a508f0a$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $8acf48ac1a508f0a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8acf48ac1a508f0a$var$isTouchDevice() {
    if (!$kQ44K.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $8acf48ac1a508f0a$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $8acf48ac1a508f0a$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $8acf48ac1a508f0a$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $8acf48ac1a508f0a$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($8acf48ac1a508f0a$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $8acf48ac1a508f0a$var$getPadding() {
    if (!$kQ44K.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $8acf48ac1a508f0a$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($kQ44K.canUseDOM) return window.innerHeight * multiplier;
}
function $8acf48ac1a508f0a$var$getDocumentHeight() {
    if ($kQ44K.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $8acf48ac1a508f0a$var$makeStyleTag() {
    if (!$kQ44K.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $8acf48ac1a508f0a$var$injectStyles(tag, css) {
    if (!$kQ44K.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $8acf48ac1a508f0a$var$insertStyleTag(tag) {
    if (!$kQ44K.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("hLKOl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cefb231f4a7a20a5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $cefb231f4a7a20a5$var$withLockSheet;

var $eUqFw = parcelRequire("eUqFw");
var $cefb231f4a7a20a5$var$_react2 = $cefb231f4a7a20a5$var$_interopRequireDefault($eUqFw);

var $bUSBK = parcelRequire("bUSBK");
function $cefb231f4a7a20a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cefb231f4a7a20a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cefb231f4a7a20a5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cefb231f4a7a20a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $cefb231f4a7a20a5$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $cefb231f4a7a20a5$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $cefb231f4a7a20a5$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $cefb231f4a7a20a5$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $bUSBK.makeStyleTag)();
                if (!sheet) return;
                (0, $bUSBK.injectStyles)(sheet, styles);
                (0, $bUSBK.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $bUSBK.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $bUSBK.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $cefb231f4a7a20a5$var$_possibleConstructorReturn(_this, _ret);
        }
        $cefb231f4a7a20a5$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $cefb231f4a7a20a5$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($eUqFw.PureComponent);
}

});

parcelRegister("6sZKb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4b5540a16c16631f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $4b5540a16c16631f$var$withTouchListeners;

var $eUqFw = parcelRequire("eUqFw");
var $4b5540a16c16631f$var$_react2 = $4b5540a16c16631f$var$_interopRequireDefault($eUqFw);

var $kQ44K = parcelRequire("kQ44K");

var $bUSBK = parcelRequire("bUSBK");
function $4b5540a16c16631f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b5540a16c16631f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4b5540a16c16631f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4b5540a16c16631f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $4b5540a16c16631f$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $4b5540a16c16631f$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $4b5540a16c16631f$var$_classCallCheck(this, TouchProvider);
            return $4b5540a16c16631f$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $4b5540a16c16631f$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$kQ44K.canUseDOM || !(0, $bUSBK.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $bUSBK.preventTouchMove, $bUSBK.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$kQ44K.canUseDOM || !(0, $bUSBK.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $bUSBK.preventTouchMove, $bUSBK.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $4b5540a16c16631f$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($eUqFw.PureComponent);
}

});



parcelRegister("hwTa5", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("d8Wyj")).monitorForExternal);

var $d8Wyj = parcelRequire("d8Wyj");

});
parcelRegister("d8Wyj", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => $20a15c8e8b8cdbee$export$bb1740f3194979c1);

var $74BVL = parcelRequire("74BVL");

var $4PCWk = parcelRequire("4PCWk");

var $eDT75 = parcelRequire("eDT75");

var $c1r0x = parcelRequire("c1r0x");

var $fURjR = parcelRequire("fURjR");


function $20a15c8e8b8cdbee$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $4df75fb0870d0fce$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $559dbbdafee2f66d$export$fd3d00026297c0ad) && value === (0, $eDT75.androidFallbackText)) return false;
    return true;
}
function $20a15c8e8b8cdbee$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$20a15c8e8b8cdbee$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $20a15c8e8b8cdbee$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $20a15c8e8b8cdbee$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $20a15c8e8b8cdbee$var$didDragStartLocally = false;
const $20a15c8e8b8cdbee$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $74BVL.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($20a15c8e8b8cdbee$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $c1r0x.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $20a15c8e8b8cdbee$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $20a15c8e8b8cdbee$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$20a15c8e8b8cdbee$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $20a15c8e8b8cdbee$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $20a15c8e8b8cdbee$var$adapter.dropTarget(args);
}
function $20a15c8e8b8cdbee$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $20a15c8e8b8cdbee$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $20a15c8e8b8cdbee$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $20a15c8e8b8cdbee$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $74BVL.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $fURjR.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $74BVL.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $20a15c8e8b8cdbee$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("c1r0x", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $7a2d52d2fb986fd7$export$d1c6f249e893cdf4);

var $enquP = parcelRequire("enquP");

var $Fx8Dp = parcelRequire("Fx8Dp");

var $jivNo = parcelRequire("jivNo");

var $ehWpG = parcelRequire("ehWpG");
function $7a2d52d2fb986fd7$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $Fx8Dp.isSafari)()) return (0, $jivNo.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $enquP.isFirefox)()) return (0, $ehWpG.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("d6uEr", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("9FZ6n")).monitorForTextSelection);

var $9FZ6n = parcelRequire("9FZ6n");

});
parcelRegister("9FZ6n", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $9fb780febd4b5d1e$export$2e178e3647f5e6e9);

var $74BVL = parcelRequire("74BVL");

var $8pyWR = parcelRequire("8pyWR");

var $4PCWk = parcelRequire("4PCWk");

var $jFl9L = parcelRequire("jFl9L");

var $Fx8Dp = parcelRequire("Fx8Dp");



function $9fb780febd4b5d1e$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $Fx8Dp.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $9fb780febd4b5d1e$var$honeyPotFix = (0, $8pyWR.makeHoneyPotFix)();
const $9fb780febd4b5d1e$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $jFl9L.combine)($9fb780febd4b5d1e$var$honeyPotFix.bindEvents(), (0, $74BVL.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $4df75fb0870d0fce$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $559dbbdafee2f66d$export$fd3d00026297c0ad))) return;
                const target = $9fb780febd4b5d1e$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $e9758b1921dfdebb$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $9fb780febd4b5d1e$var$honeyPotFix.getOnPostDispatch()
});
function $9fb780febd4b5d1e$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $9fb780febd4b5d1e$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $9fb780febd4b5d1e$var$adapter.registerUsage();
})();
function $9fb780febd4b5d1e$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $9fb780febd4b5d1e$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $e9758b1921dfdebb$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("a2Ury", function(module, exports) {

var $k7fXr = parcelRequire("k7fXr");
var $7505dfc8e879aec6$var$listeningFocusTrap = null;
function $7505dfc8e879aec6$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $7505dfc8e879aec6$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($7505dfc8e879aec6$var$listeningFocusTrap) $7505dfc8e879aec6$var$listeningFocusTrap.pause();
        $7505dfc8e879aec6$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $7505dfc8e879aec6$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $7505dfc8e879aec6$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $7505dfc8e879aec6$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $7505dfc8e879aec6$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $7505dfc8e879aec6$var$tryFocus(lastTabbableNode);
            return $7505dfc8e879aec6$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $7505dfc8e879aec6$var$tryFocus(firstTabbableNode);
        $7505dfc8e879aec6$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $k7fXr(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $7505dfc8e879aec6$var$tryFocus(lastTabbableNode);
        $7505dfc8e879aec6$var$tryFocus(firstTabbableNode);
    }
}
function $7505dfc8e879aec6$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $7505dfc8e879aec6$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $7505dfc8e879aec6$var$focusTrap;

});
parcelRegister("k7fXr", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ea50d6f71335097e$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ea50d6f71335097e$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("k7cZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4e8918d9e7eef9$export$2e2bcd8739ae039);

var $luZsm = parcelRequire("luZsm");
function $ea4e8918d9e7eef9$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $ea4e8918d9e7eef9$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $ea4e8918d9e7eef9$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($ea4e8918d9e7eef9$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $ea4e8918d9e7eef9$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($ea4e8918d9e7eef9$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $luZsm.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $ea4e8918d9e7eef9$var$getOptions(options);
    return $ea4e8918d9e7eef9$var$defaultBehavior((0, $luZsm.default)(target, computeOptions), computeOptions.behavior);
}
var $ea4e8918d9e7eef9$export$2e2bcd8739ae039 = $ea4e8918d9e7eef9$var$scrollIntoView;

});
parcelRegister("luZsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6c124618acde79$export$2e2bcd8739ae039);
function $fa6c124618acde79$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $fa6c124618acde79$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $fa6c124618acde79$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $fa6c124618acde79$var$isHiddenByFrame(el) {
    var frame = $fa6c124618acde79$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $fa6c124618acde79$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $fa6c124618acde79$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $fa6c124618acde79$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $fa6c124618acde79$var$isHiddenByFrame(el);
    }
    return false;
}
function $fa6c124618acde79$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $fa6c124618acde79$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$fa6c124618acde79$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($fa6c124618acde79$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $fa6c124618acde79$var$isScrollable(cursor) && !$fa6c124618acde79$var$isScrollable(document.documentElement)) continue;
        if ($fa6c124618acde79$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $fa6c124618acde79$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $fa6c124618acde79$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $fa6c124618acde79$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $fa6c124618acde79$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("awwEG", function(module, exports) {

$parcel$export(module.exports, "PendoChoreographerPlugin", () => $cdacd5c911e10af8$export$3390a677f4025523);

var $67SDP = parcelRequire("67SDP");

var $lpE0E = parcelRequire("lpE0E");
class $cdacd5c911e10af8$export$3390a677f4025523 extends (0, $lpE0E.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $67SDP.ProductIds).PENDO, envType, metaMetricsData);
        this.currentMessageId = '';
        this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("9t7rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c99d1e49d5bdb$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $6e4c99d1e49d5bdb$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("5crv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8807e53b93f719$export$2e2bcd8739ae039);

var $aAo2q = parcelRequire("aAo2q");
var $0e8807e53b93f719$export$2e2bcd8739ae039 = (0, $aAo2q.default);

});
parcelRegister("aAo2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6615b2d932d14b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9oL1R = parcelRequire("9oL1R");

var $hompL = parcelRequire("hompL");

var $66aNr = parcelRequire("66aNr");

var $fTZm7 = parcelRequire("fTZm7");

var $baC3k = parcelRequire("baC3k");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $41dmJ = parcelRequire("41dmJ");

var $6KSRl = parcelRequire("6KSRl");
let $c6615b2d932d14b4$var$tryCompleteHandle;

const $c6615b2d932d14b4$var$AsyncSegmentHighlight = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("ffuK9")).then((module)=>({
            default: module.SegmentHighlight
        })));
function $c6615b2d932d14b4$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    const parentContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const segmentId = (0, $eUqFw.useMemo)(()=>(0, $6KSRl.default)(), []);
    const labelStack = (0, $eUqFw.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ], [
        parentContext,
        segmentName,
        segmentId
    ]);
    const interactionId = (0, $eUqFw.useContext)((0, $51JrV.default));
    const interactionContext = (0, $eUqFw.useMemo)(()=>{
        (0, $fYqUr.addSegment)(labelStack);
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($c6615b2d932d14b4$var$tryCompleteHandle) cancelAnimationFrame?.($c6615b2d932d14b4$var$tryCompleteHandle);
                    (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_NormalPriority), ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $c6615b2d932d14b4$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $c6615b2d932d14b4$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $fYqUr.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $fYqUr.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    });
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $fYqUr.addHold)(interactionId.current, labelStack, name);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $fYqUr.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $fYqUr.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                if (interactionId.current != null) (0, $fYqUr.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $fTZm7.getInteractionRate)(name, 'press');
                if ((0, $66aNr.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    const newId = (0, $hompL.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $baC3k.setInteractionActiveTrace)(newId, 'press');
                    (0, $fYqUr.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $41dmJ.default).current, (0, $baC3k.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $fYqUr.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $fYqUr.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $fYqUr.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $fYqUr.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $fYqUr.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $fYqUr.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $fYqUr.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $fYqUr.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        interactionId
    ]);
    const onRender = (0, $eUqFw.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            (0, $fYqUr.removeSegment)(labelStack);
        }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $eUqFw.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    const enableSegmentHighlighting = (0, $fTZm7.getConfig)()?.enableSegmentHighlighting;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Hphq.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children, enableSegmentHighlighting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6615b2d932d14b4$var$AsyncSegmentHighlight, {
        segmentName: segmentName
    }))));
}

});
parcelRegister("6KSRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c72df03463e0769$export$2e2bcd8739ae039);
function $6c72df03463e0769$export$2e2bcd8739ae039(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}

});

parcelRegister("ffuK9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bHr9o").then(()=>parcelRequire('8C2hd'));

});
parcelRegister("d1Cng", function(module, exports) {
"use strict";

function $97b922b3683b5ed5$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("2MVa4")).resolve(id));
}
module.exports = $97b922b3683b5ed5$var$load;

});
parcelRegister("2MVa4", function(module, exports) {

$parcel$export(module.exports, "register", () => $207c67878e5e04f0$export$6503ec6e8aabbaf, (v) => $207c67878e5e04f0$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $207c67878e5e04f0$export$f7ad0328861e2f03, (v) => $207c67878e5e04f0$export$f7ad0328861e2f03 = v);
var $207c67878e5e04f0$export$6503ec6e8aabbaf;
var $207c67878e5e04f0$export$f7ad0328861e2f03;
"use strict";
var $207c67878e5e04f0$var$mapping = new Map();
function $207c67878e5e04f0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$207c67878e5e04f0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $207c67878e5e04f0$var$resolve(id) {
    var resolved = $207c67878e5e04f0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$207c67878e5e04f0$export$6503ec6e8aabbaf = $207c67878e5e04f0$var$register;
$207c67878e5e04f0$export$f7ad0328861e2f03 = $207c67878e5e04f0$var$resolve;

});





parcelRegister("c8Guq", function(module, exports) {

var $fpEqY = parcelRequire("fpEqY");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $8d6730f25ee9d2fa$var$flow = $fpEqY();
module.exports = $8d6730f25ee9d2fa$var$flow;

});
parcelRegister("fpEqY", function(module, exports) {

var $9xdpl = parcelRequire("9xdpl");

var $224h2 = parcelRequire("224h2");

var $6bTTb = parcelRequire("6bTTb");

var $hNaPv = parcelRequire("hNaPv");

var $1c8hB = parcelRequire("1c8hB");

var $cp9gS = parcelRequire("cp9gS");
/** Error message constants. */ var $b3888e314dbeb79d$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $b3888e314dbeb79d$var$WRAP_CURRY_FLAG = 8, $b3888e314dbeb79d$var$WRAP_PARTIAL_FLAG = 32, $b3888e314dbeb79d$var$WRAP_ARY_FLAG = 128, $b3888e314dbeb79d$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $b3888e314dbeb79d$var$createFlow(fromRight) {
    return $224h2(function(funcs) {
        var length = funcs.length, index = length, prereq = $9xdpl.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($b3888e314dbeb79d$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $hNaPv(func) == 'wrapper') var wrapper = new $9xdpl([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $hNaPv(func), data = funcName == 'wrapper' ? $6bTTb(func) : undefined;
            if (data && $cp9gS(data[0]) && data[1] == ($b3888e314dbeb79d$var$WRAP_ARY_FLAG | $b3888e314dbeb79d$var$WRAP_CURRY_FLAG | $b3888e314dbeb79d$var$WRAP_PARTIAL_FLAG | $b3888e314dbeb79d$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$hNaPv(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $cp9gS(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $1c8hB(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $b3888e314dbeb79d$var$createFlow;

});
parcelRegister("9xdpl", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $2YyaX = parcelRequire("2YyaX");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $6f1198a73916bb8b$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$6f1198a73916bb8b$var$LodashWrapper.prototype = $9F9XB($2YyaX.prototype);
$6f1198a73916bb8b$var$LodashWrapper.prototype.constructor = $6f1198a73916bb8b$var$LodashWrapper;
module.exports = $6f1198a73916bb8b$var$LodashWrapper;

});
parcelRegister("2YyaX", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $22abb1f8c23ed823$var$baseLodash() {
// No operation performed.
}
module.exports = $22abb1f8c23ed823$var$baseLodash;

});


parcelRegister("6bTTb", function(module, exports) {

var $beYtW = parcelRequire("beYtW");

var $jG2Eu = parcelRequire("jG2Eu");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $481f1f8dc967c82b$var$getData = !$beYtW ? $jG2Eu : function(func) {
    return $beYtW.get(func);
};
module.exports = $481f1f8dc967c82b$var$getData;

});
parcelRegister("beYtW", function(module, exports) {

var $dFXwz = parcelRequire("dFXwz");
/** Used to store function metadata. */ var $82efeaf6ac20d822$var$metaMap = $dFXwz && new $dFXwz;
module.exports = $82efeaf6ac20d822$var$metaMap;

});


parcelRegister("hNaPv", function(module, exports) {

var $g25CO = parcelRequire("g25CO");
/** Used for built-in method references. */ var $cf3f69db4573ada3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cf3f69db4573ada3$var$hasOwnProperty = $cf3f69db4573ada3$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $cf3f69db4573ada3$var$getFuncName(func) {
    var result = func.name + '', array = $g25CO[result], length = $cf3f69db4573ada3$var$hasOwnProperty.call($g25CO, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $cf3f69db4573ada3$var$getFuncName;

});
parcelRegister("g25CO", function(module, exports) {
/** Used to lookup unminified function names. */ var $bac1323da4446d2f$var$realNames = {};
module.exports = $bac1323da4446d2f$var$realNames;

});


parcelRegister("cp9gS", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $6bTTb = parcelRequire("6bTTb");

var $hNaPv = parcelRequire("hNaPv");

var $bqBQL = parcelRequire("bqBQL");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $907f02e660ccd17b$var$isLaziable(func) {
    var funcName = $hNaPv(func), other = $bqBQL[funcName];
    if (typeof other != 'function' || !(funcName in $jZYVT.prototype)) return false;
    if (func === other) return true;
    var data = $6bTTb(other);
    return !!data && func === data[0];
}
module.exports = $907f02e660ccd17b$var$isLaziable;

});
parcelRegister("jZYVT", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $2YyaX = parcelRequire("2YyaX");
/** Used as references for the maximum length and index of an array. */ var $e8f2face14749367$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $e8f2face14749367$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $e8f2face14749367$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$e8f2face14749367$var$LazyWrapper.prototype = $9F9XB($2YyaX.prototype);
$e8f2face14749367$var$LazyWrapper.prototype.constructor = $e8f2face14749367$var$LazyWrapper;
module.exports = $e8f2face14749367$var$LazyWrapper;

});

parcelRegister("bqBQL", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $9xdpl = parcelRequire("9xdpl");

var $2YyaX = parcelRequire("2YyaX");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");

var $edDMs = parcelRequire("edDMs");
/** Used for built-in method references. */ var $851f7b9fbf6fdb93$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $851f7b9fbf6fdb93$var$hasOwnProperty = $851f7b9fbf6fdb93$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $851f7b9fbf6fdb93$var$lodash(value) {
    if ($hYEMs(value) && !$1c8hB(value) && !(value instanceof $jZYVT)) {
        if (value instanceof $9xdpl) return value;
        if ($851f7b9fbf6fdb93$var$hasOwnProperty.call(value, '__wrapped__')) return $edDMs(value);
    }
    return new $9xdpl(value);
}
// Ensure wrappers are instances of `baseLodash`.
$851f7b9fbf6fdb93$var$lodash.prototype = $2YyaX.prototype;
$851f7b9fbf6fdb93$var$lodash.prototype.constructor = $851f7b9fbf6fdb93$var$lodash;
module.exports = $851f7b9fbf6fdb93$var$lodash;

});
parcelRegister("edDMs", function(module, exports) {

var $jZYVT = parcelRequire("jZYVT");

var $9xdpl = parcelRequire("9xdpl");

var $b69Sx = parcelRequire("b69Sx");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $a5a1232fcca67a49$var$wrapperClone(wrapper) {
    if (wrapper instanceof $jZYVT) return wrapper.clone();
    var result = new $9xdpl(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $b69Sx(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $a5a1232fcca67a49$var$wrapperClone;

});





parcelRegister("f0W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d04ac07fa4ce669$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
var $6d04ac07fa4ce669$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $eUqFw.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $2jDha.default)()(EngagementEventsWrapper);
};

});

parcelRegister("7T7X6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce36dae8713b677$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $5ce36dae8713b677$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $eUqFw.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
            };
        }
        UNSAFE_componentWillMount() {
            if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
            if (this.canSetConfig()) this.removeConfig = this.setChoreographerConfig();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props?.engagementId !== nextProps?.engagementId && this.removeConfig && this.canSetConfig()) {
                this.removeConfig();
                this.removeConfig = this.setChoreographerConfig(nextProps);
            } else if ((this.props?.messageType !== nextProps?.messageType || this.props?.onMessageDisposition !== nextProps?.onMessageDisposition) && this.canSetConfig()) this.setChoreographerConfig(nextProps);
        }
        componentWillUnmount() {
            if (this.unsubscribe) this.unsubscribe();
            if (this.removeConfig) this.removeConfig();
        }
        canSetConfig() {
            return this.context && this.context.setComponentConfig;
        }
        setChoreographerConfig(props = this.props) {
            return this.context.setComponentConfig(getComponentType(), {
                messageType: props.messageType,
                onMessageDisposition: props.onMessageDisposition
            }, props.engagementId);
        }
        canSubscribe() {
            return this.context && this.context.subscribeEngagementState;
        }
        subscribeToStore() {
            return this.context.subscribeEngagementState(this.onStoreChange);
        }
        render() {
            const { children: children, engagementId: engagementId } = this.props;
            const { message: message } = this.state;
            if (!message) {
                if (componentType === 'inlineDialog') return children || null;
                return null;
            }
            if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
            const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
            // Key is useful here to make sure that when the currently active
            // messages changes, the old component is unmounted (therefore
            // firing an analytic event for hiding the component) and mounting
            // a new component for the new message (firing a shown event for
            // the new message). Not using key would allow React to apply an
            // optimization that would reuse the current component for a new
            // message which would not call the normal mount and unmount
            // lifecycle methods.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerComponent, {
                key: messageKey,
                ...this.props,
                ...message
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                message: null
            };
            this.onStoreChange = (state)=>{
                this.setState(computeNewState(state));
            };
        }
    }
    return StoreWrapper;
};

});

parcelRegister("54qz7", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", () => $3605140b34c09432$export$e7d79186651244da);
const $3605140b34c09432$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("ip3Rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe3a1bc9fdc1afd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $6fe3a1bc9fdc1afd$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("joBf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ed25e38ff42c85$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kXwvz = parcelRequire("kXwvz");

var $byn9U = parcelRequire("byn9U");

var $lDjMI = parcelRequire("lDjMI");

var $b9Xoy = parcelRequire("b9Xoy");

var $T3JCe = parcelRequire("T3JCe");
var $e1ed25e38ff42c85$var$testOmitPropsOnStringTag = (0, $kXwvz.default);
var $e1ed25e38ff42c85$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $e1ed25e38ff42c85$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $e1ed25e38ff42c85$var$testOmitPropsOnStringTag : $e1ed25e38ff42c85$var$testOmitPropsOnComponent;
};
var $e1ed25e38ff42c85$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $e1ed25e38ff42c85$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $e1ed25e38ff42c85$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lDjMI.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $T3JCe.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lDjMI.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e1ed25e38ff42c85$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $e1ed25e38ff42c85$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $e1ed25e38ff42c85$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $byn9U.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $eUqFw.useContext)((0, $byn9U.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lDjMI.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $b9Xoy.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $e1ed25e38ff42c85$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $eUqFw.createElement)($e1ed25e38ff42c85$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $eUqFw.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kU09D.default)({}, options, nextOptions, {
                shouldForwardProp: $e1ed25e38ff42c85$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $e1ed25e38ff42c85$export$2e2bcd8739ae039 = $e1ed25e38ff42c85$var$createStyled;

});
parcelRegister("kXwvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42288cd8c23180b$export$2e2bcd8739ae039);

var $bRPu3 = parcelRequire("bRPu3");
var $f42288cd8c23180b$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f42288cd8c23180b$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $bRPu3.default)(function(prop) {
    return $f42288cd8c23180b$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("lDjMI", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $fbfc9659b588f826$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $fbfc9659b588f826$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $fbfc9659b588f826$export$6f077d94b33a01aa);
var $fbfc9659b588f826$var$isBrowser = true;
function $fbfc9659b588f826$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $fbfc9659b588f826$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $fbfc9659b588f826$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $fbfc9659b588f826$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $fbfc9659b588f826$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRegister("fcWBJ", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/** Used for built-in method references. */ var $b12570436e43257d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b12570436e43257d$var$hasOwnProperty = $b12570436e43257d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b12570436e43257d$var$groupBy = $f2sQe(function(result, value, key) {
    if ($b12570436e43257d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3pSMu(result, key, [
        value
    ]);
});
module.exports = $b12570436e43257d$var$groupBy;

});

parcelRegister("cnRoI", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $90410db367a60352$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $90410db367a60352$var$mapKeys;

});

parcelRegister("fUTZC", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $awetI = parcelRequire("awetI");

var $cOXK6 = parcelRequire("cOXK6");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $b96784f98aa1ce5f$var$forEach(collection, iteratee) {
    var func = $1c8hB(collection) ? $9Kzih : $awetI;
    return func(collection, $cOXK6(iteratee));
}
module.exports = $b96784f98aa1ce5f$var$forEach;

});
parcelRegister("cOXK6", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $95587f286d00dd83$var$castFunction(value) {
    return typeof value == 'function' ? value : $3QMTK;
}
module.exports = $95587f286d00dd83$var$castFunction;

});


parcelRegister("lyOYo", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $42tFs = parcelRequire("42tFs");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $fb245023a1ed37bc$var$uniqBy(array, iteratee) {
    return array && array.length ? $42tFs(array, $7qARj(iteratee, 2)) : [];
}
module.exports = $fb245023a1ed37bc$var$uniqBy;

});

parcelRegister("jDNSq", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $359ff269acabe1de$export$fcd404066e55a7a8);

var $kkRql = parcelRequire("kkRql");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira-software/board/manifest.ts
var $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kkRql.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $kkRql.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $359ff269acabe1de$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("kkRql", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64a01189673ac62a$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64a01189673ac62a$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64a01189673ac62a$export$d716ba4f5572ec86 = "jira-software", $64a01189673ac62a$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("8npnf", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $682906413775fbdd$export$75a0a0a7cb0a58ae);

var $dbOi4 = parcelRequire("dbOi4");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/project/manifest.ts
var $682906413775fbdd$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dbOi4.JiraProjectAriResourceOwner),
    resourceType: (0, $dbOi4.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $682906413775fbdd$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $682906413775fbdd$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $682906413775fbdd$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $682906413775fbdd$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $682906413775fbdd$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $682906413775fbdd$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $682906413775fbdd$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("dbOi4", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $fc714a2435bc97e4$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $fc714a2435bc97e4$export$736763838d3aa22e);
// src/jira/project/types.ts
var $fc714a2435bc97e4$export$99d538a3b04916b1 = "jira", $fc714a2435bc97e4$export$736763838d3aa22e = "project";

});


parcelRegister("aeTOI", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $i31gq = parcelRequire("i31gq");

var $3Bqj8 = parcelRequire("3Bqj8");

var $jxg5X = parcelRequire("jxg5X");

var $fdip7 = parcelRequire("fdip7");

var $8nrDO = parcelRequire("8nrDO");
/** Used for built-in method references. */ var $7746824ad0b9147c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7746824ad0b9147c$var$hasOwnProperty = $7746824ad0b9147c$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $7746824ad0b9147c$var$assign = $3Bqj8(function(object, source) {
    if ($fdip7(source) || $jxg5X(source)) {
        $i31gq(source, $8nrDO(source), object);
        return;
    }
    for(var key in source)if ($7746824ad0b9147c$var$hasOwnProperty.call(source, key)) $jDLwO(object, key, source[key]);
});
module.exports = $7746824ad0b9147c$var$assign;

});

parcelRegister("apShl", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9c877c92ec46b4$export$2e2bcd8739ae039);

var $qEqgo = parcelRequire("qEqgo");
var $da9c877c92ec46b4$export$2e2bcd8739ae039 = (0, $qEqgo.default);

});
parcelRegister("qEqgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b50f9086cb75e31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lDuRz = parcelRequire("lDuRz");

var $3Hphq = parcelRequire("3Hphq");
function $3b50f9086cb75e31$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // react-18: useId instead
    const context = (0, $eUqFw.useContext)((0, $3Hphq.default));
    (0, $lDuRz.default)(()=>{
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : null;
}

});
parcelRegister("lDuRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $824a72923f5632a9$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $eUqFw = parcelRequire("eUqFw");
var $824a72923f5632a9$export$2e2bcd8739ae039 = (0, $eUqFw.useLayoutEffect);

});



parcelRegister("4vTMF", function(module, exports) {

var $lrLC2 = parcelRequire("lrLC2");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $34955437dbccaff0$var$kebabCase = $lrLC2(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $34955437dbccaff0$var$kebabCase;

});

parcelRegister("lyUHD", function(module, exports) {

var $7jNqu = parcelRequire("7jNqu");
var $fb28c1ebd36ca859$var$Global = $7jNqu.Global;
module.exports = {
    name: 'sessionStorage',
    read: $fb28c1ebd36ca859$var$read,
    write: $fb28c1ebd36ca859$var$write,
    each: $fb28c1ebd36ca859$var$each,
    remove: $fb28c1ebd36ca859$var$remove,
    clearAll: $fb28c1ebd36ca859$var$clearAll
};
function $fb28c1ebd36ca859$var$sessionStorage() {
    return $fb28c1ebd36ca859$var$Global.sessionStorage;
}
function $fb28c1ebd36ca859$var$read(key) {
    return $fb28c1ebd36ca859$var$sessionStorage().getItem(key);
}
function $fb28c1ebd36ca859$var$write(key, data) {
    return $fb28c1ebd36ca859$var$sessionStorage().setItem(key, data);
}
function $fb28c1ebd36ca859$var$each(fn) {
    for(var i = $fb28c1ebd36ca859$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $fb28c1ebd36ca859$var$sessionStorage().key(i);
        fn($fb28c1ebd36ca859$var$read(key), key);
    }
}
function $fb28c1ebd36ca859$var$remove(key) {
    return $fb28c1ebd36ca859$var$sessionStorage().removeItem(key);
}
function $fb28c1ebd36ca859$var$clearAll() {
    return $fb28c1ebd36ca859$var$sessionStorage().clear();
}

});

parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("8PVSz", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $eb0717707fcb1402$export$5b689ca7b019e89f);

var $fYqUr = parcelRequire("fYqUr");
function $eb0717707fcb1402$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $fYqUr.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $fYqUr.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("75e8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $547614b66fbb32c5$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $66aNr = parcelRequire("66aNr");

var $fTZm7 = parcelRequire("fTZm7");

var $baC3k = parcelRequire("baC3k");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $41dmJ = parcelRequire("41dmJ");
function $547614b66fbb32c5$export$2e2bcd8739ae039(name, timestamp) {
    const rate = (0, $fTZm7.getInteractionRate)(name, 'press');
    const pressInteractionsList = (0, $fTZm7.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $fYqUr.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $66aNr.default)(rate)) {
        (0, $fYqUr.abortAll)('new_interaction', name);
        const startTimestamp = timestamp ?? performance.now();
        const newId = (0, $hompL.v4)();
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $baC3k.setInteractionActiveTrace)(newId, 'press');
        (0, $51JrV.DefaultInteractionID).current = newId;
        (0, $fYqUr.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $41dmJ.default).current, (0, $baC3k.getActiveTrace)());
    }
}

});

parcelRegister("5s6G4", function(module, exports) {

$parcel$export(module.exports, "default", () => $74508b29b3843e7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
function $74508b29b3843e7a$export$2e2bcd8739ae039(name) {
    const context = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("cEaY5", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $e8058d97d3aac8cb$export$a72bfd9b1e5592c8);
var $e8058d97d3aac8cb$export$a72bfd9b1e5592c8;
(function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
})($e8058d97d3aac8cb$export$a72bfd9b1e5592c8 || ($e8058d97d3aac8cb$export$a72bfd9b1e5592c8 = {}));

});

parcelRegister("53Hxw", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $e451209030b9e707$export$e83743682263315a);

var $3S0d8 = parcelRequire("3S0d8");

var $8WtaH = parcelRequire("8WtaH");

var $1XFiH = parcelRequire("1XFiH");
const $e451209030b9e707$var$cache = (0, $3S0d8.createCache)(new Map());
function $e451209030b9e707$export$e83743682263315a(loader, opts) {
    return $e451209030b9e707$var$cache.get(opts.moduleId, ()=>(0, $8WtaH.PreloadableJSResource)(()=>(0, $1XFiH.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("3S0d8", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $de8e77497676528b$export$cf6fa0bbcc94b912);
function $de8e77497676528b$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("8WtaH", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $54632155f7a7e4ee$export$4fe5fba5bb1d3c09);

var $exT6p = parcelRequire("exT6p");
function $54632155f7a7e4ee$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $exT6p.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("exT6p", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $188b11922b7d5f1b$export$148e45a6d4b4d65);

var $h5RWI = parcelRequire("h5RWI");

var $6906R = parcelRequire("6906R");

var $7qqtP = parcelRequire("7qqtP");
function $188b11922b7d5f1b$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $6906R.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $6906R.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $h5RWI.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $6906R.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7qqtP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("h5RWI", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $865acd242141a4aa$export$567fc7097e064344);
let $865acd242141a4aa$var$id = 100000;
function $865acd242141a4aa$export$567fc7097e064344() {
    $865acd242141a4aa$var$id += 1;
    return $865acd242141a4aa$var$id.toString();
}

});

parcelRegister("6906R", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $c27d88c0a7a2d653$export$10dc3edfc20c8ff);
function $c27d88c0a7a2d653$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $c27d88c0a7a2d653$export$10dc3edfc20c8ff = $c27d88c0a7a2d653$var$createEventEmitter();

});

parcelRegister("7qqtP", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $500842c537c7e6c8$export$3b514faac3ba993c);
function $500842c537c7e6c8$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("1XFiH", function(module, exports) {

$parcel$export(module.exports, "postTask", () => $2991483d9552cc26$export$13c9d02ca54955a3);
async function $2991483d9552cc26$var$toPromise(callback) {
    return callback();
}
function $2991483d9552cc26$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $2991483d9552cc26$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $2991483d9552cc26$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("lX6nC")).then(()=>$2991483d9552cc26$var$getScheduler(globalThis).postTask(callback, options));
        return $2991483d9552cc26$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("lX6nC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cT2it").then(()=>parcelRequire('7wK8q'));

});



parcelRegister("artI2", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $57382c4d17607dce$export$fa00dd5c1a75592f);
function $57382c4d17607dce$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("haZ9d", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $22c2d7a1b9aaa8da$export$555c8ae00f64ebff);

var $goMJF = parcelRequire("goMJF");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira-servicedesk/queue/manifest.ts
var $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $goMJF.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $goMJF.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $22c2d7a1b9aaa8da$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $22c2d7a1b9aaa8da$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("goMJF", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $24fcacac74407936$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $24fcacac74407936$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $24fcacac74407936$export$704112eeb385ceab = "jira-servicedesk", $24fcacac74407936$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("aZApM", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $06731b813f1d1253$export$b7d4016f0f5da5b8);

var $iSMOl = parcelRequire("iSMOl");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/dashboard/manifest.ts
var $06731b813f1d1253$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $iSMOl.JiraDashboardAriResourceOwner),
    resourceType: (0, $iSMOl.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $06731b813f1d1253$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $06731b813f1d1253$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $06731b813f1d1253$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $06731b813f1d1253$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $06731b813f1d1253$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $06731b813f1d1253$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $06731b813f1d1253$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("iSMOl", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $670109b3c031a884$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $670109b3c031a884$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $670109b3c031a884$export$62c1deae25c41d24 = "jira", $670109b3c031a884$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("csxeI", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $bb528b9b812dc7f9$export$6d2eb3641569f26);

var $jpnxi = parcelRequire("jpnxi");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/plan/manifest.ts
var $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $jpnxi.JiraPlanAriResourceOwner),
    resourceType: (0, $jpnxi.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $bb528b9b812dc7f9$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $bb528b9b812dc7f9$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("jpnxi", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b5e8ba39b9be08d1$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b5e8ba39b9be08d1$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b5e8ba39b9be08d1$export$bfd26af3c5e1b90d = "jira", $b5e8ba39b9be08d1$export$d6abe08eb30f433d = "plan";

});


parcelRegister("9WJJx", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $11208f5b95d47870$export$eebbda33f5d4d735);

var $eUqFw = parcelRequire("eUqFw");

var $6078G = parcelRequire("6078G");

var $gmZvv = parcelRequire("gmZvv");

var $i6BC8 = parcelRequire("i6BC8");

var $74BVL = parcelRequire("74BVL");

var $4VsvK = parcelRequire("4VsvK");

var $4ItDq = parcelRequire("4ItDq");

var $6Pq2D = parcelRequire("6Pq2D");
const $11208f5b95d47870$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $11208f5b95d47870$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4VsvK.default), nudge: Nudge = (0, $6078G.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $eUqFw.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $eUqFw.useRef)(null);
    const spotlightCardRef = (0, $eUqFw.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $eUqFw.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $eUqFw.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $eUqFw.useState)(false);
    const stopBlink = (0, $eUqFw.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $eUqFw.useRef)({
        fn: ()=>{}
    });
    (0, $eUqFw.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $eUqFw.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $eUqFw.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $eUqFw.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $eUqFw.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $eUqFw.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $eUqFw.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $eUqFw.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $74BVL.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $11208f5b95d47870$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $eUqFw.useMemo)(()=>Spotlight === (0, $4VsvK.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Nudge, {
        ref: nudgeRef,
        hasPulse: showNudge,
        onClickCapture: onTargetClick,
        onMouseEnter: markReadyToShow,
        pulseColor: pulseColor,
        pulseShadowColor: pulseShadowColor,
        pulseBorderRadius: pulseBorderRadius,
        nudgeTestId: nudgeTestId,
        tag: nudgeTag
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: position,
        referenceElement: nudgeRef.current || undefined,
        offset: offset
    }, ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ItDq.SpotlightContainer), {
            showSpotlight: showSpotlight,
            shouldBlink: shouldBlink,
            stopBlink: stopBlink,
            zIndex: zIndex,
            ref: ref,
            containerStyles: {
                ...popperStyles,
                ...concealSpotlightOnScrollStyles(isReferenceHidden)
            },
            role: "dialog",
            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, (forceUpdateFnRef.current.fn = forceUpdate) && null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Spotlight, {
            ...cardConfig,
            ref: spotlightCardRef
        }))))));
});
var $11208f5b95d47870$export$2e2bcd8739ae039 = $11208f5b95d47870$export$eebbda33f5d4d735;

});
parcelRegister("6078G", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $f5456a86e5d0b314$export$b7d614104f4a4a7c);

var $eUqFw = parcelRequire("eUqFw");

var $VDAtw = parcelRequire("VDAtw");
const $f5456a86e5d0b314$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $VDAtw.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));

});
parcelRegister("VDAtw", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $a9486f7afde85855$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
function $a9486f7afde85855$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9486f7afde85855$var$baseShadow = '0 0 0 3px';
const $a9486f7afde85855$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P75})`;
const $a9486f7afde85855$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $a9486f7afde85855$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $a9486f7afde85855$var$pulseAnimation = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animation: `pulseKeyframes 3000ms ${$a9486f7afde85855$var$easing} infinite`
});
const $a9486f7afde85855$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $a9486f7afde85855$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $byn9U.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $a9486f7afde85855$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$a9486f7afde85855$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $a9486f7afde85855$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$a9486f7afde85855$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $a9486f7afde85855$var$pulseAnimation
            ]
        }
    });
const $a9486f7afde85855$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $lcnyw.borderRadius)(), pulseColor: pulseColor = $a9486f7afde85855$var$basePulseColor, pulseShadowColor: pulseShadowColor = $a9486f7afde85855$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $byn9U.jsx)(CastTargetContainer, {
        css: $a9486f7afde85855$export$814d9bf8c56ac913({
            hasPulse: hasPulse,
            pulseBorderRadius: pulseBorderRadius,
            pulseColor: pulseColor,
            pulseShadowColor: pulseShadowColor
        }),
        ref: ref,
        ...rest
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("4VsvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0324b41a659f77e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");


var $byn9U = parcelRequire("byn9U");
function $0324b41a659f77e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0324b41a659f77e2$var$borderRadius = 3;
const $0324b41a659f77e2$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`,
    borderRadius: `${$0324b41a659f77e2$var$borderRadius}px`,
    overflow: 'auto'
};
const $0324b41a659f77e2$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $0324b41a659f77e2$var$headingStyles = {
    name: "1j2r6qm",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:500;letter-spacing:-0.008em;margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $0324b41a659f77e2$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $0324b41a659f77e2$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $0324b41a659f77e2$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $byn9U.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        fontFamily: 'inherit',
        fontWeight: 500,
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $73a5c9d720aa66e1$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $73a5c9d720aa66e1$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $73a5c9d720aa66e1$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $73a5c9d720aa66e1$export$a7175d4e9206bc80)})`
        }
    });
const $0324b41a659f77e2$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        css: $0324b41a659f77e2$var$actionItemStyles(index),
        ...rest
    });
const $0324b41a659f77e2$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $0324b41a659f77e2$export$b3ae98194e057550 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $eUqFw.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $byn9U.jsx)($0324b41a659f77e2$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$0324b41a659f77e2$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$headerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $0324b41a659f77e2$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $byn9U.jsx)("span", null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        style: $0324b41a659f77e2$var$actionItemContainerStyles
    }, renderedActions))));
});
var $0324b41a659f77e2$export$2e2bcd8739ae039 = $0324b41a659f77e2$export$b3ae98194e057550;

});

parcelRegister("4ItDq", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $28cfb52a1cf9708a$export$d0f55839b708c0a0);

var $eUqFw = parcelRequire("eUqFw");

var $247XK = parcelRequire("247XK");

var $gmZvv = parcelRequire("gmZvv");
const $28cfb52a1cf9708a$export$474e8ee88cc7cd8f = 200;
const $28cfb52a1cf9708a$export$3d6f334bf7dc4597 = 120;
const $28cfb52a1cf9708a$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$28cfb52a1cf9708a$export$474e8ee88cc7cd8f}ms`
};
const $28cfb52a1cf9708a$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$28cfb52a1cf9708a$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $28cfb52a1cf9708a$var$timeoutDurations = {
    enter: 0,
    exit: $28cfb52a1cf9708a$export$3d6f334bf7dc4597
};
const $28cfb52a1cf9708a$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $28cfb52a1cf9708a$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink
    }, (state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
            zIndex: zIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...containerStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$28cfb52a1cf9708a$var$defaultTransitionStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$28cfb52a1cf9708a$var$statefulTransitionStyles[state]
            },
            ref: ref,
            "aria-labelledby": ariaLabelledBy,
            ...rest
        }))));

});


parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("3IRl5", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("55pTl", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $985e05c858fa7d8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7zpSo = parcelRequire("7zpSo");

var $9M7iF = parcelRequire("9M7iF");

var $f0W8K = parcelRequire("f0W8K");

var $7T7X6 = parcelRequire("7T7X6");

var $83IfW = parcelRequire("83IfW");
const $985e05c858fa7d8f$var$SpotlightWithVariables = (0, $9M7iF.default)((0, $83IfW.default));
const $985e05c858fa7d8f$export$f57123e11f24bec9 = (0, $f0W8K.default)($985e05c858fa7d8f$var$SpotlightWithVariables);
const $985e05c858fa7d8f$var$SpotlightWithMessage = (0, $7T7X6.default)($985e05c858fa7d8f$export$f57123e11f24bec9, 'spotlight');
function $985e05c858fa7d8f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($985e05c858fa7d8f$var$SpotlightWithMessage, props));
}

});
parcelRegister("9M7iF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b878ab4f8250ec4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1QU7b = parcelRequire("1QU7b");
function $5b878ab4f8250ec4$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $eUqFw.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $5b878ab4f8250ec4$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TargetComponent, props);
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $5b878ab4f8250ec4$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $1QU7b.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $1QU7b.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $1QU7b.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("1QU7b", function(module, exports) {

$parcel$export(module.exports, "rebuildButtonAction", () => $df30909478a09c9a$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $df30909478a09c9a$export$d808999430a3f186);

var $k72TP = parcelRequire("k72TP");
function $df30909478a09c9a$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $df30909478a09c9a$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $k72TP.runTemplateForUrl)(input, variables) : (0, $k72TP.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $d9ce6e8390cc9e22$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $d9ce6e8390cc9e22$export$e26f00bd90899835 = 'success';
const $d9ce6e8390cc9e22$export$edb46161045fece7 = 'error';

parcelRegister("k72TP", function(module, exports) {

$parcel$export(module.exports, "runTemplateForUrl", () => $3521bc85b03f137c$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $3521bc85b03f137c$export$5681b97796b74884);

var $056xv = parcelRequire("056xv");

var $jGSa9 = parcelRequire("jGSa9");


var $e3VxJ = parcelRequire("e3VxJ");
function $3521bc85b03f137c$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $056xv.default)(template);
    return (0, $e3VxJ.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $3521bc85b03f137c$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $056xv.default)(template);
    return (0, $jGSa9.replaceForUrl)(epTemplate, variables);
}
function $3521bc85b03f137c$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $056xv.default)(template);
    return (0, $jGSa9.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("056xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a39e6a5d0b749e$export$2e2bcd8739ae039);

var $2qgwt = parcelRequire("2qgwt");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $77a39e6a5d0b749e$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $77a39e6a5d0b749e$var$UNESCAPED_MATCH = 1;
const $77a39e6a5d0b749e$var$UNESCAPED_GROUP_CONTENTS = 2;
const $77a39e6a5d0b749e$var$ESCAPED_GROUP_CONTENTS = 5;
function $77a39e6a5d0b749e$export$2e2bcd8739ae039(template) {
    const parts = (0, $2qgwt.regexpParts)(template, $77a39e6a5d0b749e$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$77a39e6a5d0b749e$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$77a39e6a5d0b749e$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$77a39e6a5d0b749e$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("2qgwt", function(module, exports) {

$parcel$export(module.exports, "regexpParts", () => $b3e4073afaffdb2f$export$b16d411b3b6d6dff);
function $b3e4073afaffdb2f$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $b3e4073afaffdb2f$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $b3e4073afaffdb2f$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $b3e4073afaffdb2f$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $b3e4073afaffdb2f$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("jGSa9", function(module, exports) {

$parcel$export(module.exports, "replaceForUrl", () => $5627171d3c642bc9$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $5627171d3c642bc9$export$ca536300dbd6350);

var $e3VxJ = parcelRequire("e3VxJ");

var $451xh = parcelRequire("451xh");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $5627171d3c642bc9$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $e3VxJ.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $5627171d3c642bc9$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $5627171d3c642bc9$var$rawReplaceVariablesForUrl(template, variables) {
    return $5627171d3c642bc9$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $5627171d3c642bc9$var$rawReplaceVariablesForHtml(template, variables) {
    return $5627171d3c642bc9$var$rawReplaceVariables(template, variables, (0, $451xh.default));
}
function $5627171d3c642bc9$export$d10ae881b12b8ef2(template, variables) {
    return $5627171d3c642bc9$var$withVariableValidation(template, variables, $5627171d3c642bc9$var$rawReplaceVariablesForUrl);
}
function $5627171d3c642bc9$export$ca536300dbd6350(template, variables) {
    return $5627171d3c642bc9$var$withVariableValidation(template, variables, $5627171d3c642bc9$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("e3VxJ", function(module, exports) {

$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $2c23722beb4ab688$export$4a33186abb06007b);

var $2qLrQ = parcelRequire("2qLrQ");
function $2c23722beb4ab688$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $2c23722beb4ab688$export$4a33186abb06007b(template) {
    const variableParts = $2c23722beb4ab688$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $2qLrQ.uniqStrings)(variableNames);
}

});
parcelRegister("2qLrQ", function(module, exports) {

$parcel$export(module.exports, "uniqStrings", () => $711b02ab773feae3$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $711b02ab773feae3$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("451xh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2d53286ca8c1a1$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $6e2d53286ca8c1a1$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("83IfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb279e000c223dfa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hJJD2 = parcelRequire("hJJD2");

var $54qz7 = parcelRequire("54qz7");

var $ip3Rl = parcelRequire("ip3Rl");
class $eb279e000c223dfa$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $54qz7.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ip3Rl.default), {
            html: body
        }));
    }
}

});


parcelRegister("xMKqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9749a350b9a888$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $ba9749a350b9a888$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            fallback: null
        };
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});

parcelRegister("DEVKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05973a9986dfa7a$export$2e2bcd8739ae039);

var $anvcr = parcelRequire("anvcr");

var $goEaH = parcelRequire("goEaH");
class $c05973a9986dfa7a$export$2e2bcd8739ae039 {
    constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $goEaH.isMessagingEnabled)()) return false;
        return (0, $anvcr.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $goEaH.isMessagingEnabled)()) return false;
        return (0, $anvcr.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("7ZwLV", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModalContext", () => $b221e8733bcb4950$export$be58429061ae5194);
$parcel$export(module.exports, "InvitePeopleModalContextProvider", () => $b221e8733bcb4950$export$496e4f58036bb94d);

var $eUqFw = parcelRequire("eUqFw");

const $b221e8733bcb4950$var$AKInvitePeopleModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("jyPvB")));

const $b221e8733bcb4950$var$AKModalTransition = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7lPXQ")).then((module)=>({
            default: module.ModalTransition
        })));
const $b221e8733bcb4950$export$be58429061ae5194 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isOpen: false,
    openModal: ()=>undefined,
    closeModal: ()=>undefined
});
const $b221e8733bcb4950$export$496e4f58036bb94d = (invitePeopleModalContextProviderProps)=>{
    const { children: children } = invitePeopleModalContextProviderProps;
    const [invitePeopleState, setInvitePeopleState] = (0, $eUqFw.useState)({
        isOpen: false
    });
    const openModal = (invitePeopleProps, onClose)=>{
        setInvitePeopleState({
            isOpen: true,
            props: invitePeopleProps,
            onClose: onClose
        });
    };
    const closeModal = (0, $eUqFw.useCallback)((trigger)=>{
        if (!invitePeopleState.isOpen) return;
        invitePeopleState.onClose?.(trigger);
        setInvitePeopleState({
            previousProps: invitePeopleState.props,
            isOpen: false
        });
    }, [
        invitePeopleState
    ]);
    const reopenModal = (0, $eUqFw.useCallback)(()=>{
        // Reopen function can only reopen invite people if openModal has been called once with props
        setInvitePeopleState((prevState)=>!prevState.isOpen && prevState.previousProps ? {
                props: prevState.previousProps,
                isOpen: true
            } : prevState);
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            openModal: openModal,
            closeModal: closeModal,
            isOpen: invitePeopleState.isOpen
        }), [
        closeModal,
        invitePeopleState.isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b221e8733bcb4950$export$be58429061ae5194.Provider, {
        value: context
    }, children, invitePeopleState.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b221e8733bcb4950$var$AKModalTransition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b221e8733bcb4950$var$AKInvitePeopleModal, {
        onCloseHandler: closeModal,
        experimental_onReopenHandler: reopenModal,
        ...invitePeopleState.props
    }))));
};

});
parcelRegister("jyPvB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("d6UUi")
]).then(()=>parcelRequire('44yUc'));

});

parcelRegister("7lPXQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jf59F")
]).then(()=>parcelRequire('dzmUA'));

});


parcelRegister("6Qy8u", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $72a4b41762a7cddc$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");
const $72a4b41762a7cddc$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("byYfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7d202e8a0eafca$export$2e2bcd8739ae039);
const $4c7d202e8a0eafca$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $4c7d202e8a0eafca$export$2e2bcd8739ae039 = $4c7d202e8a0eafca$var$convertToError;

});

parcelRegister("3XyGA", function(module, exports) {

$parcel$export(module.exports, "fetchItemsWithCursor", () => $ec921e0afce975cd$export$1d3435507f486e79);
$parcel$export(module.exports, "retryFetch", () => $ec921e0afce975cd$export$635968db05579875);
$parcel$export(module.exports, "httpRetryPolicy", () => $ec921e0afce975cd$export$bd28f8bf945907aa);
$parcel$export(module.exports, "FetchError", () => $ec921e0afce975cd$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $ec921e0afce975cd$export$6d71b655afe1638d);
$parcel$export(module.exports, "buildQueryString", () => $ec921e0afce975cd$export$6b17a39e52c8ee53);
$parcel$export(module.exports, "sortByName", () => $ec921e0afce975cd$export$7932064324870761);

var $3G3gn = parcelRequire("3G3gn");


var $iJLxP = parcelRequire("iJLxP");
function $ec921e0afce975cd$var$defaultErrorMapper(response) {
    return Promise.resolve({
        code: response.status.toString(),
        message: response.statusText
    });
}
function $ec921e0afce975cd$var$defaultResultMapper(response) {
    return response.json();
}
async function $ec921e0afce975cd$export$1d3435507f486e79({ url: url, queryParams: queryParams = {}, signal: signal, getItems: getItems, getCursor: getCursor, canRetryCheck: canRetryCheck, mapError: mapError = $ec921e0afce975cd$var$defaultErrorMapper }) {
    const items = [];
    let response;
    let page = 0;
    do {
        // Bail out here in case the abort signal is fired between requests.
        if (signal?.aborted) return {
            ok: false,
            aborted: true
        };
        const cursor = response?.ok ? getCursor(response.result) : undefined;
        const queryParamsWithCursor = cursor ? {
            ...queryParams,
            cursor: cursor
        } : queryParams;
        const search = Object.entries(queryParamsWithCursor ?? {}).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        const urlWithParams = [
            url,
            search
        ].filter(Boolean).join('?');
        // Get the next page and retry in case of intermittent errors
        response = await $ec921e0afce975cd$export$635968db05579875({
            request: ()=>fetch(urlWithParams, {
                    signal: signal
                }),
            mapError: mapError,
            signal: signal,
            canRetryCheck: canRetryCheck
        });
        if (!response.ok) return response.aborted ? response : {
            ...response,
            page: page
        };
        items.push.apply(items, getItems(response.result));
        ++page;
    }while (response?.ok && getCursor(response.result));
    return {
        ok: true,
        items: items,
        pages: page
    };
}
async function $ec921e0afce975cd$export$9369b12211e1fce4({ request: request, canRetryCheck: canRetryCheck, attempt: attempt = 0, signal: signal }) {
    const result = await request(signal);
    if (result.ok || result.aborted || signal?.aborted) return result;
    else {
        const [canRetry, timeToWait] = canRetryCheck(result.status, ++attempt, signal);
        if (canRetry) {
            if (timeToWait) await (0, $iJLxP.wait)(timeToWait);
            return $ec921e0afce975cd$export$9369b12211e1fce4({
                request: request,
                canRetryCheck: canRetryCheck,
                attempt: attempt,
                signal: signal
            });
        }
    }
    return result;
}
const $ec921e0afce975cd$var$DEFAULT_MAX_ATTEMPTS = 3;
const $ec921e0afce975cd$var$DEFAULT_BACKOFF_TIME_MS = 200;
const $ec921e0afce975cd$var$DEFAULT_BACKOFF_TIME_429_MS = 1000;
function $ec921e0afce975cd$export$bd28f8bf945907aa({ maxAttempts: maxAttempts = $ec921e0afce975cd$var$DEFAULT_MAX_ATTEMPTS, backoffTimeMs: backoffTimeMs = $ec921e0afce975cd$var$DEFAULT_BACKOFF_TIME_MS, rateLimitBackoffTimeMs: rateLimitBackoffTimeMs = $ec921e0afce975cd$var$DEFAULT_BACKOFF_TIME_429_MS } = {}) {
    return (status, attempts)=>{
        // Stop if attempts are exhausted
        if (attempts >= maxAttempts) return [
            false,
            0
        ];
        switch(status){
            // Unlikely to recover from these
            case 401:
            case 403:
            case 404:
                return [
                    false,
                    0
                ];
            // Probably rate limiting. Back off and try again.
            case 429:
                return [
                    true,
                    rateLimitBackoffTimeMs
                ];
            // Unknown error. Back off and try again.
            default:
                return [
                    true,
                    backoffTimeMs
                ];
        }
    };
}
function $ec921e0afce975cd$export$635968db05579875({ request: request, mapResult: mapResult = $ec921e0afce975cd$var$defaultResultMapper, mapError: mapError = $ec921e0afce975cd$var$defaultErrorMapper, canRetryCheck: canRetryCheck = $ec921e0afce975cd$export$bd28f8bf945907aa(), signal: signal }) {
    return $ec921e0afce975cd$export$9369b12211e1fce4({
        request: async ()=>{
            let response;
            try {
                response = await request();
                if (response.ok) return {
                    ok: true,
                    result: await mapResult(response)
                };
                const { code: code, message: message } = await mapError(response);
                // Error status
                return {
                    ok: false,
                    aborted: false,
                    status: response.status,
                    code: code,
                    message: message
                };
            } catch (error) {
                if (error instanceof Error) {
                    // Request aborted client-side
                    if (error.name === 'AbortError') return {
                        ok: false,
                        aborted: true
                    };
                    // Client-side networking error
                    return {
                        ok: false,
                        aborted: false,
                        status: (0, $7ee89ee043484255$export$2c32b0fe4533d89e),
                        code: error.name,
                        message: error.message
                    };
                }
                return {
                    ok: false,
                    aborted: false,
                    status: (0, $7ee89ee043484255$export$2c32b0fe4533d89e),
                    code: (0, $7ee89ee043484255$export$9267d266a5449137),
                    message: (0, $7ee89ee043484255$export$33789febc109c023)
                };
            }
        },
        canRetryCheck: canRetryCheck,
        signal: signal
    });
}
class $ec921e0afce975cd$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, errorType){
        super(message);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.errorType = errorType;
    }
}
const $ec921e0afce975cd$export$6d71b655afe1638d = (url, action, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new $ec921e0afce975cd$export$26e841bcf1aeb894(`Unable to fetch ${action} ${response.statusText}`, response.status);
    });
const $ec921e0afce975cd$var$isNil = (value)=>value === undefined || value === null;
function $ec921e0afce975cd$export$6b17a39e52c8ee53(obj) {
    const query = Object.keys(obj).filter((key)=>!$ec921e0afce975cd$var$isNil(obj[key])).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    return query ? '?' + query : query;
}
function $ec921e0afce975cd$export$7932064324870761(values) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(values, ({ name: name })=>name.toLowerCase());
}

});
parcelRegister("3G3gn", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $943C2 = parcelRequire("943C2");

var $9eFtX = parcelRequire("9eFtX");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $2ad7d356c61a8e97$var$sortBy = $9eFtX(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $3P7i5(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $3P7i5(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $943C2(collection, $hKE3p(iteratees, 1), []);
});
module.exports = $2ad7d356c61a8e97$var$sortBy;

});
parcelRegister("943C2", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $dS3e6 = parcelRequire("dS3e6");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $hVWSV = parcelRequire("hVWSV");

var $74vSq = parcelRequire("74vSq");

var $2UGl0 = parcelRequire("2UGl0");

var $3QMTK = parcelRequire("3QMTK");

var $1c8hB = parcelRequire("1c8hB");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $69974a25804cb8c6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $kJvGp(iteratees, function(iteratee) {
        if ($1c8hB(iteratee)) return function(value) {
            return $dS3e6(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $3QMTK
    ];
    var index = -1;
    iteratees = $kJvGp(iteratees, $74vSq($7qARj));
    var result = $iA1h1(collection, function(value, key, collection) {
        var criteria = $kJvGp(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $hVWSV(result, function(object, other) {
        return $2UGl0(object, other, orders);
    });
}
module.exports = $69974a25804cb8c6$var$baseOrderBy;

});
parcelRegister("iA1h1", function(module, exports) {

var $awetI = parcelRequire("awetI");

var $jxg5X = parcelRequire("jxg5X");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d86c93b23723e939$var$baseMap(collection, iteratee) {
    var index = -1, result = $jxg5X(collection) ? Array(collection.length) : [];
    $awetI(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $d86c93b23723e939$var$baseMap;

});

parcelRegister("hVWSV", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $d0e56fd712f7edce$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $d0e56fd712f7edce$var$baseSortBy;

});

parcelRegister("2UGl0", function(module, exports) {

var $3Sx56 = parcelRequire("3Sx56");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $21f1a725ef116621$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $3Sx56(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $21f1a725ef116621$var$compareMultiple;

});
parcelRegister("3Sx56", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $2d301382a375e0f6$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8aco7(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8aco7(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $2d301382a375e0f6$var$compareAscending;

});




const $7ee89ee043484255$export$68362b925a39303e = '/gateway/api/slack';
const $7ee89ee043484255$export$83c8d7110915321e = 'invite-people';
const $7ee89ee043484255$export$2c32b0fe4533d89e = 0;
const $7ee89ee043484255$export$9267d266a5449137 = 'NETWORK_ERROR';
const $7ee89ee043484255$export$33789febc109c023 = 'Network error';
const $7ee89ee043484255$export$4804b650706e0b62 = 'CONFLUENCE_METADATA_ERROR';
const $7ee89ee043484255$export$85183a312807388d = 'peopleTeams';
const $7ee89ee043484255$export$d67bd32411617d53 = 480;
const $7ee89ee043484255$export$cce5ee914c2ec5d9 = 924;
const $7ee89ee043484255$export$ab2f49a861856bab = '/gateway/api';
const $7ee89ee043484255$export$127769e597bc5ee5 = '/external-users/third-party';
const $7ee89ee043484255$export$8bad17bb0225d989 = '/external-users/orgs';
const $7ee89ee043484255$export$e468596ea25b5295 = 'integrations';
const $7ee89ee043484255$export$458ba67f45a7f353 = 'Third Party Search';
const $7ee89ee043484255$export$bc2c06c4779f47f2 = 'Organisation Settings';
const $7ee89ee043484255$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $7ee89ee043484255$export$3f9855fcc7fa383e = '/slack-channels';
const $7ee89ee043484255$export$2d4bcc939d0de9de = 'google-invites';
const $7ee89ee043484255$export$baca96d2908c1d98 = 'microsoft-invites';
const $7ee89ee043484255$export$89aa938ff9a6aec2 = 3;

parcelRegister("iJLxP", function(module, exports) {

$parcel$export(module.exports, "wait", () => $fb439d87a366f75b$export$5c069c93d2b7493f);
async function $fb439d87a366f75b$export$5c069c93d2b7493f(delayMs) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, delayMs);
    });
}

});


parcelRegister("5JCC2", function(module, exports) {

$parcel$export(module.exports, "slackServiceFactory", () => $92fee434ceb3b12f$export$b2ac8baa522556a7);

var $1EiSw = parcelRequire("1EiSw");

var $i263v = parcelRequire("i263v");

var $lxFlr = parcelRequire("lxFlr");
function $92fee434ceb3b12f$export$b2ac8baa522556a7(cloudId, product, createAnalyticsEvent) {
    switch(product){
        case 'platform':
            return new (0, $lxFlr.default)(cloudId, createAnalyticsEvent);
        case 'confluence':
            return new (0, $1EiSw.default)(cloudId, createAnalyticsEvent);
        default:
            return new (0, $i263v.default)(cloudId, createAnalyticsEvent);
    }
}

});
parcelRegister("1EiSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2746d04e51d492$export$2e2bcd8739ae039);

var $3oQAd = parcelRequire("3oQAd");

var $1aHSN = parcelRequire("1aHSN");

var $4J56D = parcelRequire("4J56D");
class $4d2746d04e51d492$export$2e2bcd8739ae039 extends (0, $3oQAd.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $1aHSN.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'confluence', analytics);
        this.confluenceAnalytics = (0, $1aHSN.getConfluenceSlackServiceAnalytics)(createUIAnalyticsEvent);
    }
    async primeConsentUrl() {
        if (this.consentUrl) return;
        const location = typeof window === 'undefined' ? undefined : window.location;
        if (location) {
            const urlResult = await (0, $4J56D.default)(location, this.confluenceAnalytics, this.abortController?.signal);
            if (urlResult.ok) this.consentUrl = urlResult.result;
            else throw new Error('Failed priming consent URL');
        }
    }
}

});
parcelRegister("3oQAd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2635f3f60dd539$export$2e2bcd8739ae039);

var $jkH4Q = parcelRequire("jkH4Q");

var $3G3gn = parcelRequire("3G3gn");

var $hompL = parcelRequire("hompL");


var $bbg70 = parcelRequire("bbg70");

var $1VQjI = parcelRequire("1VQjI");

var $jivJx = parcelRequire("jivJx");

var $3XyGA = parcelRequire("3XyGA");
const $1c2635f3f60dd539$var$POPUP_WIDTH = 500;
const $1c2635f3f60dd539$var$POPUP_HEIGHT = 900;
const $1c2635f3f60dd539$var$USER_FETCH_LIMIT = 1000;
const $1c2635f3f60dd539$var$retryOptions = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $1c2635f3f60dd539$export$2e2bcd8739ae039 {
    constructor(cloudId, product, analytics){
        this.cloudId = cloudId;
        this.product = product;
        this.analytics = analytics;
        this.windowName = (0, $hompL.v4)();
        this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        this.onMessage = ({ data: data, target: target, source: source })=>{
            if (!source || target !== window || data !== 'success') return;
            window.removeEventListener('message', this.onMessage);
            const popupWindow = source;
            if (!this.popupWindow) return;
            popupWindow.close();
            this.popupWindow = undefined;
            this.onSuccess?.();
        };
        this.baseUrl = `${0, $7ee89ee043484255$export$68362b925a39303e}/${product}`;
    }
    abort() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        }
    }
    async getConsent(onSuccess) {
        await this.primeConsentUrl();
        this.onSuccess = onSuccess;
        window.addEventListener('message', this.onMessage);
        const popupWindow = window.open(this.consentUrl, this.windowName, (0, $bbg70.default)($1c2635f3f60dd539$var$POPUP_WIDTH, $1c2635f3f60dd539$var$POPUP_HEIGHT));
        if (popupWindow) this.popupWindow = popupWindow;
    }
    async isSlackEnabled() {
        const result = await (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/enabled?cloudId=${this.cloudId}`, {
                    signal: this.abortController?.signal
                }),
            mapResult: (response)=>response.json().then(({ enabled: enabled })=>enabled),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                })
        });
        if (result.ok) this.analytics.onGetEnabledSucceeded();
        else if (!result.aborted && !(0, $1VQjI.isAcceptableFailure)(result.status)) this.analytics.onGetEnabledFailed({
            status: result.status,
            errorMessage: result.message
        });
        return result;
    }
    async getTeams() {
        const response = await (0, $3XyGA.fetchItemsWithCursor)({
            url: `${this.baseUrl}/teams`,
            queryParams: {
                cloudId: this.cloudId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.teams,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($1c2635f3f60dd539$var$retryOptions)
        });
        if (response.ok) {
            this.analytics.onFetchTeamsSucceeded({
                teams: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(response.items, [
                    ({ name: name })=>name.toLowerCase()
                ])
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchTeamsFailed({
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    streamUsers(teamId, onResponse, cursor) {
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/recipients${(0, $3XyGA.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor,
                    limit: $1c2635f3f60dd539$var$USER_FETCH_LIMIT
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($1c2635f3f60dd539$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchUsersFailed({
                    teamId: teamId,
                    page: this.userStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.recipients.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.recipients,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    streamChannels(teamId, onResponse, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/channels${(0, $3XyGA.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($1c2635f3f60dd539$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchChannelsFailed({
                    teamId: teamId,
                    page: this.channelStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannels(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchChannelsSucceeded({
                teamId: teamId,
                channels: this.channelStream.count,
                pages: this.channelStream.pages
            });
        });
    }
    async fetchSlackUsers(teamId) {
        const response = await (0, $3XyGA.fetchItemsWithCursor)({
            url: `${this.baseUrl}/recipients`,
            queryParams: {
                cloudId: this.cloudId,
                teamId: teamId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.recipients,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($1c2635f3f60dd539$var$retryOptions)
        });
        if (response.ok) {
            const users = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(response.items, [
                ({ name: name })=>name.toLowerCase()
            ]);
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: users
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchUsersFailed({
                teamId: teamId,
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    async share({ teamId: teamId, conversationId: conversationId, conversationType: conversationType, link: link, message: message }) {
        (0, $jivJx.startUfoExperience)((0, $jivJx.UfoExperiences).SLACK_REQUEST_SENT);
        const origin = new (0, $jkH4Q.default)({
            product: this.product
        });
        const response = await (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/share`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        conversation: {
                            id: conversationId,
                            type: conversationType
                        },
                        link: origin.addToUrl(link),
                        message: message
                    }),
                    signal: this.abortController?.signal
                }),
            mapResult: ()=>Promise.resolve(),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                }),
            signal: this.abortController?.signal
        });
        if (response.ok) {
            const successAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: message.length || 0,
                userCount: this.userStream.count
            };
            this.analytics.onShareSucceeded(successAttributes);
            (0, $jivJx.succeedUfoExperience)((0, $jivJx.UfoExperiences).SLACK_REQUEST_SENT, successAttributes);
        } else if (!response.aborted && !(0, $1VQjI.isAcceptableFailure)(response.status)) {
            const failedAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: response.status,
                errorMessage: response.message
            };
            this.analytics.onShareFailed(failedAttributes);
            (0, $jivJx.failUfoExperience)((0, $jivJx.UfoExperiences).SLACK_REQUEST_SENT, failedAttributes);
        }
        return response.ok ? {
            ok: true,
            result: origin
        } : response;
    }
}

});
parcelRegister("bbg70", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afbb09ecc663fab$export$2e2bcd8739ae039);
function $9afbb09ecc663fab$export$2e2bcd8739ae039(preferredWidth, preferredHeight) {
    const width = Math.min(preferredWidth, window.screen.availWidth);
    const height = Math.min(preferredHeight, window.screen.availHeight);
    return Object.entries({
        toolbar: 0,
        menubar: 0,
        location: 0,
        status: 0,
        scrollbars: 1,
        resizable: 0,
        chrome: 'yes',
        width: width,
        height: height,
        left: Math.round((window.innerWidth - width) / 2 + window.screenX),
        top: Math.round((window.innerHeight - height) / 3 + window.screenY)
    }).map(([key, value])=>`${key}=${value}`).join(',');
}

});

parcelRegister("1VQjI", function(module, exports) {

$parcel$export(module.exports, "isAcceptableFailure", () => $ec7bc8fd219725a1$export$678d91a98f79a24d);
const $ec7bc8fd219725a1$export$678d91a98f79a24d = (statusCode)=>!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;

});

parcelRegister("jivJx", function(module, exports) {

$parcel$export(module.exports, "UfoExperiences", () => $162ede8c67c5cc3d$export$72df3c76208340b5);
$parcel$export(module.exports, "ufoExperiences", () => $162ede8c67c5cc3d$export$615f888019c45765);
$parcel$export(module.exports, "startUfoExperience", () => $162ede8c67c5cc3d$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $162ede8c67c5cc3d$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $162ede8c67c5cc3d$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $162ede8c67c5cc3d$export$b1021040eb94cdca);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $162ede8c67c5cc3d$export$72df3c76208340b5;
(function(UfoExperiences) {
    UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
    UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
    UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
    UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
})($162ede8c67c5cc3d$export$72df3c76208340b5 || ($162ede8c67c5cc3d$export$72df3c76208340b5 = {}));
var $162ede8c67c5cc3d$var$PlatformComponent;
(function(PlatformComponent) {
    PlatformComponent["ShareToSlack"] = "share-to-slack";
    PlatformComponent["CoreInvites"] = "core-invites";
})($162ede8c67c5cc3d$var$PlatformComponent || ($162ede8c67c5cc3d$var$PlatformComponent = {}));
const $162ede8c67c5cc3d$export$615f888019c45765 = {
    ["slack-request-sent"]: new (0, $kDfSL.UFOExperience)("slack-request-sent", {
        type: (0, $12kyE.ExperienceTypes).Experience,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["slack-segment-rendered"]: new (0, $kDfSL.UFOExperience)("slack-segment-rendered", {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["share-form-enabled"]: new (0, $kDfSL.UFOExperience)("share-form-enabled", {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["platform-slack-users-page-fetched"]: new (0, $kDfSL.UFOExperience)("platform-slack-users-page-fetched", {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "core-invites"
        }
    })
};
const $162ede8c67c5cc3d$export$5e9287b6a10f8075 = (experienceName, properties)=>{
    const experience = $162ede8c67c5cc3d$export$615f888019c45765[experienceName];
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $162ede8c67c5cc3d$export$c5a5cf072c836c0e = (experienceName, properties)=>{
    const experience = $162ede8c67c5cc3d$export$615f888019c45765[experienceName];
    experience.success({
        metadata: properties
    });
};
const $162ede8c67c5cc3d$export$8dda83bafca11b77 = (experienceName, properties)=>{
    const experience = $162ede8c67c5cc3d$export$615f888019c45765[experienceName];
    experience.failure({
        metadata: properties
    });
};
const $162ede8c67c5cc3d$export$b1021040eb94cdca = (experienceName, properties)=>{
    const experience = $162ede8c67c5cc3d$export$615f888019c45765[experienceName];
    experience.abort({
        metadata: properties
    });
};

});


parcelRegister("1aHSN", function(module, exports) {

$parcel$export(module.exports, "getSlackServiceAnalytics", () => $ce367bb01fcab500$export$2b9ff26dd710d5d7);
$parcel$export(module.exports, "getConfluenceSlackServiceAnalytics", () => $ce367bb01fcab500$export$2cc68fa43a97a8c);


var $hM7RE = parcelRequire("hM7RE");

const $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams = (0, $hM7RE.default)((0, $7ee89ee043484255$export$85183a312807388d));
var $ce367bb01fcab500$var$AnalyticsActionSubject;
(function(AnalyticsActionSubject) {
    AnalyticsActionSubject["INTEGRATION_SUCCEEDED"] = "integrationEnabled";
    AnalyticsActionSubject["INTEGRATION_TEAMS"] = "integrationTeams";
    AnalyticsActionSubject["INTEGRATION_CONVERSATIONS"] = "integrationConversations";
    AnalyticsActionSubject["INTEGRATION_METADATA"] = "integrationMetadata";
    AnalyticsActionSubject["INTEGRATION_TOKEN"] = "integrationCsrfToken";
    AnalyticsActionSubject["SHARE"] = "share";
})($ce367bb01fcab500$var$AnalyticsActionSubject || ($ce367bb01fcab500$var$AnalyticsActionSubject = {}));
var $ce367bb01fcab500$var$AnalyticsAction;
(function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
})($ce367bb01fcab500$var$AnalyticsAction || ($ce367bb01fcab500$var$AnalyticsAction = {}));
const $ce367bb01fcab500$export$e0925453bd625a62 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationEnabled",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$d533ef9287e29338 = (createAnalyticsEvent, { status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationEnabled",
        action: "failed",
        attributes: {
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$10723e48240e4b6a = (createAnalyticsEvent, { teams: teams, pages: pages })=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationTeams",
        action: "succeeded",
        attributes: {
            teams: teams,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$77d7c2557ef0cb5b = (createAnalyticsEvent, { page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationTeams",
        action: "failed",
        attributes: {
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$1fb50f4a006f5510 = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages })=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationConversations",
        action: "succeeded",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$121a5feec5d3a18f = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationConversations",
        action: "failed",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$503ff4642f649174 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$68485a36cbb1a06f = (createAnalyticsEvent, params)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "failed",
        attributes: {
            ...params
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$5cc3ad7b898341e7 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$757b1ed45dd16a84 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "integrationCsrfToken",
        action: "failed"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$var$productActionSubjectId = {
    jira: 'issue',
    confluence: 'page',
    // default to issue at the moment but should
    // be something else depending on what is actually shared
    // once we implement sharing with the platform slack app
    platform: 'issue'
};
const $ce367bb01fcab500$export$24b0574fd3374a47 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "share",
        action: "succeeded",
        actionSubjectId: $ce367bb01fcab500$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            messageLength: messageLength,
            workspaceSize: userCount
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$867fe86603399772 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: "share",
        action: "failed",
        actionSubjectId: $ce367bb01fcab500$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$5a5d58e4161f41aa = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: "succeeded",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$1286eed6ab074bde = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $ce367bb01fcab500$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: 'integrationConversations',
        action: "failed",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $ce367bb01fcab500$export$2b9ff26dd710d5d7 = (createAnalyticsEvent)=>({
        onGetEnabledSucceeded: ()=>$ce367bb01fcab500$export$e0925453bd625a62(createAnalyticsEvent),
        onGetEnabledFailed: (params)=>$ce367bb01fcab500$export$d533ef9287e29338(createAnalyticsEvent, params),
        onFetchTeamsSucceeded: (params)=>$ce367bb01fcab500$export$10723e48240e4b6a(createAnalyticsEvent, params),
        onFetchTeamsFailed: (params)=>$ce367bb01fcab500$export$77d7c2557ef0cb5b(createAnalyticsEvent, params),
        onFetchUsersSucceeded: ({ teamId: teamId, users: users, pages: pages })=>$ce367bb01fcab500$export$1fb50f4a006f5510(createAnalyticsEvent, {
                slackTeamId: teamId || '',
                conversationTypes: [
                    'directMessage'
                ],
                conversations: users || 0,
                pages: pages
            }),
        onFetchUsersFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>$ce367bb01fcab500$export$121a5feec5d3a18f(createAnalyticsEvent, {
                slackTeamId: teamId,
                conversationTypes: [
                    'directMessage'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage
            }),
        onShareSucceeded: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount })=>{
            $ce367bb01fcab500$export$24b0574fd3374a47({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: messageLength,
                userCount: userCount
            }, createAnalyticsEvent);
        },
        onShareFailed: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage })=>{
            $ce367bb01fcab500$export$867fe86603399772({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: status,
                errorMessage: errorMessage
            }, createAnalyticsEvent);
        },
        onFetchChannelsSucceeded: ({ teamId: teamId, channels: channels, pages: pages })=>{
            $ce367bb01fcab500$export$5a5d58e4161f41aa({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                conversations: channels,
                pages: pages,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        },
        onFetchChannelsFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>{
            $ce367bb01fcab500$export$1286eed6ab074bde({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        }
    });
const $ce367bb01fcab500$export$2cc68fa43a97a8c = (createAnalyticsEvent)=>({
        onFetchConnectMetadataSucceeded: ()=>$ce367bb01fcab500$export$503ff4642f649174(createAnalyticsEvent),
        onFetchConnectMetadataFailed: (params)=>$ce367bb01fcab500$export$68485a36cbb1a06f(createAnalyticsEvent, params),
        onRefreshIntegrationCsrfTokenSucceeded: ()=>$ce367bb01fcab500$export$5cc3ad7b898341e7(createAnalyticsEvent),
        onRefreshIntegrationCsrfTokenFailed: ()=>$ce367bb01fcab500$export$757b1ed45dd16a84(createAnalyticsEvent)
    });

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';


parcelRegister("4J56D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3cba125572afe09$export$2e2bcd8739ae039);


var $lS8iL = parcelRequire("lS8iL");

var $gMceK = parcelRequire("gMceK");
const $c3cba125572afe09$var$consentUrl = {
    prod: `https://confluence-chats-integr.services.atlassian.com/api/slack/teams/login?source=${(0, $7ee89ee043484255$export$83c8d7110915321e)}`,
    staging: `https://confluence-chats-integr.stg.services.atlassian.com/api/slack/teams/login?source=${(0, $7ee89ee043484255$export$83c8d7110915321e)}`
};
const $c3cba125572afe09$var$connectKey = {
    prod: 'confluence-chats-integration',
    staging: 'confluence-chats-integration-stg-east'
};
const $c3cba125572afe09$var$ACQUIRE_CSRF_TIMEOUT_MS = 2000;
async function $c3cba125572afe09$export$2e2bcd8739ae039(location, analytics, signal) {
    const environment = (0, $lS8iL.default)(location.hostname);
    const response = await $c3cba125572afe09$var$getConfluenceSlackIntegrationDialogParams(location, signal);
    if (!response.ok) {
        if (!response.aborted) analytics.onFetchConnectMetadataFailed({
            status: response.status,
            errorMessage: response.message
        });
        return response;
    }
    analytics.onFetchConnectMetadataSucceeded();
    const { contextJwt: contextJwt, url: url } = response.result;
    // Prime the consent URL’s origin with any cookies it needs (namely, the CSRF
    // token) which would ordinarily be set by integration’s dialog.
    //
    // Explanation: This ensures a cookie containing a valid CSRF token is set on
    // the Slack consent popup window’s origin. This is a necessary step because
    // the Slack integration requires a valid CSRF token in the consent page
    // request when its URL contains a jwt query parameter. Failure to provide a
    // CSRF token cookie results in an invalid CSRF token error.
    try {
        await (0, $gMceK.default)(url, $c3cba125572afe09$var$ACQUIRE_CSRF_TIMEOUT_MS);
        analytics.onRefreshIntegrationCsrfTokenSucceeded();
    } catch (error) {
        analytics.onRefreshIntegrationCsrfTokenFailed();
    // Ignore and hope there’s already a valid CSRF token.
    }
    return {
        ok: true,
        result: `${$c3cba125572afe09$var$consentUrl[environment]}&jwt=${encodeURIComponent(contextJwt)}`
    };
}
async function $c3cba125572afe09$var$getConfluenceSlackIntegrationDialogParams(location, signal) {
    const connectPath = $c3cba125572afe09$var$getConnectPath(location);
    try {
        const response = await fetch(connectPath, {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            signal: signal,
            body: Object.entries({
                'plugin-key': 'confluence-chats-integration',
                key: 'dialog',
                productContext: '{}',
                classifier: 'json'
            }).map((kvp)=>kvp.map(encodeURIComponent).join('=')).join('&')
        });
        if (response.ok) return {
            ok: true,
            result: await response.json()
        };
        return {
            ok: false,
            aborted: false,
            status: response.status,
            code: `${response.status}`,
            message: await response.text()
        };
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === 'AbortError') return {
                ok: false,
                aborted: true
            };
            return {
                ok: false,
                aborted: false,
                status: (0, $7ee89ee043484255$export$2c32b0fe4533d89e),
                code: (0, $7ee89ee043484255$export$9267d266a5449137),
                message: error.message || (0, $7ee89ee043484255$export$33789febc109c023)
            };
        }
        return {
            ok: false,
            aborted: false,
            status: (0, $7ee89ee043484255$export$2c32b0fe4533d89e),
            code: (0, $7ee89ee043484255$export$9267d266a5449137),
            message: (0, $7ee89ee043484255$export$33789febc109c023)
        };
    }
}
function $c3cba125572afe09$var$getConnectPath(location) {
    const environment = (0, $lS8iL.default)(location.hostname);
    return `/wiki/plugins/servlet/ac/${$c3cba125572afe09$var$connectKey[environment]}/dialog`;
}

});
parcelRegister("lS8iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5058b8dc02747ec$export$2e2bcd8739ae039);
function $b5058b8dc02747ec$export$2e2bcd8739ae039(hostname) {
    return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
}

});

parcelRegister("gMceK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7ded2306c8d543$export$2e2bcd8739ae039);
/**
 * Fetch the specified URL, which is expected to set one or more cookies on its
 * origin.
 *
 * In order for this to work, a same-origin request is made by temporarily
 * creating an iframe.
 *
 * @param url       - the URL to fetch
 * @param timeoutMs - milliseconds to wait before timing out
 */ function $5b7ded2306c8d543$export$2e2bcd8739ae039(url, timeoutMs) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.position = 'absolute';
    iframe.style.visibility = 'hidden';
    iframe.style.borderWidth = '0';
    document.body.appendChild(iframe);
    return new Promise((resolve, reject)=>{
        let completed = false;
        const timeout = setTimeout(()=>{
            completed = true;
            document.body.removeChild(iframe);
            reject();
        }, timeoutMs);
        iframe.onload = ()=>{
            if (!completed) {
                clearTimeout(timeout);
                completed = true;
                document.body.removeChild(iframe);
                resolve();
            }
        };
    });
}

});



parcelRegister("i263v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f16b611ab626592$export$2e2bcd8739ae039);

var $3oQAd = parcelRequire("3oQAd");

var $1aHSN = parcelRequire("1aHSN");

var $1eYlr = parcelRequire("1eYlr");
class $8f16b611ab626592$export$2e2bcd8739ae039 extends (0, $3oQAd.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $1aHSN.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'jira', analytics);
    }
    async primeConsentUrl() {
        if (!this.consentUrl) this.consentUrl = (0, $1eYlr.default)(location);
    }
}

});
parcelRegister("1eYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b58e60098a5c94$export$2e2bcd8739ae039);


var $lS8iL = parcelRequire("lS8iL");
const $22b58e60098a5c94$var$consentUrl = {
    prod: `https://atlassian-slack-integration.services.atlassian.com/api/slack/login?source=${(0, $7ee89ee043484255$export$83c8d7110915321e)}`,
    staging: `https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login?source=${(0, $7ee89ee043484255$export$83c8d7110915321e)}`
};
function $22b58e60098a5c94$export$2e2bcd8739ae039(location) {
    const environment = (0, $lS8iL.default)(location.hostname);
    return $22b58e60098a5c94$var$consentUrl[environment];
}

});


parcelRegister("lxFlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b867228242956b2f$export$2e2bcd8739ae039);

var $3oQAd = parcelRequire("3oQAd");

var $1aHSN = parcelRequire("1aHSN");


var $jivJx = parcelRequire("jivJx");

var $3XyGA = parcelRequire("3XyGA");
const $b867228242956b2f$var$USER_FETCH_LIMIT = 500;
const $b867228242956b2f$var$RETRY_OPTIONS = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $b867228242956b2f$export$2e2bcd8739ae039 extends (0, $3oQAd.default) {
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $1aHSN.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'platform', analytics);
    }
    streamUsers(teamId, onResponse, cursor) {
        (0, $jivJx.startUfoExperience)((0, $jivJx.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
            limit: $b867228242956b2f$var$USER_FETCH_LIMIT
        });
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            teamId: teamId,
            cloudId: this.cloudId,
            limit: $b867228242956b2f$var$USER_FETCH_LIMIT.toString(),
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${(0, $7ee89ee043484255$export$ab2f49a861856bab)}${(0, $7ee89ee043484255$export$127769e597bc5ee5)}/slack/users?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($b867228242956b2f$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) {
                    this.analytics.onFetchUsersFailed({
                        teamId: teamId,
                        page: this.userStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    (0, $jivJx.failUfoExperience)((0, $jivJx.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                } else (0, $jivJx.abortUfoExperience)((0, $jivJx.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.users.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.users.map(({ id: id, email: email, displayName: displayName, realName: name, avatar: avatarUrl })=>({
                        id: id,
                        name: name,
                        displayName: displayName,
                        avatarUrl: avatarUrl,
                        email: email,
                        type: 'directMessage'
                    })),
                nextCursor: resp.result.nextCursor
            });
            (0, $jivJx.succeedUfoExperience)((0, $jivJx.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                numResults: resp.result.users.length
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    /*
	 * Temporary experiment endpoint for Invite 3rd Party Team (ITPT)
	 */ streamChannelsExperiment(workspaceId, onResponse, onError, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            workspaceId: workspaceId,
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $3XyGA.retryFetch)({
            request: ()=>fetch(`${(0, $7ee89ee043484255$export$ab2f49a861856bab)}${(0, $7ee89ee043484255$export$20875166a8676880)}${(0, $7ee89ee043484255$export$3f9855fcc7fa383e)}?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $3XyGA.httpRetryPolicy)($b867228242956b2f$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannelsExperiment(workspaceId, onResponse, onError, resp.result.nextCursor);
        }).catch((error)=>{
            onError(error);
        });
    }
    // This was necessary since it was abstract in the base class
    // but is not used in this slack service
    async primeConsentUrl() {}
}

});


parcelRegister("enb7h", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $898882c2165eb45f$export$b9ec44715ae5ad99);

var $eUqFw = parcelRequire("eUqFw");

var $7ZwLV = parcelRequire("7ZwLV");
const $898882c2165eb45f$export$b9ec44715ae5ad99 = (useInvitePeopleModalProps)=>{
    const { onClose: onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
    const { openModal: openModal, closeModal: closeModal, isOpen: isOpen } = (0, $eUqFw.useContext)((0, $7ZwLV.InvitePeopleModalContext));
    return {
        // this is experimental only and should not be used without consulting !core-invtes in #groot-techops
        experimental_openModal: (propsOverride)=>openModal({
                ...invitePeopleProps,
                ...propsOverride
            }, onClose),
        openModal: ()=>openModal(invitePeopleProps, onClose),
        closeModal: closeModal,
        isOpen: isOpen
    };
};

});

parcelRegister("16UJG", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("gdgmj")).AbstractResource);

$parcel$export(module.exports, "utils", () => $30e3ff12b332d773$export$eab97d15b1788b8d);
parcelRequire("1GW5Z");
parcelRequire("gdgmj");

var $eG8mk = parcelRequire("eG8mk");
const $30e3ff12b332d773$export$eab97d15b1788b8d = $eG8mk;

});
parcelRegister("1GW5Z", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $b0494a54f1853cda$export$2ac26f1ab7eda637);
const $b0494a54f1853cda$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("gdgmj", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $f733c180c466e71c$export$4529f10aed0950d4);
class $f733c180c466e71c$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("eG8mk", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $55e0d7df395d2852$export$97bfde5a702aaeca);

var $1GW5Z = parcelRequire("1GW5Z");
const $55e0d7df395d2852$var$defaultRequestServiceOptions = {};
const $55e0d7df395d2852$var$buildUrl = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $55e0d7df395d2852$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $55e0d7df395d2852$var$buildHeaders = (secOptions, extraHeaders)=>{
    const headers = {};
    $55e0d7df395d2852$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $55e0d7df395d2852$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
const $55e0d7df395d2852$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || $55e0d7df395d2852$var$defaultRequestServiceOptions;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = $55e0d7df395d2852$var$buildUrl(url, path, queryParams, secOptions);
    const headers = $55e0d7df395d2852$var$buildHeaders(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $1GW5Z.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    const requestOptions = {
        ...requestInit,
        headers: headers,
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $55e0d7df395d2852$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});


parcelRegister("6BD9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5bd3b2b1c3a4ae$export$2e2bcd8739ae039);

var $h4jeE = parcelRequire("h4jeE");
const $ef5bd3b2b1c3a4ae$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $ef5bd3b2b1c3a4ae$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
					 * Commented out removing this item, as it is a slightly different state
					 * to the item not existing that we may want to preserve.
					 *  this.client.removeItem(this.itemKey(key));
					 */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $ef5bd3b2b1c3a4ae$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $h4jeE.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers?.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("h4jeE", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", () => $d13c58bdee1481e4$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers that have disabled local storage setting
 */ const $d13c58bdee1481e4$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        return Object.keys(this._data)[index];
    }
};
const $d13c58bdee1481e4$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    for (const storageToMockElement of storageToMock)Object.defineProperty(window, storageToMockElement, {
        value: {
            ...$d13c58bdee1481e4$export$c65e688d8b365035
        },
        configurable: true
    });
};

});


parcelRegister("taXj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $057b35180044d2aa$export$2e2bcd8739ae039);
function $057b35180044d2aa$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $057b35180044d2aa$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $057b35180044d2aa$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $057b35180044d2aa$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $057b35180044d2aa$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $057b35180044d2aa$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $057b35180044d2aa$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $057b35180044d2aa$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $057b35180044d2aa$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $057b35180044d2aa$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $057b35180044d2aa$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $057b35180044d2aa$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $057b35180044d2aa$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $057b35180044d2aa$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $057b35180044d2aa$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $057b35180044d2aa$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $057b35180044d2aa$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $057b35180044d2aa$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $057b35180044d2aa$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $057b35180044d2aa$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $057b35180044d2aa$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $057b35180044d2aa$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $057b35180044d2aa$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $057b35180044d2aa$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $057b35180044d2aa$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $057b35180044d2aa$var$fromHex_1 = $057b35180044d2aa$var$fromHex, $057b35180044d2aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $057b35180044d2aa$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $057b35180044d2aa$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $057b35180044d2aa$var$fromRgb_1 = $057b35180044d2aa$var$fromRgb, $057b35180044d2aa$var$fromCssRgb_1 = $057b35180044d2aa$var$fromCssRgb, $057b35180044d2aa$var$fromHsl_1 = $057b35180044d2aa$var$fromHsl, $057b35180044d2aa$var$fromCssHsl_1 = $057b35180044d2aa$var$fromCssHsl, $057b35180044d2aa$var$fromHsv_1 = $057b35180044d2aa$var$fromHsv, $057b35180044d2aa$var$fromCmyk_1 = $057b35180044d2aa$var$fromCmyk, $057b35180044d2aa$var$fromYiq_1 = $057b35180044d2aa$var$fromYiq, $057b35180044d2aa$var$fromXYZ_1 = $057b35180044d2aa$var$fromXYZ, $057b35180044d2aa$var$fromxyY_1 = $057b35180044d2aa$var$fromxyY, $057b35180044d2aa$var$fromLms_1 = $057b35180044d2aa$var$fromLms, $057b35180044d2aa$var$fromCieLab_1 = $057b35180044d2aa$var$fromCieLab, $057b35180044d2aa$var$fromCieLuv_1 = $057b35180044d2aa$var$fromCieLuv, $057b35180044d2aa$var$fromCieLch_1 = $057b35180044d2aa$var$fromCieLch, $057b35180044d2aa$var$fromHsluv = $057b35180044d2aa$var$fromCieLch$1, $057b35180044d2aa$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $057b35180044d2aa$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $057b35180044d2aa$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $057b35180044d2aa$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $057b35180044d2aa$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $057b35180044d2aa$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $057b35180044d2aa$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $057b35180044d2aa$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $057b35180044d2aa$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $057b35180044d2aa$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $057b35180044d2aa$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $057b35180044d2aa$var$fromHsluv
    }
}, $057b35180044d2aa$var$adapt_1 = $057b35180044d2aa$var$adapt, $057b35180044d2aa$var$adjacent_1 = $057b35180044d2aa$var$adjacent, $057b35180044d2aa$var$brightness_1 = $057b35180044d2aa$var$brightness, $057b35180044d2aa$var$complementary_1 = $057b35180044d2aa$var$complementary, $057b35180044d2aa$var$contrast_1 = $057b35180044d2aa$var$contrast, $057b35180044d2aa$var$contrastRatio_1 = $057b35180044d2aa$var$contrastRatio, $057b35180044d2aa$var$convert_1 = $057b35180044d2aa$var$convert, $057b35180044d2aa$var$difference_1 = $057b35180044d2aa$var$difference, $057b35180044d2aa$var$fade_1 = $057b35180044d2aa$var$fade, $057b35180044d2aa$var$greyscale_1 = $057b35180044d2aa$var$greyscale, $057b35180044d2aa$var$hue_1 = $057b35180044d2aa$var$hue, $057b35180044d2aa$var$invert_1 = $057b35180044d2aa$var$invert, $057b35180044d2aa$var$invertLightness_1 = $057b35180044d2aa$var$invertLightness, $057b35180044d2aa$var$mid_1 = $057b35180044d2aa$var$mid, $057b35180044d2aa$var$multiply_1 = $057b35180044d2aa$var$multiply, $057b35180044d2aa$var$saturation_1 = $057b35180044d2aa$var$saturation, $057b35180044d2aa$var$sepia_1 = $057b35180044d2aa$var$sepia, $057b35180044d2aa$var$shade_1 = $057b35180044d2aa$var$shade, $057b35180044d2aa$var$temperature_1 = $057b35180044d2aa$var$temperature, $057b35180044d2aa$var$tetrad_1 = $057b35180044d2aa$var$tetrad, $057b35180044d2aa$var$triad_1 = $057b35180044d2aa$var$triad, $057b35180044d2aa$var$index$2 = {
    adapt: $057b35180044d2aa$var$adapt_1,
    adjacent: $057b35180044d2aa$var$adjacent_1,
    brightness: $057b35180044d2aa$var$brightness_1,
    complementary: $057b35180044d2aa$var$complementary_1,
    contrast: $057b35180044d2aa$var$contrast_1,
    contrastRatio: $057b35180044d2aa$var$contrastRatio_1,
    convert: $057b35180044d2aa$var$convert_1,
    difference: $057b35180044d2aa$var$difference_1,
    fade: $057b35180044d2aa$var$fade_1,
    greyscale: $057b35180044d2aa$var$greyscale_1,
    hue: $057b35180044d2aa$var$hue_1,
    invert: $057b35180044d2aa$var$invert_1,
    invertLightness: $057b35180044d2aa$var$invertLightness_1,
    mid: $057b35180044d2aa$var$mid_1,
    multiply: $057b35180044d2aa$var$multiply_1,
    saturation: $057b35180044d2aa$var$saturation_1,
    sepia: $057b35180044d2aa$var$sepia_1,
    shade: $057b35180044d2aa$var$shade_1,
    temperature: $057b35180044d2aa$var$temperature_1,
    tetrad: $057b35180044d2aa$var$tetrad_1,
    triad: $057b35180044d2aa$var$triad_1
}, $057b35180044d2aa$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $057b35180044d2aa$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $057b35180044d2aa$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($057b35180044d2aa$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $057b35180044d2aa$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($057b35180044d2aa$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $057b35180044d2aa$var$api_1 = $057b35180044d2aa$var$api, $057b35180044d2aa$var$helpers = {
    getIlluminant: function(r) {
        return $057b35180044d2aa$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $057b35180044d2aa$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $057b35180044d2aa$var$index)if ($057b35180044d2aa$var$index.hasOwnProperty(e) && $057b35180044d2aa$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $057b35180044d2aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $057b35180044d2aa$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $057b35180044d2aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $057b35180044d2aa$var$constants, s));
            default:
                return null;
        }
    }
}, $057b35180044d2aa$var$helpers_1 = $057b35180044d2aa$var$helpers, $057b35180044d2aa$var$dependencies = {
    conversions: $057b35180044d2aa$var$index,
    operations: $057b35180044d2aa$var$index$2,
    helpers: $057b35180044d2aa$var$helpers_1
}, $057b35180044d2aa$var$entry = $057b35180044d2aa$var$api_1($057b35180044d2aa$var$dependencies, $057b35180044d2aa$var$constants);
var $057b35180044d2aa$export$2e2bcd8739ae039 = $057b35180044d2aa$var$entry;

});

parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("jZ5HC", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $4ed66b44f8644add$export$3c29cca421979b0e);

var $eUqFw = parcelRequire("eUqFw");
const $4ed66b44f8644add$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $eUqFw.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("hXPzA", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("6wYjl")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("6wYjl")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("6wYjl")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("6waSD")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("6waSD")).Reasons);

var $6wYjl = parcelRequire("6wYjl");

var $6waSD = parcelRequire("6waSD");

});
parcelRegister("6wYjl", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $606dd72bb06c61b6$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $606dd72bb06c61b6$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $606dd72bb06c61b6$export$655b6c19a0daddb8);

var $eUqFw = parcelRequire("eUqFw");

var $kms3n = parcelRequire("kms3n");

var $6waSD = parcelRequire("6waSD");
const $606dd72bb06c61b6$var$LATEST_VERSION = (0, $kms3n.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $606dd72bb06c61b6$var$CrossFlowContext = /*#__PURE__*/ (0, $eUqFw.createContext)(()=>({
        isEnabled: false,
        reason: (0, $6waSD.Reasons).NO_PROVIDER
    }));
const $606dd72bb06c61b6$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $kms3n.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $kms3n.createAPIv0)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $6waSD.Reasons).NO_API_SUPPORT
                };
        }
    };
const $606dd72bb06c61b6$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $eUqFw.useMemo)(()=>$606dd72bb06c61b6$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($606dd72bb06c61b6$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $606dd72bb06c61b6$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $eUqFw.useContext)($606dd72bb06c61b6$var$CrossFlowContext);
    return (0, $eUqFw.useMemo)(()=>negotiateApi($606dd72bb06c61b6$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $606dd72bb06c61b6$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $606dd72bb06c61b6$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("kms3n", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $0a8c1b627b4c08ea$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv0", () => $0a8c1b627b4c08ea$export$9ff7368ac93fcf2d);
const $0a8c1b627b4c08ea$export$a4ad2735b021c132 = 0;
const $0a8c1b627b4c08ea$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("6waSD", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $d119a1389c5a1fdc$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $d119a1389c5a1fdc$export$da2d4f2f250d6f84);
const $d119a1389c5a1fdc$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $d119a1389c5a1fdc$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("8a0ZO", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("kxJAm")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("bPFq3")).Targets);

var $kxJAm = parcelRequire("kxJAm");

var $bPFq3 = parcelRequire("bPFq3");

});
parcelRegister("kxJAm", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $694aea767013a371$export$a5e53d1dcbd6eb61);
class $694aea767013a371$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("bPFq3", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $ff4315d85018519c$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $ff4315d85018519c$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand'
};

});


parcelRegister("fbeIa", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("6wYjl")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("6wYjl")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("6waSD")).Journeys);
$parcel$export(module.exports, "Targets", () => (parcelRequire("bPFq3")).Targets);
parcelRequire("hXPzA");
var $6waSD = parcelRequire("6waSD");
var $6wYjl = parcelRequire("6wYjl");
parcelRequire("8a0ZO");
var $bPFq3 = parcelRequire("bPFq3");

var $2UT5H = parcelRequire("2UT5H");

});
parcelRegister("2UT5H", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("hXPzA");
var $6wYjl = parcelRequire("6wYjl");
const $fc9614b9412cfff7$export$bb23a1e8e036feea = (props)=>{
    // Using useRef here to ensure that only the initial props are used
    // and it ensures that the useEffect handler below is only run once.
    // Any subsequent changes to props have no effect.
    const propsRef = (0, $eUqFw.useRef)(props);
    const crossFlowRef = (0, $eUqFw.useRef)((0, $6wYjl.useCrossFlow)());
    (0, $eUqFw.useEffect)(()=>{
        const crossFlow = crossFlowRef.current;
        (async ()=>{
            const { onComplete: onComplete, onError: onError, ...options } = propsRef.current;
            if (crossFlow.isEnabled) try {
                const status = await crossFlow.api.open(options);
                onComplete?.(status);
            } catch (err) {
                onError?.(err);
            }
        })();
    }, []);
    return null;
};

});


parcelRegister("9ngKA", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $242e052eccf5db88$export$e955abb82869dc84);

var $eUqFw = parcelRequire("eUqFw");

var $cPQ3Q = parcelRequire("cPQ3Q");
var $bFzGY = parcelRequire("bFzGY");

var $kSKS9 = parcelRequire("kSKS9");

var $hVQSl = parcelRequire("hVQSl");

var $ca2wn = parcelRequire("ca2wn");

var $cvWKT = parcelRequire("cvWKT");
const $242e052eccf5db88$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $242e052eccf5db88$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $242e052eccf5db88$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef } = (0, $kSKS9.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $eUqFw.useCallback)((inputPayload)=>{
        const payload = inputPayload instanceof (0, $cPQ3Q.default) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $242e052eccf5db88$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const getDefaultAttributes = (0, $eUqFw.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product } = propertiesRef.current;
        return {
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $hVQSl.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $eUqFw.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$242e052eccf5db88$var$DEFAULT_TAGS
        ];
        if ($242e052eccf5db88$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, timestamp: timestamp, is3PLink: is3PLink } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            is3PLink: is3PLink
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        // Handle specific AI MAU events
        switch(payload.type){
            case 'initiated':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'initiated'
                };
                break;
            case 'viewed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'viewed'
                };
                break;
            case 'error':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'error'
                };
                break;
            case 'dismissed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'dismissed'
                };
                break;
            case 'actioned':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'actioned',
                    attributes: {
                        ...eventPayload.attributes,
                        aiResultAction: payload.actionResult
                    }
                };
                break;
            case 'feedback':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiFeedback',
                    action: 'submitted',
                    attributes: {
                        ...eventPayload.attributes,
                        aiFeedbackResult: payload.feedbackResult
                    }
                };
                break;
        }
        // Build event and apply context attributes
        const event = createAnalyticsEvent(eventPayload);
        const aiMateContextAttributes = (0, $cvWKT.getAttributesFromContexts)(event.context);
        // Fire
        event.update({
            attributes: {
                ...event.payload.attributes,
                ...aiMateContextAttributes
            }
        }).fire((0, $ca2wn.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        getDefaultAttributes
    ]);
    const sendAnalyticsEvent = (0, $eUqFw.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $242e052eccf5db88$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if (payload instanceof (0, $cPQ3Q.default)) {
            const aiMateContextAttributes = (0, $cvWKT.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $ca2wn.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $cvWKT.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $ca2wn.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent
    };
};

});
parcelRegister("kSKS9", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $f43162cbfdeaa728$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $f43162cbfdeaa728$export$ab8aa3dfd687f012);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $f43162cbfdeaa728$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    propertiesRef: {
        current: {
            conversationChannelId: '',
            experienceId: '',
            product: '',
            agentId: null,
            fullScreen: false,
            agentCreatorType: '',
            agentVisibility: '',
            singleInstrumentationID: ''
        }
    },
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $f43162cbfdeaa728$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
    const propertiesRef = (0, $eUqFw.useRef)({
        conversationChannelId: '',
        experienceId: '',
        product: '',
        agentId: null,
        fullScreen: false,
        agentCreatorType: '',
        agentVisibility: '',
        singleInstrumentationID: ''
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $eUqFw.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            propertiesRef: propertiesRef,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f43162cbfdeaa728$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $f43162cbfdeaa728$export$a00cd3c213413389 = ({ source: source, children: children })=>{
    const data = (0, $eUqFw.useMemo)(()=>({
            source: source
        }), [
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f43162cbfdeaa728$export$1aefd27d2ed3c1c9, null, children));
};
const $f43162cbfdeaa728$export$ab8aa3dfd687f012 = ()=>{
    return (0, $eUqFw.useContext)($f43162cbfdeaa728$var$AnalyticsPropertiesContext);
};

});

parcelRegister("hVQSl", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $7ad7366e1d4a6111$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $7ad7366e1d4a6111$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    product: 'product',
    singleInstrumentationID: 'singleInstrumentationID'
};

});

parcelRegister("ca2wn", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $cc3e725e06424e5b$export$85183a312807388d);

var $6PJBT = parcelRequire("6PJBT");
const $cc3e725e06424e5b$export$85183a312807388d = (0, $6PJBT.FabricChannel).aiMate;

});

parcelRegister("cvWKT", function(module, exports) {

$parcel$export(module.exports, "getAttributesFromContexts", () => $e448a5461fdd9388$export$d97c97ed77ff09e8);
const $e448a5461fdd9388$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return true;
};
const $e448a5461fdd9388$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let aiMateOnly = context.filter((x)=>$e448a5461fdd9388$var$isSourceAndAttributes(x) && x.source === 'AIMate');
    return aiMateOnly.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};

});


parcelRegister("kIMU7", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $76151e4ba3e4933f$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $76151e4ba3e4933f$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $76151e4ba3e4933f$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $76151e4ba3e4933f$export$60959659b2c22881);

var $eUqFw = parcelRequire("eUqFw");
const $76151e4ba3e4933f$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload'
]);
const $76151e4ba3e4933f$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = events.length.toString();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$76151e4ba3e4933f$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish
    };
};
const $76151e4ba3e4933f$var$pubSub = $76151e4ba3e4933f$var$createPubSub();
const $76151e4ba3e4933f$var$usePubSub = ()=>{
    return $76151e4ba3e4933f$var$pubSub;
};
const $76151e4ba3e4933f$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $76151e4ba3e4933f$var$usePubSub();
    const callbackRef = (0, $eUqFw.useRef)(callback);
    callbackRef.current = callback;
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $76151e4ba3e4933f$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $76151e4ba3e4933f$var$usePubSub();
    const callbackRef = (0, $eUqFw.useRef)(callback);
    callbackRef.current = callback;
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $76151e4ba3e4933f$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $76151e4ba3e4933f$var$usePubSub();
    const publishFn = (0, $eUqFw.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $76151e4ba3e4933f$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent })=>{
    $76151e4ba3e4933f$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    return null;
};

});

parcelRegister("8CIQt", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", () => $3f6d2bafc33240ac$export$a0f6cb8061290bbb);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $3f6d2bafc33240ac$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8859 4.24256C12.3462 3.92351 11.6816 3.91921 11.1385 4.22964C11.1307 4.23541 11.1226 4.24083 11.1141 4.24585L11.114 4.2459L11.1129 4.24659C10.7631 4.45372 10.4987 4.77394 10.3536 5.14702C10.2734 5.35552 10.2305 5.58075 10.2305 5.81255V8.20867L13.1599 9.94087L13.1601 9.94098C13.8796 10.3649 14.3207 11.1485 14.3207 11.9983L14.3207 18.1841C14.3207 18.4616 14.2732 18.7325 14.1841 18.9861L18.1141 16.6613L18.1145 16.661C18.6633 16.3377 19 15.7403 19 15.0912V8.90544C19 8.25896 18.6614 7.6589 18.1142 7.33545L18.1141 7.33541L12.8859 4.24256Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7695 18.1875C13.7695 18.4196 13.7265 18.645 13.6461 18.8537C13.5008 19.2269 13.2361 19.5472 12.8859 19.7542L12.8859 19.7542C12.8774 19.7592 12.8693 19.7646 12.8615 19.7704C12.3184 20.0808 11.6538 20.0765 11.1141 19.7575L11.114 19.7575L5.88586 16.6646L5.88579 16.6646C5.33861 16.3411 5 15.7411 5 15.0946L5 8.90882C5 8.25978 5.33663 7.66233 5.88543 7.33904L9.81585 5.01392C9.72678 5.26758 9.67926 5.53842 9.67926 5.81593V12.0017C9.67926 12.8514 10.1203 13.635 10.8397 14.059L10.8401 14.0592L13.7695 15.7914V18.1875Z",
        fill: "currentColor"
    }));
const $3f6d2bafc33240ac$export$a0f6cb8061290bbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $3f6d2bafc33240ac$var$CustomGlyph,
        primaryColor: "var(--ds-icon-brand, #0C66E4)",
        ...props
    });

});

parcelRegister("jraxv", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $3b7d8ccdc00d8b90$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $3b7d8ccdc00d8b90$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $3b7d8ccdc00d8b90$export$eddc20a009406015);

var $86gqG = parcelRequire("86gqG");
const $3b7d8ccdc00d8b90$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $3b7d8ccdc00d8b90$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $3b7d8ccdc00d8b90$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $3b7d8ccdc00d8b90$export$9748efee331ec573 = (param)=>`${0, $86gqG.ROVO_PARAM_PREFIX}${$3b7d8ccdc00d8b90$export$fda91e425d265029(param)}`;
const $3b7d8ccdc00d8b90$export$f2888183a34644d4 = (param)=>{
    return $3b7d8ccdc00d8b90$export$858653b7ee3cbb17(param.replace((0, $86gqG.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $3b7d8ccdc00d8b90$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $3b7d8ccdc00d8b90$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $86gqG.ROVO_PARAM_PREFIX))) return;
        const paramKey = $3b7d8ccdc00d8b90$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $3b7d8ccdc00d8b90$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $3b7d8ccdc00d8b90$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $3b7d8ccdc00d8b90$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $3b7d8ccdc00d8b90$export$ef04687636c850fe(window.location.pathname, params));
};
const $3b7d8ccdc00d8b90$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $3b7d8ccdc00d8b90$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $3b7d8ccdc00d8b90$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $3b7d8ccdc00d8b90$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$3b7d8ccdc00d8b90$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$3b7d8ccdc00d8b90$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $3b7d8ccdc00d8b90$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $3b7d8ccdc00d8b90$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $86gqG.ROVO_VALID_PARAMS).map((param)=>`${$3b7d8ccdc00d8b90$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("86gqG", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $331b31232415eabe$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $331b31232415eabe$export$3cd6b610e7ede579);
const $331b31232415eabe$export$5a550907ffbc9119 = 'rovoChat';
const $331b31232415eabe$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen'
];

});


parcelRegister("itKco", function(module, exports) {

$parcel$export(module.exports, "useRovoEntitlement", () => $a6cf3e830705007f$export$66d5dd4be64dea43);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $a6cf3e830705007f$export$d03a05ad8547472c);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $a6cf3e830705007f$var$rovoEntitlementStore = (0, $WBLbN.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $a6cf3e830705007f$var$useStateHook = (0, $WBLbN.createStateHook)($a6cf3e830705007f$var$rovoEntitlementStore);
const $a6cf3e830705007f$export$66d5dd4be64dea43 = ()=>{
    const result = $a6cf3e830705007f$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $a6cf3e830705007f$export$8004893135276275 = (0, $WBLbN.createActionsHook)($a6cf3e830705007f$var$rovoEntitlementStore);
const $a6cf3e830705007f$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $a6cf3e830705007f$export$8004893135276275();
    (0, $eUqFw.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("7OD2s", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $3717b525e287c93f$export$224367b01f71f2aa);

var $lAaEy = parcelRequire("lAaEy");

var $1N36E = parcelRequire("1N36E");
let $3717b525e287c93f$var$previousClientVersion;
const $3717b525e287c93f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($3717b525e287c93f$var$previousClientVersion && $3717b525e287c93f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $3717b525e287c93f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $lAaEy.ActivityClientV2)(product, baseUrl);
    return new (0, $1N36E.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("lAaEy", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $299ae2b81346e4f9$export$330ab0047f2fb745);

var $ku8ih = parcelRequire("ku8ih");

var $a7LZ2 = parcelRequire("a7LZ2");

var $jNHrN = parcelRequire("jNHrN");
class $299ae2b81346e4f9$export$330ab0047f2fb745 extends (0, $a7LZ2.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $ku8ih.fetchActivitiesWithExperience)((experience)=>(0, $jNHrN.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("ku8ih", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $0321b85bec86771e$export$4a906f16800734f3);

var $k6CIf = parcelRequire("k6CIf");

var $bRFOx = parcelRequire("bRFOx");

var $hCvXY = parcelRequire("hCvXY");
async function $0321b85bec86771e$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $hCvXY.recentWorkClientExperienceV2)() : (0, $hCvXY.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $bRFOx.packageName,
            packageVersion: $bRFOx.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $0321b85bec86771e$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $0321b85bec86771e$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $k6CIf.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("k6CIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d9e9ac2d41c7b7$export$2e2bcd8739ae039);
class $e6d9e9ac2d41c7b7$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $e6d9e9ac2d41c7b7$export$97b788730ba59845 = (e)=>e instanceof $e6d9e9ac2d41c7b7$export$2e2bcd8739ae039;

});

parcelRegister("bRFOx", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $66f840e811fbbabd$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $66f840e811fbbabd$export$91546b032799aa40);
const $66f840e811fbbabd$export$9345d7360ffe0722 = "platform-pkg";
const $66f840e811fbbabd$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("hCvXY", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $a6e60f0a5572165f$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $a6e60f0a5572165f$export$9e32a4ed888f4717);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $a6e60f0a5572165f$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $a6e60f0a5572165f$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($a6e60f0a5572165f$var$keyToTiming);
const $a6e60f0a5572165f$export$d7769758f5eaa63b = ()=>{
    return new (0, $kDfSL.UFOExperience)('client', {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a6e60f0a5572165f$var$timings
    });
};
const $a6e60f0a5572165f$export$9e32a4ed888f4717 = ()=>new (0, $kDfSL.UFOExperience)('client-v3', {
        type: (0, $12kyE.ExperienceTypes).Load,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a6e60f0a5572165f$var$timings
    });

});


parcelRegister("a7LZ2", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $9a0ff6cf0c3b87f6$export$157740f5433f3dbe);

var $lIN21 = parcelRequire("lIN21");
class $9a0ff6cf0c3b87f6$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $lIN21.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("lIN21", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $df9245ab91de6bce$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $df9245ab91de6bce$export$eb4e9f525aef1cc3);
const $df9245ab91de6bce$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $df9245ab91de6bce$export$d245b105c09339d8;
(function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
})($df9245ab91de6bce$export$d245b105c09339d8 || ($df9245ab91de6bce$export$d245b105c09339d8 = {}));
var $df9245ab91de6bce$export$eb4e9f525aef1cc3;
(function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
})($df9245ab91de6bce$export$eb4e9f525aef1cc3 || ($df9245ab91de6bce$export$eb4e9f525aef1cc3 = {}));
var $df9245ab91de6bce$export$d02a56686be43f69;
(function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
})($df9245ab91de6bce$export$d02a56686be43f69 || ($df9245ab91de6bce$export$d02a56686be43f69 = {}));

});


parcelRegister("jNHrN", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $b8698fe74741cc27$export$750ec7816fdd2f9e);

var $5C73L = parcelRequire("5C73L");

var $ZxUBV = parcelRequire("ZxUBV");

var $4BJxO = parcelRequire("4BJxO");

var $hwEyN = parcelRequire("hwEyN");
const $b8698fe74741cc27$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $b8698fe74741cc27$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $b8698fe74741cc27$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $b8698fe74741cc27$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $b8698fe74741cc27$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $4BJxO.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $b8698fe74741cc27$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $ZxUBV.postResource)(baseUrl, {
            operationName: (0, $5C73L.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($b8698fe74741cc27$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $hwEyN.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $hwEyN.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $hwEyN.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $hwEyN.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $hwEyN.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("5C73L", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $046bcb531d7cc6a8$export$41bca9dc6871dd4e);

var $jh2R9 = parcelRequire("jh2R9");
const $046bcb531d7cc6a8$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(product);
};
const $046bcb531d7cc6a8$export$41bca9dc6871dd4e = (product)=>{
    return `${$046bcb531d7cc6a8$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("ZxUBV", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $559068669abf53c6$export$2ff3e1f219ccfad6);
parcelRequire("45owE");
var $7qhNL = parcelRequire("7qhNL");
var $45owE = parcelRequire("45owE");

var $esyZx = parcelRequire("esyZx");

var $k6CIf = parcelRequire("k6CIf");
const $559068669abf53c6$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $esyZx.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $7qhNL.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $559068669abf53c6$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $k6CIf.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $559068669abf53c6$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $559068669abf53c6$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $559068669abf53c6$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $45owE.retryOnException)(()=>$559068669abf53c6$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $559068669abf53c6$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("45owE", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $e157174ff0ba4a41$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("7qhNL")).default);

var $byYfF = parcelRequire("byYfF");

var $2ZoHW = parcelRequire("2ZoHW");

var $7qhNL = parcelRequire("7qhNL");
const $e157174ff0ba4a41$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $e157174ff0ba4a41$var$NO_CALLS_ERROR = 'No calls made';
const $e157174ff0ba4a41$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $2ZoHW.NO_RETRIES), retryOn: retryOn = [
    (0, $7qhNL.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($e157174ff0ba4a41$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $e157174ff0ba4a41$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $e157174ff0ba4a41$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $byYfF.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("2ZoHW", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", () => $e20c214c1fd5c843$export$a0a1c8f90becc136);
const $e20c214c1fd5c843$export$a0a1c8f90becc136 = [];
const $e20c214c1fd5c843$export$972171517b12aa4 = [
    0,
    0
];
const $e20c214c1fd5c843$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $e20c214c1fd5c843$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("7qhNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9efe841de14d49e$export$2e2bcd8739ae039);
class $d9efe841de14d49e$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("esyZx", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $cca3a8206982f6b7$export$2414511207262909);
const $cca3a8206982f6b7$var$urlRegex = new RegExp(/^https?:\/\//);
function $cca3a8206982f6b7$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($cca3a8206982f6b7$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("4BJxO", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $64dab3eaf7b17eb3$export$855cd08371c65b8c);

var $5C73L = parcelRequire("5C73L");

var $3qgUQ = parcelRequire("3qgUQ");
const $64dab3eaf7b17eb3$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $64dab3eaf7b17eb3$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$64dab3eaf7b17eb3$var$ACTIVITIES}
   }
`;
const $64dab3eaf7b17eb3$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$64dab3eaf7b17eb3$var$ACTIVITIES}
   }
`;
const $64dab3eaf7b17eb3$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$64dab3eaf7b17eb3$var$ACTIVITIES}
    }
`;
const $64dab3eaf7b17eb3$var$activityQueryMap = new Map([
    [
        'workedOn',
        $64dab3eaf7b17eb3$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $64dab3eaf7b17eb3$var$VIEWED__QUERY
    ],
    [
        'all',
        $64dab3eaf7b17eb3$var$ALL__QUERY
    ]
]);
const $64dab3eaf7b17eb3$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $64dab3eaf7b17eb3$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $5C73L.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $64dab3eaf7b17eb3$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $64dab3eaf7b17eb3$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$64dab3eaf7b17eb3$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $3qgUQ.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $64dab3eaf7b17eb3$var$getActivitiesQuery(product, $64dab3eaf7b17eb3$var$getMyActivitiesQuery(activityQueries.map((query)=>$64dab3eaf7b17eb3$var$activityQueryMap.get(query)))),
        queryFilters: (0, $3qgUQ.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("3qgUQ", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $d98a6ac392082ac6$export$5201d39848130041);

var $gDtfg = parcelRequire("gDtfg");

var $463SC = parcelRequire("463SC");
const $d98a6ac392082ac6$export$5201d39848130041 = {
    v2: (0, $gDtfg.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $463SC.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("gDtfg", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $77cd3d994937641f$export$1dca7bc1ec360897);

var $546bY = parcelRequire("546bY");

var $a1RSJ = parcelRequire("a1RSJ");
const $77cd3d994937641f$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $a1RSJ.default)
    ],
    [
        'activities',
        (0, $546bY.default)
    ]
]);

});
parcelRegister("546bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc21f6352337439$export$2e2bcd8739ae039);

var $2Vvj7 = parcelRequire("2Vvj7");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $bcc21f6352337439$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2Vvj7.generateActivityFiltersV2)(restFilters);
};
var $bcc21f6352337439$export$2e2bcd8739ae039 = $bcc21f6352337439$var$generateV2ActivitiesFilters;

});
parcelRegister("2Vvj7", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $015f881651e1628d$export$ebef9c1f1e15c057);

var $92yfY = parcelRequire("92yfY");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $015f881651e1628d$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $015f881651e1628d$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $015f881651e1628d$export$ebef9c1f1e15c057 = (filters = {})=>(0, $92yfY.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $015f881651e1628d$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $015f881651e1628d$var$KEYS_TO_TRANSFROM.has(originalkey) ? $015f881651e1628d$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("92yfY", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $3b1543d65b88138b$export$23c75313f46dd54e);
const $3b1543d65b88138b$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("a1RSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $128b74cacea8440e$export$2e2bcd8739ae039);

var $2Vvj7 = parcelRequire("2Vvj7");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $128b74cacea8440e$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2Vvj7.generateActivityFiltersV2)(restFilters);
};
var $128b74cacea8440e$export$2e2bcd8739ae039 = $128b74cacea8440e$var$generateV2MyActivityFilters;

});


parcelRegister("463SC", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $5c3f82ca6aca5fe6$export$9a1782843b6e99d2);

var $9vfOq = parcelRequire("9vfOq");

var $ffYk7 = parcelRequire("ffYk7");
const $5c3f82ca6aca5fe6$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $ffYk7.default)
    ],
    [
        'activities',
        (0, $9vfOq.default)
    ]
]);

});
parcelRegister("9vfOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f21cad690f5b785$export$2e2bcd8739ae039);

var $heMH8 = parcelRequire("heMH8");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $9f21cad690f5b785$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $heMH8.generateActivityFiltersV3)(restFilters);
};
var $9f21cad690f5b785$export$2e2bcd8739ae039 = $9f21cad690f5b785$var$generateV3ActivityFilters;

});
parcelRegister("heMH8", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $90801f6c15d41e4d$export$e73fe7ded3fe2664);

var $92yfY = parcelRequire("92yfY");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $90801f6c15d41e4d$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $90801f6c15d41e4d$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $90801f6c15d41e4d$export$e73fe7ded3fe2664 = (filters = {})=>(0, $92yfY.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $90801f6c15d41e4d$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $90801f6c15d41e4d$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("ffYk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8a3390db4f22a0$export$2e2bcd8739ae039);

var $heMH8 = parcelRequire("heMH8");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $4f8a3390db4f22a0$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $heMH8.generateActivityFiltersV3)(restFilters);
};
var $4f8a3390db4f22a0$export$2e2bcd8739ae039 = $4f8a3390db4f22a0$var$generateV3MyActivityFilters;

});




parcelRegister("hwEyN", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $9a84020e03e32675$export$306a8b649360ca6f);
const $9a84020e03e32675$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $9a84020e03e32675$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$9a84020e03e32675$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("1N36E", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $0d64a3f9b3496ad4$export$3c3c237c92ca1fb9);

var $45owE = parcelRequire("45owE");

var $lIN21 = parcelRequire("lIN21");

var $bRFOx = parcelRequire("bRFOx");

var $ku8ih = parcelRequire("ku8ih");

var $ZxUBV = parcelRequire("ZxUBV");

var $4nUmu = parcelRequire("4nUmu");

var $eRdUW = parcelRequire("eRdUW");

var $dQaci = parcelRequire("dQaci");

var $bvwYi = parcelRequire("bvwYi");

var $jrdnl = parcelRequire("jrdnl");

var $et31k = parcelRequire("et31k");

var $a7LZ2 = parcelRequire("a7LZ2");

var $3mfGw = parcelRequire("3mfGw");

var $ckTrR = parcelRequire("ckTrR");

var $apwQs = parcelRequire("apwQs");
const $0d64a3f9b3496ad4$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $0d64a3f9b3496ad4$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $0d64a3f9b3496ad4$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $0d64a3f9b3496ad4$var$DEFAULT_TAGS = {
    source: (0, $bRFOx.packageName),
    sourcePackageVersion: (0, $bRFOx.packageVersion)
};
class $0d64a3f9b3496ad4$export$3c3c237c92ca1fb9 extends (0, $a7LZ2.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl);
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$0d64a3f9b3496ad4$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$0d64a3f9b3496ad4$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $eRdUW.GraphQLJSError)(err));
                    const invalidFragment = (0, $3mfGw.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $45owE.retryOnException)(async ()=>{
                    const request = (0, $ckTrR.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $apwQs.filtersToMetadata)(filters)
                    });
                    const res = await (0, $ZxUBV.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $apwQs.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $4nUmu.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $4nUmu.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$0d64a3f9b3496ad4$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$0d64a3f9b3496ad4$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $apwQs.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $dQaci.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $0d64a3f9b3496ad4$var$transformActivityItem('workedOn', (0, $apwQs.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $0d64a3f9b3496ad4$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $0d64a3f9b3496ad4$var$transformActivityItem('all', (0, $apwQs.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $apwQs.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $ku8ih.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $et31k.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
function $0d64a3f9b3496ad4$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $bvwYi.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $jrdnl.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $jrdnl.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $lIN21.WORKED_EVENT).CREATED ? (0, $lIN21.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $apwQs.parseRootContainerARI)(object.rootContainerId),
                        icon: $0d64a3f9b3496ad4$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $jrdnl.hydrateConfluenceIcon)(object.data?.container?.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $jrdnl.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                        id: object.id,
                        deduplicateId: (0, $jrdnl.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $jrdnl.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $jrdnl.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        url: (0, $jrdnl.hydratedValueToString)(hydratedData.url)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("4nUmu", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $7d67fc44ea2fc8cc$export$2d1b192199788179);
class $7d67fc44ea2fc8cc$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("eRdUW", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $a412f1d72fb49492$export$8d4af49ee2a0fbe2);
class $a412f1d72fb49492$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("dQaci", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $10c7e34a43ce8723$export$3f19ff30d409b70);
class $10c7e34a43ce8723$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("bvwYi", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $51dd25c50c7e98b4$export$d658049bf1a63492);

var $illlw = parcelRequire("illlw");

var $8cTbn = parcelRequire("8cTbn");
const $51dd25c50c7e98b4$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $51dd25c50c7e98b4$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $8cTbn.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $8cTbn.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $8cTbn.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $51dd25c50c7e98b4$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $51dd25c50c7e98b4$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(object, path);
}
function $51dd25c50c7e98b4$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $51dd25c50c7e98b4$var$getOrSearch(current, split);
    return current;
}
function $51dd25c50c7e98b4$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(edge, fieldId) === searchValue);
}
function $51dd25c50c7e98b4$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$51dd25c50c7e98b4$var$resolvePath(object, path));
}
const $51dd25c50c7e98b4$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $51dd25c50c7e98b4$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("8cTbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $05842a2bdbb5db16$export$2e2bcd8739ae039);
class $05842a2bdbb5db16$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("jrdnl", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $4e0100003ad6d633$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $4e0100003ad6d633$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $4e0100003ad6d633$export$a328b2bb0d21d984);
const $4e0100003ad6d633$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $4e0100003ad6d633$var$isURL(icon) {
    return typeof icon === 'string';
}
function $4e0100003ad6d633$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $4e0100003ad6d633$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $4e0100003ad6d633$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $4e0100003ad6d633$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $4e0100003ad6d633$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $4e0100003ad6d633$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $4e0100003ad6d633$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $4e0100003ad6d633$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($4e0100003ad6d633$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($4e0100003ad6d633$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $4e0100003ad6d633$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("et31k", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $6dc5bc0dc3dfac60$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $6dc5bc0dc3dfac60$export$2e2bcd8739ae039);

var $5PgJs = parcelRequire("5PgJs");

var $1T9Ld = parcelRequire("1T9Ld");
const $6dc5bc0dc3dfac60$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $6dc5bc0dc3dfac60$var$FD_ENVIRONMENT = 'prod';
const $6dc5bc0dc3dfac60$export$c270c412a04ff3e6 = {
    name: $6dc5bc0dc3dfac60$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $6dc5bc0dc3dfac60$var$FD_ENVIRONMENT
    }
};
class $6dc5bc0dc3dfac60$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        this.flightDeck = new (0, $5PgJs.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $6dc5bc0dc3dfac60$var$FD_ENVIRONMENT
                },
                value: (0, $1T9Ld.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($6dc5bc0dc3dfac60$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("5PgJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $43deb1d1d793aea4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $45owE = parcelRequire("45owE");

var $6BD9J = parcelRequire("6BD9J");

var $fRLSZ = parcelRequire("fRLSZ");

var $R6vVg = parcelRequire("R6vVg");

var $dyjVx = parcelRequire("dyjVx");

var $l525T = parcelRequire("l525T");
function $43deb1d1d793aea4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43deb1d1d793aea4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43deb1d1d793aea4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43deb1d1d793aea4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $43deb1d1d793aea4$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $43deb1d1d793aea4$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $43deb1d1d793aea4$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $5zQU9.default)(this, "fallbackArtifactMap", new Map());
        (0, $5zQU9.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $6BD9J.default)($43deb1d1d793aea4$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $dyjVx.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $45owE.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $fRLSZ.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $R6vVg.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$43deb1d1d793aea4$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $l525T.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $43deb1d1d793aea4$var$_objectSpread($43deb1d1d793aea4$var$_objectSpread({}, artifact), {}, {
                key: (0, $dyjVx.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $l525T.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("fRLSZ", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $b8d0f360ecd40095$export$6026918e023c9101);

var $ao10V = parcelRequire("ao10V");

var $dHnOe = parcelRequire("dHnOe");

var $ireIJ = parcelRequire("ireIJ");

var $3znRC = parcelRequire("3znRC");

var $6KucS = parcelRequire("6KucS");

var $c6GqO = parcelRequire("c6GqO");

var $79X2t = parcelRequire("79X2t");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $b8d0f360ecd40095$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $b8d0f360ecd40095$var$defaultPerimeter = "commercial";
async function $b8d0f360ecd40095$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $b8d0f360ecd40095$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $b8d0f360ecd40095$var$defaultPerimeter;
    const environment = $b8d0f360ecd40095$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $ao10V.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $b8d0f360ecd40095$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $b8d0f360ecd40095$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $b8d0f360ecd40095$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $b8d0f360ecd40095$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $b8d0f360ecd40095$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $b8d0f360ecd40095$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $c6GqO.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $c6GqO.getVersionMetadataFetchExperience)();
    return new (0, $6KucS.ConfigClient)(new (0, $ireIJ.BifrostDataSource)(new (0, $3znRC.BifrostHttpClientImpl)(env, perimeter), (0, $dHnOe.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $b8d0f360ecd40095$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("ao10V", function(module, exports) {

$parcel$export(module.exports, "default", () => $43aa36fdb0196a46$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $43aa36fdb0196a46$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $43aa36fdb0196a46$export$2e2bcd8739ae039 = $43aa36fdb0196a46$export$852ff24d0930c62f;

});

parcelRegister("dHnOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $2HKgG = parcelRequire("2HKgG");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $2HKgG.Either;
    }
});

var $2n3xt = parcelRequire("2n3xt");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $2n3xt.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $2n3xt.tryGetArtifactData;
    }
});

var $8BS3z = parcelRequire("8BS3z");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $8BS3z.parseArtifactManifest;
    }
});

var $bK1Zf = parcelRequire("bK1Zf");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $bK1Zf.parseVersionMetadata;
    }
});

var $k0bKY = parcelRequire("k0bKY");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $k0bKY.checkManifest;
    }
});

var $9I5dh = parcelRequire("9I5dh");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $9I5dh.ConfigRegistryDataSource;
    }
});

var $f3GMw = parcelRequire("f3GMw");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $f3GMw.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $f3GMw.Versions;
    }
});

});
parcelRegister("2HKgG", function(module, exports) {
"use strict";
var $1f837cd1c4517ada$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $1f837cd1c4517ada$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $1f837cd1c4517ada$var$Right(value);
    };
    Either.left = function(error) {
        return new $1f837cd1c4517ada$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $1f837cd1c4517ada$var$Either;
var $1f837cd1c4517ada$var$Right = /** @class */ function(_super) {
    $1f837cd1c4517ada$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $1f837cd1c4517ada$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $1f837cd1c4517ada$var$Either.right(this.right);
    };
    return Right;
}($1f837cd1c4517ada$var$Either);
var $1f837cd1c4517ada$var$Left = /** @class */ function(_super) {
    $1f837cd1c4517ada$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $1f837cd1c4517ada$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $1f837cd1c4517ada$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $1f837cd1c4517ada$var$Either.left(f(this.left));
    };
    return Left;
}($1f837cd1c4517ada$var$Either);

});

parcelRegister("2n3xt", function(module, exports) {
"use strict";
var $1ba0797e33c02ae7$var$__assign = module.exports && module.exports.__assign || function() {
    $1ba0797e33c02ae7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1ba0797e33c02ae7$var$__assign.apply(this, arguments);
};
var $1ba0797e33c02ae7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1ba0797e33c02ae7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = void 0;

var $lpRxL = parcelRequire("lpRxL");

var $dHnOe = parcelRequire("dHnOe");

var $1W6dg = parcelRequire("1W6dg");

var $ifW8h = parcelRequire("ifW8h");

var $dMICC = parcelRequire("dMICC");
function $1ba0797e33c02ae7$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $1ba0797e33c02ae7$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $1ba0797e33c02ae7$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $dHnOe.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $1W6dg.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $1ba0797e33c02ae7$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $ifW8h.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
module.exports.getArtifactFromSource = $1ba0797e33c02ae7$var$getArtifactFromSource;
function $1ba0797e33c02ae7$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $1ba0797e33c02ae7$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $lpRxL.interpolateTagScheme)(manifest.tagScheme, $1ba0797e33c02ae7$var$__assign($1ba0797e33c02ae7$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $1ba0797e33c02ae7$var$__awaiter(_this, void 0, void 0, function() {
                                return $1ba0797e33c02ae7$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $1ba0797e33c02ae7$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $dMICC.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $dMICC.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $ifW8h.assertUnreachable)(artifact);
    }
}
module.exports.tryGetArtifactData = $1ba0797e33c02ae7$var$tryGetArtifactData;

});
parcelRegister("lpRxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVersionMetadataTag = module.exports.getDataTagForManifest = module.exports.getDimensionsFromTagScheme = module.exports.generateTagScheme = module.exports.interpolateTagScheme = void 0;
const $f975776b9718f145$var$TAG_SCHEME_VERSION = 2;
function $f975776b9718f145$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($f975776b9718f145$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $f975776b9718f145$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
module.exports.interpolateTagScheme = $f975776b9718f145$var$interpolateTagScheme;
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $f975776b9718f145$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $f975776b9718f145$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
module.exports.generateTagScheme = $f975776b9718f145$var$generateTagScheme;
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $f975776b9718f145$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
module.exports.getDimensionsFromTagScheme = $f975776b9718f145$var$getDimensionsFromTagScheme;
function $f975776b9718f145$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
module.exports.getDataTagForManifest = $f975776b9718f145$var$getDataTagForManifest;
function $f975776b9718f145$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
module.exports.getVersionMetadataTag = $f975776b9718f145$var$getVersionMetadataTag;
function $f975776b9718f145$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("1W6dg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = void 0;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $169006f8d69b336a$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}
module.exports.getDimensionContext = $169006f8d69b336a$var$getDimensionContext;

});

parcelRegister("ifW8h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = void 0;
function $d4a6b89938522709$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}
module.exports.assertUnreachable = $d4a6b89938522709$var$assertUnreachable;

});

parcelRegister("dMICC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toPrettyJson = module.exports.toJson = void 0;
function $a0925f05dd8f3b3a$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
module.exports.toJson = $a0925f05dd8f3b3a$var$toJson;
function $a0925f05dd8f3b3a$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}
module.exports.toPrettyJson = $a0925f05dd8f3b3a$var$toPrettyJson;

});


parcelRegister("8BS3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = void 0;

var $60rra = parcelRequire("60rra");
function $644bb5f5dadb27d9$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $60rra.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $60rra.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $644bb5f5dadb27d9$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $60rra.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $644bb5f5dadb27d9$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $644bb5f5dadb27d9$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $60rra.parseUnknownObject)(dimensions);
    var supported = (0, $60rra.parseArray)(unparsedDimensions.supported).map($60rra.parseString);
    var fallback = (0, $60rra.parseUndefinedOr)($60rra.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $644bb5f5dadb27d9$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $60rra.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $644bb5f5dadb27d9$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $644bb5f5dadb27d9$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $60rra.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $60rra.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $60rra.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $60rra.parseUndefinedOr)($60rra.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $644bb5f5dadb27d9$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $644bb5f5dadb27d9$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}
module.exports.parseArtifactManifest = $644bb5f5dadb27d9$var$parseArtifactManifest;

});
parcelRegister("60rra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUndefinedOr = module.exports.parseUnknownObject = module.exports.parseBoolean = module.exports.parseArray = module.exports.parseString = void 0;
function $45f806a1ce3c9fdf$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
module.exports.parseString = $45f806a1ce3c9fdf$var$parseString;
function $45f806a1ce3c9fdf$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
module.exports.parseArray = $45f806a1ce3c9fdf$var$parseArray;
function $45f806a1ce3c9fdf$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
module.exports.parseBoolean = $45f806a1ce3c9fdf$var$parseBoolean;
function $45f806a1ce3c9fdf$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
module.exports.parseUnknownObject = $45f806a1ce3c9fdf$var$parseUnknownObject;
function $45f806a1ce3c9fdf$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}
module.exports.parseUndefinedOr = $45f806a1ce3c9fdf$var$parseUndefinedOr;

});


parcelRegister("bK1Zf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = void 0;

var $60rra = parcelRequire("60rra");
function $88c5882811c7e79d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $60rra.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $60rra.parseString)(unknownObject.version);
    var publishTime = new Date((0, $60rra.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $60rra.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}
module.exports.parseVersionMetadata = $88c5882811c7e79d$var$parseVersionMetadata;

});

parcelRegister("k0bKY", function(module, exports) {
"use strict";
var $e8fced57781eaa38$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = void 0;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $e8fced57781eaa38$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $e8fced57781eaa38$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}
module.exports.checkManifest = $e8fced57781eaa38$var$checkManifest;

});

parcelRegister("9I5dh", function(module, exports) {
"use strict";
var $711c445488059f65$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $711c445488059f65$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $lpRxL = parcelRequire("lpRxL");

var $2HKgG = parcelRequire("2HKgG");

var $8BS3z = parcelRequire("8BS3z");

var $bK1Zf = parcelRequire("bK1Zf");
var $711c445488059f65$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $lpRxL.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($8BS3z.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2HKgG.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $711c445488059f65$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $711c445488059f65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $lpRxL.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $bK1Zf.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $711c445488059f65$var$ConfigRegistryDataSource;

});

parcelRegister("f3GMw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $af685263f5b966f2$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $af685263f5b966f2$var$BaseUrls;
var $af685263f5b966f2$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $af685263f5b966f2$var$Versions;

});


parcelRegister("ireIJ", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", () => $d6c62ace4660398e$export$2cb8d79200775058);

var $dHnOe = parcelRequire("dHnOe");

var $lpRxL = parcelRequire("lpRxL");
class $d6c62ace4660398e$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $lpRxL.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $dHnOe.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $dHnOe.parseVersionMetadata)(response);
                return (0, $dHnOe.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $dHnOe.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $lpRxL.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $dHnOe.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $dHnOe.parseArtifactManifest)(response);
                return (0, $dHnOe.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $dHnOe.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3znRC", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", () => $299726d14403a47c$export$45c6d12ca9c14f83);

var $dHnOe = parcelRequire("dHnOe");
function $299726d14403a47c$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $299726d14403a47c$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $299726d14403a47c$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $dHnOe.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $dHnOe.Either).right(json)));
            }).catch((error)=>resolve((0, $dHnOe.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("6KucS", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", () => $4e9e7864c43d3946$export$8489e2f039bfcc4c);

var $5zQU9 = parcelRequire("5zQU9");

var $dHnOe = parcelRequire("dHnOe");

var $8usMG = parcelRequire("8usMG");
function $4e9e7864c43d3946$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e9e7864c43d3946$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e9e7864c43d3946$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e9e7864c43d3946$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4e9e7864c43d3946$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $8usMG.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $4e9e7864c43d3946$var$_objectSpread($4e9e7864c43d3946$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $dHnOe.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $dHnOe.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("8usMG", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $62e77403356b9f6a$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $62e77403356b9f6a$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("c6GqO", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $8d06f594ac1cbfc0$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $8d06f594ac1cbfc0$export$c3ac7702bfd47c1b);
const $8d06f594ac1cbfc0$var$SAMPLING_RATE = 10;
class $8d06f594ac1cbfc0$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $8d06f594ac1cbfc0$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $8d06f594ac1cbfc0$var$SAMPLING_RATE) return new $8d06f594ac1cbfc0$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("7Rgkm"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $8d06f594ac1cbfc0$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $8d06f594ac1cbfc0$export$5e7536cf7bc56fee();
    }
}
const $8d06f594ac1cbfc0$export$a3006f8f221c0a3b = ()=>$8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $8d06f594ac1cbfc0$export$c3ac7702bfd47c1b = ()=>$8d06f594ac1cbfc0$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("7Rgkm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iHz4i").then(()=>parcelRequire('lnTas'));

});


parcelRegister("79X2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $04oes = parcelRequire("04oes");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $04oes.parseConfigWithTargeting;
    }
});

var $rIcfx = parcelRequire("rIcfx");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $rIcfx.TargetedConfig;
    }
});

});
parcelRegister("04oes", function(module, exports) {
"use strict";
var $00d32bdcf6bd19e4$var$__assign = module.exports && module.exports.__assign || function() {
    $00d32bdcf6bd19e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00d32bdcf6bd19e4$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = void 0;

var $rIcfx = parcelRequire("rIcfx");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $00d32bdcf6bd19e4$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $00d32bdcf6bd19e4$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $rIcfx.TargetedConfig({
                defaultConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $00d32bdcf6bd19e4$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $rIcfx.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $00d32bdcf6bd19e4$var$__assign($00d32bdcf6bd19e4$var$__assign({}, accObject), (_a = {}, _a[key] = $00d32bdcf6bd19e4$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
module.exports.parseConfigWithTargeting = $00d32bdcf6bd19e4$var$parseConfigWithTargeting;
function $00d32bdcf6bd19e4$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $00d32bdcf6bd19e4$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $00d32bdcf6bd19e4$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $00d32bdcf6bd19e4$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.orgIds),
            siteIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.siteIds),
            userIds: $00d32bdcf6bd19e4$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $00d32bdcf6bd19e4$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("rIcfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $0534ce4013dfa5ab$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $0534ce4013dfa5ab$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $0534ce4013dfa5ab$var$TargetedConfig;
function $0534ce4013dfa5ab$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("R6vVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fa00df7248ff0a$export$2e2bcd8739ae039);
class $09fa00df7248ff0a$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $09fa00df7248ff0a$export$1d76d155060824c9 = (e)=>e instanceof $09fa00df7248ff0a$export$2e2bcd8739ae039;

});

parcelRegister("dyjVx", function(module, exports) {

$parcel$export(module.exports, "artifactKey", () => $9ddde86f16eefbf7$export$e3553dc63541d477);
const $9ddde86f16eefbf7$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("l525T", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", () => $f58bb07408e7b310$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $f58bb07408e7b310$export$f33622abb5224195);

var $5zQU9 = parcelRequire("5zQU9");

var $djJWz = parcelRequire("djJWz");
var $fcWr6 = parcelRequire("fcWr6");
function $f58bb07408e7b310$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f58bb07408e7b310$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f58bb07408e7b310$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f58bb07408e7b310$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f58bb07408e7b310$export$6061a1a9a61f2e21 = ()=>new (0, $fcWr6.UFOExperience)("fetch", {
        type: (0, $djJWz.ExperienceTypes).Operation,
        performanceType: (0, $djJWz.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f58bb07408e7b310$export$1e3a41a51f6457c5 = ()=>new (0, $fcWr6.UFOExperience)("retrieve-artifact", {
        type: (0, $djJWz.ExperienceTypes).Operation,
        performanceType: (0, $djJWz.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f58bb07408e7b310$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $f58bb07408e7b310$var$_objectSpread($f58bb07408e7b310$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("djJWz", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $9b20b02b961aec05$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $9b20b02b961aec05$export$cc26007c03242fff);
let $9b20b02b961aec05$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($9b20b02b961aec05$export$994164cf3ae1cc9a || ($9b20b02b961aec05$export$994164cf3ae1cc9a = {}));
let $9b20b02b961aec05$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($9b20b02b961aec05$export$cc26007c03242fff || ($9b20b02b961aec05$export$cc26007c03242fff = {}));

});

parcelRegister("fcWr6", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $b1254e3038344acf$export$c00d22927c60484a);

var $gA9dG = parcelRequire("gA9dG");
class $b1254e3038344acf$export$c00d22927c60484a extends (0, $gA9dG.UFOAbstractExperience) {
}

});
parcelRegister("gA9dG", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $c12728f8666a1364$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $c12728f8666a1364$export$d31c89db257648c);

var $5zQU9 = parcelRequire("5zQU9");

var $gJLAX = parcelRequire("gJLAX");


var $9bTBN = parcelRequire("9bTBN");

var $7t4T3 = parcelRequire("7t4T3");

var $h4O30 = parcelRequire("h4O30");

var $j7daQ = parcelRequire("j7daQ");

var $boFrT = parcelRequire("boFrT");

var $9jdzP = parcelRequire("9jdzP");

var $73c8y = parcelRequire("73c8y");

var $g6r05 = parcelRequire("g6r05");

var $djJWz = parcelRequire("djJWz");
const $c12728f8666a1364$var$getPageVisibleState = ()=>{
    return !(0, $9bTBN.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $boFrT.PageVisibleState).VISIBLE : (0, $boFrT.PageVisibleState).HIDDEN;
};
const $c12728f8666a1364$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9jdzP.roundPerfNow)();
};
class $c12728f8666a1364$export$d31c89db257648c {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    constructor(id, config, instanceId = null){
        (0, $5zQU9.default)(this, "state", (0, $73c8y.UFOExperienceState).NOT_STARTED);
        (0, $5zQU9.default)(this, "instanceId", null);
        (0, $5zQU9.default)(this, "parent", null);
        (0, $5zQU9.default)(this, "category", null);
        (0, $5zQU9.default)(this, "metadata", {});
        (0, $5zQU9.default)(this, "onDoneCallbacks", []);
        (0, $5zQU9.default)(this, "childExperiences", []);
        (0, $5zQU9.default)(this, "explicitTimings", {});
        (0, $5zQU9.default)(this, "isSSROutputAsFMP", false);
        (0, $5zQU9.default)(this, "uuid", null);
        (0, $5zQU9.default)(this, "_until", null);
        (0, $5zQU9.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $5zQU9.default)(this, "performanceConfig", {});
        (0, $5zQU9.default)(this, "setPageVisibleStateToMixed", ()=>{
            this.pageVisibleState = (0, $boFrT.PageVisibleState).MIXED;
            (0, $j7daQ.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $c12728f8666a1364$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $djJWz.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $djJWz.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $h4O30.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g6r05.canTransition)(this.state, newState)) {
            (0, $h4O30.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $73c8y.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $c12728f8666a1364$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $gJLAX.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $c12728f8666a1364$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $7t4T3.getGlobalEventStream)().push((0, $7t4T3.unsubscribeEvent)((0, $boFrT.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $h4O30.ufolog)('this.parent', this.parent);
                (0, $7t4T3.getGlobalEventStream)().push((0, $7t4T3.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $h4O30.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $h4O30.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $73c8y.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $c12728f8666a1364$var$getPageVisibleState();
            (0, $j7daQ.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $h4O30.ufolog)('subscribed', this.id);
                (0, $7t4T3.getGlobalEventStream)().push((0, $7t4T3.subscribeEvent)((0, $boFrT.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $boFrT.FMP_MARK) && name !== (0, $boFrT.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $h4O30.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $c12728f8666a1364$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $73c8y.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $boFrT.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $boFrT.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $h4O30.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $j7daQ.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $73c8y.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $73c8y.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $73c8y.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $h4O30.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $8d6d7b0a00a30749$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("gJLAX", function(module, exports) {

var $lucXI = parcelRequire("lucXI");

var $p9V29 = parcelRequire("p9V29");
var $c2f5c4ae737d9431$var$uuid = $p9V29;
$c2f5c4ae737d9431$var$uuid.v1 = $lucXI;
$c2f5c4ae737d9431$var$uuid.v4 = $p9V29;
module.exports = $c2f5c4ae737d9431$var$uuid;

});
parcelRegister("lucXI", function(module, exports) {

var $2kP14 = parcelRequire("2kP14");

var $ciYYq = parcelRequire("ciYYq");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $fa467455f6a0cae0$var$_nodeId;
var $fa467455f6a0cae0$var$_clockseq;
// Previous uuid creation time
var $fa467455f6a0cae0$var$_lastMSecs = 0;
var $fa467455f6a0cae0$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $fa467455f6a0cae0$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $fa467455f6a0cae0$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $fa467455f6a0cae0$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $2kP14();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $fa467455f6a0cae0$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $fa467455f6a0cae0$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $fa467455f6a0cae0$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $fa467455f6a0cae0$var$_lastMSecs + (nsecs - $fa467455f6a0cae0$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $fa467455f6a0cae0$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $fa467455f6a0cae0$var$_lastMSecs = msecs;
    $fa467455f6a0cae0$var$_lastNSecs = nsecs;
    $fa467455f6a0cae0$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $ciYYq(b);
}
module.exports = $fa467455f6a0cae0$var$v1;

});
parcelRegister("2kP14", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $1b3505cca8f4203a$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($1b3505cca8f4203a$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $1b3505cca8f4203a$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $1b3505cca8f4203a$var$getRandomValues($1b3505cca8f4203a$var$rnds8);
        return $1b3505cca8f4203a$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $1b3505cca8f4203a$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $1b3505cca8f4203a$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $1b3505cca8f4203a$var$rnds;
    };
}

});

parcelRegister("ciYYq", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8f56768b894f6aa8$var$byteToHex = [];
for(var $8f56768b894f6aa8$var$i = 0; $8f56768b894f6aa8$var$i < 256; ++$8f56768b894f6aa8$var$i)$8f56768b894f6aa8$var$byteToHex[$8f56768b894f6aa8$var$i] = ($8f56768b894f6aa8$var$i + 0x100).toString(16).substr(1);
function $8f56768b894f6aa8$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8f56768b894f6aa8$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $8f56768b894f6aa8$var$bytesToUuid;

});


parcelRegister("p9V29", function(module, exports) {

var $2kP14 = parcelRequire("2kP14");

var $ciYYq = parcelRequire("ciYYq");
function $04ba0799c6cbd711$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $2kP14)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $ciYYq(rnds);
}
module.exports = $04ba0799c6cbd711$var$v4;

});


// temp solution until we can get it automated
const $8d6d7b0a00a30749$export$2295b861f318254a = '0.1.5';

parcelRegister("9bTBN", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $6b1046d45a6dbcd5$export$15e172712955e18f);
const $6b1046d45a6dbcd5$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("7t4T3", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $56ff0843d8771360$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $56ff0843d8771360$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $56ff0843d8771360$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $56ff0843d8771360$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $56ff0843d8771360$export$7c957416596ca127);

var $h4O30 = parcelRequire("h4O30");

var $boFrT = parcelRequire("boFrT");
const $56ff0843d8771360$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $56ff0843d8771360$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $56ff0843d8771360$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $56ff0843d8771360$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $h4O30.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $56ff0843d8771360$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $boFrT.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $56ff0843d8771360$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $boFrT.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $56ff0843d8771360$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $boFrT.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("h4O30", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $c6e9a1c553f4d48d$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $c6e9a1c553f4d48d$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c6e9a1c553f4d48d$export$d53d07b6034c4560);

var $5zQU9 = parcelRequire("5zQU9");
class $c6e9a1c553f4d48d$var$UFOLogger {
    constructor(){
        (0, $5zQU9.default)(this, "enabled", false);
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c6e9a1c553f4d48d$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c6e9a1c553f4d48d$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
(0, $5zQU9.default)($c6e9a1c553f4d48d$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
const $c6e9a1c553f4d48d$export$4ab84f6f04f6566d = new $c6e9a1c553f4d48d$var$UFOLogger();
const $c6e9a1c553f4d48d$export$b4958caff08a0960 = (...args)=>{
    $c6e9a1c553f4d48d$export$4ab84f6f04f6566d.log(...args);
};
const $c6e9a1c553f4d48d$export$d53d07b6034c4560 = (...args)=>{
    $c6e9a1c553f4d48d$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("boFrT", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $84c2167b1100e3b5$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $84c2167b1100e3b5$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $84c2167b1100e3b5$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $84c2167b1100e3b5$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $84c2167b1100e3b5$export$837e0f79a8056912);

let $84c2167b1100e3b5$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($84c2167b1100e3b5$export$96253c35c37cf96b || ($84c2167b1100e3b5$export$96253c35c37cf96b = {}));
let $84c2167b1100e3b5$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($84c2167b1100e3b5$export$a12c67b37a306b13 || ($84c2167b1100e3b5$export$a12c67b37a306b13 = {}));
let $84c2167b1100e3b5$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($84c2167b1100e3b5$export$66b33c055cbb625e || ($84c2167b1100e3b5$export$66b33c055cbb625e = {}));
let $84c2167b1100e3b5$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($84c2167b1100e3b5$export$3ce489cbe02dc21b || ($84c2167b1100e3b5$export$3ce489cbe02dc21b = {}));
let $84c2167b1100e3b5$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($84c2167b1100e3b5$export$341b330828bd3906 || ($84c2167b1100e3b5$export$341b330828bd3906 = {}));
let $84c2167b1100e3b5$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($84c2167b1100e3b5$export$b9b20160f581e4f8 || ($84c2167b1100e3b5$export$b9b20160f581e4f8 = {}));
const $84c2167b1100e3b5$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $84c2167b1100e3b5$export$9f2bf58999404c75 = 'fmp';
const $84c2167b1100e3b5$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("j7daQ", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $dea8e3d398c2260f$export$13e680397ec8f3eb);

var $5zQU9 = parcelRequire("5zQU9");

var $9bTBN = parcelRequire("9bTBN");
class $dea8e3d398c2260f$var$VisibilityChangeObserver {
    constructor(){
        (0, $5zQU9.default)(this, "started", false);
        (0, $5zQU9.default)(this, "observers", []);
        (0, $5zQU9.default)(this, "broadcast", ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        });
    }
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $9bTBN.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
}
const $dea8e3d398c2260f$export$13e680397ec8f3eb = new $dea8e3d398c2260f$var$VisibilityChangeObserver();

});

parcelRegister("9jdzP", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $6c706b798f4f939b$export$5f490af6b2b115cf);
const $6c706b798f4f939b$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("73c8y", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $52223a5d0121b68b$export$81b70111112841a0);
const $52223a5d0121b68b$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("g6r05", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $bb92269b026eb001$export$178881f329fdb81f);

var $73c8y = parcelRequire("73c8y");
const $bb92269b026eb001$var$UFOStateAvailableTransitions = {
    [(0, $73c8y.UFOExperienceState).NOT_STARTED.id]: [
        (0, $73c8y.UFOExperienceState).STARTED.id
    ],
    [(0, $73c8y.UFOExperienceState).STARTED.id]: [
        (0, $73c8y.UFOExperienceState).IN_PROGRESS.id,
        (0, $73c8y.UFOExperienceState).BLOCKED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $73c8y.UFOExperienceState).FAILED.id,
        (0, $73c8y.UFOExperienceState).ABORTED.id
    ],
    [(0, $73c8y.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $73c8y.UFOExperienceState).BLOCKED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $73c8y.UFOExperienceState).FAILED.id,
        (0, $73c8y.UFOExperienceState).ABORTED.id
    ],
    [(0, $73c8y.UFOExperienceState).BLOCKED.id]: [
        (0, $73c8y.UFOExperienceState).RECOVERED.id,
        (0, $73c8y.UFOExperienceState).ABORTED.id
    ],
    [(0, $73c8y.UFOExperienceState).RECOVERED.id]: [
        (0, $73c8y.UFOExperienceState).STARTED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED.id,
        (0, $73c8y.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $73c8y.UFOExperienceState).FAILED.id,
        (0, $73c8y.UFOExperienceState).ABORTED.id
    ],
    [(0, $73c8y.UFOExperienceState).SUCCEEDED.id]: [
        (0, $73c8y.UFOExperienceState).STARTED.id
    ],
    [(0, $73c8y.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $73c8y.UFOExperienceState).SUCCEEDED.id,
        (0, $73c8y.UFOExperienceState).FAILED.id,
        (0, $73c8y.UFOExperienceState).ABORTED.id
    ],
    [(0, $73c8y.UFOExperienceState).FAILED.id]: [
        (0, $73c8y.UFOExperienceState).STARTED.id
    ],
    [(0, $73c8y.UFOExperienceState).ABORTED.id]: [
        (0, $73c8y.UFOExperienceState).STARTED.id
    ]
};
const $bb92269b026eb001$export$178881f329fdb81f = (state1, state2)=>{
    return $bb92269b026eb001$var$UFOStateAvailableTransitions[state1.id] && $bb92269b026eb001$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("1T9Ld", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab5a4126c5034b1d$export$2e2bcd8739ae039);
var $ab5a4126c5034b1d$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("3mfGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d10744acdbfc4372$export$2e2bcd8739ae039);

var $4RlHY = parcelRequire("4RlHY");
const $d10744acdbfc4372$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $4RlHY.default)
    ]
]);
const $d10744acdbfc4372$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $d10744acdbfc4372$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $d10744acdbfc4372$export$2e2bcd8739ae039 = $d10744acdbfc4372$var$graphQLErrorHandler;

});
parcelRegister("4RlHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41d598bc880d501$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $f41d598bc880d501$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $f41d598bc880d501$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $f41d598bc880d501$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $f41d598bc880d501$export$2e2bcd8739ae039 = $f41d598bc880d501$var$validationErrorHandler;

});


parcelRegister("ckTrR", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $70f34aa7a56a1c60$export$7489a6ef09862e48);

var $5C73L = parcelRequire("5C73L");

var $3qgUQ = parcelRequire("3qgUQ");
const $70f34aa7a56a1c60$var$ACTIVITIES_LIMIT = 50;
const $70f34aa7a56a1c60$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $70f34aa7a56a1c60$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $70f34aa7a56a1c60$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $70f34aa7a56a1c60$var$activityQueryMap = new Map([
    [
        'workedOn',
        $70f34aa7a56a1c60$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $70f34aa7a56a1c60$var$VIEWED__QUERY
    ],
    [
        'all',
        $70f34aa7a56a1c60$var$ALL__QUERY
    ]
]);
const $70f34aa7a56a1c60$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $70f34aa7a56a1c60$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $5C73L.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $70f34aa7a56a1c60$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $70f34aa7a56a1c60$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$70f34aa7a56a1c60$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $3qgUQ.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $70f34aa7a56a1c60$var$getActivitiesQuery(product, $70f34aa7a56a1c60$var$getMyActivitiesQuery(activityQueries.map((query)=>$70f34aa7a56a1c60$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $3qgUQ.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $70f34aa7a56a1c60$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $70f34aa7a56a1c60$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $70f34aa7a56a1c60$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $5C73L.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("apwQs", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $02d155be495eb149$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $02d155be495eb149$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $02d155be495eb149$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $02d155be495eb149$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $02d155be495eb149$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $02d155be495eb149$export$c939d6148e47244a);
function $02d155be495eb149$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $02d155be495eb149$var$rollUpActivityItems(all),
        viewed: $02d155be495eb149$var$rollUpActivityItems(viewed),
        workedOn: $02d155be495eb149$var$rollUpActivityItems(workedOn)
    };
}
function $02d155be495eb149$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $02d155be495eb149$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$02d155be495eb149$var$fragmentName(key)} on ${$02d155be495eb149$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $02d155be495eb149$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $02d155be495eb149$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $02d155be495eb149$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $02d155be495eb149$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $02d155be495eb149$var$containerMapTypes = new Map([
    [
        $02d155be495eb149$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $02d155be495eb149$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $02d155be495eb149$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $02d155be495eb149$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $02d155be495eb149$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $02d155be495eb149$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$02d155be495eb149$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($02d155be495eb149$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $02d155be495eb149$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $02d155be495eb149$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$02d155be495eb149$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $02d155be495eb149$export$884573c560ed3600(response.data);
}
function $02d155be495eb149$export$884573c560ed3600(queryData) {
    return !queryData.activity || $02d155be495eb149$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $02d155be495eb149$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}

});



parcelRegister("hgFNe", function(module, exports) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $c92459879273b4b9$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = $c92459879273b4b9$var$fromPairs;

});

parcelRegister("a0eNT", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $0be31bab44d4c374$export$c2095165ae2bdcda);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8fAH0 = parcelRequire("8fAH0");

var $01mPo = parcelRequire("01mPo");
function $0be31bab44d4c374$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $eUqFw.useRef)();
    const firedViewedUIEventId = (0, $eUqFw.useRef)();
    const mapToCcpProductKeys = (0, $eUqFw.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $8fAH0.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $eUqFw.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $eUqFw.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $eUqFw.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $01mPo.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $01mPo.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("8fAH0", function(module, exports) {

$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $b894dc23cc6a0ac0$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $b894dc23cc6a0ac0$export$54e3fc09a2a3347a);
const $b894dc23cc6a0ac0$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b894dc23cc6a0ac0$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b894dc23cc6a0ac0$export$6c053e1694ef181c = {
    prod: $b894dc23cc6a0ac0$export$31048cb2a0753b12,
    staging: $b894dc23cc6a0ac0$export$9d8f18312db80469
};
const $b894dc23cc6a0ac0$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("01mPo", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $2ccab29d76660949$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $2ccab29d76660949$export$285f3d0989f9023f);
const $2ccab29d76660949$export$c536a7e29a0739b8 = 'crossFlow';
var $2ccab29d76660949$export$285f3d0989f9023f;
(function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
})($2ccab29d76660949$export$285f3d0989f9023f || ($2ccab29d76660949$export$285f3d0989f9023f = {}));

});


parcelRegister("hfrLs", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $6023b8cf578677cf$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $6023b8cf578677cf$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $6023b8cf578677cf$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
            borderColor: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $6023b8cf578677cf$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $6023b8cf578677cf$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, $6023b8cf578677cf$export$e6c62eb05a8288ed.default, searchCSS);
};
const $6023b8cf578677cf$var$ctx = /*#__PURE__*/ (0, $eUqFw.createContext)($6023b8cf578677cf$export$e6c62eb05a8288ed.default);
const $6023b8cf578677cf$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $6023b8cf578677cf$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6023b8cf578677cf$var$ctx.Provider, {
        value: theme
    }, children);
};
const $6023b8cf578677cf$export$93d4e7f90805808f = ()=>{
    return (0, $eUqFw.useContext)($6023b8cf578677cf$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $6023b8cf578677cf$export$f9bb738f552c610d = $6023b8cf578677cf$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $6023b8cf578677cf$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("6gzlv", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $63ed2ab7c7a76a14$export$82eafebb825fc23f);

var $eUqFw = parcelRequire("eUqFw");

var $aB51E = parcelRequire("aB51E");

const $63ed2ab7c7a76a14$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`, label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aB51E))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });

});

parcelRegister("6B5oU", function(module, exports) {

$parcel$export(module.exports, "MobileSearchIconWrapper", () => $8443fa54391f9997$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $8443fa54391f9997$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $8443fa54391f9997$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $8443fa54391f9997$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $8443fa54391f9997$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $8443fa54391f9997$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $8443fa54391f9997$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $8443fa54391f9997$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $8443fa54391f9997$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $8443fa54391f9997$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $8443fa54391f9997$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $8443fa54391f9997$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $8443fa54391f9997$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $8443fa54391f9997$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $g3tFP = parcelRequire("g3tFP");

var $21jbO = parcelRequire("21jbO");


var $joBf7 = parcelRequire("joBf7");
function $8443fa54391f9997$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8443fa54391f9997$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $8443fa54391f9997$export$63e083aca343a6ae = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "eq4kchp13"
})("display:none;@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $8443fa54391f9997$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $joBf7.default)('span', {
    target: "eq4kchp12"
})("width:", (0, $21jbO.grid).multiple(2).px, ";height:", (0, $21jbO.grid).multiple(2).px, ";position:absolute;top:", (0, $21jbO.grid).px, ";left:", (0, $21jbO.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:none;}");
const $8443fa54391f9997$export$1da38d078e896a10 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp11"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){right:24px;}");
const $8443fa54391f9997$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp10"
})("width:", (0, $21jbO.grid).multiple(2).px, ";height:", (0, $21jbO.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
const $8443fa54391f9997$export$54c466678ae7c638 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp9"
})("display:none;margin:0 ", (0, $21jbO.grid).px, ";height:", (0, $21jbO.grid).multiple(4).px, ";padding-bottom:", (0, $21jbO.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $8443fa54391f9997$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $8443fa54391f9997$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp8"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $byn9U.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $21jbO.dialogWidth) : (0, $21jbO.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $8443fa54391f9997$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)(styles, " @media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $21jbO.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $8443fa54391f9997$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $joBf7.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $21jbO.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font-size:14px;line-height:20px;", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $8443fa54391f9997$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $21jbO.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $21jbO.grid).multiple(1.5).px} ${(0, $21jbO.grid).multiple(0.25).px};
            margin: 0 ${(0, $21jbO.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, ";");
const $8443fa54391f9997$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $joBf7.default)((0, $g3tFP.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $8443fa54391f9997$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $joBf7.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $21jbO.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font-size:14px;line-height:20px;border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:none;}");
const $8443fa54391f9997$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp4"
})({
    name: "6vqrnl",
    styles: "position:relative;@media screen and (min-width: 781px){min-width:200px;}height:32px"
});
const $8443fa54391f9997$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $8443fa54391f9997$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $21jbO.collapsedSearchInputWidth;
}, ";");
const $8443fa54391f9997$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $joBf7.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $21jbO.grid).multiple(2).px, ";height:", (0, $21jbO.grid).multiple(2).px, ";position:absolute;top:", (0, $21jbO.grid).px, ";left:", (0, $21jbO.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:none;}");
const $8443fa54391f9997$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $joBf7.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $21jbO.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){display:flex;}");

});
parcelRegister("21jbO", function(module, exports) {

$parcel$export(module.exports, "zIndex", () => $043f1e1cba0e1506$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $043f1e1cba0e1506$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $043f1e1cba0e1506$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $043f1e1cba0e1506$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $043f1e1cba0e1506$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $043f1e1cba0e1506$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $043f1e1cba0e1506$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $043f1e1cba0e1506$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $043f1e1cba0e1506$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $043f1e1cba0e1506$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $043f1e1cba0e1506$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $043f1e1cba0e1506$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $043f1e1cba0e1506$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $043f1e1cba0e1506$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");

function $043f1e1cba0e1506$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $043f1e1cba0e1506$var$GRID_UNIT = (0, $lcnyw.gridSize)();
const $043f1e1cba0e1506$var$AkGrid = (num = 1)=>({
        px: `${num * $043f1e1cba0e1506$var$GRID_UNIT}px`,
        unitless: num * $043f1e1cba0e1506$var$GRID_UNIT,
        multiple: (multiplier)=>$043f1e1cba0e1506$var$AkGrid(multiplier * num),
        half: ()=>$043f1e1cba0e1506$var$AkGrid(0.5 * num),
        twice: ()=>$043f1e1cba0e1506$var$AkGrid(2 * num)
    });
const $043f1e1cba0e1506$export$56446adcecbeec34 = {
    searchDialog: (0, $lcnyw.layers).dialog()
};
const $043f1e1cba0e1506$export$85fc379452d91af0 = $043f1e1cba0e1506$var$AkGrid(1);
const $043f1e1cba0e1506$export$b9930dabfa4a3a3 = '56px';
const $043f1e1cba0e1506$export$f6af7620e8789c39 = '200px';
const $043f1e1cba0e1506$export$64d8573e83b64ff8 = '150px';
const $043f1e1cba0e1506$export$a3da89b899389ed8 = '780px';
const $043f1e1cba0e1506$export$ce4512df260a325a = 780;
const $043f1e1cba0e1506$export$a406031ed42c8e02 = '1130px';
const $043f1e1cba0e1506$export$e00021bea368c518 = $043f1e1cba0e1506$export$85fc379452d91af0.multiple(4);
const $043f1e1cba0e1506$export$30310ee354b45eb0 = $043f1e1cba0e1506$export$85fc379452d91af0.multiple(6);
const $043f1e1cba0e1506$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $043f1e1cba0e1506$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $043f1e1cba0e1506$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $043f1e1cba0e1506$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`;
const $043f1e1cba0e1506$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("cbDiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7470b930c5e12966$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $hfrLs = parcelRequire("hfrLs");

var $6B5oU = parcelRequire("6B5oU");

var $lTGK8 = parcelRequire("lTGK8");

var $6gzlv = parcelRequire("6gzlv");

var $j9fWg = parcelRequire("j9fWg");

var $kMbxv = parcelRequire("kMbxv");

var $gHokf = parcelRequire("gHokf");
const $7470b930c5e12966$var$MAX_INPUT_LENGTH = 500;
const $7470b930c5e12966$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $hfrLs.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $kMbxv.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gHokf.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lTGK8.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SearchInputContainer), {
        ...theme,
        shouldFillContainer: shouldFillContainer,
        isExpanded: false,
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.MobileSearchIconWrapper), {
        isExpanded: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: "Search",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gzlv.SearchIcon), {
                theme: theme,
                isExpanded: false,
                size: "medium"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.DesktopSearchIconWrapper), {
        ...theme,
        isExpanded: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gzlv.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SearchInputField), {
        "data-test-id": "search-dialog-search-skeleton",
        isExpanded: false,
        placeholder: placeholder,
        ref: forwardRef || undefined,
        disabled: true,
        value: "",
        maxLength: $7470b930c5e12966$var$MAX_INPUT_LENGTH,
        onChange: ()=>{},
        "aria-label": placeholder,
        ...theme
    })));
};
var $7470b930c5e12966$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7470b930c5e12966$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("lTGK8", function(module, exports) {

$parcel$export(module.exports, "AbsoluteContainer", () => $10a15b9197eef32a$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $10a15b9197eef32a$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $10a15b9197eef32a$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $10a15b9197eef32a$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $21jbO = parcelRequire("21jbO");

var $joBf7 = parcelRequire("joBf7");
const $10a15b9197eef32a$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $21jbO.zIndex).searchDialog
    });
    return {};
});
const $10a15b9197eef32a$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $joBf7.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)("@media screen and (max-width: ", (0, $21jbO.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $21jbO.zIndex).searchDialog, ";left:calc((100% - ", (0, $21jbO.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $21jbO.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $10a15b9197eef32a$export$dfece74a62f1398d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $21jbO.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $21jbO.inputFieldHeight).px, ";height:", (0, $21jbO.inputFieldHeight).px, ";");
const $10a15b9197eef32a$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $joBf7.default)($10a15b9197eef32a$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $21jbO.enlargedInputFieldHeight).px : (0, $21jbO.inputFieldHeight).px, ";");

});

parcelRegister("kMbxv", function(module, exports) {

$parcel$export(module.exports, "getInputSkeletonQuery", () => $b61c262d537db3ca$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $b61c262d537db3ca$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $b61c262d537db3ca$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $b61c262d537db3ca$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $b61c262d537db3ca$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $b61c262d537db3ca$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $b61c262d537db3ca$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $b61c262d537db3ca$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $b61c262d537db3ca$export$c830bcf42e072a93);
const $b61c262d537db3ca$export$b8b6c2e7a0664212 = ()=>{
    return window?.inputSkeletonState?.query || '';
};
const $b61c262d537db3ca$export$baa1c819dd4691f3 = (newQuery)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.query = newQuery;
};
const $b61c262d537db3ca$export$38fcbc98be180790 = ()=>{
    return window?.inputSkeletonState?.isFocused || false;
};
const $b61c262d537db3ca$export$d3c6894b4e9af000 = (newIsFocused)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
};
const $b61c262d537db3ca$export$a0c71b3bd9ec143c = ()=>{
    const selectionStart = window?.inputSkeletonState?.selectionStart || 0;
    const selectionEnd = window?.inputSkeletonState?.selectionEnd || 0;
    const selectionDirection = window?.inputSkeletonState?.selectionDirection || 'none';
    return {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        selectionDirection: selectionDirection
    };
};
const $b61c262d537db3ca$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    if (window?.inputSkeletonState) {
        window.inputSkeletonState.selectionStart = newSelectionStart;
        window.inputSkeletonState.selectionEnd = newSelectionEnd;
        window.inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $b61c262d537db3ca$export$c89dd2d5d4024c5e = ()=>{
    window.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $b61c262d537db3ca$export$166ce39761ad7743 = ()=>{
    if (window.inputSkeletonState) {
        window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
            const [target, event, handler] = ssrEventListener;
            target.removeEventListener(event, handler);
        });
        window.inputSkeletonState.listeners = [];
    }
};
const $b61c262d537db3ca$export$c830bcf42e072a93 = ()=>{
    if (window['inputSkeletonState']) {
        $b61c262d537db3ca$export$166ce39761ad7743();
        delete window['inputSkeletonState'];
    }
};

});

parcelRegister("gHokf", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $eUqFw = parcelRequire("eUqFw");

var $6B5oU = parcelRequire("6B5oU");


var $6gzlv = parcelRequire("6gzlv");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRsearchInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "ssr-search-input-popout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRformContainer), {
        id: "ssr-form-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        method: "get",
        action: advancedSearchUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRsearchInputContainer), {
        shouldFillContainer: shouldFillContainer,
        id: "ssr-input-container",
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRmobileSearchIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gzlv.SearchIcon), {
        theme: theme,
        isExpanded: false,
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRdesktopSearchIconWrapper), {
        id: "ssr-search-icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gzlv.SearchIcon), {
        theme: theme,
        isExpanded: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6B5oU.SSRsearchInputField), {
        id: "ssr-search-input",
        name: "text",
        placeholder: placeholder,
        autoComplete: "off"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-test-id": "ssr-scripts-init",
        ref: scriptRef,
        dangerouslySetInnerHTML: {
            __html: (0, $569df1b1e9fbc0d0$export$bc237d627614fc48)
        },
        ...customScriptDataAttributes
    })))));
};

});
/* eslint-disable */ // @ts-ignore
const $569df1b1e9fbc0d0$export$bc237d627614fc48 = `(function(document,window){var _a;var currentInput=document.getElementById("ssr-search-input");var container=document.getElementById("ssr-input-container");var topContainer=document.getElementById("ssr-search-input-popout-container");var iconWrapper=document.getElementById("ssr-search-icon-wrapper");var formContainer=document.getElementById("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute;right: 0px;z-index: 300;");formContainer===null||formContainer===void 0?void 0:formContainer.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");container===null||container===void 0?void 0:container.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute; right:0px; z-index:300;");container===null||container===void 0?void 0:container.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused&&currentInput){currentInput.value=window.inputSkeletonState.query;currentInput.placeholder=window.inputSkeletonState.placeholder;currentInput.focus();currentInput.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&currentInput&&!!queryValue){currentInput.value=queryValue}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){topContainer===null||topContainer===void 0?void 0:topContainer.setAttribute("style","position: absolute;right: 0px;z-index: 300;");formContainer===null||formContainer===void 0?void 0:formContainer.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");container===null||container===void 0?void 0:container.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}window.inputSkeletonState.selectionStart=currentInput.selectionStart||0;window.inputSkeletonState.selectionEnd=currentInput.selectionEnd||0;window.inputSkeletonState.selectionDirection=currentInput.selectionDirection||"none"}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;window.inputSkeletonState.placeholder=currentInput.placeholder}setExpandedStyles()}function blurClickHandler(e){if(currentInput&&e.target===currentInput&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=currentInput.selectionStart||0;window.inputSkeletonState.selectionEnd=currentInput.selectionEnd||0;window.inputSkeletonState.selectionDirection=currentInput.selectionDirection||"none";if(!(topContainer===null||topContainer===void 0?void 0:topContainer.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==currentInput){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){currentInput.value=sessionQuery}else{currentInput.value=""}topContainer===null||topContainer===void 0?void 0:topContainer.removeAttribute("style");container===null||container===void 0?void 0:container.removeAttribute("style");iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.removeAttribute("style");currentInput.removeAttribute("style");formContainer===null||formContainer===void 0?void 0:formContainer.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}addListener(currentInput,"input",changeHandler);addListener(currentInput,"select",changeHandler);addListener(currentInput,"keydown",changeHandler);addListener(currentInput,"focus",focusHandler);addListener(document,"click",blurClickHandler)})(document,window);`;



parcelRegister("eFsBo", function(module, exports) {

$parcel$export(module.exports, "useTeamsPermissionsService", () => $ea8bb2fd3073cac8$export$b24dcbe1ec677a8);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $bFzGY = parcelRequire("bFzGY");

var $XHGTv = parcelRequire("XHGTv");

var $jr7pv = parcelRequire("jr7pv");

var $2JFSN = parcelRequire("2JFSN");

var $9w676 = parcelRequire("9w676");

var $51Hlu = parcelRequire("51Hlu");
const $ea8bb2fd3073cac8$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: {
        setError: (error)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    error: error
                });
            },
        setLoading: (isLoading)=>({ setState: setState })=>{
                setState({
                    isLoading: isLoading
                });
            },
        setPermissions: (permissions)=>({ setState: setState })=>{
                setState({
                    hasLoaded: true,
                    isLoading: false,
                    permissions: (0, $51Hlu.transformPermissions)(permissions)
                });
            }
    },
    name: 'teams-permissions'
});
const $ea8bb2fd3073cac8$var$useTeamsPermissionsStore = (0, $WBLbN.createHook)($ea8bb2fd3073cac8$var$Store);
const $ea8bb2fd3073cac8$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, initialState: initialState, attributes: attributes } = {
    enabled: false,
    initialState: {},
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { setError: setError, setLoading: setLoading, setPermissions: setPermissions }] = $ea8bb2fd3073cac8$var$useTeamsPermissionsStore();
    const [request, controller] = (0, $eUqFw.useMemo)(()=>(0, $51Hlu.requestPermissions)({
            orgId: orgId,
            apiVersion: 'v4',
            siteId: cloudId || 'None'
        }), [
        orgId,
        cloudId
    ]);
    const [getPermissions, { loading: loading, error: error, data: data }] = (0, $9w676.useLazyService)(request, controller, {
        ErrorHandler: (0, $jr7pv.LegionError),
        initialState: initialState
    });
    const isLoadingAnywhere = state.isLoading || loading;
    const hasLoadedAnywhere = state.error || state.hasLoaded || !!data || !!error;
    const willSendRequest = orgId && enabled && !hasLoadedAnywhere && !isLoadingAnywhere;
    const analyticAttributes = (0, $eUqFw.useMemo)(()=>({
            userId: attributes?.userId,
            orgId: orgId,
            cloudId: cloudId
        }), [
        attributes?.userId,
        orgId,
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (willSendRequest) {
                // There is a race condition here with RSS where the request can be sent twice, so using the client to prevent that
                if ((0, $XHGTv.fg)('pf-directory-settings-query-migration')) $ea8bb2fd3073cac8$var$clientWithCaching.setRequest(async ()=>{
                    await getPermissions();
                });
                setLoading(true);
                (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: analyticAttributes
                });
                if ((0, $XHGTv.fg)('pf-directory-settings-query-migration')) await $ea8bb2fd3073cac8$var$clientWithCaching.getPermissions();
                else await getPermissions();
            }
        };
        fetchData();
        return ()=>{
            setLoading(false);
        };
    }, [
        getPermissions,
        setLoading,
        createAnalyticsEvent,
        orgId,
        cloudId,
        analyticAttributes,
        willSendRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data?.permissions) setPermissions(data.permissions);
        if (error) setError(error);
    }, [
        data,
        error,
        setPermissions,
        setError
    ]);
    return {
        loading: loading,
        data: data,
        ...state
    };
};
const $ea8bb2fd3073cac8$var$clientWithCaching = new (0, $51Hlu.PermissionsCachingClient)();

});
parcelRegister("jr7pv", function(module, exports) {

$parcel$export(module.exports, "LegionError", () => $7e29721be66e40d1$export$6f5d01e55f14843f);
class $7e29721be66e40d1$export$6f5d01e55f14843f extends Error {
    constructor(data, ...params){
        super(...params);
        this.name = 'LegionError';
        this.message = data.error;
        this.status = data.status;
        this.path = data.path;
        this.timestamp = data.timestamp;
    }
}

});

parcelRegister("2JFSN", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $4b176859ad789954$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $4b176859ad789954$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $4b176859ad789954$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireUIEvent", () => $4b176859ad789954$export$7eca133280843f9e);
$parcel$export(module.exports, "isSeriousError", () => $4b176859ad789954$export$91c413c8a5c77e19);
const $4b176859ad789954$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $4b176859ad789954$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $4b176859ad789954$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $4b176859ad789954$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($4b176859ad789954$var$ANALYTICS_CHANNEL);
        });
    };
const $4b176859ad789954$export$a1fb57756f0de62b = $4b176859ad789954$var$fireEvent('operational');
const $4b176859ad789954$export$59608e0169622110 = $4b176859ad789954$var$fireEvent('screen');
const $4b176859ad789954$export$574d2f19a52d67ca = $4b176859ad789954$var$fireEvent('track');
const $4b176859ad789954$export$7eca133280843f9e = $4b176859ad789954$var$fireEvent('ui');
const $4b176859ad789954$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};

});

parcelRegister("9w676", function(module, exports) {

$parcel$export(module.exports, "useLazyService", () => $8bff949fcdac42fd$export$1a85343b4dbf3bf5);
$parcel$export(module.exports, "useService", () => $8bff949fcdac42fd$export$6de4685a6c88b4e9);

var $eUqFw = parcelRequire("eUqFw");

var $boS14 = parcelRequire("boS14");
const $8bff949fcdac42fd$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        error: undefined,
        data: undefined,
        ...options?.initialState
    });
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setState((s)=>({
                ...s,
                loading: true
            }));
        try {
            const response = await request();
            const traceId = response?.headers?.get('atl-traceid');
            let jsonResponse;
            let isResponseText = false;
            const resText = await response?.text() || '{}';
            try {
                jsonResponse = JSON.parse(resText);
            } catch  {
                isResponseText = true;
            }
            if (!response?.ok || isResponseText) {
                if (options?.ErrorHandler) throw new options.ErrorHandler({
                    ...jsonResponse,
                    traceId: traceId,
                    status: response?.status,
                    statusText: response?.statusText || resText
                });
                else throw new (0, $boS14.HttpError)(response?.status, response?.statusText || resText, traceId);
            }
            setState((s)=>({
                    ...s,
                    loading: false,
                    data: jsonResponse
                }));
            return response;
        } catch (error) {
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: error
                }));
        }
    }, [
        request,
        options?.ErrorHandler
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            controller.abort();
        };
    }, [
        controller
    ]);
    return [
        getData,
        state
    ];
};
const $8bff949fcdac42fd$export$6de4685a6c88b4e9 = (...[request, controller, options])=>{
    const [getData, state] = $8bff949fcdac42fd$export$1a85343b4dbf3bf5(request, controller, {
        ...options,
        initialState: {
            ...options?.initialState,
            loading: true
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return state;
};

});
parcelRegister("boS14", function(module, exports) {

$parcel$export(module.exports, "requestWithAbort", () => $64fe909c69537697$export$970d18814fa0cb04);
$parcel$export(module.exports, "HttpError", () => $64fe909c69537697$export$65bd6083489bd8bb);

var $gR1jx = parcelRequire("gR1jx");
const $64fe909c69537697$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            ...options
        });
const $64fe909c69537697$export$970d18814fa0cb04 = (url, options = {})=>{
    const controller = new (0, $gR1jx.AbortControllerFacade)();
    return [
        $64fe909c69537697$export$b5fe3f66a567bec0(url, {
            signal: controller.signal,
            ...options
        }),
        controller
    ];
};
class $64fe909c69537697$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}

});
parcelRegister("gR1jx", function(module, exports) {

$parcel$export(module.exports, "AbortControllerFacade", () => $b497bc7e12672156$export$f5cffffa581a7d2c);
class $b497bc7e12672156$var$AbortSignalFacade {
    constructor(){
        this.aborted = false;
        this.reason = '';
        this.onabort = ()=>{};
        this.throwIfAborted = ()=>{};
        this.addEventListener = ()=>{};
        this.removeEventListener = ()=>{};
        this.dispatchEvent = ()=>false;
    }
}
class $b497bc7e12672156$export$f5cffffa581a7d2c {
    abort() {}
    constructor(){
        this.signal = new $b497bc7e12672156$var$AbortSignalFacade();
        if (typeof window === 'object' && window.AbortController) {
            const controller = new AbortController();
            this.abort = controller.abort.bind(controller);
            this.signal = controller.signal;
        }
    }
}

});



parcelRegister("51Hlu", function(module, exports) {

$parcel$export(module.exports, "requestPermissions", () => $84a3a5e2179bd4ac$export$8cec5d3683c6896e);
$parcel$export(module.exports, "transformPermissions", () => $84a3a5e2179bd4ac$export$7fe0bfa353103198);
$parcel$export(module.exports, "PermissionsCachingClient", () => $84a3a5e2179bd4ac$export$ee02ad81fc43bb6d);

var $gR1jx = parcelRequire("gR1jx");

var $boS14 = parcelRequire("boS14");

var $l1x4U = parcelRequire("l1x4U");
const $84a3a5e2179bd4ac$export$510a9a6650a678de = ({ orgId: orgId, siteId: siteId, apiVersion: apiVersion })=>`/gateway/api/${apiVersion}/teams/permission/self/organization/${orgId}${apiVersion === 'v4' ? `?siteId=${siteId}` : ''}`;
const $84a3a5e2179bd4ac$export$8cec5d3683c6896e = ({ orgId: orgId, ...props })=>orgId ? (0, $boS14.requestWithAbort)($84a3a5e2179bd4ac$export$510a9a6650a678de({
        ...props,
        orgId: orgId
    }), {
        method: 'GET'
    }) : [
        ()=>Promise.resolve(),
        new (0, $gR1jx.AbortControllerFacade)()
    ];
const $84a3a5e2179bd4ac$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case (0, $l1x4U.TeamsPermissionApi).canCreateTeams:
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case (0, $l1x4U.TeamsPermissionApi).canViewTeams:
                return {
                    ...acc,
                    canViewTeams: true
                };
            case (0, $l1x4U.TeamsPermissionApi).canAdminTeams:
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};
class $84a3a5e2179bd4ac$export$ee02ad81fc43bb6d {
    constructor(){
        this.request = null;
        this.response = null;
    }
    async setRequest(request) {
        this.request = request;
    }
    async getPermissions() {
        if (!this.request) return;
        if (!this.response) this.response = this.request();
        return this.response;
    }
}

});
parcelRegister("l1x4U", function(module, exports) {

$parcel$export(module.exports, "TeamsPermissionApi", () => $dcee1539b8c45e1b$export$d079b1c48d5fbf57);
var $dcee1539b8c45e1b$export$d079b1c48d5fbf57;
(function(TeamsPermissionApi) {
    TeamsPermissionApi["canCreateTeams"] = "CAN_CREATE_TEAMS";
    TeamsPermissionApi["canViewTeams"] = "CAN_VIEW_TEAMS";
    TeamsPermissionApi["canAdminTeams"] = "CAN_ADMIN_TEAMS";
})($dcee1539b8c45e1b$export$d079b1c48d5fbf57 || ($dcee1539b8c45e1b$export$d079b1c48d5fbf57 = {}));

});



parcelRegister("45GTD", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeamsConfigurationProvider", () => $3c401dee04d80427$export$d3f5bd36d1c6597e);
$parcel$export(module.exports, "usePeopleAndTeamsConfigurationContext", () => $3c401dee04d80427$export$130340d16a670190);

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $9XstO = parcelRequire("9XstO");

var $k20By = parcelRequire("k20By");

var $4VTsd = parcelRequire("4VTsd");
const $3c401dee04d80427$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $k20By.DEFAULT_CONTEXT));
const $3c401dee04d80427$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $4VTsd.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $9XstO.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c401dee04d80427$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $k20By.DEFAULT_CONTEXT)
    }, children);
};
const $3c401dee04d80427$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aNvhX.FlightDeckProvider), {
        product: product,
        ...flightDeckProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c401dee04d80427$export$3bf19eb896b777b8, {
        locale: locale,
        product: product,
        teamPermissions: teamPermissions,
        teamPermissionCheckEnabled: teamPermissionCheckEnabled,
        orgId: orgId
    }, children));
};
const $3c401dee04d80427$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($3c401dee04d80427$export$8a37839ac1e08b25);

});
parcelRegister("aNvhX", function(module, exports) {

$parcel$export(module.exports, "FlightDeckProvider", () => $7dc6c04379a09164$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "useFlightDeckContext", () => $7dc6c04379a09164$export$73c96350a5e69ec);
$parcel$export(module.exports, "useFlightDeckArtifact", () => $7dc6c04379a09164$export$3b241cde208d2c5e);

var $eUqFw = parcelRequire("eUqFw");

var $5PgJs = parcelRequire("5PgJs");
const $7dc6c04379a09164$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    getArtifact: null
});
function $7dc6c04379a09164$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return new (0, $5PgJs.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dc6c04379a09164$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $7dc6c04379a09164$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($7dc6c04379a09164$export$ca1b33377afa620);
function $7dc6c04379a09164$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const { getArtifact: getArtifact } = $7dc6c04379a09164$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("9XstO", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsRemoteArtifact", () => $f5f0a7ec99c24871$export$233293b7afb7b362);

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $eyEyC = parcelRequire("eyEyC");
const $f5f0a7ec99c24871$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $f5f0a7ec99c24871$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $eUqFw.useMemo)(()=>({
            ...(0, $eyEyC.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $aNvhX.useFlightDeckArtifact)((0, $eyEyC.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $eUqFw.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $f5f0a7ec99c24871$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};

});
parcelRegister("eyEyC", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $a928c90d1d7aefbd$export$c270c412a04ff3e6);

var $dfBCt = parcelRequire("dfBCt");
const $a928c90d1d7aefbd$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $a928c90d1d7aefbd$export$71f196808ce40e60 = 'prod';
const $a928c90d1d7aefbd$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $a928c90d1d7aefbd$export$e836203c1e95eac3 = 'commercial';
const $a928c90d1d7aefbd$export$c270c412a04ff3e6 = {
    name: $a928c90d1d7aefbd$export$953923d576277fd6,
    dimensions: {
        environmentType: $a928c90d1d7aefbd$export$71f196808ce40e60,
        perimeter: (0, $dfBCt.isFedRamp)() ? $a928c90d1d7aefbd$export$6392ca3738ed1e9 : $a928c90d1d7aefbd$export$e836203c1e95eac3
    }
};

});


parcelRegister("k20By", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $21e0e7eb8d6ad3d8$export$9c542858adf7dcd0);
const $21e0e7eb8d6ad3d8$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};

});

parcelRegister("4VTsd", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsConfigurationOverrides", () => $8185319ada25a259$export$66d7d96ce076bcd6);

var $eFsBo = parcelRequire("eFsBo");

var $6rM24 = parcelRequire("6rM24");
const $8185319ada25a259$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $eFsBo.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $6rM24.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $6rM24.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};

});
parcelRegister("6rM24", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuOverrides", () => $dc21082618dcf6f6$export$c6e6fe52d34907dc);
var $dc21082618dcf6f6$export$c6e6fe52d34907dc;
(function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
})($dc21082618dcf6f6$export$c6e6fe52d34907dc || ($dc21082618dcf6f6$export$c6e6fe52d34907dc = {}));

});



parcelRegister("gg6hk", function(module, exports) {

$parcel$export(module.exports, "ErrorWithContext", () => $261ae53273279786$export$6e749dfbce027249);
class $261ae53273279786$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = context;
    }
}

});

parcelRegister("gtYBG", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsPeopleMenuConfiguration", () => $4542c47cc3043081$export$c616dd7f2557d148);
$parcel$export(module.exports, "withMandatoryPeopleMenuConfiguration", () => $4542c47cc3043081$export$aecb6ab9d1724228);

var $45GTD = parcelRequire("45GTD");
var $aWUBG = parcelRequire("aWUBG");
const $4542c47cc3043081$var$KEY = 'people-menu';
const $4542c47cc3043081$export$c616dd7f2557d148 = ()=>{
    const configuration = (0, $45GTD.usePeopleAndTeamsConfigurationContext)();
    return configuration[$4542c47cc3043081$var$KEY];
};
const $4542c47cc3043081$export$aecb6ab9d1724228 = (WrappedComponent)=>(0, $aWUBG.withMandatoryPeopleAndTeamsConfiguration)(WrappedComponent, $4542c47cc3043081$var$KEY);

});
parcelRegister("aWUBG", function(module, exports) {

$parcel$export(module.exports, "withMandatoryPeopleAndTeamsConfiguration", () => $8221a50125c6d8d2$export$aead0eac38c797a5);

var $eUqFw = parcelRequire("eUqFw");

var $45GTD = parcelRequire("45GTD");
function $8221a50125c6d8d2$var$isMandatoryPeopleAndTeamsConfiguration(context) {
    return Boolean(context);
}
const $8221a50125c6d8d2$export$aead0eac38c797a5 = (WrappedComponent, key)=>(props)=>{
        const remoteConfig = (0, $45GTD.usePeopleAndTeamsConfigurationContext)();
        if (!remoteConfig) return null;
        const keyedConfig = remoteConfig[key];
        if (!$8221a50125c6d8d2$var$isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            remoteConfig: keyedConfig,
            ...props
        });
    };

});


parcelRegister("i8zHb", function(module, exports) {

$parcel$export(module.exports, "LazyIntlProvider", () => $b4c43c451f620776$export$b4f1ecc6daf5eb10);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");
const $b4c43c451f620776$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $b4c43c451f620776$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $b4c43c451f620776$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $b4c43c451f620776$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $b4c43c451f620776$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $5JgJ2.default)();
    const { messages: messages } = $b4c43c451f620776$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};

});

parcelRegister("dgrT7", function(module, exports) {

$parcel$export(module.exports, "constructProductOriginParams", () => $3d07cddf0aedfaa1$export$d479c7e8f449d360);
$parcel$export(module.exports, "getPeopleDirectoryHomePageWithOrgId", () => $3d07cddf0aedfaa1$export$873f5b458fb2c7bd);
$parcel$export(module.exports, "getPeopleProfilePage", () => $3d07cddf0aedfaa1$export$8d1c08ae3a193cc5);
$parcel$export(module.exports, "getTeamProfilePageLinkWithOrgId", () => $3d07cddf0aedfaa1$export$143be302a1686103);
$parcel$export(module.exports, "trimLastForwardSlash", () => $3d07cddf0aedfaa1$export$41ba1f3da3359c4);
function $3d07cddf0aedfaa1$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $3d07cddf0aedfaa1$export$d479c7e8f449d360(originQuery) {
    return $3d07cddf0aedfaa1$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $3d07cddf0aedfaa1$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$3d07cddf0aedfaa1$var$toStrParams(params)}`;
}
function $3d07cddf0aedfaa1$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$3d07cddf0aedfaa1$var$toStrParams(params)}`;
}
function $3d07cddf0aedfaa1$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$3d07cddf0aedfaa1$var$toStrParams(params)}`;
}
function $3d07cddf0aedfaa1$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$3d07cddf0aedfaa1$var$toStrParams(params)}`;
}
function $3d07cddf0aedfaa1$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$3d07cddf0aedfaa1$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$3d07cddf0aedfaa1$var$toStrParams(params)}`;
}
function $3d07cddf0aedfaa1$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}

});

parcelRegister("26oQD", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $16e9839a19de0340$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $16e9839a19de0340$export$c776284ef4b1209a);
const $16e9839a19de0340$export$83179404a61b001a = 'FetchError';
function $16e9839a19de0340$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $16e9839a19de0340$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $16e9839a19de0340$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $16e9839a19de0340$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $16e9839a19de0340$export$c776284ef4b1209a = (url, data, headers)=>$16e9839a19de0340$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });

});

parcelRegister("8Biwj", function(module, exports) {

$parcel$export(module.exports, "searchTeamsOfUser", () => $8317463f665b09cb$export$c52386bca71fd065);
$parcel$export(module.exports, "postCreateTeam", () => $8317463f665b09cb$export$db3c0c162386baf4);

var $cAxhS = parcelRequire("cAxhS");

var $dgrT7 = parcelRequire("dgrT7");

var $8nLQS = parcelRequire("8nLQS");

var $gg6hk = parcelRequire("gg6hk");

var $26oQD = parcelRequire("26oQD");
const $8317463f665b09cb$var$LIMIT_RESULTS = 5;
const $8317463f665b09cb$export$51eb1e4b266d279a = '/gateway/api';
const $8317463f665b09cb$export$a6635dd972d6facf = `${$8317463f665b09cb$export$51eb1e4b266d279a}/v3/teams`;
const $8317463f665b09cb$export$8ebb304bc6fdbba2 = `${$8317463f665b09cb$export$51eb1e4b266d279a}/v4/teams`;
const $8317463f665b09cb$export$d6cee1ef1aa86c6d = `${$8317463f665b09cb$export$a6635dd972d6facf}/of-user`;
const $8317463f665b09cb$export$5c5040d455d75334 = `${$8317463f665b09cb$export$8ebb304bc6fdbba2}/search`;
const $8317463f665b09cb$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$8317463f665b09cb$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$8317463f665b09cb$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $8317463f665b09cb$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$8317463f665b09cb$export$5c5040d455d75334}${(0, $dgrT7.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $8317463f665b09cb$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $26oQD.fetchJson)($8317463f665b09cb$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $8317463f665b09cb$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $gg6hk.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $8317463f665b09cb$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $8317463f665b09cb$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $26oQD.postJson)(url, postData);
};
const $8317463f665b09cb$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $cAxhS.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $cAxhS.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$8317463f665b09cb$export$51eb1e4b266d279a}`);
    const result = await (0, $cAxhS.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings === (0, $8nLQS.TeamMembershipSettings).OPEN ? 'OPEN' : 'MEMBER_INVITE');
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $8nLQS.TeamState).ACTIVE : (0, $8nLQS.TeamState).PURGED,
        membershipSettings: result.membershipSettings === 'OPEN' ? (0, $8nLQS.TeamMembershipSettings).OPEN : (0, $8nLQS.TeamMembershipSettings).INVITE_ONLY,
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $8nLQS.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $8nLQS.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $8nLQS.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $8nLQS.TeamPermission).FULL_READ : (0, $8nLQS.TeamPermission).NONE
    };
};
const $8317463f665b09cb$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$8317463f665b09cb$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $dgrT7.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $8317463f665b09cb$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $8317463f665b09cb$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $26oQD.postJson)(url, postData);
};

});
parcelRegister("cAxhS", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $07bdbf800813919b$export$5ed932c3646b89c6);

var $XHGTv = parcelRequire("XHGTv");

var $ci6rY = parcelRequire("ci6rY");

var $dwTbk = parcelRequire("dwTbk");

var $mbQNN = parcelRequire("mbQNN");

var $fbZks = parcelRequire("fbZks");

var $8i0AR = parcelRequire("8i0AR");

var $7TZPI = parcelRequire("7TZPI");

var $djf2A = parcelRequire("djf2A");

var $bGmMr = parcelRequire("bGmMr");

var $eEFFV = parcelRequire("eEFFV");

var $cSZJB = parcelRequire("cSZJB");
class $07bdbf800813919b$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $dwTbk.aggClient);
        this._atlasClient = (0, $mbQNN.atlasClient);
        this._directoryClient = (0, $fbZks.directoryClient);
        this._legionClient = (0, $7TZPI.defaultLegionClient);
        this._mutabilityClient = (0, $djf2A.default);
        this._permsClient = (0, $bGmMr.default);
        this._publicApiClient = (0, $eEFFV.default);
        this._invitationsClient = (0, $8i0AR.default);
        this._userPreferencesClient = (0, $cSZJB.default);
        if (context) this.setContext(context);
    }
    async measurePerformance(name, fn) {
        const exp = (0, $ci6rY.TEAMS_CLIENT_EXPERIENCES).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._atlasClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
        this._atlasClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
    }
    /**
	 * @private
	 * @deprecated use setBaseUrl instead
	 */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
	 * Fetches Browse user settings
	 */ async querySettings(cloudId, product) {
        if (cloudId) this.setContext({
            cloudId: cloudId
        });
        return this.measurePerformance('querySettings', (0, $XHGTv.fg)('pf-directory-settings-query-migration') ? async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        } : ()=>this._directoryClient.querySettings(cloudId, product));
    }
    /**
	 * Fetches feature flags from Directory
	 * @deprecated As part of decommisioning pf-directoy
	 */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
	 * Fetches team health monitor details for a team from Atlas
	 */ async queryTeamHealthMonitors(...args) {
        return this.measurePerformance('queryTeamHealthMonitors', ()=>this._atlasClient.queryTeamHealthMonitors(...args));
    }
    /**
	 * Get user information of members of a team, paginated
	 * @param {string} teamId
	 * @returns {Promise}
	 */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
	 * Get user information given an user id
	 * @param {string} userId
	 * @returns {Promise}
	 */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
	 * Get user information of a member of a team
	 * @param {string} userId
	 * @returns {Promise<CloudUser>}
	 */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<TeamWithImageUrls>}
	 */ async getTeamById(teamId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId));
    }
    /**
	 * Search teams based on query
	 */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
	 * Update team details
	 */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
	 * @private
	 * @deprecated use addUsersToTeam instead
	 */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
	 * Get the current user's team membership
	 */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
	 * Get a teams "Links"
	 */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
	 * Create a team link
	 */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
	 * Update a team link
	 */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
	 * Delete a team link
	 */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
	 * Reorder a team link
	 */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Accept a team invitation
	 */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
	 * @deprecated Invitation status no longer exists
	 * Decline a team invitation
	 */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
	 * Add current user to a team
	 */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
	 * Cancel a join request to a private team
	 */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
	 * Accept a join request to a private team
	 */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
	 * Decline a join request to a private team
	 */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
	 * @deprecated use removeTeamMemberships instead
	 */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
	 * Delete a team
	 */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
	 * Create a team
	 */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
	 * Create a external team
	 * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
	 * @param {ExternalReference} externalReference
	 */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
	 * Get linked teams for a groups in bulk
	 * @param {string} groupIds - The group ids to fetch linked teams for
	 */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<LinkedTeamsProfileDetails>}
	 */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
	 *
	 * @param teamId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 * @param userId
	 * @returns {Promise<SoftDeletedTeam>}
	 */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
	 * Get user profile with mutability constraints
	 */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
	 * Is the current user a site admin
	 */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
	 * Add users to a team
	 */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
	 * Remove users from a team
	 */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
	 * Restore a deleted team
	 */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
	 * Get token to upload media for a team
	 */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
	 * Get token to read media for a user
	 */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
	 * Get token to upload media for a user
	 */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
	 * Update header image for a user
	 */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
}
const $07bdbf800813919b$export$5ed932c3646b89c6 = new $07bdbf800813919b$export$db59823f35bf78ce();

});
parcelRegister("ci6rY", function(module, exports) {

$parcel$export(module.exports, "TEAMS_CLIENT_EXPERIENCES", () => $52666ed71f5bd518$export$879344107b04120c);

var $12kyE = parcelRequire("12kyE");

var $csKSa = parcelRequire("csKSa");
const $52666ed71f5bd518$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamHealthMonitors',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'isSingleFullMemberTeam',
    'createTeam',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails'
];
const $52666ed71f5bd518$export$879344107b04120c = new Map([
    ...$52666ed71f5bd518$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $csKSa.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $12kyE.ExperienceTypes).Operation,
                performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);

});
parcelRegister("csKSa", function(module, exports) {

$parcel$export(module.exports, "TeamsUFOExperience", () => $5e8d0d95a6390e9f$export$9a18529d1e90e81a);

var $kDfSL = parcelRequire("kDfSL");

var $4SdTa = parcelRequire("4SdTa");

var $dOIVf = parcelRequire("dOIVf");
class $5e8d0d95a6390e9f$export$9a18529d1e90e81a extends (0, $kDfSL.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $dOIVf.createErrorMetadata)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $4SdTa.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $4SdTa.isErrorStatusCode)((0, $4SdTa.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $dOIVf.isIgnoredError)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $4SdTa.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $dOIVf.createErrorMetadata)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}

});
parcelRegister("4SdTa", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $b9c41581a10bab1a$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $b9c41581a10bab1a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $b9c41581a10bab1a$export$9677d7c364ada66c);
$parcel$export(module.exports, "DefaultError", () => $b9c41581a10bab1a$export$c73ca302efeda3b4);
$parcel$export(module.exports, "SLOIgnoreError", () => $b9c41581a10bab1a$export$d87f401f8106d7a2);
$parcel$export(module.exports, "HttpError", () => $b9c41581a10bab1a$export$65bd6083489bd8bb);
$parcel$export(module.exports, "SLOIgnoreHttpError", () => $b9c41581a10bab1a$export$826a3d65b8435adf);
$parcel$export(module.exports, "GraphQLError", () => $b9c41581a10bab1a$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "isNetworkError", () => $b9c41581a10bab1a$export$476aa014e2fd89d5);
var $b9c41581a10bab1a$export$fe4bb20808298551;
(function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
})($b9c41581a10bab1a$export$fe4bb20808298551 || ($b9c41581a10bab1a$export$fe4bb20808298551 = {}));
var $b9c41581a10bab1a$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})($b9c41581a10bab1a$export$f66f92b8741acd5b || ($b9c41581a10bab1a$export$f66f92b8741acd5b = {}));
function $b9c41581a10bab1a$export$cde1786a482f9a1c(error) {
    return $b9c41581a10bab1a$export$9677d7c364ada66c(401, error) || $b9c41581a10bab1a$export$9677d7c364ada66c(403, error);
}
function $b9c41581a10bab1a$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $b9c41581a10bab1a$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $b9c41581a10bab1a$export$c33cd4757598521c;
(function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
})($b9c41581a10bab1a$export$c33cd4757598521c || ($b9c41581a10bab1a$export$c33cd4757598521c = {}));
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $b9c41581a10bab1a$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $b9c41581a10bab1a$export$c73ca302efeda3b4 extends $b9c41581a10bab1a$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $b9c41581a10bab1a$export$c73ca302efeda3b4.prototype);
    }
}
class $b9c41581a10bab1a$export$d87f401f8106d7a2 extends $b9c41581a10bab1a$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $b9c41581a10bab1a$export$d87f401f8106d7a2.prototype);
    }
}
class $b9c41581a10bab1a$export$65bd6083489bd8bb extends $b9c41581a10bab1a$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $b9c41581a10bab1a$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $b9c41581a10bab1a$export$826a3d65b8435adf extends $b9c41581a10bab1a$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $b9c41581a10bab1a$export$826a3d65b8435adf.prototype);
    }
}
class $b9c41581a10bab1a$export$92d6ed0888e7cb7f extends $b9c41581a10bab1a$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $b9c41581a10bab1a$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $b9c41581a10bab1a$export$92d6ed0888e7cb7f(errorData);
        };
    }
}
function $b9c41581a10bab1a$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}

});

parcelRegister("dOIVf", function(module, exports) {

$parcel$export(module.exports, "createErrorMetadata", () => $b2c8af3a51c693e9$export$7286a0fb7b5aab6b);
$parcel$export(module.exports, "isIgnoredError", () => $b2c8af3a51c693e9$export$a8da197a8bcc7e95);

var $4SdTa = parcelRequire("4SdTa");
const $b2c8af3a51c693e9$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $4SdTa.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $4SdTa.HttpError) ? error.status : undefined
        }
    });
const $b2c8af3a51c693e9$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $b2c8af3a51c693e9$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $b2c8af3a51c693e9$var$ignoredErrors.includes(errorName);
};

});



parcelRegister("dwTbk", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $3bcdec609c0dfb6b$export$464c991dbf0b2393);

var $ky70V = parcelRequire("ky70V");

var $i6gsr = parcelRequire("i6gsr");

var $1Mgb6 = parcelRequire("1Mgb6");

var $jnlyS = parcelRequire("jnlyS");

var $3fcik = parcelRequire("3fcik");

var $5ToV0 = parcelRequire("5ToV0");

var $4tLXa = parcelRequire("4tLXa");
class $3bcdec609c0dfb6b$export$b44e5dafe13af7b3 extends (0, $1Mgb6.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $3fcik.default),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $ky70V.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $ky70V.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $4tLXa.toUserType)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $5ToV0.TeamsUserQuery),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
}
const $3bcdec609c0dfb6b$export$464c991dbf0b2393 = new $3bcdec609c0dfb6b$export$b44e5dafe13af7b3((0, $i6gsr.DEFAULT_CONFIG).stargateRoot, {
    logException: $jnlyS.logException
});

});
parcelRegister("ky70V", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $a5086526e89b4bd3$export$1d0eef1d33b05366);

const $a5086526e89b4bd3$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $70acd7cf35f8e72d$export$470b0d72e4fdc43a));
const $a5086526e89b4bd3$export$1d0eef1d33b05366 = (ari)=>{
    if ($a5086526e89b4bd3$export$caac29844ad91f64(ari)) return ari.replace((0, $70acd7cf35f8e72d$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $a5086526e89b4bd3$export$fca6a88adb58674a = (userId)=>{
    return $a5086526e89b4bd3$export$caac29844ad91f64(userId) ? userId : `${0, $70acd7cf35f8e72d$export$470b0d72e4fdc43a}${userId}`;
};
const $a5086526e89b4bd3$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $70acd7cf35f8e72d$export$cfedc369802e0c68));
const $a5086526e89b4bd3$export$e78216c959b9f3af = (ari)=>{
    if ($a5086526e89b4bd3$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $70acd7cf35f8e72d$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $a5086526e89b4bd3$export$2bcc6e4924859c6f = (teamId)=>{
    return $a5086526e89b4bd3$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $70acd7cf35f8e72d$export$cfedc369802e0c68}${teamId}`;
};

});
const $70acd7cf35f8e72d$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $70acd7cf35f8e72d$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


parcelRegister("i6gsr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $8b46d78294ce83fb$export$c2f8e0cc249a8d8f);
const $8b46d78294ce83fb$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations'
};

});

parcelRegister("1Mgb6", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $51496de1946116ea$export$42f6d6baced34b2d);

var $4SdTa = parcelRequire("4SdTa");

var $1mJpI = parcelRequire("1mJpI");

var $ffooY = parcelRequire("ffooY");
class $51496de1946116ea$export$42f6d6baced34b2d extends (0, $1mJpI.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $ffooY.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $4SdTa.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $4SdTa.DefaultError)({});
        }
    }
}

});
parcelRegister("1mJpI", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $37233d3fcdd559ef$export$4f22f74eddb7716a);

var $jnlyS = parcelRequire("jnlyS");
class $37233d3fcdd559ef$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $jnlyS.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[key] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[key];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});
parcelRegister("jnlyS", function(module, exports) {

$parcel$export(module.exports, "logException", () => $9d192572534a817a$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $9d192572534a817a$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $9d192572534a817a$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $9d192572534a817a$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $9d192572534a817a$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $9d192572534a817a$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $9d192572534a817a$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $9d192572534a817a$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $9CTdJ = parcelRequire("9CTdJ");
function $9d192572534a817a$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $9d192572534a817a$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $9CTdJ.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $9d192572534a817a$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $9d192572534a817a$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $9CTdJ.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $9d192572534a817a$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $9d192572534a817a$export$ece28f5cfa04608(message, context = {}) {
    $9d192572534a817a$var$logMessage('error', message, context).catch(()=>{});
}
function $9d192572534a817a$export$386587bcf05ee8ea(message, context = {}) {
    $9d192572534a817a$var$logMessage('info', message, context).catch(()=>{});
}
const $9d192572534a817a$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $9d192572534a817a$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $9d192572534a817a$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $9d192572534a817a$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $9d192572534a817a$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $9d192572534a817a$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $9d192572534a817a$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $9d192572534a817a$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $9d192572534a817a$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$9d192572534a817a$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $9d192572534a817a$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $9CTdJ.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("9CTdJ", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $a933265dddc61b3d$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $a933265dddc61b3d$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $a933265dddc61b3d$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $a933265dddc61b3d$export$d8bd0edf6c978788);

var $gCa0O = parcelRequire("gCa0O");

var $9Wq4p = parcelRequire("9Wq4p");
let $a933265dddc61b3d$export$ac71c212168fcd2b;
const $a933265dddc61b3d$export$7d446c6f4e54de82 = (client)=>{
    $a933265dddc61b3d$export$ac71c212168fcd2b = client;
};
const $a933265dddc61b3d$export$f553e8b08ef59d31 = async ()=>{
    if (!$a933265dddc61b3d$export$ac71c212168fcd2b) await $a933265dddc61b3d$export$d8bd0edf6c978788({});
    return $a933265dddc61b3d$export$ac71c212168fcd2b;
};
async function $a933265dddc61b3d$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $a933265dddc61b3d$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $9Wq4p.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $a933265dddc61b3d$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $gCa0O.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $a933265dddc61b3d$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("kqjnB"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $a933265dddc61b3d$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("gCa0O", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $22355b6ea4b4df15$export$6faa4a850bc4d0ce);

var $dfBCt = parcelRequire("dfBCt");
const $22355b6ea4b4df15$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $22355b6ea4b4df15$export$68c35ed3898e185a = '5988845';
const $22355b6ea4b4df15$var$SENTRY_COMMERCIAL_DSN = `https://${$22355b6ea4b4df15$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$22355b6ea4b4df15$export$68c35ed3898e185a}`;
const $22355b6ea4b4df15$var$SENTRY_FEDRAMP_DSN = `https://${$22355b6ea4b4df15$export$9cf97fd92bea5d81}@sentry.atlassian-us-gov-mod.com/${$22355b6ea4b4df15$export$68c35ed3898e185a}`;
const $22355b6ea4b4df15$export$6faa4a850bc4d0ce = (0, $dfBCt.isFedRamp)() ? $22355b6ea4b4df15$var$SENTRY_FEDRAMP_DSN : $22355b6ea4b4df15$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("9Wq4p", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $483b419864cb44b5$export$357606956af25316);

var $7TvPd = parcelRequire("7TvPd");

var $9CTdJ = parcelRequire("9CTdJ");
const $483b419864cb44b5$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $483b419864cb44b5$export$357606956af25316(client, options) {
    if (0, $9CTdJ.sentryClient) return;
    if (!client) return;
    (0, $9CTdJ.setSentryClient)(client);
    const sentryConfig = (0, $7TvPd.getSentryConfig)(options);
    (0, $9CTdJ.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $483b419864cb44b5$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("7TvPd", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $48e821ecef4a5bd9$export$5580e6304e95c792);

var $gCa0O = parcelRequire("gCa0O");
const $48e821ecef4a5bd9$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.'
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $gCa0O.SENTRY_DSN),
    attachStacktrace: true
};
function $48e821ecef4a5bd9$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$48e821ecef4a5bd9$var$DEFAULT_SENTRY_CONFIG,
        // __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("kqjnB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8UdLd").then(()=>parcelRequire('hvUtX'));

});




parcelRegister("ffooY", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $05b5b9ec5e0dd3d7$export$7feffc86760ee7ce);

var $4SdTa = parcelRequire("4SdTa");

var $3MdrA = parcelRequire("3MdrA");

var $eBLvo = parcelRequire("eBLvo");
async function $05b5b9ec5e0dd3d7$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $4SdTa.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $4SdTa.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $05b5b9ec5e0dd3d7$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $3MdrA.withExponentialBackoff)($05b5b9ec5e0dd3d7$export$93d33e3b46bf00e7, {
        initial: (0, $3MdrA.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $3MdrA.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $3MdrA.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $3MdrA.isFetchResponse)(data) && (0, $3MdrA.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $eBLvo.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $4SdTa.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("3MdrA", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $1c8d9ebc98d76b14$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $1c8d9ebc98d76b14$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $1c8d9ebc98d76b14$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $1c8d9ebc98d76b14$export$20eaa22f2295996f);
$parcel$export(module.exports, "fetchWithExponentialBackoff", () => $1c8d9ebc98d76b14$export$b4c0bf5325504bf3);
const $1c8d9ebc98d76b14$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $1c8d9ebc98d76b14$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $1c8d9ebc98d76b14$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $1c8d9ebc98d76b14$var$defaultRetryIfCallback = (a)=>!a;
const $1c8d9ebc98d76b14$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $1c8d9ebc98d76b14$var$defaultRetryIfCallback
};
function $1c8d9ebc98d76b14$export$20eaa22f2295996f(toTry, hofOptions = $1c8d9ebc98d76b14$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $1c8d9ebc98d76b14$export$b4c0bf5325504bf3 = $1c8d9ebc98d76b14$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $1c8d9ebc98d76b14$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $1c8d9ebc98d76b14$export$8f4286bf21155381.JITTER,
    max: $1c8d9ebc98d76b14$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$1c8d9ebc98d76b14$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("eBLvo", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $0e89867a4d4ba19d$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $0e89867a4d4ba19d$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $0e89867a4d4ba19d$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $0e89867a4d4ba19d$export$8c005e458e12d501.handlers = handlers;
    }
};
function $0e89867a4d4ba19d$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $0e89867a4d4ba19d$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("3fcik", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5edb7a342bae4e$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");
const $de5edb7a342bae4e$var$TeamMembershipQuery = `query TeamMembership($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
  team {
    teamV2(
      id: $teamId
      siteId: $siteId
    ) @optIn(to: "Team-v2") {
      members(state: $membershipState, first: $first, after: $after) {
        edges {
          node {
            member {
              id
              name
              picture
              accountStatus
              ... on AtlassianAccountUser {
                extendedProfile {
                  jobTitle
                }
              }
            }
            role
            state
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}`;
// TODO: Rename query to TeamMembership
const $de5edb7a342bae4e$var$TeamMembershipQueryNext = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $de5edb7a342bae4e$export$2e2bcd8739ae039 = (0, $XHGTv.fg)('enable_teams_for_agents') ? $de5edb7a342bae4e$var$TeamMembershipQueryNext : $de5edb7a342bae4e$var$TeamMembershipQuery;

});

parcelRegister("5ToV0", function(module, exports) {

$parcel$export(module.exports, "TeamsUserQuery", () => $992aadb4f09f7c5a$export$9963ed3cbf7b791c);

var $aKlnM = parcelRequire("aKlnM");

var $9ypom = parcelRequire("9ypom");
const $992aadb4f09f7c5a$export$9963ed3cbf7b791c = (0, $aKlnM.print)((0, $9ypom.default)`
	query TeamsUserQuery($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				locale
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					department
					location
					phoneNumbers {
						type
						value
					}
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				locale
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`);

});

parcelRegister("4tLXa", function(module, exports) {

$parcel$export(module.exports, "toUserType", () => $dac32a07ead45836$export$6b53fef091c7e27d);
function $dac32a07ead45836$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}

});


parcelRegister("mbQNN", function(module, exports) {

$parcel$export(module.exports, "atlasClient", () => $552d4ebc642824c3$export$f355c2c282c063e9);

var $4ODts = parcelRequire("4ODts");

var $i6gsr = parcelRequire("i6gsr");

var $1Mgb6 = parcelRequire("1Mgb6");

var $jnlyS = parcelRequire("jnlyS");
const $552d4ebc642824c3$var$buildTeamHealthQuery = (teamId, cloudId)=>({
        query: `query TeamHealthMonitors($teamId: String!, $cloudId: String) {
    TeamHealthMonitors: teamHealthMonitorsByTeamId(teamId: $teamId, sort: CREATION_DATE_DESC, first: 5) {
      edges {
        node {
          creationDate
          isComplete(cloudId: $cloudId)
          uuid
          teamHealthMonitorResults(cloudId: $cloudId) {
            rating
          }
        }
      }
    }
  }`,
        variables: {
            teamId: teamId,
            cloudId: cloudId
        }
    });
const $552d4ebc642824c3$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $552d4ebc642824c3$export$a43522412b2aa24c extends (0, $1Mgb6.BaseGraphQlClient) {
    constructor(baseUrl, config){
        // TODO: https://product-fabric.atlassian.net/browse/TC-10338
        super(`${baseUrl}/watermelon/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        // TODO: https://product-fabric.atlassian.net/browse/TC-10338
        this.setServiceUrl(`${baseUrl}/watermelon/graphql`);
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Gets team health monitor data
   * @param {string} teamId
   * @returns {Promise}
   * @private
   */ queryTeamHealthMonitors(teamId) {
        const teamHealthQuery = $552d4ebc642824c3$var$buildTeamHealthQuery(teamId, this.getContext().cloudId);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                const data = await this.makeGraphQLRequest(teamHealthQuery, {
                    operationName: 'TeamHealthMonitors'
                });
                return data.TeamHealthMonitors.edges?.map((edge)=>{
                    const node = edge?.node;
                    if (!node || !node.uuid || !node.creationDate) return null;
                    return {
                        date: node.creationDate,
                        uuid: node.uuid,
                        greenCount: node.teamHealthMonitorResults?.filter((result)=>result.rating === 'GREEN').length ?? 0,
                        yellowCount: node.teamHealthMonitorResults?.filter((result)=>result.rating === 'YELLOW').length ?? 0,
                        redCount: node.teamHealthMonitorResults?.filter((result)=>result.rating === 'RED').length ?? 0
                    };
                }).filter((0, $4ODts.filterNull)) ?? [];
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $552d4ebc642824c3$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $552d4ebc642824c3$export$f355c2c282c063e9 = new $552d4ebc642824c3$export$a43522412b2aa24c((0, $i6gsr.DEFAULT_CONFIG).stargateRoot, {
    logException: $jnlyS.logException
});

});
parcelRegister("4ODts", function(module, exports) {

$parcel$export(module.exports, "filterNull", () => $5c8a5a1c979dccfa$export$f340908427d1f469);
function $5c8a5a1c979dccfa$export$f340908427d1f469(x) {
    return !!x;
}

});


parcelRegister("fbZks", function(module, exports) {

$parcel$export(module.exports, "directoryClient", () => $88e1102f07ef4ea4$export$ead519165de472de);

var $i6gsr = parcelRequire("i6gsr");

var $1Mgb6 = parcelRequire("1Mgb6");

var $jnlyS = parcelRequire("jnlyS");
const $88e1102f07ef4ea4$export$28456d095a642fd = 'internal.browse-users-allowed';
const $88e1102f07ef4ea4$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $88e1102f07ef4ea4$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $88e1102f07ef4ea4$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $88e1102f07ef4ea4$export$c8a50bf6c196fc10 extends (0, $1Mgb6.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async querySettings(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, // only Embeddable Directory care about value of product.
    product) {
        const settingsQuery = {
            query: `query Settings($cloudId: String!, $product: Product) {
        Settings: PeopleDirectorySettings(cloudId: $cloudId, product: $product) {
          isEnabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                product: product
            }
        };
        const response = await this.makeGraphQLRequest(settingsQuery, {
            operationName: 'Settings'
        });
        const searchEnabled = response.Settings && response.Settings.isEnabled;
        return {
            [$88e1102f07ef4ea4$export$28456d095a642fd]: searchEnabled
        };
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $88e1102f07ef4ea4$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $88e1102f07ef4ea4$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $88e1102f07ef4ea4$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $88e1102f07ef4ea4$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
}
const $88e1102f07ef4ea4$export$ead519165de472de = new $88e1102f07ef4ea4$export$c8a50bf6c196fc10((0, $i6gsr.DEFAULT_CONFIG).stargateRoot, {
    logException: $jnlyS.logException
});

});

parcelRegister("8i0AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ca942db99107b49$export$2e2bcd8739ae039);

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");

var $jnlyS = parcelRequire("jnlyS");

var $hBydc = parcelRequire("hBydc");
const $4ca942db99107b49$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $4ca942db99107b49$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $4ca942db99107b49$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $4ca942db99107b49$export$3209eb31343f39d extends (0, $ghawq.RestClient) {
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
    async getProductRecommendationsInner(supportedProducts = $4ca942db99107b49$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $4ca942db99107b49$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$4ca942db99107b49$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $4ca942db99107b49$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $hBydc.removeDuplicateRecommendations)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($4ca942db99107b49$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$4ca942db99107b49$export$2e2bcd8739ae039 = new $4ca942db99107b49$export$3209eb31343f39d((0, $i6gsr.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $jnlyS.logException
});

});
parcelRegister("ghawq", function(module, exports) {

$parcel$export(module.exports, "RestClient", () => $a0749cbca366a11c$export$ea8b5b3aea9558ce);

var $6l6Xk = parcelRequire("6l6Xk");

var $4SdTa = parcelRequire("4SdTa");

var $3MdrA = parcelRequire("3MdrA");

var $eBLvo = parcelRequire("eBLvo");

var $1mJpI = parcelRequire("1mJpI");

var $eASCL = parcelRequire("eASCL");

var $2CvHT = parcelRequire("2CvHT");

var $hKWEb = parcelRequire("hKWEb");

var $6V0Z9 = parcelRequire("6V0Z9");
const $a0749cbca366a11c$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $a0749cbca366a11c$var$incrementRedirectCount;
let $a0749cbca366a11c$var$clearRedirectCount;
$a0749cbca366a11c$export$7a0fc52d8c359feb();
function $a0749cbca366a11c$export$7a0fc52d8c359feb() {
    $a0749cbca366a11c$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $eASCL.setCookie)((0, $eASCL.REDIRECT_COUNT), (0, $eASCL.getCookieAsInteger)((0, $eASCL.REDIRECT_COUNT)) + 1));
    $a0749cbca366a11c$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $eASCL.clearCookie)((0, $eASCL.REDIRECT_COUNT)));
}
class $a0749cbca366a11c$export$ea8b5b3aea9558ce extends (0, $1mJpI.BaseClient) {
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config);
        /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $a0749cbca366a11c$var$incrementRedirectCount();
            } else $a0749cbca366a11c$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$a0749cbca366a11c$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $3MdrA.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $eBLvo.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $4SdTa.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $2CvHT.parseErrorMessage)(response);
                const httpError = new (0, $4SdTa.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $6V0Z9.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : (0, $hKWEb.parseResponse)(response);
    }
}

});
parcelRegister("eASCL", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $26c18bc27aa0ab9f$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $26c18bc27aa0ab9f$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $26c18bc27aa0ab9f$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $26c18bc27aa0ab9f$export$ad3506281d5a5e5d);
const $26c18bc27aa0ab9f$export$f6101897f0230549 = 'redirectCount';
const $26c18bc27aa0ab9f$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $26c18bc27aa0ab9f$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $26c18bc27aa0ab9f$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $26c18bc27aa0ab9f$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});

parcelRegister("2CvHT", function(module, exports) {

$parcel$export(module.exports, "parseErrorMessage", () => $90314992f948b539$export$91c32f1b22d29b2d);
async function $90314992f948b539$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}

});

parcelRegister("hKWEb", function(module, exports) {

$parcel$export(module.exports, "parseResponse", () => $d08b074ce514278d$export$ba14d9a5a581e827);
function $d08b074ce514278d$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}

});

parcelRegister("6V0Z9", function(module, exports) {

$parcel$export(module.exports, "stripUUIDFromPath", () => $cc58b15e66d53947$export$6bd073e2c6dda996);
const $cc58b15e66d53947$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $cc58b15e66d53947$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($cc58b15e66d53947$var$UUID_REGEX, '<UUID>');
};

});


parcelRegister("hBydc", function(module, exports) {

$parcel$export(module.exports, "removeDuplicateRecommendations", () => $1a8f646d89773ab1$export$d9d1c981635dd213);
/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $1a8f646d89773ab1$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $1a8f646d89773ab1$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $1a8f646d89773ab1$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($1a8f646d89773ab1$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($1a8f646d89773ab1$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($1a8f646d89773ab1$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($1a8f646d89773ab1$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $1a8f646d89773ab1$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $1a8f646d89773ab1$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $1a8f646d89773ab1$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($1a8f646d89773ab1$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($1a8f646d89773ab1$var$toRecommendation)
        }
    };
};

});


parcelRegister("7TZPI", function(module, exports) {

$parcel$export(module.exports, "defaultLegionClient", () => $aa1468ccc3905a46$export$95c697fe95d86a77);

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");
const $aa1468ccc3905a46$var$v3UrlPath = `/v3/teams`;
const $aa1468ccc3905a46$var$v4UrlPath = `/v4/teams`;
class $aa1468ccc3905a46$export$68a6a391e3cf23be extends (0, $ghawq.RestClient) {
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = serviceUrl;
    }
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId) {
        const siteId = this.getCloudId();
        const teamResponse = await this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.addUsersToTeam instead
	 */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$aa1468ccc3905a46$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$aa1468ccc3905a46$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
	 * @private
	 * @deprecated in V4, as no invitation status for team membership anymore.
	 */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$aa1468ccc3905a46$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
	 * @private
	 * @deprecated use publicApiClient.removeTeamMemberships instead
	 */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$aa1468ccc3905a46$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
	 * @private
	 * @deprecated INVITED status has been deprecated
	 */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$aa1468ccc3905a46$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    /**
	 * @private
	 * @deprecated should be other means to solve this issue
	 */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN') {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$aa1468ccc3905a46$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ]
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$aa1468ccc3905a46$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: cloudId
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
	 * Shoud only be used within Teams (P&T) packages
	 */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResource(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$aa1468ccc3905a46$var$v4UrlPath}/externalLinks/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId) {
        const siteId = this.getCloudId();
        if (!siteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$aa1468ccc3905a46$var$v4UrlPath}/${teamId}/profile?siteId=${this.getCloudId()}`);
        return linkedTeamsProfileDetails;
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            members: [],
            membership: {
                members: [],
                errors: []
            }
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
}
const $aa1468ccc3905a46$export$95c697fe95d86a77 = new $aa1468ccc3905a46$export$68a6a391e3cf23be((0, $i6gsr.DEFAULT_CONFIG).stargateRoot);

});

parcelRegister("djf2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $397124e48ed7c71a$export$2e2bcd8739ae039);

var $4SdTa = parcelRequire("4SdTa");

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");
const $397124e48ed7c71a$var$defaultConfig = {
    serviceUrl: `${(0, $i6gsr.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $397124e48ed7c71a$var$NOT_EDITABLE = 'not_editable';
const $397124e48ed7c71a$var$NOT_EDITABLE_FIELD = 'field';
const $397124e48ed7c71a$var$NOT_EDITABLE_REASON = 'reason';
class $397124e48ed7c71a$export$1f387592ab3ca6d0 extends (0, $ghawq.RestClient) {
    constructor(config = {}){
        super({
            ...$397124e48ed7c71a$var$defaultConfig,
            ...config
        });
    }
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $397124e48ed7c71a$var$mapToMutabilityConstraints(resp);
        });
    }
}
function $397124e48ed7c71a$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$397124e48ed7c71a$var$NOT_EDITABLE] != null) for (const value of json[$397124e48ed7c71a$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$397124e48ed7c71a$var$NOT_EDITABLE_FIELD],
        reason: $397124e48ed7c71a$var$determineReason(value[$397124e48ed7c71a$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $397124e48ed7c71a$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $4SdTa.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$397124e48ed7c71a$export$2e2bcd8739ae039 = new $397124e48ed7c71a$export$1f387592ab3ca6d0();

});

parcelRegister("bGmMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ac2a9360f27164$export$2e2bcd8739ae039);

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");
class $66ac2a9360f27164$export$23820d8d740dd467 extends (0, $ghawq.RestClient) {
    getIsSiteAdmin(/**
		 * @private
		 * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
		 */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$66ac2a9360f27164$export$2e2bcd8739ae039 = new $66ac2a9360f27164$export$23820d8d740dd467({
    serviceUrl: (0, $i6gsr.DEFAULT_CONFIG).permsServiceUrl
});

});

parcelRegister("eEFFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $710ea881e3796bce$export$2e2bcd8739ae039);

var $4SdTa = parcelRequire("4SdTa");

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");
const $710ea881e3796bce$var$V1_URL = '/teams/v1';
const $710ea881e3796bce$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $710ea881e3796bce$export$38575d07403d67c extends (0, $ghawq.RestClient) {
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$710ea881e3796bce$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $4SdTa.HttpError) && $710ea881e3796bce$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $4SdTa.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$710ea881e3796bce$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$710ea881e3796bce$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$710ea881e3796bce$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$710ea881e3796bce$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$710ea881e3796bce$export$2e2bcd8739ae039 = new $710ea881e3796bce$export$38575d07403d67c((0, $i6gsr.DEFAULT_CONFIG).publicApiRoot);

});

parcelRegister("cSZJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48be3e8f7751e6c$export$2e2bcd8739ae039);

var $i6gsr = parcelRequire("i6gsr");

var $ghawq = parcelRequire("ghawq");
const $a48be3e8f7751e6c$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $a48be3e8f7751e6c$export$3c27e20d1b94924 extends (0, $ghawq.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($a48be3e8f7751e6c$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $a48be3e8f7751e6c$export$2e2bcd8739ae039 = new $a48be3e8f7751e6c$export$3c27e20d1b94924({
    serviceUrl: (0, $i6gsr.DEFAULT_CONFIG).stargateRoot
});

});


parcelRegister("8nLQS", function(module, exports) {

$parcel$export(module.exports, "TeamState", () => $2e5fa38ffd4b0d6d$export$c5c56131401e0716);
$parcel$export(module.exports, "TeamMembershipSettings", () => $2e5fa38ffd4b0d6d$export$93b1c6cf9d16dce6);
$parcel$export(module.exports, "TeamDiscoverability", () => $2e5fa38ffd4b0d6d$export$c698762b98da6685);
$parcel$export(module.exports, "TeamRestriction", () => $2e5fa38ffd4b0d6d$export$e94592bde85a4d74);
$parcel$export(module.exports, "TeamPermission", () => $2e5fa38ffd4b0d6d$export$4db108522156032a);
// raw data is returned from Legion API
var $2e5fa38ffd4b0d6d$export$c5c56131401e0716;
(function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
})($2e5fa38ffd4b0d6d$export$c5c56131401e0716 || ($2e5fa38ffd4b0d6d$export$c5c56131401e0716 = {}));
var $2e5fa38ffd4b0d6d$export$93b1c6cf9d16dce6;
(function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
})($2e5fa38ffd4b0d6d$export$93b1c6cf9d16dce6 || ($2e5fa38ffd4b0d6d$export$93b1c6cf9d16dce6 = {}));
var $2e5fa38ffd4b0d6d$export$c698762b98da6685;
(function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
})($2e5fa38ffd4b0d6d$export$c698762b98da6685 || ($2e5fa38ffd4b0d6d$export$c698762b98da6685 = {}));
var $2e5fa38ffd4b0d6d$export$e94592bde85a4d74;
(function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
})($2e5fa38ffd4b0d6d$export$e94592bde85a4d74 || ($2e5fa38ffd4b0d6d$export$e94592bde85a4d74 = {}));
var $2e5fa38ffd4b0d6d$export$4db108522156032a;
(function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
})($2e5fa38ffd4b0d6d$export$4db108522156032a || ($2e5fa38ffd4b0d6d$export$4db108522156032a = {}));

});


parcelRegister("9yJpK", function(module, exports) {

$parcel$export(module.exports, "trimTeamAriInObject", () => $63a25746b791bcd5$export$c75c12ecb0b3724e);
$parcel$export(module.exports, "transformTeams", () => $63a25746b791bcd5$export$fd398a52d6f57b46);
function $63a25746b791bcd5$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $63a25746b791bcd5$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($63a25746b791bcd5$export$c75c12ecb0b3724e);
};

});

parcelRegister("iofV5", function(module, exports) {

$parcel$export(module.exports, "useService", () => $9fa4d280775014cc$export$6de4685a6c88b4e9);

var $eUqFw = parcelRequire("eUqFw");
const $9fa4d280775014cc$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $eUqFw.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $eUqFw.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});

parcelRegister("k7Bof", function(module, exports) {

$parcel$export(module.exports, "useActivityClient", () => $cb2d97d0746d6d9f$export$6620595b7f837f8f);

var $eUqFw = parcelRequire("eUqFw");

var $aNvhX = parcelRequire("aNvhX");

var $et31k = parcelRequire("et31k");

var $7OD2s = parcelRequire("7OD2s");
const $cb2d97d0746d6d9f$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $aNvhX.useFlightDeckContext)();
    return (0, $eUqFw.useMemo)(()=>(0, $7OD2s.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $et31k.FD_CLIENT_FETCH_PROPS).name, (0, $et31k.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});

parcelRegister("2gElh", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $89402e11df804753$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $89402e11df804753$export$9465f65715425f1b);

var $WBLbN = parcelRequire("WBLbN");
const $89402e11df804753$var$store = (0, $WBLbN.createStore)({
    initialState: {
        editorContext: undefined,
        browserContext: undefined
    },
    actions: {
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            }
    }
});
const $89402e11df804753$export$53bf948a400e8426 = (0, $WBLbN.createActionsHook)($89402e11df804753$var$store);
const $89402e11df804753$export$9465f65715425f1b = (0, $WBLbN.createHook)($89402e11df804753$var$store, {
    selector: (state)=>state.editorContext
});

});

parcelRegister("fcmS9", function(module, exports) {

$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("9ljhx")).default);

var $9ljhx = parcelRequire("9ljhx");

});
parcelRegister("9ljhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa373dd081ea8bd1$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");
const $fa373dd081ea8bd1$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $fa373dd081ea8bd1$export$2e2bcd8739ae039 {
    constructor(baseUrl, cloudId, source = $fa373dd081ea8bd1$export$b055de0e665cb20c){
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$fa373dd081ea8bd1$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        return (0, $16UJG.utils).requestService(this.serviceConfig, mergedOptions);
    }
}

});


parcelRegister("aqjZk", function(module, exports) {

var $7yTVG = parcelRequire("7yTVG");

var $6EV6g = parcelRequire("6EV6g");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $796bd651c63a4c51$var$shuffle(collection) {
    var func = $1c8hB(collection) ? $7yTVG : $6EV6g;
    return func(collection);
}
module.exports = $796bd651c63a4c51$var$shuffle;

});
parcelRegister("7yTVG", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3F3vs = parcelRequire("3F3vs");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $581717cde6f26598$var$arrayShuffle(array) {
    return $3F3vs($b69Sx(array));
}
module.exports = $581717cde6f26598$var$arrayShuffle;

});
parcelRegister("3F3vs", function(module, exports) {

var $9JT20 = parcelRequire("9JT20");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $2aa7ebbe760856ad$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $9JT20(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $2aa7ebbe760856ad$var$shuffleSelf;

});
parcelRegister("9JT20", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7173011882c80230$var$nativeFloor = Math.floor, $7173011882c80230$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $7173011882c80230$var$baseRandom(lower, upper) {
    return lower + $7173011882c80230$var$nativeFloor($7173011882c80230$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $7173011882c80230$var$baseRandom;

});



parcelRegister("6EV6g", function(module, exports) {

var $3F3vs = parcelRequire("3F3vs");

var $hvbu2 = parcelRequire("hvbu2");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $4d92c55b2944d5b8$var$baseShuffle(collection) {
    return $3F3vs($hvbu2(collection));
}
module.exports = $4d92c55b2944d5b8$var$baseShuffle;

});


parcelRegister("l3nfS", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => (parcelRequire("fMnuI")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("fMnuI")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("fMnuI")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("6McIL")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("R3yQe")).createRecommendationContextExtensions);

var $fMnuI = parcelRequire("fMnuI");

var $1C8Mr = parcelRequire("1C8Mr");

var $99V7q = parcelRequire("99V7q");

var $6rN8D = parcelRequire("6rN8D");

var $6McIL = parcelRequire("6McIL");

var $R3yQe = parcelRequire("R3yQe");

var $jwM9a = parcelRequire("jwM9a");

});
parcelRegister("fMnuI", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => $6675c3eddcc769ef$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $6675c3eddcc769ef$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $6675c3eddcc769ef$export$d1609d6291f3d60d);
const $6675c3eddcc769ef$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $6675c3eddcc769ef$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $6675c3eddcc769ef$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $6675c3eddcc769ef$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("1C8Mr", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $0c47cde06babf078$export$196a138f6d49c2bb = [
    'edition'
];
const $0c47cde06babf078$export$28c762e8047316d8 = (0, $jwM9a.createProductExtensions)($0c47cde06babf078$export$196a138f6d49c2bb);

});
parcelRegister("jwM9a", function(module, exports) {

$parcel$export(module.exports, "createProductExtensions", () => $521c483279788870$export$42e62ee12e8ced48);
parcelRequire("8a0ZO");
var $kxJAm = parcelRequire("kxJAm");
const $521c483279788870$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $521c483279788870$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $521c483279788870$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $kxJAm.CrossFlowExtensions)(filteredOptions);
    };
const $521c483279788870$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $kxJAm.CrossFlowExtensions)(combinedOptions);
};

});


parcelRegister("99V7q", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $11b100e259e3e828$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $11b100e259e3e828$export$386012fe624cad4 = (0, $jwM9a.createProductExtensions)($11b100e259e3e828$export$390f3b1f433f2095);

});

parcelRegister("6rN8D", function(module, exports) {

var $jwM9a = parcelRequire("jwM9a");

var $fMnuI = parcelRequire("fMnuI");
const $87312b9f08e3bc2d$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $87312b9f08e3bc2d$export$a60e4abab2cc3b2b = (0, $jwM9a.createProductExtensions)($87312b9f08e3bc2d$export$c41268b4369999ed);

});

parcelRegister("6McIL", function(module, exports) {

$parcel$export(module.exports, "createProvisioningPageExtensions", () => $16d391dc83d3e7c4$export$f05508383d0ca130);

var $jwM9a = parcelRequire("jwM9a");
const $16d391dc83d3e7c4$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $16d391dc83d3e7c4$export$f05508383d0ca130 = (options)=>(0, $jwM9a.createProductExtensions)($16d391dc83d3e7c4$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("R3yQe", function(module, exports) {

$parcel$export(module.exports, "createRecommendationContextExtensions", () => $4f0f7ee27b3a43d5$export$d1baeed0bd0517aa);

var $jwM9a = parcelRequire("jwM9a");
const $4f0f7ee27b3a43d5$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $4f0f7ee27b3a43d5$export$d1baeed0bd0517aa = (options)=>(0, $jwM9a.createProductExtensions)($4f0f7ee27b3a43d5$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("aRS7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e98d550d03be7fb$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $7ueqz = parcelRequire("7ueqz");

var $5W2Uo = parcelRequire("5W2Uo");
var $7e98d550d03be7fb$var$isValid = (0, $5W2Uo.default)((0, $7ueqz.default), 1);
var $7e98d550d03be7fb$export$2e2bcd8739ae039 = $7e98d550d03be7fb$var$isValid;

});
parcelRegister("5W2Uo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4524a0196fe23b4f$export$2e2bcd8739ae039);
function $4524a0196fe23b4f$export$2e2bcd8739ae039(fn, arity, a) {
    a = a || [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return $4524a0196fe23b4f$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});


parcelRegister("9pRhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dafc8522cb390e5$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $kWEgJ = parcelRequire("kWEgJ");

var $5W2Uo = parcelRequire("5W2Uo");
var $6dafc8522cb390e5$var$isWithinInterval = (0, $5W2Uo.default)((0, $kWEgJ.default), 2);
var $6dafc8522cb390e5$export$2e2bcd8739ae039 = $6dafc8522cb390e5$var$isWithinInterval;

});

parcelRegister("9myoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d10d8d515bab2af$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $fiOXn = parcelRequire("fiOXn");

var $5W2Uo = parcelRequire("5W2Uo");
var $6d10d8d515bab2af$var$sub = (0, $5W2Uo.default)((0, $fiOXn.default), 2);
var $6d10d8d515bab2af$export$2e2bcd8739ae039 = $6d10d8d515bab2af$var$sub;

});

parcelRegister("2LOJ0", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $90094790a6cc0e0f$export$57ddd9301662f8e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gVRsf = parcelRequire("gVRsf");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $i5Di6 = parcelRequire("i5Di6");
const $90094790a6cc0e0f$var$buttonStyles = (0, $1ZAYh.xcss)({
    borderWidth: 'border.width',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $90094790a6cc0e0f$var$brandStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand'
});
const $90094790a6cc0e0f$var$warningStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border.warning'
});
const $90094790a6cc0e0f$var$dangerStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border.danger'
});
const $90094790a6cc0e0f$var$iconStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
const $90094790a6cc0e0f$var$sparkleAnimation = null;
const $90094790a6cc0e0f$var$sparkleStyles = null;
const $90094790a6cc0e0f$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, status: status, ...rest }, ref)=>/*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $4ZL0y.default), {
        ...rest,
        ref: ref,
        xcss: [
            $90094790a6cc0e0f$var$buttonStyles,
            status === 'default' && $90094790a6cc0e0f$var$brandStyles,
            status === 'warning' && $90094790a6cc0e0f$var$warningStyles,
            status === 'danger' && $90094790a6cc0e0f$var$dangerStyles
        ]
    }, /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $90094790a6cc0e0f$var$iconStyles
    }, status === 'default' && /*#__PURE__*/ $eUqFw.createElement((0, $i5Di6.SparkleIcon), {
        label: "",
        primaryColor: "var(--ds-icon-discovery)"
    }), status === 'warning' && /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVRsf))), {
        label: "",
        color: "var(--ds-icon-warning)"
    }), status === 'danger' && /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVRsf))), {
        label: "",
        color: "var(--ds-icon-danger)"
    })), children)));

});
parcelRegister("i5Di6", function(module, exports) {

$parcel$export(module.exports, "SparkleIcon", () => $482f7808687d36b1$export$1019ff5537a7252e);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $482f7808687d36b1$var$SparkleGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starMain",
        fillRule: "evenodd",
        d: "m5.184 1.921-1.28 3.244L.664 6.443a.52.52 0 0 0 0 .966l3.242 1.279 1.279 3.242a.52.52 0 0 0 .967 0l1.278-3.242 3.242-1.28a.52.52 0 0 0 0-.966L7.43 5.165 6.15 1.92a.517.517 0 0 0-.69-.285.519.519 0 0 0-.276.285Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starBottomRight",
        fillRule: "evenodd",
        d: "m10.246 9.237-.496 1.255-1.255.496a.37.37 0 0 0-.205.494c.04.09.113.162.205.198l1.255.495.496 1.256a.373.373 0 0 0 .692 0l.496-1.256 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496-.496-1.255a.369.369 0 0 0-.494-.205.373.373 0 0 0-.198.205Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starTopRight",
        fillRule: "evenodd",
        d: "m10.715.568-.495 1.257-1.256.496a.373.373 0 0 0 0 .692l1.256.495.495 1.257a.372.372 0 0 0 .692 0l.497-1.257 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496L11.407.57a.367.367 0 0 0-.209-.21.375.375 0 0 0-.483.209Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
const $482f7808687d36b1$export$1019ff5537a7252e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $482f7808687d36b1$var$SparkleGlyph,
        ...props
    });

});


parcelRegister("RA7i2", function(module, exports) {

$parcel$export(module.exports, "ChatOpenerSubscriber", () => $278a622eca0b85f4$export$6fa95a645837361b);

var $eUqFw = parcelRequire("eUqFw");

var $9ngKA = parcelRequire("9ngKA");

var $jraxv = parcelRequire("jraxv");
var $kIMU7 = parcelRequire("kIMU7");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $278a622eca0b85f4$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload'
]);
const $278a622eca0b85f4$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $eUqFw.useState)(!!(0, $jraxv.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $eUqFw.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $kIMU7.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $278a622eca0b85f4$var$ignoredEvents.has(type);
        sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        onTriggerOpeningChat();
    });
    return null;
};

});

parcelRegister("aS5EA", function(module, exports) {

$parcel$export(module.exports, "ChatContextSubscriber", () => $178482fd480a1bd6$export$29ff0802eb3bb217);

var $eUqFw = parcelRequire("eUqFw");

var $kIMU7 = parcelRequire("kIMU7");

var $2gElh = parcelRequire("2gElh");
const $178482fd480a1bd6$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext } = (0, $2gElh.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIMU7.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    default:
                }
            } catch (error) {}
        }
    });
};

});

parcelRegister("gmooP", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantButton", () => $3da355772483c933$export$7c328c0993982813);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");
var $jZ5HC = parcelRequire("jZ5HC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $asu8X = parcelRequire("asu8X");

var $dA9yl = parcelRequire("dA9yl");

var $aOINP = parcelRequire("aOINP");
var $8Wt6T = parcelRequire("8Wt6T");
var $ltfxy = parcelRequire("ltfxy");

var $XHGTv = parcelRequire("XHGTv");

var $9ngKA = parcelRequire("9ngKA");

var $4JXAG = parcelRequire("4JXAG");
var $h1wKM = parcelRequire("h1wKM");
var $3kNDr = parcelRequire("3kNDr");

var $8CIQt = parcelRequire("8CIQt");

var $g45DL = parcelRequire("g45DL");
const $3da355772483c933$var$defaultButtonStyles = {
    paddingInline: '8px'
};
const $3da355772483c933$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #091E420F)"
};
const $3da355772483c933$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $3da355772483c933$export$7c328c0993982813 = ({ testId: testId, isActive: isActive, onClick: onClick, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey })=>{
    (0, $asu8X.di)((0, $jZ5HC.useCoordination), (0, $3kNDr.useCoordinationClient));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { start: start } = (0, $h1wKM.useConversationAssistantSpotlightActions)();
    const [shouldShowMessage, setShouldShowMessage] = (0, $eUqFw.useState)(false);
    const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
    const spotlightOnboardingFlagEnabled = (0, $XHGTv.fg)('rovo_chat_agents_spotlight_onboarding');
    const shouldUseCoordination = spotlightOnboardingFlagEnabled && !!messageId;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    const openRovoChat = (event, analyticsEvent)=>{
        if (!isActive && onClick) onClick(event, analyticsEvent);
    };
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dA9yl.PrimaryButton), {
        onMouseEnter: ()=>{
            if (shouldShowMessage) {
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'hovered',
                    actionSubject: 'rovoChatButtonSpotlight'
                });
                start();
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$3da355772483c933$var$defaultButtonStyles,
            ...!isActive && $3da355772483c933$var$inactiveButtonStyles
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CIQt.RovoLogo), {
            size: "medium",
            label: "",
            primaryColor: "currentColor"
        }),
        testId: testId,
        isSelected: isActive,
        onClick: onClick,
        tooltip: tooltipContent ?? formatMessage((0, $g45DL.messages).buttonLabel)
    }, formatMessage((0, $g45DL.messages).buttonLabel));
    return shouldUseCoordination ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3da355772483c933$export$de76c194bfb85689, {
        setShouldShowMessage: setShouldShowMessage,
        messageId: messageId,
        siteId: siteId,
        children: children,
        shouldShowMessage: shouldShowMessage,
        openRovoChat: openRovoChat
    }) : children;
};
const $3da355772483c933$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $h1wKM.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $3kNDr.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $jZ5HC.useCoordination)(coordinationClient, messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3da355772483c933$export$39aecc95f0365819, {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), {
                blanketIsTinted: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
                name: (0, $47955e927d984cfd$export$12496216771c6bdd)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
                radius: 3,
                pulse: activeSpotlight === null
            }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4JXAG.ConversationAssistantOnboardingSpotlight), {
                onDismiss: onDismissMessage,
                openRovoChat: openRovoChat
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
                engagementId: (0, $47955e927d984cfd$export$12496216771c6bdd)
            }))))
    }, children);
};

});
parcelRegister("4JXAG", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $16551fa9ea561b92$export$e4abc8af2fc5e2ac);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $asu8X = parcelRequire("asu8X");

var $hJJD2 = parcelRequire("hJJD2");

var $XHGTv = parcelRequire("XHGTv");

var $9ngKA = parcelRequire("9ngKA");

var $h1wKM = parcelRequire("h1wKM");


var $lFifw = parcelRequire("lFifw");
const $16551fa9ea561b92$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
    (0, $asu8X.di)((0, $h1wKM.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { end: end } = (0, $h1wKM.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $h1wKM.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                actions: [
                    {
                        onClick: (event, analyticsEvent)=>{
                            if (openRovoChat) openRovoChat(event, analyticsEvent);
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'dismissed',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $lFifw.default).tryChat)
                    }
                ],
                heading: formatMessage((0, $lFifw.default).onboardingHeading),
                target: (0, $47955e927d984cfd$export$12496216771c6bdd),
                key: (0, $47955e927d984cfd$export$12496216771c6bdd),
                targetRadius: 3
            }, formatMessage((0, $lFifw.default).onboardingDescription))
        ];
        if (!(0, $XHGTv.fg)('rovo_chat_agents_spotlight_onboarding')) return null;
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, renderActiveSpotlight());
};

});
parcelRegister("h1wKM", function(module, exports) {

$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $ea7e746815e795c0$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $ea7e746815e795c0$export$258c2a6b93cdef4a);

var $WBLbN = parcelRequire("WBLbN");
const $ea7e746815e795c0$var$initialState = {
    activeSpotlight: null
};
const $ea7e746815e795c0$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $ea7e746815e795c0$var$ConversationAssistantSpotlightStore = (0, $WBLbN.createStore)({
    initialState: $ea7e746815e795c0$var$initialState,
    actions: $ea7e746815e795c0$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $ea7e746815e795c0$export$283f4929c8863814 = (0, $WBLbN.createActionsHook)($ea7e746815e795c0$var$ConversationAssistantSpotlightStore);
const $ea7e746815e795c0$export$258c2a6b93cdef4a = (0, $WBLbN.createStateHook)($ea7e746815e795c0$var$ConversationAssistantSpotlightStore);

});

const $47955e927d984cfd$export$12496216771c6bdd = 'rovo-chat-button';

parcelRegister("lFifw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e60d88e353084d2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5e60d88e353084d2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Try Chat',
        description: 'Action button for rovo onboarding spotlight'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Harness company knowledge',
        description: 'Onboarding step heading'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'Rovo Chat is an expert in your company. It knows the people, the projects, and the way things work.',
        description: 'Onboarding step description'
    }
});

});


parcelRegister("3kNDr", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $0e926fb3df9f7b8b$export$ddc368dc94a41e62);

var $eUqFw = parcelRequire("eUqFw");

var $DEVKo = parcelRequire("DEVKo");
const $0e926fb3df9f7b8b$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $eUqFw.useMemo)(()=>new (0, $DEVKo.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};

});

parcelRegister("g45DL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $318c0ed6fe4ffa80$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $318c0ed6fe4ffa80$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        id: 'conversation-assistant-button.label',
        defaultMessage: 'Chat',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("bB06Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1105f80d1b2f496$export$2e2bcd8739ae039);
// export main component

var $047uW = parcelRequire("047uW");
var $d1105f80d1b2f496$export$2e2bcd8739ae039 = (0, $047uW.default);

});
parcelRegister("047uW", function(module, exports) {

$parcel$export(module.exports, "default", () => $031be8b90a3c1283$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $cTgSO = parcelRequire("cTgSO");

var $3MV1G = parcelRequire("3MV1G");

var $lwMt0 = parcelRequire("lwMt0");

var $jLsPA = parcelRequire("jLsPA");

var $jEywk = parcelRequire("jEywk");

var $lE5gC = parcelRequire("lE5gC");

var $kiYze = parcelRequire("kiYze");

var $9k7cN = parcelRequire("9k7cN");

var $aMDOW = parcelRequire("aMDOW");

var $4IuJi = parcelRequire("4IuJi");

var $13Jkn = parcelRequire("13Jkn");

var $w5pg8 = parcelRequire("w5pg8");
// if `@atlaskit/popup` is upgraded from 0.6.x to 1.x,
// we may need to change this to an array of numbers like [0, 12];.
const $031be8b90a3c1283$var$OFFSET_FOR_MORE_BUTTON_VIEW = '12px -11px';
const $031be8b90a3c1283$var$eventuallyClearHoverMeasure = ()=>{
    setTimeout(()=>{
        (0, $lE5gC.clearMeasure)('hoverAndClick');
    }, 5 * $031be8b90a3c1283$var$SECOND);
};
const $031be8b90a3c1283$var$SECOND = 1000;
function $031be8b90a3c1283$export$b26ac1e1a63fbe24(props) {
    const { customChevronIcon: customChevronIcon, isHighlighted: isHighlighted, enablePreFetchingByHovering: enablePreFetchingByHovering, createAnalyticsEvent: createAnalyticsEvent, peopleText: peopleText, onClick: onClick = (0, $jEywk.VOID_FUNC) } = props;
    const [canPrefetch, setCanPrefetch] = (0, $eUqFw.useState)(false);
    const { testId: testId, isPeopleMenuOpen: isPeopleMenuOpen, isSSR: isSSR, cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, togglePeopleMenu: togglePeopleMenu = (0, $jEywk.VOID_FUNC), renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent = false } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const closeMenu = (0, $eUqFw.useCallback)(()=>togglePeopleMenu(false), [
        togglePeopleMenu
    ]);
    const handleClickOnTriggerButton = (0, $eUqFw.useCallback)(()=>{
        onClick(!isPeopleMenuOpen);
        togglePeopleMenu(!isPeopleMenuOpen);
        // measure duration of click and show menu
        (0, $lE5gC.startMeasure)('clickAndShow');
        (0, $lE5gC.stopMeasure)('hoverAndClick', (duration, startTime)=>{
            (0, $kiYze.triggerAnalyticsForHoverAndClick)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isPeopleMenuOpen,
        onClick,
        togglePeopleMenu
    ]);
    const handleMouseEnterTriggerButton = (0, $eUqFw.useCallback)(()=>{
        (0, $9k7cN.MenuContent).preload();
        if (!canPrefetch) {
            setCanPrefetch(true);
            // measure duration time between hovering and clicking
            (0, $lE5gC.startMeasure)('hoverAndClick');
            // clear all unwanted hovering after 5 seconds
            $031be8b90a3c1283$var$eventuallyClearHoverMeasure();
        }
    }, [
        canPrefetch,
        setCanPrefetch
    ]);
    const buttonProps = {
        isSelected: isPeopleMenuOpen,
        onClick: handleClickOnTriggerButton,
        onMouseEnter: handleMouseEnterTriggerButton,
        testId: `${testId}-people-primary-button`,
        peopleText: peopleText
    };
    const PopupContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aMDOW.PeopleMenuContentInternal), null), []);
    if (isSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $13Jkn.PeopleMenuTriggerSSR), {
        testId: testId,
        peopleText: peopleText
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        // @ts-ignore
        offset: isVisible ? undefined : $031be8b90a3c1283$var$OFFSET_FOR_MORE_BUTTON_VIEW,
        content: PopupContent,
        isOpen: isPeopleMenuOpen,
        placement: isVisible ? 'bottom-start' : 'right-start',
        onClose: closeMenu,
        shouldRenderToParent: shouldRenderToParent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $13Jkn.default), {
                isVisible: isVisible,
                isHighlighted: isHighlighted,
                customChevronIcon: customChevronIcon,
                triggerProps: triggerProps,
                ...buttonProps
            })
    }), enablePreFetchingByHovering && canPrefetch && (0, $jLsPA.isCachedDataClear)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $w5pg8.UsersTeamsPreFetch), {
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        product: product,
        tenantUrl: tenantUrl,
        renotifyExperiment: renotifyExperimentProps
    }));
}
const $031be8b90a3c1283$var$PeopleMenuInternalWithAnalytics = (0, $2jDha.default)()($031be8b90a3c1283$export$b26ac1e1a63fbe24);
function $031be8b90a3c1283$export$2e2bcd8739ae039(props) {
    const { isHighlighted: isHighlighted, onClick: onClick, enablePreFetchingByHovering: enablePreFetchingByHovering, customChevronIcon: customChevronIcon, peopleText: peopleText, ...providerProps } = {
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IuJi.default), providerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($031be8b90a3c1283$var$PeopleMenuInternalWithAnalytics, {
        customChevronIcon: customChevronIcon,
        isHighlighted: isHighlighted,
        onClick: onClick,
        enablePreFetchingByHovering: enablePreFetchingByHovering,
        peopleText: peopleText
    }));
}

});
parcelRegister("lwMt0", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContext", () => $c018f03a0948b3a0$export$c92ff8b73313c89);
$parcel$export(module.exports, "PeopleMenuContextProvider", () => $c018f03a0948b3a0$export$4e812997de4564ae);
$parcel$export(module.exports, "usePeopleMenuContext", () => $c018f03a0948b3a0$export$c8d82c28669da5dc);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kwce8 = parcelRequire("kwce8");
parcelRequire("kiYze");
var $g8xDQ = parcelRequire("g8xDQ");

var $fMK6v = parcelRequire("fMK6v");

var $7lnvo = parcelRequire("7lnvo");

const $c018f03a0948b3a0$var$AKModalTransition = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7lPXQ")).then((module)=>({
            default: module.ModalTransition
        })), {
    moduleId: "../platform/packages/design-system/modal-dialog/src/index.tsx"
});

const $c018f03a0948b3a0$var$TeamCreateDialog = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("c9M9x")).then((module)=>({
            default: module.TeamCreateDialog
        })), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/teamCreateDialog.ts"
});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $c018f03a0948b3a0$var$resetBoxModel = /*#__PURE__*/ (0, $kwce8.css)`width:${"var(--ds-space-0, 0px)"} !important;height:${"var(--ds-space-0, 0px)"} !important;margin:${"var(--ds-space-0, 0px)"} !important;padding:${"var(--ds-space-0, 0px)"} !important;`;
// this wrapper is for preventing changing layout of around elements
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c018f03a0948b3a0$var$DialogWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "g4bi47-0"
})`${$c018f03a0948b3a0$var$resetBoxModel};&:before,&:after{${$c018f03a0948b3a0$var$resetBoxModel};content:'' !important;box-shadow:none !important;border-radius:${"var(--ds-space-0, 0px)"} !important;}`;
const $c018f03a0948b3a0$var$analyticsAttrsTeamCreateDialog = {
    ref: (0, $g8xDQ.AnalyticsSource).PEOPLE_MENU
};
const $c018f03a0948b3a0$export$c92ff8b73313c89 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    orgId: '',
    cloudId: '',
    userId: '',
    product: 'confluence',
    testId: '',
    isPeopleMenuOpen: false,
    isSSR: false,
    onClickedItem: ()=>undefined,
    pushRoute: ()=>undefined,
    togglePeopleMenu: ()=>undefined,
    toggleTeamCreateDialog: ()=>undefined,
    _hasError: undefined,
    teamCreateDialogProps: {},
    renotifyExperimentProps: {
        isLoading: false,
        isEnrolled: false
    },
    showRenotifyMessage: false,
    shouldRenderToParent: false,
    isSectionList: false
});
function $c018f03a0948b3a0$export$4e812997de4564ae(props) {
    const { isSSR: isSSR = false, cloudId: cloudId, renotifyExperimentProps: renotifyExperimentProps } = props;
    const [isOpenTeamCreateDialog, toggleOpenTeamCreateDialog] = (0, $eUqFw.useState)(false);
    const [renotifyDismissed, setRenotifyDismissed] = (0, $eUqFw.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(undefined);
    const [showRenotifyModal, setShowRenotifyModal] = (0, $eUqFw.useState)(false);
    const { children: children, isOpen: isOpen, onOpen: onOpen, onClose: onClose, ...otherProps } = props;
    const pendingUsersResponse = (0, $7lnvo.usePendingUsers)({
        cloudId: cloudId,
        startFetching: isOpen,
        renotifyExperiment: renotifyExperimentProps,
        product: props?.product
    });
    const renotifyEligible = pendingUsersResponse.status === (0, $7lnvo.RenotifyStatus).ELIGIBLE;
    const pendingUsers = renotifyEligible ? pendingUsersResponse.pendingUsers : undefined;
    const showRenotifyMessage = renotifyEligible && !renotifyDismissed;
    const togglePeopleMenu = (0, $eUqFw.useCallback)((newState)=>{
        if (newState === isOpen) return;
        if (newState) onOpen();
        else onClose();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const toggleTeamCreateDialog = (0, $eUqFw.useCallback)((isOpen)=>{
        toggleOpenTeamCreateDialog(isOpen);
    }, [
        toggleOpenTeamCreateDialog
    ]);
    const toggleRenotifyModal = (0, $eUqFw.useCallback)(()=>{
        setShowRenotifyModal((prevState)=>{
            return !prevState;
        });
    }, []);
    const values = (0, $eUqFw.useMemo)(()=>({
            teamCreateDialogProps: {},
            ...otherProps,
            // extra props
            isPeopleMenuOpen: isOpen,
            togglePeopleMenu: togglePeopleMenu,
            toggleTeamCreateDialog: toggleTeamCreateDialog,
            toggleRenotifyModal: toggleRenotifyModal,
            pendingUsers: pendingUsers,
            renotifyEligible: renotifyEligible,
            showRenotifyMessage: showRenotifyMessage,
            setRenotifyDismissed: setRenotifyDismissed,
            isSpotlightActive: isSpotlightActive,
            setIsSpotlightActive: setIsSpotlightActive
        }), [
        otherProps,
        isOpen,
        togglePeopleMenu,
        toggleTeamCreateDialog,
        toggleRenotifyModal,
        pendingUsers,
        renotifyEligible,
        showRenotifyMessage,
        setRenotifyDismissed,
        isSpotlightActive,
        setIsSpotlightActive
    ]);
    const closeTeamCreateDialog = (0, $eUqFw.useCallback)(()=>{
        toggleOpenTeamCreateDialog(false);
        if (typeof values.teamCreateDialogProps?.onClose === 'function') values.teamCreateDialogProps.onClose();
    }, [
        toggleOpenTeamCreateDialog,
        values.teamCreateDialogProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$export$c92ff8b73313c89.Provider, {
        value: values
    }, children, !isSSR && isOpenTeamCreateDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$var$DialogWrapper, {
        "data-testid": `${otherProps.testId}-team-create-dialog-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$var$AKModalTransition, null, isOpenTeamCreateDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$var$TeamCreateDialog, {
        cloudId: values.cloudId,
        orgId: values.orgId,
        product: values.product,
        principalId: values.userId,
        addFlag: values.addFlag,
        pushRoute: values.pushRoute,
        extraAnalyticsAttrs: $c018f03a0948b3a0$var$analyticsAttrsTeamCreateDialog,
        ...values.teamCreateDialogProps,
        onClose: closeTeamCreateDialog
    })))), !isSSR && showRenotifyModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$var$DialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c018f03a0948b3a0$var$AKModalTransition, null, showRenotifyModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fMK6v.RenotifyModal), null)))));
}
const $c018f03a0948b3a0$export$c8d82c28669da5dc = ()=>(0, $eUqFw.useContext)($c018f03a0948b3a0$export$c92ff8b73313c89);

});
parcelRegister("kiYze", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForClickCreateNewTeam", () => $640bce514bddc0f9$export$c22050996e7c2c8a);
$parcel$export(module.exports, "triggerAnalyticsForMenuLink", () => $640bce514bddc0f9$export$e2de484c93cb7dd8);
$parcel$export(module.exports, "triggerAnalyticsForClickViewDirectory", () => $640bce514bddc0f9$export$e3be20a27c367b1d);
$parcel$export(module.exports, "triggerAnalyticsForClickInvitePeople", () => $640bce514bddc0f9$export$bb6086ba6d61c34e);
$parcel$export(module.exports, "triggerAnalyticsForClickOnPeople", () => $640bce514bddc0f9$export$8c5588f22f5cd9d8);
$parcel$export(module.exports, "triggerAnalyticsForClickOnTeam", () => $640bce514bddc0f9$export$580e4977bd9f636d);
$parcel$export(module.exports, "triggerAnalyticsForViewedPeopleMenu", () => $640bce514bddc0f9$export$b7b4061d9dd52eb9);
$parcel$export(module.exports, "triggerAnalyticsForRenderedInvitePeople", () => $640bce514bddc0f9$export$3e9b11df8135b7cb);
$parcel$export(module.exports, "triggerAnalyticsForPreFetchData", () => $640bce514bddc0f9$export$750c07c02477d2f7);
$parcel$export(module.exports, "triggerAnalyticsForLoadingIndicator", () => $640bce514bddc0f9$export$d88a623841ba7b50);
$parcel$export(module.exports, "triggerAnalyticsForFetchingData", () => $640bce514bddc0f9$export$bda81aea2199d550);
$parcel$export(module.exports, "triggerAnalyticsForHoverAndClick", () => $640bce514bddc0f9$export$f2cf5fec906275c6);
$parcel$export(module.exports, "triggerAnalyticsForViewedFullUsersAndTeams", () => $640bce514bddc0f9$export$589011fd49e3f6d6);
$parcel$export(module.exports, "triggerAnalyticsForNoBrowsePeoplePermission", () => $640bce514bddc0f9$export$1eb2f70fed6b75f7);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageNotNow", () => $640bce514bddc0f9$export$a5bdd25287196af4);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageRemindTeam", () => $640bce514bddc0f9$export$881b6b12fd147cc);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyMessageViewed", () => $640bce514bddc0f9$export$451dcd11e28959);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalViewed", () => $640bce514bddc0f9$export$fdfb31060bc22a02);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCopyLink", () => $640bce514bddc0f9$export$5deab56d147776ca);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalCancelButton", () => $640bce514bddc0f9$export$a4a63a010743799d);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyModalSendReminderButton", () => $640bce514bddc0f9$export$faf6c5030f38bba5);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded", () => $640bce514bddc0f9$export$736bb3246fa74c1f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyFetchInactiveUsersFailed", () => $640bce514bddc0f9$export$794d511945a81231);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesSucceeded", () => $640bce514bddc0f9$export$866a7379b396a7e3);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySendInvitesFailed", () => $640bce514bddc0f9$export$498c81c82596e8ea);
$parcel$export(module.exports, "triggerAnalyticsForRenotifyNotEligible", () => $640bce514bddc0f9$export$644347da17a1bc39);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightViewed", () => $640bce514bddc0f9$export$68b8d9efc6f7f58f);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightCancelButton", () => $640bce514bddc0f9$export$f900d0881e38df06);
$parcel$export(module.exports, "triggerAnalyticsForRenotifySpotlightConfirmButton", () => $640bce514bddc0f9$export$acbad06cf5c53b17);
$parcel$export(module.exports, "AnalyticsActionSubject", () => (parcelRequire("g8xDQ")).AnalyticsActionSubject);
$parcel$export(module.exports, "AnalyticsAction", () => (parcelRequire("g8xDQ")).AnalyticsAction);
$parcel$export(module.exports, "AnalyticsSource", () => (parcelRequire("g8xDQ")).AnalyticsSource);

var $2JFSN = parcelRequire("2JFSN");

var $g8xDQ = parcelRequire("g8xDQ");

var $2g8G5 = parcelRequire("2g8G5");
const $640bce514bddc0f9$export$c22050996e7c2c8a = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).CREATE_NEW_TEAM_LINK,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED
    });
};
const $640bce514bddc0f9$export$e2de484c93cb7dd8 = (additionalLinkId, action, createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).VIEW_PEOPLE_ADDITIONAL_LINK,
        actionSubjectId: additionalLinkId,
        action: action,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $640bce514bddc0f9$export$e3be20a27c367b1d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).VIEW_PEOPLE_DIRECTORY_LINK,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $640bce514bddc0f9$export$bb6086ba6d61c34e = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).NAVIGATION_MENU_ITEM,
        actionSubjectId: 'addPeopleNavigationMenuItem',
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        attributes: {
            integration: 'peopleMenu',
            ...attributes
        }
    });
};
const $640bce514bddc0f9$export$8c5588f22f5cd9d8 = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $640bce514bddc0f9$export$580e4977bd9f636d = (createAnalyticsEvent, isLeftClick = false)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        attributes: {
            isLeftClick: isLeftClick
        }
    });
};
const $640bce514bddc0f9$export$b7b4061d9dd52eb9 = (createAnalyticsEvent, isCacheEmpty = false)=>{
    (0, $2JFSN.fireScreenEvent)(createAnalyticsEvent, {
        name: 'peopleMenu',
        attributes: {
            isCacheEmpty: isCacheEmpty
        }
    });
};
const $640bce514bddc0f9$export$3e9b11df8135b7cb = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: 'addPeopleNavigationItem',
        action: (0, $g8xDQ.AnalyticsAction).RENDERED
    });
};
const $640bce514bddc0f9$export$750c07c02477d2f7 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PRE_FETCH_DATA,
        action: (0, $g8xDQ.AnalyticsAction).TRIGGERED
    });
};
const $640bce514bddc0f9$export$d88a623841ba7b50 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU,
        actionSubjectId: 'loadingIndicator',
        action: (0, $g8xDQ.AnalyticsAction).VIEWED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $640bce514bddc0f9$export$bda81aea2199d550 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2JFSN.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).FETCHING_USERS_TEAMS_DATA,
        action: (0, $g8xDQ.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $640bce514bddc0f9$export$f2cf5fec906275c6 = (createAnalyticsEvent, duration = 0, startTime = 0)=>{
    (0, $2JFSN.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).HOVER_AND_CLICK_PEOPLE_BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).MEASURED,
        attributes: {
            duration: duration,
            startTime: startTime
        }
    });
};
const $640bce514bddc0f9$export$589011fd49e3f6d6 = (createAnalyticsEvent, usersCount = 0, teamsCount = 0, duration = 0, startTime = 0)=>{
    (0, $2JFSN.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $g8xDQ.AnalyticsAction).SUCCEEDED,
        attributes: {
            usersCount: usersCount,
            teamsCount: teamsCount,
            duration: duration,
            startTime: startTime
        }
    });
};
const $640bce514bddc0f9$export$1eb2f70fed6b75f7 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU,
        action: (0, $g8xDQ.AnalyticsAction).VIEWED,
        actionSubjectId: 'noBrowsePermission'
    });
};
const $640bce514bddc0f9$export$a5bdd25287196af4 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $640bce514bddc0f9$export$881b6b12fd147cc = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'remindTeamMembersButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $640bce514bddc0f9$export$451dcd11e28959 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $g8xDQ.AnalyticsAction).VIEWED,
        name: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MESSAGE
    });
};
const $640bce514bddc0f9$export$fdfb31060bc22a02 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $g8xDQ.AnalyticsAction).VIEWED,
        name: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $640bce514bddc0f9$export$5deab56d147776ca = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'copyInviteLinkButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$a4a63a010743799d = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'dismissButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $640bce514bddc0f9$export$faf6c5030f38bba5 = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'sendReminderButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$736bb3246fa74c1f = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $g8xDQ.AnalyticsAction).SUCCEEDED,
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$794d511945a81231 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).FETCH_INACTIVE_USERS_DATA,
        action: (0, $g8xDQ.AnalyticsAction).FAILED,
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL
    });
};
const $640bce514bddc0f9$export$866a7379b396a7e3 = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $g8xDQ.AnalyticsAction).SUCCEEDED,
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$498c81c82596e8ea = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).SEND_REINVITES,
        action: (0, $g8xDQ.AnalyticsAction).FAILED,
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MODAL,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$644347da17a1bc39 = (createAnalyticsEvent, attributes)=>{
    (0, $2JFSN.fireTrackEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).RENOTIFY_EXPERIMENT,
        action: (0, $g8xDQ.AnalyticsAction).INELIGIBLE,
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_MESSAGE,
        attributes: attributes
    });
};
const $640bce514bddc0f9$export$68b8d9efc6f7f58f = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireScreenEvent)(createAnalyticsEvent, {
        action: (0, $g8xDQ.AnalyticsAction).VIEWED,
        name: (0, $g8xDQ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $640bce514bddc0f9$export$f900d0881e38df06 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightDismissButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};
const $640bce514bddc0f9$export$acbad06cf5c53b17 = (createAnalyticsEvent)=>{
    (0, $2JFSN.fireUIEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).BUTTON,
        action: (0, $g8xDQ.AnalyticsAction).CLICKED,
        actionSubjectId: 'renotifySpotlightConfirmButton',
        source: (0, $g8xDQ.AnalyticsSource).RENOTIFY_SPOTLIGHT
    });
};

});
parcelRegister("g8xDQ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsActionSubject", () => $ff8b9b910add8360$export$4bce2c1f3a5d9f61);
$parcel$export(module.exports, "AnalyticsAction", () => $ff8b9b910add8360$export$30c16f5c43437fd7);
$parcel$export(module.exports, "AnalyticsSource", () => $ff8b9b910add8360$export$6890652a1aff7d1c);
var $ff8b9b910add8360$export$4bce2c1f3a5d9f61;
(function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["VIEW_PEOPLE_ADDITIONAL_LINK"] = "additionalMenuLink";
    AnalyticsActionSubject["VIEW_PEOPLE_DIRECTORY_LINK"] = "viewAllPeopleDirectory";
    AnalyticsActionSubject["CREATE_NEW_TEAM_LINK"] = "createNewTeamLink";
    AnalyticsActionSubject["PEOPLE_MENU_LINK"] = "peopleMenuLink";
    AnalyticsActionSubject["TEAM_MENU_LINK"] = "teamMenuLink";
    AnalyticsActionSubject["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsActionSubject["NAVIGATION_MENU_ITEM"] = "navigationMenuItem";
    AnalyticsActionSubject["PRE_FETCH_DATA"] = "preFetchData";
    AnalyticsActionSubject["FETCHING_USERS_TEAMS_DATA"] = "fetchingUsersTeamsData";
    AnalyticsActionSubject["HOVER_AND_CLICK_PEOPLE_BUTTON"] = "hoverAndClickPeopleButton";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["FETCH_INACTIVE_USERS_DATA"] = "fetchInactiveUsersData";
    AnalyticsActionSubject["SEND_REINVITES"] = "sendReinvites";
    AnalyticsActionSubject["RENOTIFY_EXPERIMENT"] = "renotifyExperiment";
})($ff8b9b910add8360$export$4bce2c1f3a5d9f61 || ($ff8b9b910add8360$export$4bce2c1f3a5d9f61 = {}));
var $ff8b9b910add8360$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["TRIGGERED"] = "triggered";
    AnalyticsAction["MEASURED"] = "measured";
    AnalyticsAction["INELIGIBLE"] = "ineligible";
})($ff8b9b910add8360$export$30c16f5c43437fd7 || ($ff8b9b910add8360$export$30c16f5c43437fd7 = {}));
var $ff8b9b910add8360$export$6890652a1aff7d1c;
(function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_MENU"] = "peopleMenu";
    AnalyticsSource["RENOTIFY_MESSAGE"] = "renotifyMessage";
    AnalyticsSource["RENOTIFY_MODAL"] = "renotifyModal";
    AnalyticsSource["RENOTIFY_SPOTLIGHT"] = "renotifySpotlight";
})($ff8b9b910add8360$export$6890652a1aff7d1c || ($ff8b9b910add8360$export$6890652a1aff7d1c = {}));

});

parcelRegister("2g8G5", function(module, exports) {

$parcel$export(module.exports, "triggerAnalyticsForLoadedPeople", () => $d3a9db343090ae75$export$62ecc9342d32a444);
$parcel$export(module.exports, "triggerAnalyticsForLoadedTeam", () => $d3a9db343090ae75$export$e648838c8bbef986);

var $2JFSN = parcelRequire("2JFSN");
parcelRequire("kiYze");
var $g8xDQ = parcelRequire("g8xDQ");
const $d3a9db343090ae75$export$62ecc9342d32a444 = (action, createAnalyticsEvent, status, error)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU_LINK,
        action: action === 'succeeded' ? (0, $g8xDQ.AnalyticsAction).SUCCEEDED : (0, $g8xDQ.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};
const $d3a9db343090ae75$export$e648838c8bbef986 = (action, createAnalyticsEvent, status, error)=>{
    (0, $2JFSN.fireOperationalEvent)(createAnalyticsEvent, {
        actionSubject: (0, $g8xDQ.AnalyticsActionSubject).TEAM_MENU_LINK,
        action: action === 'succeeded' ? (0, $g8xDQ.AnalyticsAction).SUCCEEDED : (0, $g8xDQ.AnalyticsAction).FAILED,
        attributes: {
            status: status,
            error: error?.message || JSON.stringify(error)
        }
    });
};

});


parcelRegister("fMK6v", function(module, exports) {

$parcel$export(module.exports, "RenotifyModal", () => $b675f5105c71bebb$export$c68d29a05874a11b);

var $7rh0R = parcelRequire("7rh0R");

const $b675f5105c71bebb$export$c68d29a05874a11b = (0, $7rh0R.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("5EKVn")), {
    moduleId: "../platform/packages/people-and-teams/people-menu/src/components/PeopleMenu/RenotifyModal.tsx"
});

});
parcelRegister("5EKVn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("VNG7l")
]).then(()=>parcelRequire('jDFCV'));

});


parcelRegister("7lnvo", function(module, exports) {

$parcel$export(module.exports, "RenotifyStatus", () => $47eb00c18c777048$export$e1b7db4c83021afe);
$parcel$export(module.exports, "usePendingUsers", () => $47eb00c18c777048$export$8d720c7cdd23491d);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $kiYze = parcelRequire("kiYze");

var $jgrVG = parcelRequire("jgrVG");
const $47eb00c18c777048$export$50fd3325777ce4bc = new Map();
const $47eb00c18c777048$export$7149af0c7f6b6e85 = 'pendingUsers';
const $47eb00c18c777048$export$c9c3fbf7cb17786e = 'renotifyEligibility';
var $47eb00c18c777048$export$e1b7db4c83021afe;
(function(RenotifyStatus) {
    RenotifyStatus["IS_LOADING"] = "isLoading";
    RenotifyStatus["ELIGIBLE"] = "eligible";
    RenotifyStatus["INELIGIBLE"] = "ineligible";
    RenotifyStatus["ERROR"] = "error";
})($47eb00c18c777048$export$e1b7db4c83021afe || ($47eb00c18c777048$export$e1b7db4c83021afe = {}));
const $47eb00c18c777048$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS = 600000; // 10 minutes
function $47eb00c18c777048$export$8d720c7cdd23491d({ cloudId: cloudId, startFetching: startFetching, renotifyExperiment: renotifyExperiment, product: product, requestCacheTimeout: requestCacheTimeout }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [pendingUsers, setPendingUsers] = (0, $eUqFw.useState)($47eb00c18c777048$export$50fd3325777ce4bc.get($47eb00c18c777048$export$7149af0c7f6b6e85));
    const [renotifyEligible, setRenotifyEligibility] = (0, $eUqFw.useState)($47eb00c18c777048$export$50fd3325777ce4bc.get($47eb00c18c777048$export$c9c3fbf7cb17786e));
    const { loading: pendingUsersLoading, error: pendingUsersError, data: pendingUsersData, fetchData: fetchPendingUsers } = (0, $jgrVG.usePendingUsersService)(cloudId, requestCacheTimeout === undefined ? $47eb00c18c777048$var$REQUEST_CACHE_TIMEOUT_PENDING_USERS : requestCacheTimeout, product);
    (0, $eUqFw.useEffect)(()=>{
        if (renotifyEligible !== undefined || renotifyExperiment?.isLoading || !startFetching) return;
        if (renotifyExperiment?.isEnrolled) fetchPendingUsers();
        else {
            $47eb00c18c777048$export$50fd3325777ce4bc.set($47eb00c18c777048$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        renotifyEligible,
        fetchPendingUsers,
        renotifyExperiment?.isLoading,
        renotifyExperiment?.isEnrolled,
        startFetching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (pendingUsersError) {
            (0, $kiYze.triggerAnalyticsForRenotifyFetchInactiveUsersFailed)(createAnalyticsEvent);
            $47eb00c18c777048$export$50fd3325777ce4bc.set($47eb00c18c777048$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
            return;
        }
        if (pendingUsersData === undefined || pendingUsersLoading) return;
        $47eb00c18c777048$export$50fd3325777ce4bc.set($47eb00c18c777048$export$7149af0c7f6b6e85, pendingUsersData);
        setPendingUsers(pendingUsersData);
        if (pendingUsersData?.length) {
            (0, $kiYze.triggerAnalyticsForRenotifyFetchInactiveUsersSucceeded)(createAnalyticsEvent, {
                numberOfInviteeEmails: pendingUsersData?.length
            });
            $47eb00c18c777048$export$50fd3325777ce4bc.set($47eb00c18c777048$export$c9c3fbf7cb17786e, true);
            if (renotifyExperiment?.isEnrolled) setRenotifyEligibility(true);
        } else {
            (0, $kiYze.triggerAnalyticsForRenotifyNotEligible)(createAnalyticsEvent, {
                reason: 'No pending users'
            });
            $47eb00c18c777048$export$50fd3325777ce4bc.set($47eb00c18c777048$export$c9c3fbf7cb17786e, false);
            setRenotifyEligibility(false);
        }
    }, [
        createAnalyticsEvent,
        pendingUsersData,
        pendingUsersError,
        pendingUsersLoading,
        renotifyExperiment
    ]);
    if (pendingUsersLoading || renotifyExperiment?.isLoading) return {
        status: "isLoading",
        isLoading: true
    };
    if (pendingUsersError) return {
        status: "error",
        pendingUsersError: pendingUsersError ?? new Error('Invalid pending user response'),
        isLoading: false
    };
    if (renotifyEligible === false || !pendingUsers) return {
        status: "ineligible",
        isLoading: false
    };
    return {
        status: "eligible",
        isLoading: false,
        pendingUsers: pendingUsers
    };
}

});
parcelRegister("jgrVG", function(module, exports) {

$parcel$export(module.exports, "usePendingUsersService", () => $9ae0ccaf714c4dce$export$4e16c66a0a5052e1);

var $eUqFw = parcelRequire("eUqFw");

var $h5lVt = parcelRequire("h5lVt");

var $iofV5 = parcelRequire("iofV5");

var $jb3V4 = parcelRequire("jb3V4");

var $lwMt0 = parcelRequire("lwMt0");
const $9ae0ccaf714c4dce$var$mapFetchInactiveUserFnByTimeout = new Map();
function $9ae0ccaf714c4dce$var$getFetchInactiveUsersCachedFn(timeout = (0, $h5lVt.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $9ae0ccaf714c4dce$var$mapFetchInactiveUserFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $h5lVt.withCached)((0, $jb3V4.fetchInactiveUsers), timeout);
    $9ae0ccaf714c4dce$var$mapFetchInactiveUserFnByTimeout.set(timeout, fn);
    return fn;
}
function $9ae0ccaf714c4dce$export$4e16c66a0a5052e1(cloudId, cacheTimeout, product) {
    const { product: contextProduct } = (0, $lwMt0.usePeopleMenuContext)();
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $9ae0ccaf714c4dce$var$getFetchInactiveUsersCachedFn(cacheTimeout);
            return fn(cloudId, product ?? contextProduct);
        }
        return (0, $jb3V4.fetchInactiveUsers)(cloudId, product ?? contextProduct);
    }, [
        cacheTimeout,
        cloudId,
        product,
        contextProduct
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $iofV5.useService)(request);
    return {
        loading: loading,
        error: error,
        data: data?.users,
        fetchData: fetchData
    };
}

});
parcelRegister("h5lVt", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY", () => $f06d26f350db6feb$export$d8b1aa62ff4847fc);
$parcel$export(module.exports, "withCached", () => $f06d26f350db6feb$export$7f51828d6b6af163);
const $f06d26f350db6feb$var$ONE_SECOND = 1000;
const $f06d26f350db6feb$export$d8b1aa62ff4847fc = 5 * $f06d26f350db6feb$var$ONE_SECOND;
const $f06d26f350db6feb$var$isPromise = (p)=>{
    return p !== undefined && typeof p.then === 'function' && typeof p.catch === 'function';
};
const $f06d26f350db6feb$export$7f51828d6b6af163 = (fn, timeout = $f06d26f350db6feb$export$d8b1aa62ff4847fc)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        // we don't handle non-promise data so skip it
        if ($f06d26f350db6feb$var$isPromise(maybePromise)) {
            promiseCache.set(cacheKey, maybePromise);
            maybePromise.then((result)=>{
                resultCache.set(cacheKey, result);
                setTimeout(()=>{
                    promiseCache.delete(cacheKey);
                    resultCache.delete(cacheKey);
                }, timeout);
            }).catch(()=>{
                promiseCache.delete(cacheKey);
                resultCache.delete(cacheKey);
            });
        }
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("jb3V4", function(module, exports) {

$parcel$export(module.exports, "fetchInactiveUsers", () => $24598beec9b9805d$export$b6000772b84436c7);
$parcel$export(module.exports, "sendReinvites", () => $24598beec9b9805d$export$df764bf7318de5);

var $le2Hw = parcelRequire("le2Hw");
const $24598beec9b9805d$var$EXPERIMENT_API_BASE = '/gateway/api/growth/';
const $24598beec9b9805d$var$getExperimentAPICommonPath = (product)=>`${$24598beec9b9805d$var$EXPERIMENT_API_BASE}${product === 'confluence' ? 'notify-if-invitee-never-logged-in-confluence' : 'notify-if-invitee-never-logged-in'}`;
const $24598beec9b9805d$var$getInactiveUsersUrl = (cloudId, product)=>`${$24598beec9b9805d$var$getExperimentAPICommonPath(product)}/get-inactive-users?cloudId=${cloudId}`;
const $24598beec9b9805d$export$b6000772b84436c7 = (cloudId, product)=>(0, $le2Hw.fetchJson)($24598beec9b9805d$var$getInactiveUsersUrl(cloudId, product));
const $24598beec9b9805d$var$getReinviteUrl = (product)=>`${$24598beec9b9805d$var$getExperimentAPICommonPath(product)}/reinvite`;
const $24598beec9b9805d$export$df764bf7318de5 = (cloudId, reInvites, product)=>{
    return (0, $le2Hw.postJson)($24598beec9b9805d$var$getReinviteUrl(product), {
        owner: `ari:cloud:platform::site/${cloudId}`,
        reInvites: reInvites.map(({ userId: userId, continueUrl: continueUrl })=>({
                inviteeId: `ari:cloud:identity::user/${userId}`,
                continueUrl: continueUrl
            }))
    });
};

});
parcelRegister("le2Hw", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $d878eb74c8af6af7$export$6d71b655afe1638d);
$parcel$export(module.exports, "postJson", () => $d878eb74c8af6af7$export$c776284ef4b1209a);
const $d878eb74c8af6af7$export$83179404a61b001a = 'FetchError';
function $d878eb74c8af6af7$export$847691ec04985fa0(error, status) {
    return {
        name: $d878eb74c8af6af7$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status
    };
}
const $d878eb74c8af6af7$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw $d878eb74c8af6af7$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status);
    });
const $d878eb74c8af6af7$export$c776284ef4b1209a = (url, data)=>$d878eb74c8af6af7$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});




parcelRegister("c9M9x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("hDpoD")
]).then(()=>parcelRequire('7USMd'));

});


parcelRegister("jLsPA", function(module, exports) {

$parcel$export(module.exports, "isCachedDataClear", () => $77afdf39976da269$export$cee8b843259f0f74);
$parcel$export(module.exports, "default", () => $77afdf39976da269$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $22SBt = parcelRequire("22SBt");
var $4LUqX = parcelRequire("4LUqX");
const $77afdf39976da269$export$50fd3325777ce4bc = new Map();
const $77afdf39976da269$export$cd84c175965a58da = 'collaborators';
const $77afdf39976da269$export$b5c382592ac689a7 = 'teams';
const $77afdf39976da269$var$ONE_SEC = 1000;
const $77afdf39976da269$var$ONE_MINUTE = $77afdf39976da269$var$ONE_SEC * 60;
const $77afdf39976da269$var$REQUEST_CACHE_TIMEOUT_TEAMS = $77afdf39976da269$var$ONE_MINUTE;
const $77afdf39976da269$var$REQUEST_CACHE_TIMEOUT_USERS = $77afdf39976da269$var$ONE_MINUTE * 5;
function $77afdf39976da269$export$cee8b843259f0f74() {
    return $77afdf39976da269$export$50fd3325777ce4bc.size === 0;
}
function $77afdf39976da269$export$2e2bcd8739ae039(cloudId, userId, product, tenantUrl, requestCacheTimeout, orgId) {
    const [dataUsers, setDataUsers] = (0, $eUqFw.useState)(undefined);
    const [dataTeams, setDataTeams] = (0, $eUqFw.useState)(undefined);
    const { loading: isLoadingUsers, error: errorUsers, data: users } = (0, $22SBt.useCollaboratorsService)(cloudId, 'context', tenantUrl, requestCacheTimeout === undefined ? $77afdf39976da269$var$REQUEST_CACHE_TIMEOUT_USERS : requestCacheTimeout);
    const { loading: isLoadingTeams, error: errorTeams, data: teams } = (0, $4LUqX.useTeamsOfService)(userId, cloudId, product, tenantUrl, requestCacheTimeout === undefined ? $77afdf39976da269$var$REQUEST_CACHE_TIMEOUT_TEAMS : requestCacheTimeout, orgId);
    // after the service return the latest data,
    // we store users data in cache store.
    (0, $eUqFw.useEffect)(()=>{
        if (!users || isLoadingUsers || errorUsers) return;
        $77afdf39976da269$export$50fd3325777ce4bc.set($77afdf39976da269$export$cd84c175965a58da, users);
        setDataUsers(users);
    }, [
        users,
        isLoadingUsers,
        errorUsers
    ]);
    // after the service return the latest data,
    // store teams data in cache store.
    (0, $eUqFw.useEffect)(()=>{
        if (!teams || isLoadingTeams || errorTeams) return;
        $77afdf39976da269$export$50fd3325777ce4bc.set($77afdf39976da269$export$b5c382592ac689a7, teams);
        setDataTeams(teams);
    }, [
        teams,
        isLoadingTeams,
        errorTeams
    ]);
    return {
        users: dataUsers && dataUsers.length ? dataUsers : $77afdf39976da269$export$50fd3325777ce4bc.get($77afdf39976da269$export$cd84c175965a58da),
        teams: dataTeams && dataTeams.length ? dataTeams : $77afdf39976da269$export$50fd3325777ce4bc.get($77afdf39976da269$export$b5c382592ac689a7),
        errorTeams: errorTeams,
        errorUsers: errorUsers,
        isLoading: isLoadingUsers || isLoadingTeams
    };
}

});
parcelRegister("22SBt", function(module, exports) {

$parcel$export(module.exports, "useCollaboratorsService", () => $99d8a30a5deacd3b$export$979a4f9449b8be53);

var $eUqFw = parcelRequire("eUqFw");

var $9304A = parcelRequire("9304A");

var $ewJyV = parcelRequire("ewJyV");

var $h5lVt = parcelRequire("h5lVt");

var $iofV5 = parcelRequire("iofV5");
const $99d8a30a5deacd3b$var$mapFetchCollaboratorsFnByTimeout = new Map();
function $99d8a30a5deacd3b$var$getFetchCollaboratorsCachedFn(timeout = (0, $h5lVt.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $99d8a30a5deacd3b$var$mapFetchCollaboratorsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $h5lVt.withCached)((0, $9304A.fetchCollaborators), timeout);
    $99d8a30a5deacd3b$var$mapFetchCollaboratorsFnByTimeout.set(timeout, fn);
    return fn;
}
function $99d8a30a5deacd3b$export$979a4f9449b8be53(cloudId, userId = 'context', tenantUrl = '', cacheTimeout) {
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $99d8a30a5deacd3b$var$getFetchCollaboratorsCachedFn(cacheTimeout);
            return fn(cloudId, userId, tenantUrl);
        }
        return (0, $9304A.fetchCollaborators)(cloudId, userId, tenantUrl);
    }, [
        cacheTimeout,
        cloudId,
        userId,
        tenantUrl
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $iofV5.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $eUqFw.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $eUqFw.useMemo)(()=>(0, $ewJyV.transformCollabsDataToUsers)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});
parcelRegister("9304A", function(module, exports) {

$parcel$export(module.exports, "fetchCollaborators", () => $c65591a3ff43f49b$export$cadad85c3acf2ad8);

var $26oQD = parcelRequire("26oQD");
const $c65591a3ff43f49b$export$42623aff9edf525f = '/gateway/api/collaboration/v1/collaborationgraph/user/user';
const $c65591a3ff43f49b$var$LIMIT_RESULTS = 5;
const $c65591a3ff43f49b$export$cadad85c3acf2ad8 = (cloudId, userId = 'context', tenantUrl = '')=>(0, $26oQD.postJson)(`${tenantUrl}${$c65591a3ff43f49b$export$42623aff9edf525f}`, {
        context: {
            contextType: 'atlassianPeoplePackage',
            principalId: userId,
            siteId: cloudId
        },
        maxNumberOfResults: $c65591a3ff43f49b$var$LIMIT_RESULTS,
        userId: userId,
        expanded: true
    });

});

parcelRegister("ewJyV", function(module, exports) {

$parcel$export(module.exports, "transformCollabsDataToUsers", () => $aacfdbb11ff026fb$export$1eb7590d078520b8);

var $3oOay = parcelRequire("3oOay");
const $aacfdbb11ff026fb$var$userMapper = (user)=>{
    const { userProfile: userProfile, entityType: entityType } = user;
    if (!userProfile || entityType !== (0, $3oOay.ENTITY_TYPE).USER) return null;
    return {
        id: user.id,
        fullName: userProfile.name,
        nickname: userProfile.nickname,
        email: userProfile.email,
        avatarUrl: userProfile.picture,
        collaborationGraphScore: user.score,
        status: userProfile.account_status
    };
};
const $aacfdbb11ff026fb$export$1eb7590d078520b8 = (data)=>{
    if (!data) return [];
    const { collaborationGraphEntities: collaborationGraphEntities = [] } = data;
    return collaborationGraphEntities.map($aacfdbb11ff026fb$var$userMapper).filter((item)=>item) || [];
};

});
parcelRegister("3oOay", function(module, exports) {

$parcel$export(module.exports, "ENTITY_TYPE", () => $a11b20dd2f4be4ee$export$49be827a0aef75dd);
var $a11b20dd2f4be4ee$export$49be827a0aef75dd;
(function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
})($a11b20dd2f4be4ee$export$49be827a0aef75dd || ($a11b20dd2f4be4ee$export$49be827a0aef75dd = {}));
var $a11b20dd2f4be4ee$export$fba7c3adda5094d9;
(function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
})($a11b20dd2f4be4ee$export$fba7c3adda5094d9 || ($a11b20dd2f4be4ee$export$fba7c3adda5094d9 = {}));

});



parcelRegister("4LUqX", function(module, exports) {

$parcel$export(module.exports, "useTeamsOfService", () => $c23a7b8f8a160f5e$export$668750a034956301);

var $eUqFw = parcelRequire("eUqFw");

var $8Biwj = parcelRequire("8Biwj");

var $9yJpK = parcelRequire("9yJpK");

var $h5lVt = parcelRequire("h5lVt");

var $iofV5 = parcelRequire("iofV5");
const $c23a7b8f8a160f5e$var$mapFetchMyTeamsFnByTimeout = new Map();
function $c23a7b8f8a160f5e$var$getFetchMyTeamsCachedFn(timeout = (0, $h5lVt.DEFAULT_RELEASE_RESOLVED_PROMISE_DELAY)) {
    let fn = $c23a7b8f8a160f5e$var$mapFetchMyTeamsFnByTimeout.get(timeout);
    if (fn) return fn;
    fn = (0, $h5lVt.withCached)((0, $8Biwj.searchTeamsOfUser), timeout);
    $c23a7b8f8a160f5e$var$mapFetchMyTeamsFnByTimeout.set(timeout, fn);
    return fn;
}
function $c23a7b8f8a160f5e$export$668750a034956301(userId, cloudId, product, tenantUrl = '', cacheTimeout, orgId) {
    const request = (0, $eUqFw.useCallback)(()=>{
        if (cacheTimeout) {
            const fn = $c23a7b8f8a160f5e$var$getFetchMyTeamsCachedFn(cacheTimeout);
            return fn(userId, cloudId, product, tenantUrl, orgId);
        }
        return (0, $8Biwj.searchTeamsOfUser)(userId, cloudId, product, tenantUrl, orgId);
    }, [
        cacheTimeout,
        userId,
        cloudId,
        product,
        tenantUrl,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $iofV5.useService)(request, {
        loading: true
    });
    // For reusable services, it is better not to hardcode fetching on mount, to make them more flexible. When possible, add this code to component which calls service instead.
    (0, $eUqFw.useEffect)(()=>{
        fetchData();
    /*
      NOTE: If you add `fetchData` to the dependency list (in this component or its children) - you have to define `request` function you pass to `useService()` via `useCallback()`.
      Otherwise you may get an infinite loop.
    */ }, [
        fetchData
    ]);
    const memoizedData = (0, $eUqFw.useMemo)(()=>(0, $9yJpK.transformTeams)(data), [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        fetchData: fetchData
    };
}

});


parcelRegister("jEywk", function(module, exports) {

$parcel$export(module.exports, "VOID_FUNC", () => $b3e1fa6ca51d3e4c$export$7e6ba5d480e9bd2f);
const $b3e1fa6ca51d3e4c$export$53bb833296af4a30 = 5;
const $b3e1fa6ca51d3e4c$export$88d6945644578407 = 3;
const $b3e1fa6ca51d3e4c$export$7e6ba5d480e9bd2f = ()=>undefined;

});

parcelRegister("lE5gC", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $d565d4375ffb5205$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $d565d4375ffb5205$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $d565d4375ffb5205$export$6f766653554dac02);
const $d565d4375ffb5205$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $d565d4375ffb5205$var$hasPerformanceAPIAvailable = $d565d4375ffb5205$var$isPerformanceAPIAvailable();
const $d565d4375ffb5205$var$measureMap = new Map();
function $d565d4375ffb5205$export$b62aa2130c86b59b(measureName) {
    if (!$d565d4375ffb5205$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $d565d4375ffb5205$var$measureMap.set(measureName, performance.now());
}
function $d565d4375ffb5205$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$d565d4375ffb5205$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$d565d4375ffb5205$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $d565d4375ffb5205$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $d565d4375ffb5205$export$6f766653554dac02(measureName);
    }
}
function $d565d4375ffb5205$export$6f766653554dac02(measureName) {
    if (!$d565d4375ffb5205$var$hasPerformanceAPIAvailable) return;
    $d565d4375ffb5205$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("9k7cN", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $09335fc000baa8bd$export$479f0f2f71193efe);
$parcel$export(module.exports, "MenuContentFallback", () => $09335fc000baa8bd$export$48b47052ec2aea7f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8PFhw = parcelRequire("8PFhw");

var $lwMt0 = parcelRequire("lwMt0");

var $jLsPA = parcelRequire("jLsPA");

var $6SX3a = parcelRequire("6SX3a");

var $h4UEj = parcelRequire("h4UEj");

const $09335fc000baa8bd$export$479f0f2f71193efe = (0, $7rh0R.lazyForPaint)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("1reha")), {
    moduleId: "../platform/packages/people-and-teams/people-menu/src/components/MenuContent/MenuContent.tsx"
});
const $09335fc000baa8bd$export$b0396be60c0e9152 = 480;
const $09335fc000baa8bd$export$3f133812f81dfa49 = 320;
const $09335fc000baa8bd$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $09335fc000baa8bd$export$48b47052ec2aea7f() {
    const { cloudId: cloudId, tenantUrl: tenantUrl, userId: userId, product: product, testId: testId, orgId: orgId } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    // kick off some requests sooner
    (0, $jLsPA.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
        testId: `${testId}-group-loading`,
        maxWidth: $09335fc000baa8bd$export$b0396be60c0e9152,
        maxHeight: $09335fc000baa8bd$export$94aaf6acd960c412,
        minWidth: $09335fc000baa8bd$export$3f133812f81dfa49
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SX3a.MenuGroupPeople), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h4UEj.MenuGroupTeams), {
        isLoading: true
    }));
}

});
parcelRegister("6SX3a", function(module, exports) {

$parcel$export(module.exports, "MenuGroupPeople", () => $c60588b78687ac68$export$c521b8e86241ef89);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jDha = parcelRequire("2jDha");

var $bo4OB = parcelRequire("bo4OB");

var $gtYBG = parcelRequire("gtYBG");

var $dgrT7 = parcelRequire("dgrT7");

var $lwMt0 = parcelRequire("lwMt0");

var $jEywk = parcelRequire("jEywk");

var $7Q29Y = parcelRequire("7Q29Y");
parcelRequire("kiYze");
var $g8xDQ = parcelRequire("g8xDQ");
var $kiYze = parcelRequire("kiYze");

var $7rpGo = parcelRequire("7rpGo");

var $fdqWp = parcelRequire("fdqWp");

var $gMfij = parcelRequire("gMfij");
const $c60588b78687ac68$export$2e63129145f0c868 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { users: users = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $jEywk.VOID_FUNC), pushRoute: pushRoute = (0, $jEywk.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $jEywk.VOID_FUNC) } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    const handleClickOnPeople = (0, $eUqFw.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $7Q29Y.isModifiedEvent)(event);
            (0, $kiYze.triggerAnalyticsForClickOnPeople)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'people', event);
            if (isLeftClick) {
                const peopleProfilePage = (0, $dgrT7.getPeopleProfilePage)(remoteConfig.resources, id, product, (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU);
                pushRoute(peopleProfilePage);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.collaborators.enabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdqWp.MenuGroupSection), {
        title: remoteConfig.sections.collaborators.label ?? intl.formatMessage((0, $7rpGo.messages).yourCollab),
        testId: `${testId}-people-section`,
        isLoading: isLoading,
        isEmpty: users.length === 0,
        sectionType: 'user',
        maxItems: remoteConfig.sections.collaborators.maxItems
    }, users.slice(0, remoteConfig.sections.collaborators.maxItems).map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
            key: user.id,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMfij.ImgIcon), {
                src: user.avatarUrl,
                alt: ""
            }),
            testId: `${testId}-people-item`,
            href: (0, $dgrT7.getPeopleProfilePage)(remoteConfig.resources, user.id, product, (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU),
            onClick: handleClickOnPeople(user.id)
        }, user.fullName)));
};
const $c60588b78687ac68$export$c521b8e86241ef89 = (0, $2jDha.default)()((0, $gtYBG.withMandatoryPeopleMenuConfiguration)($c60588b78687ac68$export$2e63129145f0c868));

});
parcelRegister("7Q29Y", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $4cee2be03ba32028$export$642c6f14f6d4bbd5);
const $4cee2be03ba32028$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("7rpGo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bdec94eee5879cfd$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bdec94eee5879cfd$var$PREFIX = 'ptc.pm';
const $bdec94eee5879cfd$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    yourCollab: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.collaborators.title`,
        defaultMessage: 'Your Collaborators',
        description: 'A title of Your-Collaborators section in People Menu dropdown'
    },
    yourTeams: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.your-teams.title`,
        defaultMessage: 'Your Teams',
        description: 'A title of a Your-Teams section in People Menu dropdown'
    },
    viewYourProfile: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.view-your-profile`,
        defaultMessage: 'View your profile',
        description: 'A link in People Menu. Clicking on it will navigate the user to their personal profile'
    },
    errorHeading: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.error-heading`,
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the People Menu. Usually due to failed network requests.'
    },
    errorText: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.error-text`,
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the People Menu.'
    },
    errorImageAltText: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.error-image-alt-text`,
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the People Menu'
    },
    people: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.people`,
        defaultMessage: 'People',
        description: 'A default title of primary People menu'
    },
    teams: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.teams`,
        defaultMessage: 'Teams',
        description: 'A new default title of primary People menu'
    },
    numMembers: {
        id: `${$bdec94eee5879cfd$var$PREFIX}.num-members`,
        defaultMessage: `{memberCount, plural,
    one {# member}
    other {# members}
}`,
        description: 'Subtext of the number of members belonging to a team'
    }
});

});

parcelRegister("fdqWp", function(module, exports) {

$parcel$export(module.exports, "MenuGroupSection", () => $273c15c6647f432a$export$33b4adfb29dd0d95);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");
var $lV9rH = parcelRequire("lV9rH");

var $lwMt0 = parcelRequire("lwMt0");

var $4H46i = parcelRequire("4H46i");
const $273c15c6647f432a$export$33b4adfb29dd0d95 = ({ title: title, isEmpty: isEmpty, isLoading: isLoading, children: children, testId: testId, maxItems: maxItems, sectionType: sectionType })=>{
    const { isSectionList: isSectionList = false } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    if (!isLoading && isEmpty) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        // title is undefined if we are loading as we show the heading skeleton below
        title: isLoading ? undefined : title,
        testId: testId,
        isList: isSectionList
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        testId: `${sectionType}-skeleton-heading`
    }), Array(maxItems).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4H46i.default), {
            key: `${sectionType}-${index}`
        }))) : children);
};

});
parcelRegister("4H46i", function(module, exports) {

$parcel$export(module.exports, "default", () => $71ee925fb58476b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");


var $gMfij = parcelRequire("gMfij");
const $71ee925fb58476b2$var$cssFn = ()=>{
    return {
        '&::before': {
            backgroundColor: `var(--ds-skeleton, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`,
            borderRadius: '100%',
            flexShrink: 0,
            content: '""',
            marginLeft: 0,
            marginRight: "var(--ds-space-150, 12px)",
            width: (0, $gMfij.ICON_SIZE),
            height: (0, $gMfij.ICON_SIZE)
        }
    };
};
function $71ee925fb58476b2$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasAvatar: true,
        cssFn: $71ee925fb58476b2$var$cssFn,
        testId: "people-menu-skeleton-item"
    }));
}

});
parcelRegister("gMfij", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE", () => $e1f3a3a81ac945c2$export$91a15f1424900d33);
$parcel$export(module.exports, "MAX_POPUP_WIDTH", () => $e1f3a3a81ac945c2$export$b0396be60c0e9152);
$parcel$export(module.exports, "MIN_POPUP_WIDTH", () => $e1f3a3a81ac945c2$export$3f133812f81dfa49);
$parcel$export(module.exports, "MAX_POPUP_HEIGHT", () => $e1f3a3a81ac945c2$export$94aaf6acd960c412);
$parcel$export(module.exports, "ImgIcon", () => $e1f3a3a81ac945c2$export$804b6389edcac2c2);
$parcel$export(module.exports, "Buggy", () => $e1f3a3a81ac945c2$export$6b52db8960fbef38);
$parcel$export(module.exports, "fireRenderPeopleNavMenuFail", () => $e1f3a3a81ac945c2$export$5884f4bd467a603a);

var $eUqFw = parcelRequire("eUqFw");

var $gg6hk = parcelRequire("gg6hk");

var $7suZ8 = parcelRequire("7suZ8");
const $e1f3a3a81ac945c2$export$91a15f1424900d33 = 32;
const $e1f3a3a81ac945c2$export$b0396be60c0e9152 = 480;
const $e1f3a3a81ac945c2$export$3f133812f81dfa49 = 320;
const $e1f3a3a81ac945c2$export$94aaf6acd960c412 = 'calc(100vh - 79px)';
function $e1f3a3a81ac945c2$export$804b6389edcac2c2({ src: src, alt: alt }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src || '',
        alt: alt,
        height: $e1f3a3a81ac945c2$export$91a15f1424900d33,
        width: $e1f3a3a81ac945c2$export$91a15f1424900d33,
        style: {
            borderRadius: $e1f3a3a81ac945c2$export$91a15f1424900d33 / 2
        }
    });
}
function $e1f3a3a81ac945c2$export$6b52db8960fbef38() {
    (0, $eUqFw.useEffect)(()=>{
        throw new Error('Something wrong inside People menu.');
    });
    return null;
}
const $e1f3a3a81ac945c2$export$5884f4bd467a603a = (error)=>{
    (0, $7suZ8.renderPeopleNavMenuExp).failure({
        metadata: {
            ...error && 'status' in error ? {
                status: error.status
            } : {},
            ...error instanceof (0, $gg6hk.ErrorWithContext) ? {
                context: error.context
            } : {},
            error: error?.message
        }
    });
};

});
parcelRegister("7suZ8", function(module, exports) {

$parcel$export(module.exports, "renderPeopleNavMenuExp", () => $e01cffc1d9c57801$export$a0db9187c809008d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $kFmJM = parcelRequire("kFmJM");
class $e01cffc1d9c57801$var$UFOExperienceWithPackageContext extends (0, $kDfSL.UFOExperience) {
    async success() {
        return super.success({
            metadata: {
                ...(0, $kFmJM.packageContext)
            }
        });
    }
    async failure(config) {
        return super.failure({
            force: config?.force,
            metadata: {
                ...config?.metadata ?? {},
                ...(0, $kFmJM.packageContext)
            }
        });
    }
    async abort() {
        return super.abort({
            metadata: {
                ...(0, $kFmJM.packageContext)
            }
        });
    }
}
const $e01cffc1d9c57801$export$a0db9187c809008d = new $e01cffc1d9c57801$var$UFOExperienceWithPackageContext('render-people-nav-menu', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("kFmJM", function(module, exports) {

$parcel$export(module.exports, "packageContext", () => $a6173ab2a6e50573$export$beac86d91b8e8b21);
const $a6173ab2a6e50573$export$beac86d91b8e8b21 = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});






parcelRegister("h4UEj", function(module, exports) {

$parcel$export(module.exports, "MenuGroupTeams", () => $7103e2af65fe1d49$export$c3915c5ac3f99d49);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jDha = parcelRequire("2jDha");

var $bo4OB = parcelRequire("bo4OB");

var $gtYBG = parcelRequire("gtYBG");

var $dgrT7 = parcelRequire("dgrT7");

var $lwMt0 = parcelRequire("lwMt0");

var $jEywk = parcelRequire("jEywk");

var $7Q29Y = parcelRequire("7Q29Y");
parcelRequire("kiYze");
var $g8xDQ = parcelRequire("g8xDQ");
var $kiYze = parcelRequire("kiYze");

var $7rpGo = parcelRequire("7rpGo");

var $fdqWp = parcelRequire("fdqWp");

var $gMfij = parcelRequire("gMfij");
const $7103e2af65fe1d49$export$86c994b04df922e = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { orgId: orgId } = (0, $lwMt0.usePeopleMenuContext)();
    const { teams: teams = [], createAnalyticsEvent: createAnalyticsEvent, isLoading: isLoading, remoteConfig: remoteConfig } = props;
    const { testId: testId, product: product, onClickedItem: onClickedItem = (0, $jEywk.VOID_FUNC), pushRoute: pushRoute = (0, $jEywk.VOID_FUNC), togglePeopleMenu: togglePeopleMenu = (0, $jEywk.VOID_FUNC) } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    const handleClickOnTeam = (0, $eUqFw.useCallback)((id)=>(event)=>{
            const isLeftClick = !(0, $7Q29Y.isModifiedEvent)(event);
            (0, $kiYze.triggerAnalyticsForClickOnTeam)(createAnalyticsEvent, isLeftClick);
            onClickedItem(id, 'team', event);
            if (isLeftClick) {
                const teamUrl = (0, $dgrT7.getTeamProfilePageLinkWithOrgId)({
                    remoteConfigResources: remoteConfig.resources,
                    teamId: id,
                    orgId: orgId,
                    ref: product,
                    src: (0, $g8xDQ.AnalyticsActionSubject).PEOPLE_MENU
                });
                pushRoute(teamUrl);
                event.preventDefault();
            }
            togglePeopleMenu(false);
        }, [
        createAnalyticsEvent,
        onClickedItem,
        orgId,
        product,
        pushRoute,
        remoteConfig.resources,
        togglePeopleMenu
    ]);
    if (!remoteConfig.sections.teams.enabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdqWp.MenuGroupSection), {
        title: remoteConfig.sections.teams.label ?? intl.formatMessage((0, $7rpGo.messages).yourTeams),
        testId: `${testId}-teams-section`,
        isLoading: isLoading,
        isEmpty: teams.length === 0,
        sectionType: 'team',
        maxItems: remoteConfig.sections.teams.maxItems
    }, teams.slice(0, remoteConfig.sections.teams.maxItems).map((team)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
            key: team.id,
            href: (0, $dgrT7.getTeamProfilePageLinkWithOrgId)({
                remoteConfigResources: remoteConfig.resources,
                teamId: team.id,
                orgId: orgId
            }),
            onClick: handleClickOnTeam(team.id),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMfij.ImgIcon), {
                src: team.smallAvatarImageUrl || team.smallHeaderImageUrl,
                alt: team.displayName
            }),
            description: intl.formatMessage((0, $7rpGo.messages).numMembers, {
                memberCount: team.memberCount ?? 1
            }),
            testId: `${testId}-team-item`
        }, team.displayName)));
};
const $7103e2af65fe1d49$export$c3915c5ac3f99d49 = (0, $2jDha.default)()((0, $gtYBG.withMandatoryPeopleMenuConfiguration)($7103e2af65fe1d49$export$86c994b04df922e));

});

parcelRegister("1reha", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("547nn").then(()=>parcelRequire('itnGW'));

});


parcelRegister("aMDOW", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuContentInternal", () => $175445043920ce7f$export$78306a734b6419e6);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lwMt0 = parcelRequire("lwMt0");

var $hnIMN = parcelRequire("hnIMN");

var $jEywk = parcelRequire("jEywk");

var $9k7cN = parcelRequire("9k7cN");

var $4IuJi = parcelRequire("4IuJi");
const $175445043920ce7f$var$stopPropagation = (e)=>e.stopPropagation();
const $175445043920ce7f$export$78306a734b6419e6 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { isBrowseUsersEnabled: isBrowseUsersEnabled } = (0, $eUqFw.useContext)((0, $lwMt0.PeopleMenuContext));
    const { loading: isLoadingPermission, hasPermission: hasPermission } = (0, $hnIMN.default)(isBrowseUsersEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onClick: $175445043920ce7f$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9k7cN.MenuContentFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9k7cN.MenuContent), {
        isLoadingPermission: isLoadingPermission,
        hasPermission: hasPermission
    })));
});
const $175445043920ce7f$var$PeopleMenuContent = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IuJi.default), {
        isOpen: true,
        onOpen: (0, $jEywk.VOID_FUNC),
        onClose: (0, $jEywk.VOID_FUNC),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($175445043920ce7f$export$78306a734b6419e6, null));
};
var $175445043920ce7f$export$2e2bcd8739ae039 = $175445043920ce7f$var$PeopleMenuContent;

});
parcelRegister("hnIMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc079c09a3bbdee3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $cc079c09a3bbdee3$export$2e2bcd8739ae039(permissionPromise) {
    const noQuery = !permissionPromise;
    const [hasPermission, setPermission] = (0, $eUqFw.useState)(noQuery);
    const [loading, setLoading] = (0, $eUqFw.useState)(!noQuery);
    (0, $eUqFw.useEffect)(()=>{
        if (permissionPromise) permissionPromise().then((permissionResult)=>{
            setPermission(permissionResult);
            setLoading(false);
        }).catch(()=>{
            setPermission(false);
            setLoading(false);
        });
    }, [
        permissionPromise,
        setLoading,
        setPermission
    ]);
    return {
        loading: loading,
        hasPermission: hasPermission
    };
}

});

parcelRegister("4IuJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be0b3ec6af1f62b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $i8zHb = parcelRequire("i8zHb");

var $dgrT7 = parcelRequire("dgrT7");

var $lwMt0 = parcelRequire("lwMt0");

var $kFmJM = parcelRequire("kFmJM");
parcelRequire("kiYze");
var $g8xDQ = parcelRequire("g8xDQ");

var $9pJNq = parcelRequire("9pJNq");
const $8be0b3ec6af1f62b$var$defaultProps = {
    onClickedMenuLink: ()=>Promise.reject('No handler defined. Using default props value.'),
    testId: 'menu',
    isSSR: false
};
/**
 * There are some essential higher components wrapping an actual PeopleMenu component:
 * - PeopleMenuContext: is used to avoid passing common props like cloudId
 * - IntlProvider: to make i18n working
 * - AnalyticsContext: is used to avoid passing many props for triggering analytics events
 * - ErrorBoundary: to capture any errors inside actual PeopleMenu component
 */ const $8be0b3ec6af1f62b$var$PeopleMenuProviders = (props)=>{
    const { children: children, product: product, subProduct: subProduct, cloudId: cloudId, orgId: orgId, userId: userId, isBrowseUsersEnabled: isBrowseUsersEnabled, testId: testId, tenantUrl: tenantUrl, onClickedItem: onClickedItem, onClickedMenuLink: onClickedMenuLink, invitePeopleHandlers: invitePeopleHandlers, onOpen: onOpen, onClose: onClose, pushRoute: pushRoute, _hasError: _hasError, addFlag: addFlag, isOpen: isOpen, isSSR: isSSR, teamCreateDialogProps: teamCreateDialogProps, renotifyExperimentProps: renotifyExperimentProps, shouldRenderToParent: shouldRenderToParent, isSectionList: isSectionList } = {
        ...$8be0b3ec6af1f62b$var$defaultProps,
        ...props
    };
    const analyticsContextData = {
        product: product,
        source: (0, $g8xDQ.AnalyticsSource).PEOPLE_MENU,
        componentName: (0, $g8xDQ.AnalyticsSource).PEOPLE_MENU,
        ...(0, $kFmJM.packageContext)
    };
    const commonPropsInContext = {
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: userId,
        isBrowseUsersEnabled: isBrowseUsersEnabled,
        isSSR: isSSR,
        testId: testId,
        tenantUrl: (0, $dgrT7.trimLastForwardSlash)(tenantUrl),
        onClickedItem: onClickedItem,
        onClickedMenuLink: onClickedMenuLink,
        invitePeopleHandlers: invitePeopleHandlers,
        onOpen: onOpen,
        onClose: onClose,
        pushRoute: pushRoute,
        _hasError: _hasError,
        addFlag: addFlag,
        isPeopleMenuOpen: false,
        isOpen: isOpen,
        teamCreateDialogProps: teamCreateDialogProps,
        renotifyExperimentProps: renotifyExperimentProps,
        shouldRenderToParent: shouldRenderToParent,
        isSectionList: isSectionList
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lwMt0.PeopleMenuContextProvider), commonPropsInContext, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i8zHb.LazyIntlProvider), {
        fetchLanguageFile: (0, $9pJNq.fetchLanguageFile)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: analyticsContextData
    }, children)));
};
var $8be0b3ec6af1f62b$export$2e2bcd8739ae039 = $8be0b3ec6af1f62b$var$PeopleMenuProviders;

});
parcelRegister("9pJNq", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $8fb42016ade9b172$export$c08b58fa4727b0d2);

var $lgmyn = parcelRequire("lgmyn");
function $8fb42016ade9b172$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $lgmyn.cs();
        case 'da-DK':
        case 'da':
            return $lgmyn.da();
        case 'de-DE':
        case 'de':
            return $lgmyn.de();
        case 'es-ES':
        case 'es':
            return $lgmyn.es();
        case 'et-EE':
        case 'et':
            return $lgmyn.et();
        case 'fi-FI':
        case 'fi':
            return $lgmyn.fi();
        case 'fr-FR':
        case 'fr':
            return $lgmyn.fr();
        case 'hu-HU':
        case 'hu':
            return $lgmyn.hu();
        case 'is-IS':
        case 'is':
            return $lgmyn.is();
        case 'it-IT':
        case 'it':
            return $lgmyn.it();
        case 'ja-JP':
        case 'ja':
            return $lgmyn.ja();
        case 'ko-KR':
        case 'ko':
            return $lgmyn.ko();
        case 'nb-NB':
        case 'nb':
            return $lgmyn.nb();
        case 'nl-NL':
        case 'nl':
            return $lgmyn.nl();
        case 'pl-PL':
        case 'pl':
            return $lgmyn.pl();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $lgmyn.pt();
        case 'pt-BR':
        case 'pt_BR':
            return $lgmyn.ptbr();
        case 'ro-RO':
        case 'ro':
            return $lgmyn.ro();
        case 'ru-RU':
        case 'ru':
            return $lgmyn.ru();
        case 'sk-SK':
        case 'sk':
            return $lgmyn.sk();
        case 'sv-SE':
        case 'sv':
            return $lgmyn.sv();
        case 'tr-TR':
        case 'tr':
            return $lgmyn.tr();
        case 'th-TH':
        case 'th':
            return $lgmyn.th();
        case 'uk-UK':
        case 'uk':
            return $lgmyn.uk();
        case 'vi-VI':
        case 'vi':
            return $lgmyn.vi();
        case 'zh-TW':
        case 'zh-HK':
            return $lgmyn.zhtw();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $lgmyn.zh();
    }
    return $lgmyn.fallback();
}

});
parcelRegister("lgmyn", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $37bd08a897a6d7a9$export$bcd1dd1f397bba12);
$parcel$export(module.exports, "cs", () => $37bd08a897a6d7a9$export$bde1ed0f60b38f2f);
$parcel$export(module.exports, "da", () => $37bd08a897a6d7a9$export$8c8450b83b664ba4);
$parcel$export(module.exports, "de", () => $37bd08a897a6d7a9$export$2fa162a495d26869);
$parcel$export(module.exports, "es", () => $37bd08a897a6d7a9$export$ca5e4045a55e76d2);
$parcel$export(module.exports, "et", () => $37bd08a897a6d7a9$export$457177dcde8472be);
$parcel$export(module.exports, "fi", () => $37bd08a897a6d7a9$export$ed5179c818622fb);
$parcel$export(module.exports, "fr", () => $37bd08a897a6d7a9$export$acb2a88f7d552ebf);
$parcel$export(module.exports, "hu", () => $37bd08a897a6d7a9$export$9901d21957972d53);
$parcel$export(module.exports, "is", () => $37bd08a897a6d7a9$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "it", () => $37bd08a897a6d7a9$export$3486a10f30cf1ee4);
$parcel$export(module.exports, "ja", () => $37bd08a897a6d7a9$export$8c6f505e9474ce90);
$parcel$export(module.exports, "ko", () => $37bd08a897a6d7a9$export$798cf677954c9533);
$parcel$export(module.exports, "nb", () => $37bd08a897a6d7a9$export$38ef0e3f791a121e);
$parcel$export(module.exports, "nl", () => $37bd08a897a6d7a9$export$9c64ee4d84d79ce1);
$parcel$export(module.exports, "pl", () => $37bd08a897a6d7a9$export$6ea5311eda92944f);
$parcel$export(module.exports, "pt", () => $37bd08a897a6d7a9$export$84175d5f1cb4e39d);
$parcel$export(module.exports, "ptbr", () => $37bd08a897a6d7a9$export$82924b14976e7373);
$parcel$export(module.exports, "ro", () => $37bd08a897a6d7a9$export$ea30ec7f37fb148d);
$parcel$export(module.exports, "ru", () => $37bd08a897a6d7a9$export$cf48009033a0126b);
$parcel$export(module.exports, "sk", () => $37bd08a897a6d7a9$export$d608fa5b5bfd2021);
$parcel$export(module.exports, "sv", () => $37bd08a897a6d7a9$export$65540e5f7f6e7dce);
$parcel$export(module.exports, "tr", () => $37bd08a897a6d7a9$export$72451b88a72ad9c2);
$parcel$export(module.exports, "th", () => $37bd08a897a6d7a9$export$d657bc098992a431);
$parcel$export(module.exports, "uk", () => $37bd08a897a6d7a9$export$312745a8a3013c00);
$parcel$export(module.exports, "vi", () => $37bd08a897a6d7a9$export$e3786bf10a8abdf2);
$parcel$export(module.exports, "zh", () => $37bd08a897a6d7a9$export$b65a7f08f2280505);
$parcel$export(module.exports, "zhtw", () => $37bd08a897a6d7a9$export$41779e6acd26e15f);
/* istanbul ignore file */ const $37bd08a897a6d7a9$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $37bd08a897a6d7a9$export$bde1ed0f60b38f2f = ()=>(parcelRequire("aDR5n"));

const $37bd08a897a6d7a9$export$8c8450b83b664ba4 = ()=>(parcelRequire("ckIZr"));

const $37bd08a897a6d7a9$export$2fa162a495d26869 = ()=>(parcelRequire("6pamp"));

const $37bd08a897a6d7a9$export$ca5e4045a55e76d2 = ()=>(parcelRequire("c4ogj"));

const $37bd08a897a6d7a9$export$457177dcde8472be = ()=>(parcelRequire("5ZGi8"));

const $37bd08a897a6d7a9$export$ed5179c818622fb = ()=>(parcelRequire("95slG"));

const $37bd08a897a6d7a9$export$acb2a88f7d552ebf = ()=>(parcelRequire("3H7Pu"));

const $37bd08a897a6d7a9$export$9901d21957972d53 = ()=>(parcelRequire("6YWbS"));

const $37bd08a897a6d7a9$export$226b3eccf92c9ed9 = ()=>(parcelRequire("8zlTG"));

const $37bd08a897a6d7a9$export$3486a10f30cf1ee4 = ()=>(parcelRequire("7OzcS"));

const $37bd08a897a6d7a9$export$8c6f505e9474ce90 = ()=>(parcelRequire("yq1rK"));

const $37bd08a897a6d7a9$export$798cf677954c9533 = ()=>(parcelRequire("aTGH9"));

const $37bd08a897a6d7a9$export$38ef0e3f791a121e = ()=>(parcelRequire("4KknB"));

const $37bd08a897a6d7a9$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("hoFqV"));

const $37bd08a897a6d7a9$export$6ea5311eda92944f = ()=>(parcelRequire("3q5Br"));

const $37bd08a897a6d7a9$export$84175d5f1cb4e39d = ()=>(parcelRequire("7wHZt"));

const $37bd08a897a6d7a9$export$82924b14976e7373 = ()=>(parcelRequire("80FC3"));

const $37bd08a897a6d7a9$export$ea30ec7f37fb148d = ()=>(parcelRequire("2qxjS"));

const $37bd08a897a6d7a9$export$cf48009033a0126b = ()=>(parcelRequire("5Eqw5"));

const $37bd08a897a6d7a9$export$d608fa5b5bfd2021 = ()=>(parcelRequire("9XV9X"));

const $37bd08a897a6d7a9$export$65540e5f7f6e7dce = ()=>(parcelRequire("4J1hP"));

const $37bd08a897a6d7a9$export$72451b88a72ad9c2 = ()=>(parcelRequire("aglis"));

const $37bd08a897a6d7a9$export$d657bc098992a431 = ()=>(parcelRequire("2pXuU"));

const $37bd08a897a6d7a9$export$312745a8a3013c00 = ()=>(parcelRequire("2ymEO"));

const $37bd08a897a6d7a9$export$e3786bf10a8abdf2 = ()=>(parcelRequire("bcj5B"));

const $37bd08a897a6d7a9$export$b65a7f08f2280505 = ()=>(parcelRequire("9EkLs"));

const $37bd08a897a6d7a9$export$41779e6acd26e15f = ()=>(parcelRequire("1KCuT"));

});
parcelRegister("aDR5n", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5eYMB").then(()=>parcelRequire('afMYl'));

});

parcelRegister("ckIZr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6VQ1v").then(()=>parcelRequire('6KgOp'));

});

parcelRegister("6pamp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lEeI4").then(()=>parcelRequire('akGGy'));

});

parcelRegister("c4ogj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fYrRW").then(()=>parcelRequire('63sFj'));

});

parcelRegister("5ZGi8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("asNlo").then(()=>parcelRequire('dMY4J'));

});

parcelRegister("95slG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cP48D").then(()=>parcelRequire('7utwQ'));

});

parcelRegister("3H7Pu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3RC4G").then(()=>parcelRequire('crDOx'));

});

parcelRegister("6YWbS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bo2zO").then(()=>parcelRequire('8Oa7E'));

});

parcelRegister("8zlTG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6trH5").then(()=>parcelRequire('gqQdG'));

});

parcelRegister("7OzcS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kXRkC").then(()=>parcelRequire('dbNko'));

});

parcelRegister("yq1rK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2strq").then(()=>parcelRequire('8R0uN'));

});

parcelRegister("aTGH9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cxySg").then(()=>parcelRequire('bWyC4'));

});

parcelRegister("4KknB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8SExn").then(()=>parcelRequire('8xzmr'));

});

parcelRegister("hoFqV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2eNBg").then(()=>parcelRequire('6lHJ2'));

});

parcelRegister("3q5Br", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3Nfxl").then(()=>parcelRequire('9VlMs'));

});

parcelRegister("7wHZt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cGfwB").then(()=>parcelRequire('11LTD'));

});

parcelRegister("80FC3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c1CoI").then(()=>parcelRequire('WUCee'));

});

parcelRegister("2qxjS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jVdbX").then(()=>parcelRequire('9z1SP'));

});

parcelRegister("5Eqw5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eoxMS").then(()=>parcelRequire('9zC21'));

});

parcelRegister("9XV9X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2tTQk").then(()=>parcelRequire('2Xgl6'));

});

parcelRegister("4J1hP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7h5q7").then(()=>parcelRequire('kYeX0'));

});

parcelRegister("aglis", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jHMn0").then(()=>parcelRequire('ln5Hz'));

});

parcelRegister("2pXuU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aU79w").then(()=>parcelRequire('lHO7y'));

});

parcelRegister("2ymEO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ixhY2").then(()=>parcelRequire('cqwiW'));

});

parcelRegister("bcj5B", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3tyGR").then(()=>parcelRequire('cPie6'));

});

parcelRegister("9EkLs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ZVAsr").then(()=>parcelRequire('4JnI0'));

});

parcelRegister("1KCuT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3rMQY").then(()=>parcelRequire('dQctI'));

});





parcelRegister("13Jkn", function(module, exports) {

$parcel$export(module.exports, "PeopleMenuTriggerSSR", () => $93ba6bb8a026761e$export$7e1e2ab520ce5d59);
$parcel$export(module.exports, "default", () => $93ba6bb8a026761e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7rh0R = parcelRequire("7rh0R");

var $hTs14 = parcelRequire("hTs14");

var $dtaN9 = parcelRequire("dtaN9");

var $bULPy = parcelRequire("bULPy");

var $gtYBG = parcelRequire("gtYBG");

var $lwMt0 = parcelRequire("lwMt0");

var $7rpGo = parcelRequire("7rpGo");

var $e6l4r = parcelRequire("e6l4r");

var $85QcV = parcelRequire("85QcV");
function $93ba6bb8a026761e$export$7e1e2ab520ce5d59({ testId: testId, peopleText: peopleText }) {
    const remoteConfig = (0, $gtYBG.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), {
        testId: `${testId}-people-primary-button-ssr`
    }, navLabel ? navLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7rpGo.messages).teams));
}
function $93ba6bb8a026761e$var$PeopleMenuTrigger(props) {
    const { isSpotlightActive: isSpotlightActive, renotifyExperimentProps: renotifyExperimentProps } = (0, $lwMt0.usePeopleMenuContext)();
    const { isVisible: isVisible, isHighlighted: isHighlighted, customChevronIcon: customChevronIcon, triggerProps: triggerProps, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, isSelected: isSelected, peopleText: peopleText } = props;
    const buttonProps = (0, $eUqFw.useMemo)(()=>({
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId
        }), [
        isSelected,
        onClick,
        onMouseEnter,
        testId
    ]);
    const remoteConfig = (0, $gtYBG.usePeopleAndTeamsPeopleMenuConfiguration)();
    const navLabel = remoteConfig?.navLabel || peopleText;
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const chevron = customChevronIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: "dropdown-chevron"
    });
    const renderPrimaryDropDownButton = (0, $eUqFw.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), {
            isHighlighted: isHighlighted,
            ...buttonProps,
            ...triggerProps
        }, navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7rpGo.messages).teams));
    }, [
        buttonProps,
        isHighlighted,
        navLabel,
        triggerProps
    ]);
    if (isVisible) {
        if (renotifyExperimentProps?.isEnrolled && isSpotlightActive !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
            fallback: renderPrimaryDropDownButton()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e6l4r.RenotifySpotlight), {
            "data-testid": "renotify-spotlight-trigger",
            setIsOpen: onClick,
            renderFallback: renderPrimaryDropDownButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85QcV.default), {
            testId: "renotify-menu-trigger-button",
            triggerProps: triggerProps
        }, navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7rpGo.messages).teams))));
        return renderPrimaryDropDownButton();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        iconAfter: chevron,
        ...triggerProps,
        ...buttonProps
    }, navLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7rpGo.messages).teams));
}
var $93ba6bb8a026761e$export$2e2bcd8739ae039 = $93ba6bb8a026761e$var$PeopleMenuTrigger;

});
parcelRegister("e6l4r", function(module, exports) {

$parcel$export(module.exports, "RenotifySpotlight", () => $540d7320df7992df$export$c598a42b0405f75);

var $7rh0R = parcelRequire("7rh0R");

const $540d7320df7992df$export$c598a42b0405f75 = (0, $7rh0R.lazy)(()=>// eslint-disable-next-line import/dynamic-import-chunkname
    (parcelRequire("gapH4")), {
    moduleId: "../platform/packages/people-and-teams/people-menu/src/components/PeopleMenu/RenotifySpotlight.tsx"
});

});
parcelRegister("gapH4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ixMLB").then(()=>parcelRequire('8DhQK'));

});


parcelRegister("85QcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $018bf4ac5aaaae86$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $hxAcv = parcelRequire("hxAcv");
const $018bf4ac5aaaae86$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
function $018bf4ac5aaaae86$var$RenotifyMenuButton(props) {
    const { testId: testId, triggerProps: triggerProps, children: children } = props;
    // The cloned spotlight button requires the className prop to be set
    // for the padding style to be applied properly
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "renotify-menu-button",
        css: $018bf4ac5aaaae86$var$buttonStyles,
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $hxAcv.RenotifySpotlightTriggerChevron), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "dropdown-chevron"
        })),
        ...triggerProps
    }, children);
}
var $018bf4ac5aaaae86$export$2e2bcd8739ae039 = $018bf4ac5aaaae86$var$RenotifyMenuButton;

});
parcelRegister("hxAcv", function(module, exports) {

$parcel$export(module.exports, "RenotifyMessageContainer", () => $b2019c6ee2aece9f$export$82eb61f2818fcdcb);
$parcel$export(module.exports, "RenotifyModalWidthFull", () => $b2019c6ee2aece9f$export$1b5dc0ba5fe67cdb);
$parcel$export(module.exports, "RenotifyModalUsersContainer", () => $b2019c6ee2aece9f$export$ecd3b6bfab51e27c);
$parcel$export(module.exports, "RenotifySpotlightTriggerChevron", () => $b2019c6ee2aece9f$export$bdd40b9dcae00142);
$parcel$export(module.exports, "RenotifySpotlightContent", () => $b2019c6ee2aece9f$export$75293539a002acf6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8BKky = parcelRequire("8BKky");


var $joBf7 = parcelRequire("joBf7");
function $b2019c6ee2aece9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b2019c6ee2aece9f$export$82eb61f2818fcdcb = /*#__PURE__*/ (0, $joBf7.default)((0, $8BKky.default), {
    target: "e11sj30a4"
})({
    maxWidth: '300px',
    padding: "var(--ds-space-200, 16px)",
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${(0, $73a5c9d720aa66e1$export$1cc05bbbf340e559)})`,
    '&::before': {
        height: "var(--ds-space-0, 0px)"
    },
    '&::after': {
        height: "var(--ds-space-0, 0px)"
    }
});
const $b2019c6ee2aece9f$export$1b5dc0ba5fe67cdb = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11sj30a3"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $b2019c6ee2aece9f$export$ecd3b6bfab51e27c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11sj30a2"
})({
    name: "cjcfh5",
    styles: "height:fit-content;max-height:174px;overflow-y:auto;margin-top:var(--ds-space-200, 16px);padding-top:var(--ds-space-100, 8px)"
});
const $b2019c6ee2aece9f$export$bdd40b9dcae00142 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e11sj30a1"
})({
    name: "x63kpl",
    styles: "margin-left:var(--ds-space-negative-100, -8px);margin-right:var(--ds-space-negative-100, -8px);opacity:0.5"
});
const $b2019c6ee2aece9f$export$75293539a002acf6 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e11sj30a0"
})({
    name: "kzyyo8",
    styles: "margin-top:var(--ds-space-050, 4px);margin-bottom:var(--ds-space-100, 8px)"
});

});



parcelRegister("w5pg8", function(module, exports) {

$parcel$export(module.exports, "UsersTeamsPreFetch", () => $e3758631eee8884b$export$ffb64487c0de3976);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $7lnvo = parcelRequire("7lnvo");

var $jLsPA = parcelRequire("jLsPA");

var $lE5gC = parcelRequire("lE5gC");

var $kiYze = parcelRequire("kiYze");
function $e3758631eee8884b$export$50ca75733630fce1({ cloudId: cloudId, orgId: orgId, userId: userId, product: product, tenantUrl: tenantUrl, createAnalyticsEvent: createAnalyticsEvent, renotifyExperiment: renotifyExperiment }) {
    (0, $eUqFw.useEffect)(()=>{
        (0, $kiYze.triggerAnalyticsForPreFetchData)(createAnalyticsEvent);
        // measure duration time of fetching users and teams data
        (0, $lE5gC.startMeasure)('fetchingData');
    }, [
        createAnalyticsEvent
    ]);
    const { isLoading: isLoading } = (0, $jLsPA.default)(cloudId, userId, product, tenantUrl, undefined, orgId);
    /*
	 * This hook checks the renotify experiments eligibility passed from Jira
	 * and will only take action if enrolled. It makes a single call to
	 * Experiment-API which proxies a call to Hydra and Identity Gatekeeper
	 * to return users who have been invited to Jira but not accepted.
	 */ (0, $7lnvo.usePendingUsers)({
        cloudId: cloudId,
        startFetching: true,
        renotifyExperiment: renotifyExperiment
    });
    // stop to measure fetching data time when isLoading is finished.
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoading) (0, $lE5gC.stopMeasure)('fetchingData', (duration, startTime)=>{
            (0, $kiYze.triggerAnalyticsForFetchingData)(createAnalyticsEvent, duration, startTime);
        });
    }, [
        createAnalyticsEvent,
        isLoading
    ]);
    return null;
}
const $e3758631eee8884b$export$ffb64487c0de3976 = (0, $2jDha.default)()($e3758631eee8884b$export$50ca75733630fce1);

});



parcelRegister("9jxb2", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $1337813f893d13e9$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $cbDiB = parcelRequire("cbDiB");
var $hfrLs = parcelRequire("hfrLs");

var $eUqFw = parcelRequire("eUqFw");
const $1337813f893d13e9$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfrLs.ThemeProvider), {
        partialSearchCSS: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbDiB.default), rest));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbDiB.default), rest);
};

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';

const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

const $a00fc1524f53b0e2$export$42f4885608027d0c = 'non_boolean';

const $2005e07c976eea8a$export$b98e411ae80c806f = '/';

const $595550bfc4684751$export$cf090d5281b5ae06 = 10000;
const $595550bfc4684751$export$8575e30be0feb909 = 30000;

const $246e515cf63acef1$export$3288b14b6745c572 = 204;
const $246e515cf63acef1$export$c09e7ea0fc79f34f = 409;
const $246e515cf63acef1$export$974c37534b0191b1 = 503;

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d3227e938619716f$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d3227e938619716f$export$64aee74ba59709e5 = 439; // px
const $d3227e938619716f$export$1c07393c5bb1bc27 = 439; // px
const $d3227e938619716f$export$aa3478deee7adbeb = 350; // px
const $d3227e938619716f$export$21e515a86cd1733b = 'Chat';

const $a3c11500ccd013c5$export$d4c5499dc806c969 = ', Loading';

const $b4cc463b68660864$export$d6830277b06edd6 = 'normal';
const $b4cc463b68660864$export$4f8f13a66ae77bdd = '--color';
const $b4cc463b68660864$export$e9244ec13bd422b5 = '--bg-color';
const $b4cc463b68660864$export$97e78d9745006c11 = '--bg-color-hover';
const $b4cc463b68660864$export$291d63757828f290 = '--bg-color-active';


$parcel$global.rlb("fr9NE")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.95abb53b.js.map
